//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.0.0 (NJsonSchema v11.6.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class ApiBase {
    getBaseUrl(baseUrl: string): string {
        // NSwag now by default adds an empty string as a param to this method for some reason
        return process.env.REACT_APP_API_ENDPOINT || "";
    }

    protected transformResult(
        url: string,
        response: any,
        processor: (response: any) => any
      ): Promise<any> {
    
        if (response.status >= 400) {
          return Promise.reject(response);
        }
    
        return processor(response);
      }
}

export class AiSearchFavoritesClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getList(searchContext: string | null | undefined, cancelToken?: CancelToken): Promise<AiSearchFavoriteDto[]> {
        let url_ = this.baseUrl + "/AiSearchFavorites/GetList?";
        if (searchContext !== undefined && searchContext !== null)
            url_ += "searchContext=" + encodeURIComponent("" + searchContext) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetList(_response));
        });
    }

    protected processGetList(response: AxiosResponse): Promise<AiSearchFavoriteDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<AiSearchFavoriteDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AiSearchFavoriteDto[]>(null as any);
    }

    get(id: number, cancelToken?: CancelToken): Promise<AiSearchFavoriteDto> {
        let url_ = this.baseUrl + "/AiSearchFavorites/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<AiSearchFavoriteDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<AiSearchFavoriteDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AiSearchFavoriteDto>(null as any);
    }

    delete(id: number, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/AiSearchFavorites/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    saveCreate(favoriteVm: AiSearchFavoriteEditDto, cancelToken?: CancelToken): Promise<AiSearchFavoriteDto> {
        let url_ = this.baseUrl + "/AiSearchFavorites/SaveCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(favoriteVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreate(_response));
        });
    }

    protected processSaveCreate(response: AxiosResponse): Promise<AiSearchFavoriteDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<AiSearchFavoriteDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AiSearchFavoriteDto>(null as any);
    }

    saveUpdate(favoriteVm: AiSearchFavoriteEditDto, cancelToken?: CancelToken): Promise<AiSearchFavoriteDto> {
        let url_ = this.baseUrl + "/AiSearchFavorites/SaveUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(favoriteVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdate(_response));
        });
    }

    protected processSaveUpdate(response: AxiosResponse): Promise<AiSearchFavoriteDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<AiSearchFavoriteDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AiSearchFavoriteDto>(null as any);
    }

    saveOrder(favorites: AiSearchFavoriteOrderDto[], cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/AiSearchFavorites/SaveOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(favorites);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveOrder(_response));
        });
    }

    protected processSaveOrder(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    markUsed(id: number | undefined, cancelToken?: CancelToken): Promise<AiSearchFavoriteDto> {
        let url_ = this.baseUrl + "/AiSearchFavorites/MarkUsed?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processMarkUsed(_response));
        });
    }

    protected processMarkUsed(response: AxiosResponse): Promise<AiSearchFavoriteDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<AiSearchFavoriteDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AiSearchFavoriteDto>(null as any);
    }
}

export class AuthClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    authenticate(authRequest: AuthRequest, cancelToken?: CancelToken): Promise<AuthResult> {
        let url_ = this.baseUrl + "/Auth/Authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(authRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processAuthenticate(_response));
        });
    }

    protected processAuthenticate(response: AxiosResponse): Promise<AuthResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<AuthResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthResult>(null as any);
    }

    getAuthViewResource( cancelToken?: CancelToken): Promise<AuthViewResource> {
        let url_ = this.baseUrl + "/Auth/GetAuthViewResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAuthViewResource(_response));
        });
    }

    protected processGetAuthViewResource(response: AxiosResponse): Promise<AuthViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<AuthViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthViewResource>(null as any);
    }

    isAuthenticated( cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Auth/IsAuthenticated";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processIsAuthenticated(_response));
        });
    }

    protected processIsAuthenticated(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    refreshToken(refreshTokenString: string | null | undefined, cancelToken?: CancelToken): Promise<AuthResult> {
        let url_ = this.baseUrl + "/Auth/RefreshToken?";
        if (refreshTokenString !== undefined && refreshTokenString !== null)
            url_ += "refreshTokenString=" + encodeURIComponent("" + refreshTokenString) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRefreshToken(_response));
        });
    }

    protected processRefreshToken(response: AxiosResponse): Promise<AuthResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<AuthResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthResult>(null as any);
    }

    logout(refreshTokenString: string | null | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Auth/Logout?";
        if (refreshTokenString !== undefined && refreshTokenString !== null)
            url_ += "refreshTokenString=" + encodeURIComponent("" + refreshTokenString) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processLogout(_response));
        });
    }

    protected processLogout(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getForgotCredentialViewResource( cancelToken?: CancelToken): Promise<ForgotCredentialViewResource> {
        let url_ = this.baseUrl + "/Auth/GetForgotCredentialViewResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetForgotCredentialViewResource(_response));
        });
    }

    protected processGetForgotCredentialViewResource(response: AxiosResponse): Promise<ForgotCredentialViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ForgotCredentialViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ForgotCredentialViewResource>(null as any);
    }

    postForgotCredential(forgotCredential: ForgotCredential, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Auth/PostForgotCredential";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(forgotCredential);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPostForgotCredential(_response));
        });
    }

    protected processPostForgotCredential(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getResetPasswordViewResource( cancelToken?: CancelToken): Promise<ResetPasswordViewResource> {
        let url_ = this.baseUrl + "/Auth/GetResetPasswordViewResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetResetPasswordViewResource(_response));
        });
    }

    protected processGetResetPasswordViewResource(response: AxiosResponse): Promise<ResetPasswordViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ResetPasswordViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResetPasswordViewResource>(null as any);
    }

    getResetPassword(tenantName: string | null | undefined, userId: number | undefined, validationToken: string | null | undefined, cancelToken?: CancelToken): Promise<ResetPassword> {
        let url_ = this.baseUrl + "/Auth/GetResetPassword?";
        if (tenantName !== undefined && tenantName !== null)
            url_ += "tenantName=" + encodeURIComponent("" + tenantName) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (validationToken !== undefined && validationToken !== null)
            url_ += "validationToken=" + encodeURIComponent("" + validationToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetResetPassword(_response));
        });
    }

    protected processGetResetPassword(response: AxiosResponse): Promise<ResetPassword> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ResetPassword>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResetPassword>(null as any);
    }

    postResetPassword(resetPassword: ResetPassword, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Auth/PostResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(resetPassword);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPostResetPassword(_response));
        });
    }

    protected processPostResetPassword(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getUserRegisterViewResource( cancelToken?: CancelToken): Promise<UserRegisterViewResource> {
        let url_ = this.baseUrl + "/Auth/GetUserRegisterViewResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetUserRegisterViewResource(_response));
        });
    }

    protected processGetUserRegisterViewResource(response: AxiosResponse): Promise<UserRegisterViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<UserRegisterViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserRegisterViewResource>(null as any);
    }

    getUserRegister(tenantName: string | null | undefined, userId: number | undefined, validationToken: string | null | undefined, cancelToken?: CancelToken): Promise<UserRegister> {
        let url_ = this.baseUrl + "/Auth/GetUserRegister?";
        if (tenantName !== undefined && tenantName !== null)
            url_ += "tenantName=" + encodeURIComponent("" + tenantName) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (validationToken !== undefined && validationToken !== null)
            url_ += "validationToken=" + encodeURIComponent("" + validationToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetUserRegister(_response));
        });
    }

    protected processGetUserRegister(response: AxiosResponse): Promise<UserRegister> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<UserRegister>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserRegister>(null as any);
    }

    linkClientAccount(userRegister: UserRegister, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Auth/LinkClientAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userRegister);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processLinkClientAccount(_response));
        });
    }

    protected processLinkClientAccount(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    postUserRegister(userRegister: UserRegister, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Auth/PostUserRegister";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userRegister);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPostUserRegister(_response));
        });
    }

    protected processPostUserRegister(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class AuthV2Client extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    microsoftLogin( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/AuthV2/MicrosoftLogin";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processMicrosoftLogin(_response));
        });
    }

    protected processMicrosoftLogin(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    authenticate(authRequest: AuthRequestV2, cancelToken?: CancelToken): Promise<AuthResult> {
        let url_ = this.baseUrl + "/AuthV2/Authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(authRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processAuthenticate(_response));
        });
    }

    protected processAuthenticate(response: AxiosResponse): Promise<AuthResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<AuthResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthResult>(null as any);
    }

    swapTenant(tenantId: number | undefined, cancelToken?: CancelToken): Promise<AuthResult> {
        let url_ = this.baseUrl + "/AuthV2/SwapTenant?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSwapTenant(_response));
        });
    }

    protected processSwapTenant(response: AxiosResponse): Promise<AuthResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<AuthResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthResult>(null as any);
    }

    getAuthViewResource( cancelToken?: CancelToken): Promise<AuthViewResource> {
        let url_ = this.baseUrl + "/AuthV2/GetAuthViewResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAuthViewResource(_response));
        });
    }

    protected processGetAuthViewResource(response: AxiosResponse): Promise<AuthViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<AuthViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthViewResource>(null as any);
    }

    isAuthenticated( cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/AuthV2/IsAuthenticated";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processIsAuthenticated(_response));
        });
    }

    protected processIsAuthenticated(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    refreshToken(refreshTokenString: string | null | undefined, cancelToken?: CancelToken): Promise<AuthResult> {
        let url_ = this.baseUrl + "/AuthV2/RefreshToken?";
        if (refreshTokenString !== undefined && refreshTokenString !== null)
            url_ += "refreshTokenString=" + encodeURIComponent("" + refreshTokenString) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRefreshToken(_response));
        });
    }

    protected processRefreshToken(response: AxiosResponse): Promise<AuthResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<AuthResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthResult>(null as any);
    }

    logout(refreshTokenString: string | null | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/AuthV2/Logout?";
        if (refreshTokenString !== undefined && refreshTokenString !== null)
            url_ += "refreshTokenString=" + encodeURIComponent("" + refreshTokenString) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processLogout(_response));
        });
    }

    protected processLogout(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getForgotCredentialViewResource( cancelToken?: CancelToken): Promise<ForgotCredentialViewResource> {
        let url_ = this.baseUrl + "/AuthV2/GetForgotCredentialViewResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetForgotCredentialViewResource(_response));
        });
    }

    protected processGetForgotCredentialViewResource(response: AxiosResponse): Promise<ForgotCredentialViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ForgotCredentialViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ForgotCredentialViewResource>(null as any);
    }

    postForgotCredential(forgotCredential: ForgotCredentialV2, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/AuthV2/PostForgotCredential";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(forgotCredential);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPostForgotCredential(_response));
        });
    }

    protected processPostForgotCredential(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getResetPasswordViewResource( cancelToken?: CancelToken): Promise<ResetPasswordViewResource> {
        let url_ = this.baseUrl + "/AuthV2/GetResetPasswordViewResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetResetPasswordViewResource(_response));
        });
    }

    protected processGetResetPasswordViewResource(response: AxiosResponse): Promise<ResetPasswordViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ResetPasswordViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResetPasswordViewResource>(null as any);
    }

    getResetPassword(userId: number | undefined, validationToken: string | null | undefined, cancelToken?: CancelToken): Promise<ResetPassword> {
        let url_ = this.baseUrl + "/AuthV2/GetResetPassword?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (validationToken !== undefined && validationToken !== null)
            url_ += "validationToken=" + encodeURIComponent("" + validationToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetResetPassword(_response));
        });
    }

    protected processGetResetPassword(response: AxiosResponse): Promise<ResetPassword> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ResetPassword>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResetPassword>(null as any);
    }

    postResetPassword(resetPassword: ResetPasswordV2, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/AuthV2/PostResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(resetPassword);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPostResetPassword(_response));
        });
    }

    protected processPostResetPassword(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    linkClientAccount(userDto: UserDto, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/AuthV2/LinkClientAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processLinkClientAccount(_response));
        });
    }

    protected processLinkClientAccount(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    enrollCentralIdentity(userDto: UserDto, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/AuthV2/EnrollCentralIdentity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processEnrollCentralIdentity(_response));
        });
    }

    protected processEnrollCentralIdentity(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getUserRegisterViewResource( cancelToken?: CancelToken): Promise<UserRegisterViewResource> {
        let url_ = this.baseUrl + "/AuthV2/GetUserRegisterViewResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetUserRegisterViewResource(_response));
        });
    }

    protected processGetUserRegisterViewResource(response: AxiosResponse): Promise<UserRegisterViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<UserRegisterViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserRegisterViewResource>(null as any);
    }

    getUserRegister(validationToken: string | null | undefined, cancelToken?: CancelToken): Promise<UserRegister> {
        let url_ = this.baseUrl + "/AuthV2/GetUserRegister?";
        if (validationToken !== undefined && validationToken !== null)
            url_ += "validationToken=" + encodeURIComponent("" + validationToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetUserRegister(_response));
        });
    }

    protected processGetUserRegister(response: AxiosResponse): Promise<UserRegister> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<UserRegister>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserRegister>(null as any);
    }

    postUserRegister(userRegister: UserRegisterV2, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/AuthV2/PostUserRegister";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userRegister);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPostUserRegister(_response));
        });
    }

    protected processPostUserRegister(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    sendInvitationEmail(userId: number | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/AuthV2/SendInvitationEmail?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSendInvitationEmail(_response));
        });
    }

    protected processSendInvitationEmail(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class CommentsClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    saveUpdateComment(commentVm: Comment, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Comments/SaveUpdateComment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(commentVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdateComment(_response));
        });
    }

    protected processSaveUpdateComment(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    deleteComment(id: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Comments/DeleteComment?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteComment(_response));
        });
    }

    protected processDeleteComment(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class CommonClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getFile(fileRef: string | null | undefined, fileName: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Common/GetFile?";
        if (fileRef !== undefined && fileRef !== null)
            url_ += "fileRef=" + encodeURIComponent("" + fileRef) + "&";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetFile(_response));
        });
    }

    protected processGetFile(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    generatePdfFromHtml(htmlToPdf: HtmlToPdf, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Common/GeneratePdfFromHtml";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(htmlToPdf);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGeneratePdfFromHtml(_response));
        });
    }

    protected processGeneratePdfFromHtml(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getDataModelInfo(dataModelType: DataModelEnum | undefined, id: number | undefined, cancelToken?: CancelToken): Promise<DataModelInfo> {
        let url_ = this.baseUrl + "/Common/GetDataModelInfo?";
        if (dataModelType === null)
            throw new globalThis.Error("The parameter 'dataModelType' cannot be null.");
        else if (dataModelType !== undefined)
            url_ += "dataModelType=" + encodeURIComponent("" + dataModelType) + "&";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetDataModelInfo(_response));
        });
    }

    protected processGetDataModelInfo(response: AxiosResponse): Promise<DataModelInfo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<DataModelInfo>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataModelInfo>(null as any);
    }

    getBulkSelectResource( cancelToken?: CancelToken): Promise<BulkSelectResource> {
        let url_ = this.baseUrl + "/Common/GetBulkSelectResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetBulkSelectResource(_response));
        });
    }

    protected processGetBulkSelectResource(response: AxiosResponse): Promise<BulkSelectResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<BulkSelectResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BulkSelectResource>(null as any);
    }

    usingDisplayOrder(dataModelType: DataModelEnum | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/Common/UsingDisplayOrder?";
        if (dataModelType === null)
            throw new globalThis.Error("The parameter 'dataModelType' cannot be null.");
        else if (dataModelType !== undefined)
            url_ += "dataModelType=" + encodeURIComponent("" + dataModelType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUsingDisplayOrder(_response));
        });
    }

    protected processUsingDisplayOrder(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    usingDisplayOrderBulk(dataModelTypes: DataModelEnum[], cancelToken?: CancelToken): Promise<DataModelEnum[]> {
        let url_ = this.baseUrl + "/Common/UsingDisplayOrderBulk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dataModelTypes);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUsingDisplayOrderBulk(_response));
        });
    }

    protected processUsingDisplayOrderBulk(response: AxiosResponse): Promise<DataModelEnum[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<DataModelEnum[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataModelEnum[]>(null as any);
    }

    clearDisplayOrders(dataModelType: DataModelEnum | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Common/ClearDisplayOrders?";
        if (dataModelType === null)
            throw new globalThis.Error("The parameter 'dataModelType' cannot be null.");
        else if (dataModelType !== undefined)
            url_ += "dataModelType=" + encodeURIComponent("" + dataModelType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processClearDisplayOrders(_response));
        });
    }

    protected processClearDisplayOrders(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    assignDisplayOrders(dataModelType: DataModelEnum | undefined, ids: number[], cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Common/AssignDisplayOrders?";
        if (dataModelType === null)
            throw new globalThis.Error("The parameter 'dataModelType' cannot be null.");
        else if (dataModelType !== undefined)
            url_ += "dataModelType=" + encodeURIComponent("" + dataModelType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processAssignDisplayOrders(_response));
        });
    }

    protected processAssignDisplayOrders(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    sendEmailsV2(emailModel: EmailModel, cancelToken?: CancelToken): Promise<EmailOutput> {
        let url_ = this.baseUrl + "/Common/SendEmailsV2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(emailModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSendEmailsV2(_response));
        });
    }

    protected processSendEmailsV2(response: AxiosResponse): Promise<EmailOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<EmailOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmailOutput>(null as any);
    }

    sendEmails(emailModel: EmailModel, cancelToken?: CancelToken): Promise<EmailOutput> {
        let url_ = this.baseUrl + "/Common/SendEmails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(emailModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSendEmails(_response));
        });
    }

    protected processSendEmails(response: AxiosResponse): Promise<EmailOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<EmailOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmailOutput>(null as any);
    }
}

export class DashboardTabClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getAll( cancelToken?: CancelToken): Promise<DashboardTabDto[]> {
        let url_ = this.baseUrl + "/DashboardTab/Get";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<DashboardTabDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<DashboardTabDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DashboardTabDto[]>(null as any);
    }

    get(id: number, cancelToken?: CancelToken): Promise<DashboardTabDto> {
        let url_ = this.baseUrl + "/DashboardTab/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<DashboardTabDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<DashboardTabDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DashboardTabDto>(null as any);
    }

    delete(id: number, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/DashboardTab/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    saveCreate(tabVm: DashboardTabEditDto, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/DashboardTab/SaveCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tabVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreate(_response));
        });
    }

    protected processSaveCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveUpdate(tabVm: DashboardTabEditDto, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/DashboardTab/SaveUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tabVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdate(_response));
        });
    }

    protected processSaveUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveOrder(tabs: DashboardTabOrderDto[], cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/DashboardTab/SaveOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tabs);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveOrder(_response));
        });
    }

    protected processSaveOrder(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class EmailClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    sendMessage(request: SendMessageRequestDto, cancelToken?: CancelToken): Promise<TextingMessage> {
        let url_ = this.baseUrl + "/Email/SendMessage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSendMessage(_response));
        });
    }

    protected processSendMessage(response: AxiosResponse): Promise<TextingMessage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<TextingMessage>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TextingMessage>(null as any);
    }

    connectOutlook( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Email/ConnectOutlook";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processConnectOutlook(_response));
        });
    }

    protected processConnectOutlook(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class HealthCheckClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    health( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/HealthCheck/Health";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processHealth(_response));
        });
    }

    protected processHealth(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class HomeClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getAppResource( cancelToken?: CancelToken): Promise<AppResource> {
        let url_ = this.baseUrl + "/Home/GetAppResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAppResource(_response));
        });
    }

    protected processGetAppResource(response: AxiosResponse): Promise<AppResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<AppResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AppResource>(null as any);
    }

    get( cancelToken?: CancelToken): Promise<Home> {
        let url_ = this.baseUrl + "/Home/Get";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<Home> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<Home>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Home>(null as any);
    }

    env( cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Home/Env";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processEnv(_response));
        });
    }

    protected processEnv(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getServiceDashboard(programId: number | null | undefined, cancelToken?: CancelToken): Promise<HomeServiceDashboard> {
        let url_ = this.baseUrl + "/Home/GetServiceDashboard?";
        if (programId !== undefined && programId !== null)
            url_ += "programId=" + encodeURIComponent("" + programId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetServiceDashboard(_response));
        });
    }

    protected processGetServiceDashboard(response: AxiosResponse): Promise<HomeServiceDashboard> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<HomeServiceDashboard>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HomeServiceDashboard>(null as any);
    }

    getMatchDashboard( cancelToken?: CancelToken): Promise<HomeMatchDashboard> {
        let url_ = this.baseUrl + "/Home/GetMatchDashboard";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetMatchDashboard(_response));
        });
    }

    protected processGetMatchDashboard(response: AxiosResponse): Promise<HomeMatchDashboard> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<HomeMatchDashboard>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HomeMatchDashboard>(null as any);
    }

    getStudentCountsByGrade(request: StudentCountsByGradeRequest, cancelToken?: CancelToken): Promise<StudentCountsByGradeResponse> {
        let url_ = this.baseUrl + "/Home/GetStudentCountsByGrade";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetStudentCountsByGrade(_response));
        });
    }

    protected processGetStudentCountsByGrade(response: AxiosResponse): Promise<StudentCountsByGradeResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentCountsByGradeResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentCountsByGradeResponse>(null as any);
    }

    exportStudentCountsByGrade(request: StudentCountsByGradeRequest, cancelToken?: CancelToken): Promise<GeneratedFile> {
        let url_ = this.baseUrl + "/Home/ExportStudentCountsByGrade";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processExportStudentCountsByGrade(_response));
        });
    }

    protected processExportStudentCountsByGrade(response: AxiosResponse): Promise<GeneratedFile> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<GeneratedFile>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GeneratedFile>(null as any);
    }

    getSchoolEnrollmentSummary(request: SchoolEnrollmentSummaryRequest, cancelToken?: CancelToken): Promise<SchoolEnrollmentSummaryResponse> {
        let url_ = this.baseUrl + "/Home/GetSchoolEnrollmentSummary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSchoolEnrollmentSummary(_response));
        });
    }

    protected processGetSchoolEnrollmentSummary(response: AxiosResponse): Promise<SchoolEnrollmentSummaryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SchoolEnrollmentSummaryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SchoolEnrollmentSummaryResponse>(null as any);
    }

    generateModelStateDictionary( cancelToken?: CancelToken): Promise<NswagModels> {
        let url_ = this.baseUrl + "/Home/GenerateModelStateDictionary";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGenerateModelStateDictionary(_response));
        });
    }

    protected processGenerateModelStateDictionary(response: AxiosResponse): Promise<NswagModels> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<NswagModels>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NswagModels>(null as any);
    }

    test( cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Home/Test";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processTest(_response));
        });
    }

    protected processTest(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class NotificationsClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getList(request: NotificationListRequest, cancelToken?: CancelToken): Promise<NotificationListResponse> {
        let url_ = this.baseUrl + "/Notifications/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetList(_response));
        });
    }

    protected processGetList(response: AxiosResponse): Promise<NotificationListResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<NotificationListResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NotificationListResponse>(null as any);
    }

    markAsRead(notificationId: number, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Notifications/MarkAsRead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(notificationId);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processMarkAsRead(_response));
        });
    }

    protected processMarkAsRead(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    markAllAsRead( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Notifications/MarkAllAsRead";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processMarkAllAsRead(_response));
        });
    }

    protected processMarkAllAsRead(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class OpenAiClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    promptStudentFilters(prompt: AiPrompt, cancelToken?: CancelToken): Promise<StudentListFilter> {
        let url_ = this.baseUrl + "/OpenAi/PromptStudentFilters";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(prompt);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPromptStudentFilters(_response));
        });
    }

    protected processPromptStudentFilters(response: AxiosResponse): Promise<StudentListFilter> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentListFilter>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentListFilter>(null as any);
    }

    uploadStudentServiceTemplateFile(file: UploadFile, cancelToken?: CancelToken): Promise<AiProcessedAttendee[]> {
        let url_ = this.baseUrl + "/OpenAi/UploadStudentServiceTemplateFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(file);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUploadStudentServiceTemplateFile(_response));
        });
    }

    protected processUploadStudentServiceTemplateFile(response: AxiosResponse): Promise<AiProcessedAttendee[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<AiProcessedAttendee[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AiProcessedAttendee[]>(null as any);
    }
}

export class PublicApplicationClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getApplication(applicationGuid: string | undefined, tenantName: string | null | undefined, cancelToken?: CancelToken): Promise<PublicApplicationDto> {
        let url_ = this.baseUrl + "/PublicApplication/GetApplication?";
        if (applicationGuid === null)
            throw new globalThis.Error("The parameter 'applicationGuid' cannot be null.");
        else if (applicationGuid !== undefined)
            url_ += "applicationGuid=" + encodeURIComponent("" + applicationGuid) + "&";
        if (tenantName !== undefined && tenantName !== null)
            url_ += "tenantName=" + encodeURIComponent("" + tenantName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetApplication(_response));
        });
    }

    protected processGetApplication(response: AxiosResponse): Promise<PublicApplicationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<PublicApplicationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublicApplicationDto>(null as any);
    }

    getApplicationResponse(applicationResponseGuid: string | null | undefined, tenantName: string | null | undefined, cancelToken?: CancelToken): Promise<ApplicationResponse> {
        let url_ = this.baseUrl + "/PublicApplication/GetApplicationResponse?";
        if (applicationResponseGuid !== undefined && applicationResponseGuid !== null)
            url_ += "applicationResponseGuid=" + encodeURIComponent("" + applicationResponseGuid) + "&";
        if (tenantName !== undefined && tenantName !== null)
            url_ += "tenantName=" + encodeURIComponent("" + tenantName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetApplicationResponse(_response));
        });
    }

    protected processGetApplicationResponse(response: AxiosResponse): Promise<ApplicationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ApplicationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApplicationResponse>(null as any);
    }

    getApplicationViewResource(applicationGuid: string | undefined, tenantName: string | null | undefined, cancelToken?: CancelToken): Promise<PublicApplicationViewResource> {
        let url_ = this.baseUrl + "/PublicApplication/GetApplicationViewResource?";
        if (applicationGuid === null)
            throw new globalThis.Error("The parameter 'applicationGuid' cannot be null.");
        else if (applicationGuid !== undefined)
            url_ += "applicationGuid=" + encodeURIComponent("" + applicationGuid) + "&";
        if (tenantName !== undefined && tenantName !== null)
            url_ += "tenantName=" + encodeURIComponent("" + tenantName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetApplicationViewResource(_response));
        });
    }

    protected processGetApplicationViewResource(response: AxiosResponse): Promise<PublicApplicationViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<PublicApplicationViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublicApplicationViewResource>(null as any);
    }

    updateApplicationResponse(applicationResponse: PublicApplicationResponseDto, tenantName: string | null | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/PublicApplication/UpdateApplicationResponse?";
        if (tenantName !== undefined && tenantName !== null)
            url_ += "tenantName=" + encodeURIComponent("" + tenantName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(applicationResponse);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateApplicationResponse(_response));
        });
    }

    protected processUpdateApplicationResponse(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveApplicationResponse(applicationResponse: PublicApplicationResponseDto, tenantName: string | null | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/PublicApplication/SaveApplicationResponse?";
        if (tenantName !== undefined && tenantName !== null)
            url_ += "tenantName=" + encodeURIComponent("" + tenantName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(applicationResponse);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveApplicationResponse(_response));
        });
    }

    protected processSaveApplicationResponse(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class PublicSurveyClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getSurvey(surveyGuid: string | undefined, tenantName: string | null | undefined, cancelToken?: CancelToken): Promise<PublicSurveyDto> {
        let url_ = this.baseUrl + "/PublicSurvey/GetSurvey?";
        if (surveyGuid === null)
            throw new globalThis.Error("The parameter 'surveyGuid' cannot be null.");
        else if (surveyGuid !== undefined)
            url_ += "surveyGuid=" + encodeURIComponent("" + surveyGuid) + "&";
        if (tenantName !== undefined && tenantName !== null)
            url_ += "tenantName=" + encodeURIComponent("" + tenantName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSurvey(_response));
        });
    }

    protected processGetSurvey(response: AxiosResponse): Promise<PublicSurveyDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<PublicSurveyDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublicSurveyDto>(null as any);
    }

    getSurveyResponse(formResponseGuid: string | undefined, tenantName: string | null | undefined, cancelToken?: CancelToken): Promise<FormResponse> {
        let url_ = this.baseUrl + "/PublicSurvey/GetSurveyResponse?";
        if (formResponseGuid === null)
            throw new globalThis.Error("The parameter 'formResponseGuid' cannot be null.");
        else if (formResponseGuid !== undefined)
            url_ += "formResponseGuid=" + encodeURIComponent("" + formResponseGuid) + "&";
        if (tenantName !== undefined && tenantName !== null)
            url_ += "tenantName=" + encodeURIComponent("" + tenantName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSurveyResponse(_response));
        });
    }

    protected processGetSurveyResponse(response: AxiosResponse): Promise<FormResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<FormResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FormResponse>(null as any);
    }

    getSurveyViewResource(formGuid: string | undefined, tenantName: string | null | undefined, cancelToken?: CancelToken): Promise<PublicSurveyViewResource> {
        let url_ = this.baseUrl + "/PublicSurvey/GetSurveyViewResource?";
        if (formGuid === null)
            throw new globalThis.Error("The parameter 'formGuid' cannot be null.");
        else if (formGuid !== undefined)
            url_ += "formGuid=" + encodeURIComponent("" + formGuid) + "&";
        if (tenantName !== undefined && tenantName !== null)
            url_ += "tenantName=" + encodeURIComponent("" + tenantName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSurveyViewResource(_response));
        });
    }

    protected processGetSurveyViewResource(response: AxiosResponse): Promise<PublicSurveyViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<PublicSurveyViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublicSurveyViewResource>(null as any);
    }

    saveFormResponse(formResponse: PublicSurveyResponseDto, tenantName: string | null | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/PublicSurvey/SaveFormResponse?";
        if (tenantName !== undefined && tenantName !== null)
            url_ += "tenantName=" + encodeURIComponent("" + tenantName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(formResponse);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveFormResponse(_response));
        });
    }

    protected processSaveFormResponse(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class SearchClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    developers(searchString: string | null | undefined, cancelToken?: CancelToken): Promise<Developer[]> {
        let url_ = this.baseUrl + "/Search/Developers?";
        if (searchString !== undefined && searchString !== null)
            url_ += "searchString=" + encodeURIComponent("" + searchString) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDevelopers(_response));
        });
    }

    protected processDevelopers(response: AxiosResponse): Promise<Developer[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<Developer[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Developer[]>(null as any);
    }

    students(searchString: string | null | undefined, cancelToken?: CancelToken): Promise<Student[]> {
        let url_ = this.baseUrl + "/Search/Students?";
        if (searchString !== undefined && searchString !== null)
            url_ += "searchString=" + encodeURIComponent("" + searchString) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processStudents(_response));
        });
    }

    protected processStudents(response: AxiosResponse): Promise<Student[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<Student[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Student[]>(null as any);
    }

    staff(searchString: string | null | undefined, cancelToken?: CancelToken): Promise<Staff[]> {
        let url_ = this.baseUrl + "/Search/Staffs?";
        if (searchString !== undefined && searchString !== null)
            url_ += "searchString=" + encodeURIComponent("" + searchString) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processStaff(_response));
        });
    }

    protected processStaff(response: AxiosResponse): Promise<Staff[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<Staff[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Staff[]>(null as any);
    }

    users(searchString: string | null | undefined, cancelToken?: CancelToken): Promise<User[]> {
        let url_ = this.baseUrl + "/Search/Users?";
        if (searchString !== undefined && searchString !== null)
            url_ += "searchString=" + encodeURIComponent("" + searchString) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUsers(_response));
        });
    }

    protected processUsers(response: AxiosResponse): Promise<User[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<User[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<User[]>(null as any);
    }

    providers(searchString: string | null | undefined, cancelToken?: CancelToken): Promise<Provider[]> {
        let url_ = this.baseUrl + "/Search/Providers?";
        if (searchString !== undefined && searchString !== null)
            url_ += "searchString=" + encodeURIComponent("" + searchString) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processProviders(_response));
        });
    }

    protected processProviders(response: AxiosResponse): Promise<Provider[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<Provider[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Provider[]>(null as any);
    }

    contributors(searchString: string | null | undefined, cancelToken?: CancelToken): Promise<Contributor[]> {
        let url_ = this.baseUrl + "/Search/Contributors?";
        if (searchString !== undefined && searchString !== null)
            url_ += "searchString=" + encodeURIComponent("" + searchString) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processContributors(_response));
        });
    }

    protected processContributors(response: AxiosResponse): Promise<Contributor[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<Contributor[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Contributor[]>(null as any);
    }

    colleges(searchString: string | null | undefined, cancelToken?: CancelToken): Promise<College[]> {
        let url_ = this.baseUrl + "/Search/Colleges?";
        if (searchString !== undefined && searchString !== null)
            url_ += "searchString=" + encodeURIComponent("" + searchString) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processColleges(_response));
        });
    }

    protected processColleges(response: AxiosResponse): Promise<College[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<College[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<College[]>(null as any);
    }

    classes(searchString: string | null | undefined, schoolId: number | null | undefined, cancelToken?: CancelToken): Promise<Class[]> {
        let url_ = this.baseUrl + "/Search/Classes?";
        if (searchString !== undefined && searchString !== null)
            url_ += "searchString=" + encodeURIComponent("" + searchString) + "&";
        if (schoolId !== undefined && schoolId !== null)
            url_ += "schoolId=" + encodeURIComponent("" + schoolId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processClasses(_response));
        });
    }

    protected processClasses(response: AxiosResponse): Promise<Class[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<Class[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Class[]>(null as any);
    }

    studentServiceNames(searchString: string | null | undefined, cancelToken?: CancelToken): Promise<StudentServiceName[]> {
        let url_ = this.baseUrl + "/Search/StudentServiceNames?";
        if (searchString !== undefined && searchString !== null)
            url_ += "searchString=" + encodeURIComponent("" + searchString) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processStudentServiceNames(_response));
        });
    }

    protected processStudentServiceNames(response: AxiosResponse): Promise<StudentServiceName[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentServiceName[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentServiceName[]>(null as any);
    }

    staffServiceNames(searchString: string | null | undefined, cancelToken?: CancelToken): Promise<StaffServiceName[]> {
        let url_ = this.baseUrl + "/Search/StaffServiceNames?";
        if (searchString !== undefined && searchString !== null)
            url_ += "searchString=" + encodeURIComponent("" + searchString) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processStaffServiceNames(_response));
        });
    }

    protected processStaffServiceNames(response: AxiosResponse): Promise<StaffServiceName[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StaffServiceName[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StaffServiceName[]>(null as any);
    }

    ipeds(searchString: string | null | undefined, cancelToken?: CancelToken): Promise<LkIpeds[]> {
        let url_ = this.baseUrl + "/Search/Ipeds?";
        if (searchString !== undefined && searchString !== null)
            url_ += "searchString=" + encodeURIComponent("" + searchString) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processIpeds(_response));
        });
    }

    protected processIpeds(response: AxiosResponse): Promise<LkIpeds[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<LkIpeds[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LkIpeds[]>(null as any);
    }
}

export class TextingConversationsClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getList(listFilter: TextingConversationListFilter, cancelToken?: CancelToken): Promise<TextingConversationListDto[]> {
        let url_ = this.baseUrl + "/TextingConversations/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetList(_response));
        });
    }

    protected processGetList(response: AxiosResponse): Promise<TextingConversationListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<TextingConversationListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TextingConversationListDto[]>(null as any);
    }

    getListTotal(listFilter: TextingConversationListFilter, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/TextingConversations/GetListTotal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListTotal(_response));
        });
    }

    protected processGetListTotal(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getCreateConversations(request: GetCreateTextingConversationsRequestDto, cancelToken?: CancelToken): Promise<GetCreateTextingConversationsResponseDto> {
        let url_ = this.baseUrl + "/TextingConversations/GetCreateConversations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetCreateConversations(_response));
        });
    }

    protected processGetCreateConversations(response: AxiosResponse): Promise<GetCreateTextingConversationsResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<GetCreateTextingConversationsResponseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCreateTextingConversationsResponseDto>(null as any);
    }

    getStudentPersons(studentIds: number[], cancelToken?: CancelToken): Promise<PersonDto[]> {
        let url_ = this.baseUrl + "/TextingConversations/GetStudentPersons";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(studentIds);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetStudentPersons(_response));
        });
    }

    protected processGetStudentPersons(response: AxiosResponse): Promise<PersonDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<PersonDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PersonDto[]>(null as any);
    }

    saveCreateConversationsOptIn(request: SaveCreateTextingOptInDto, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/TextingConversations/SaveCreateConversationsOptIn";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreateConversationsOptIn(_response));
        });
    }

    protected processSaveCreateConversationsOptIn(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveCreateConversations(request: SaveCreateTextingConversationsRequestDto, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/TextingConversations/SaveCreateConversations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreateConversations(_response));
        });
    }

    protected processSaveCreateConversations(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getTenantTextingInfo( cancelToken?: CancelToken): Promise<TenantInfo> {
        let url_ = this.baseUrl + "/TextingConversations/GetTenantTextingInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetTenantTextingInfo(_response));
        });
    }

    protected processGetTenantTextingInfo(response: AxiosResponse): Promise<TenantInfo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<TenantInfo>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TenantInfo>(null as any);
    }

    getOptedInStudentNumbers( cancelToken?: CancelToken): Promise<TextingOptInDto[]> {
        let url_ = this.baseUrl + "/TextingConversations/GetOptedInStudentNumbers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetOptedInStudentNumbers(_response));
        });
    }

    protected processGetOptedInStudentNumbers(response: AxiosResponse): Promise<TextingOptInDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<TextingOptInDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TextingOptInDto[]>(null as any);
    }

    getOptedInParentNumbers( cancelToken?: CancelToken): Promise<TextingOptInDto[]> {
        let url_ = this.baseUrl + "/TextingConversations/GetOptedInParentNumbers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetOptedInParentNumbers(_response));
        });
    }

    protected processGetOptedInParentNumbers(response: AxiosResponse): Promise<TextingOptInDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<TextingOptInDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TextingOptInDto[]>(null as any);
    }

    verifyCellPhone(phoneNumber: string | null | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/TextingConversations/VerifyCellPhone?";
        if (phoneNumber !== undefined && phoneNumber !== null)
            url_ += "phoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processVerifyCellPhone(_response));
        });
    }

    protected processVerifyCellPhone(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    get(id: number | undefined, cancelToken?: CancelToken): Promise<TextingConversation> {
        let url_ = this.baseUrl + "/TextingConversations/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<TextingConversation> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<TextingConversation>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TextingConversation>(null as any);
    }

    clearUnseenMessages(id: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/TextingConversations/ClearUnseenMessages?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processClearUnseenMessages(_response));
        });
    }

    protected processClearUnseenMessages(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getListResource( cancelToken?: CancelToken): Promise<TextingConversationListResource> {
        let url_ = this.baseUrl + "/TextingConversations/GetListResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListResource(_response));
        });
    }

    protected processGetListResource(response: AxiosResponse): Promise<TextingConversationListResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<TextingConversationListResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TextingConversationListResource>(null as any);
    }

    sendMessage(request: SendMessageRequestDto, cancelToken?: CancelToken): Promise<TextingMessage> {
        let url_ = this.baseUrl + "/TextingConversations/SendMessage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSendMessage(_response));
        });
    }

    protected processSendMessage(response: AxiosResponse): Promise<TextingMessage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<TextingMessage>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TextingMessage>(null as any);
    }

    receiveMessage( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/TextingConversations/ReceiveMessage";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processReceiveMessage(_response));
        });
    }

    protected processReceiveMessage(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class TextingOptInClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getByStudentId(studentId: number | undefined, cancelToken?: CancelToken): Promise<TextingOptIn> {
        let url_ = this.baseUrl + "/TextingOptIn/GetByStudentId?";
        if (studentId === null)
            throw new globalThis.Error("The parameter 'studentId' cannot be null.");
        else if (studentId !== undefined)
            url_ += "studentId=" + encodeURIComponent("" + studentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetByStudentId(_response));
        });
    }

    protected processGetByStudentId(response: AxiosResponse): Promise<TextingOptIn> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<TextingOptIn>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TextingOptIn>(null as any);
    }

    getByParentId(parentId: number | undefined, cancelToken?: CancelToken): Promise<TextingOptIn> {
        let url_ = this.baseUrl + "/TextingOptIn/GetByParentId?";
        if (parentId === null)
            throw new globalThis.Error("The parameter 'parentId' cannot be null.");
        else if (parentId !== undefined)
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetByParentId(_response));
        });
    }

    protected processGetByParentId(response: AxiosResponse): Promise<TextingOptIn> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<TextingOptIn>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TextingOptIn>(null as any);
    }

    getViewResource( cancelToken?: CancelToken): Promise<StudentTextingOptInViewResource> {
        let url_ = this.baseUrl + "/TextingOptIn/GetViewResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetViewResource(_response));
        });
    }

    protected processGetViewResource(response: AxiosResponse): Promise<StudentTextingOptInViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentTextingOptInViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentTextingOptInViewResource>(null as any);
    }

    getEditResource( cancelToken?: CancelToken): Promise<StudentTextingOptInEditResource> {
        let url_ = this.baseUrl + "/TextingOptIn/GetEditResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEditResource(_response));
        });
    }

    protected processGetEditResource(response: AxiosResponse): Promise<StudentTextingOptInEditResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentTextingOptInEditResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentTextingOptInEditResource>(null as any);
    }

    saveCreate(optInVm: TextingOptIn, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/TextingOptIn/SaveCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(optInVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreate(_response));
        });
    }

    protected processSaveCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveUpdate(optInVm: TextingOptIn, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/TextingOptIn/SaveUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(optInVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdate(_response));
        });
    }

    protected processSaveUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    delete(id: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/TextingOptIn/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class UserManualClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getUserManualSections( cancelToken?: CancelToken): Promise<UserManualSectionDto[]> {
        let url_ = this.baseUrl + "/UserManual/GetUserManualSections";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetUserManualSections(_response));
        });
    }

    protected processGetUserManualSections(response: AxiosResponse): Promise<UserManualSectionDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<UserManualSectionDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserManualSectionDto[]>(null as any);
    }

    getUserManualSubSection(subSectionId: number | undefined, cancelToken?: CancelToken): Promise<UserManualSubSectionDto> {
        let url_ = this.baseUrl + "/UserManual/GetUserManualSubSection?";
        if (subSectionId === null)
            throw new globalThis.Error("The parameter 'subSectionId' cannot be null.");
        else if (subSectionId !== undefined)
            url_ += "subSectionId=" + encodeURIComponent("" + subSectionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetUserManualSubSection(_response));
        });
    }

    protected processGetUserManualSubSection(response: AxiosResponse): Promise<UserManualSubSectionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<UserManualSubSectionDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserManualSubSectionDto>(null as any);
    }

    getUserManualSubSectionIdentifier(identifier: string | null | undefined, cancelToken?: CancelToken): Promise<UserManualSubSectionDto> {
        let url_ = this.baseUrl + "/UserManual/GetUserManualSubSectionIdentifier?";
        if (identifier !== undefined && identifier !== null)
            url_ += "identifier=" + encodeURIComponent("" + identifier) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetUserManualSubSectionIdentifier(_response));
        });
    }

    protected processGetUserManualSubSectionIdentifier(response: AxiosResponse): Promise<UserManualSubSectionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<UserManualSubSectionDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserManualSubSectionDto>(null as any);
    }
}

export class UsersClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getList(listFilter: UserListFilter, cancelToken?: CancelToken): Promise<UserListDto[]> {
        let url_ = this.baseUrl + "/Users/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetList(_response));
        });
    }

    protected processGetList(response: AxiosResponse): Promise<UserListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<UserListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserListDto[]>(null as any);
    }

    getListTotal(listFilter: UserListFilter, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Users/GetListTotal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListTotal(_response));
        });
    }

    protected processGetListTotal(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getListResource( cancelToken?: CancelToken): Promise<UserListResource> {
        let url_ = this.baseUrl + "/Users/GetListResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListResource(_response));
        });
    }

    protected processGetListResource(response: AxiosResponse): Promise<UserListResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<UserListResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserListResource>(null as any);
    }

    getFilterResource( cancelToken?: CancelToken): Promise<UserFilterResource> {
        let url_ = this.baseUrl + "/Users/GetFilterResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetFilterResource(_response));
        });
    }

    protected processGetFilterResource(response: AxiosResponse): Promise<UserFilterResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<UserFilterResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserFilterResource>(null as any);
    }

    get(id: number | undefined, cancelToken?: CancelToken): Promise<UserDto> {
        let url_ = this.baseUrl + "/Users/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<UserDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDto>(null as any);
    }

    getByUserMembership(userMembership: string | null | undefined, cancelToken?: CancelToken): Promise<UserDto> {
        let url_ = this.baseUrl + "/Users/GetByUserMembership?";
        if (userMembership !== undefined && userMembership !== null)
            url_ += "userMembership=" + encodeURIComponent("" + userMembership) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetByUserMembership(_response));
        });
    }

    protected processGetByUserMembership(response: AxiosResponse): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<UserDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDto>(null as any);
    }

    getViewResource( cancelToken?: CancelToken): Promise<UserViewResource> {
        let url_ = this.baseUrl + "/Users/GetViewResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetViewResource(_response));
        });
    }

    protected processGetViewResource(response: AxiosResponse): Promise<UserViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<UserViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserViewResource>(null as any);
    }

    getEditResource( cancelToken?: CancelToken): Promise<UserEditResource> {
        let url_ = this.baseUrl + "/Users/GetEditResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEditResource(_response));
        });
    }

    protected processGetEditResource(response: AxiosResponse): Promise<UserEditResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<UserEditResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserEditResource>(null as any);
    }

    saveCreate(userVm: User, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Users/SaveCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreate(_response));
        });
    }

    protected processSaveCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveUpdate(userVm: User, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/Users/SaveUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdate(_response));
        });
    }

    protected processSaveUpdate(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    saveUpdateSelf(userVm: User, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/Users/SaveUpdateSelf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdateSelf(_response));
        });
    }

    protected processSaveUpdateSelf(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    savePermissions(permissionIds: number[], userId: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Users/SavePermissions?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(permissionIds);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSavePermissions(_response));
        });
    }

    protected processSavePermissions(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    authenticateAsAnotherUser(id: number | undefined, cancelToken?: CancelToken): Promise<AuthResult> {
        let url_ = this.baseUrl + "/Users/AuthenticateAsAnotherUser?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processAuthenticateAsAnotherUser(_response));
        });
    }

    protected processAuthenticateAsAnotherUser(response: AxiosResponse): Promise<AuthResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<AuthResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthResult>(null as any);
    }

    sendInvitationEmail(id: number | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/Users/SendInvitationEmail?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSendInvitationEmail(_response));
        });
    }

    protected processSendInvitationEmail(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    delete(id: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Users/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    deactivate(id: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Users/Deactivate?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeactivate(_response));
        });
    }

    protected processDeactivate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    activate(id: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Users/Activate?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processActivate(_response));
        });
    }

    protected processActivate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getUserPermissions(userMembership: string | null | undefined, cancelToken?: CancelToken): Promise<AspNetUserPermission[]> {
        let url_ = this.baseUrl + "/Users/GetUserPermissions?";
        if (userMembership !== undefined && userMembership !== null)
            url_ += "userMembership=" + encodeURIComponent("" + userMembership) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetUserPermissions(_response));
        });
    }

    protected processGetUserPermissions(response: AxiosResponse): Promise<AspNetUserPermission[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<AspNetUserPermission[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AspNetUserPermission[]>(null as any);
    }

    getCentralUserTenants( cancelToken?: CancelToken): Promise<SimpleDto[]> {
        let url_ = this.baseUrl + "/Users/GetCentralUserTenants";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetCentralUserTenants(_response));
        });
    }

    protected processGetCentralUserTenants(response: AxiosResponse): Promise<SimpleDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SimpleDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SimpleDto[]>(null as any);
    }
}

export class UserSettingClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    saveNavPinned(navPinned: boolean | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/UserSetting/SaveNavPinned?";
        if (navPinned === null)
            throw new globalThis.Error("The parameter 'navPinned' cannot be null.");
        else if (navPinned !== undefined)
            url_ += "navPinned=" + encodeURIComponent("" + navPinned) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveNavPinned(_response));
        });
    }

    protected processSaveNavPinned(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    savePageSize(pageSize: number | null | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/UserSetting/SavePageSize?";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSavePageSize(_response));
        });
    }

    protected processSavePageSize(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveSortMethod(multiSort: boolean | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/UserSetting/SaveSortMethod?";
        if (multiSort === null)
            throw new globalThis.Error("The parameter 'multiSort' cannot be null.");
        else if (multiSort !== undefined)
            url_ += "multiSort=" + encodeURIComponent("" + multiSort) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveSortMethod(_response));
        });
    }

    protected processSaveSortMethod(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveMaxScreenWidth(maxScreenWidth: string | null | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/UserSetting/SaveMaxScreenWidth?";
        if (maxScreenWidth !== undefined && maxScreenWidth !== null)
            url_ += "maxScreenWidth=" + encodeURIComponent("" + maxScreenWidth) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveMaxScreenWidth(_response));
        });
    }

    protected processSaveMaxScreenWidth(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveImportAutoMapMode(importAutoMapMode: string | null | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/UserSetting/SaveImportAutoMapMode?";
        if (importAutoMapMode !== undefined && importAutoMapMode !== null)
            url_ += "importAutoMapMode=" + encodeURIComponent("" + importAutoMapMode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveImportAutoMapMode(_response));
        });
    }

    protected processSaveImportAutoMapMode(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveImportSimilarityPercent(importSimilarityPercent: number | null | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/UserSetting/SaveImportSimilarityPercent?";
        if (importSimilarityPercent !== undefined && importSimilarityPercent !== null)
            url_ += "importSimilarityPercent=" + encodeURIComponent("" + importSimilarityPercent) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveImportSimilarityPercent(_response));
        });
    }

    protected processSaveImportSimilarityPercent(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveBulkGridView(bulkGridView: boolean | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/UserSetting/SaveBulkGridView?";
        if (bulkGridView === null)
            throw new globalThis.Error("The parameter 'bulkGridView' cannot be null.");
        else if (bulkGridView !== undefined)
            url_ += "bulkGridView=" + encodeURIComponent("" + bulkGridView) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveBulkGridView(_response));
        });
    }

    protected processSaveBulkGridView(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class WalletPassClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    downloadWalletPass(token: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/WalletPass/DownloadWalletPass?";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDownloadWalletPass(_response));
        });
    }

    protected processDownloadWalletPass(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    emailWalletPass(studentId: number | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/WalletPass/EmailWalletPass?";
        if (studentId === null)
            throw new globalThis.Error("The parameter 'studentId' cannot be null.");
        else if (studentId !== undefined)
            url_ += "studentId=" + encodeURIComponent("" + studentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processEmailWalletPass(_response));
        });
    }

    protected processEmailWalletPass(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class DiplomaTypesClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getList(listFilter: DiplomaTypeListFilter, cancelToken?: CancelToken): Promise<DiplomaTypeListDto[]> {
        let url_ = this.baseUrl + "/DiplomaTypes/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetList(_response));
        });
    }

    protected processGetList(response: AxiosResponse): Promise<DiplomaTypeListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<DiplomaTypeListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiplomaTypeListDto[]>(null as any);
    }

    getListTotal(listFilter: DiplomaTypeListFilter, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/DiplomaTypes/GetListTotal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListTotal(_response));
        });
    }

    protected processGetListTotal(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getListResource( cancelToken?: CancelToken): Promise<DiplomaTypeListResource> {
        let url_ = this.baseUrl + "/DiplomaTypes/GetListResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListResource(_response));
        });
    }

    protected processGetListResource(response: AxiosResponse): Promise<DiplomaTypeListResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<DiplomaTypeListResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiplomaTypeListResource>(null as any);
    }

    getFilterResource( cancelToken?: CancelToken): Promise<DiplomaTypeFilterResource> {
        let url_ = this.baseUrl + "/DiplomaTypes/GetFilterResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetFilterResource(_response));
        });
    }

    protected processGetFilterResource(response: AxiosResponse): Promise<DiplomaTypeFilterResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<DiplomaTypeFilterResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiplomaTypeFilterResource>(null as any);
    }

    get(id: number, cancelToken?: CancelToken): Promise<DiplomaType> {
        let url_ = this.baseUrl + "/DiplomaTypes/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<DiplomaType> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<DiplomaType>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiplomaType>(null as any);
    }

    getViewResource( cancelToken?: CancelToken): Promise<DiplomaTypeViewResource> {
        let url_ = this.baseUrl + "/DiplomaTypes/GetViewResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetViewResource(_response));
        });
    }

    protected processGetViewResource(response: AxiosResponse): Promise<DiplomaTypeViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<DiplomaTypeViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiplomaTypeViewResource>(null as any);
    }

    getEditResource( cancelToken?: CancelToken): Promise<DiplomaTypeEditResource> {
        let url_ = this.baseUrl + "/DiplomaTypes/GetEditResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEditResource(_response));
        });
    }

    protected processGetEditResource(response: AxiosResponse): Promise<DiplomaTypeEditResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<DiplomaTypeEditResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiplomaTypeEditResource>(null as any);
    }

    saveCreate(diplomaTypeVm: DiplomaType, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/DiplomaTypes/SaveCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(diplomaTypeVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreate(_response));
        });
    }

    protected processSaveCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveUpdate(diplomaTypeVm: DiplomaType, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/DiplomaTypes/SaveUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(diplomaTypeVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdate(_response));
        });
    }

    protected processSaveUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    delete(id: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/DiplomaTypes/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class TopicsClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getList(listFilter: TopicListFilter, cancelToken?: CancelToken): Promise<DiplomaTypeListDto[]> {
        let url_ = this.baseUrl + "/Topics/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetList(_response));
        });
    }

    protected processGetList(response: AxiosResponse): Promise<DiplomaTypeListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<DiplomaTypeListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiplomaTypeListDto[]>(null as any);
    }

    getListTotal(listFilter: TopicListFilter, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Topics/GetListTotal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListTotal(_response));
        });
    }

    protected processGetListTotal(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getListResource( cancelToken?: CancelToken): Promise<DiplomaTypeListResource> {
        let url_ = this.baseUrl + "/Topics/GetListResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListResource(_response));
        });
    }

    protected processGetListResource(response: AxiosResponse): Promise<DiplomaTypeListResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<DiplomaTypeListResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiplomaTypeListResource>(null as any);
    }

    getFilterResource( cancelToken?: CancelToken): Promise<DiplomaTypeFilterResource> {
        let url_ = this.baseUrl + "/Topics/GetFilterResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetFilterResource(_response));
        });
    }

    protected processGetFilterResource(response: AxiosResponse): Promise<DiplomaTypeFilterResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<DiplomaTypeFilterResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiplomaTypeFilterResource>(null as any);
    }

    get(id: number, cancelToken?: CancelToken): Promise<Topic> {
        let url_ = this.baseUrl + "/Topics/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<Topic> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<Topic>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Topic>(null as any);
    }

    getViewResource( cancelToken?: CancelToken): Promise<DiplomaTypeViewResource> {
        let url_ = this.baseUrl + "/Topics/GetViewResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetViewResource(_response));
        });
    }

    protected processGetViewResource(response: AxiosResponse): Promise<DiplomaTypeViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<DiplomaTypeViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiplomaTypeViewResource>(null as any);
    }

    getEditResource( cancelToken?: CancelToken): Promise<DiplomaTypeEditResource> {
        let url_ = this.baseUrl + "/Topics/GetEditResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEditResource(_response));
        });
    }

    protected processGetEditResource(response: AxiosResponse): Promise<DiplomaTypeEditResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<DiplomaTypeEditResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiplomaTypeEditResource>(null as any);
    }

    saveCreate(topicVm: Topic, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Topics/SaveCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(topicVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreate(_response));
        });
    }

    protected processSaveCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveUpdate(topicVm: Topic, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Topics/SaveUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(topicVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdate(_response));
        });
    }

    protected processSaveUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    delete(id: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Topics/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class CohortsClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getAll( cancelToken?: CancelToken): Promise<CohortListDto[]> {
        let url_ = this.baseUrl + "/Cohorts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<CohortListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<CohortListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CohortListDto[]>(null as any);
    }

    getListResource( cancelToken?: CancelToken): Promise<CohortListResource> {
        let url_ = this.baseUrl + "/Cohorts/GetListResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListResource(_response));
        });
    }

    protected processGetListResource(response: AxiosResponse): Promise<CohortListResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<CohortListResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CohortListResource>(null as any);
    }

    getViewResource( cancelToken?: CancelToken): Promise<CohortViewResource> {
        let url_ = this.baseUrl + "/Cohorts/GetViewResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetViewResource(_response));
        });
    }

    protected processGetViewResource(response: AxiosResponse): Promise<CohortViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<CohortViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CohortViewResource>(null as any);
    }

    getEditResource( cancelToken?: CancelToken): Promise<CohortEditResource> {
        let url_ = this.baseUrl + "/Cohorts/GetEditResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEditResource(_response));
        });
    }

    protected processGetEditResource(response: AxiosResponse): Promise<CohortEditResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<CohortEditResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CohortEditResource>(null as any);
    }

    get(id: number, cancelToken?: CancelToken): Promise<Cohort> {
        let url_ = this.baseUrl + "/Cohorts/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<Cohort> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<Cohort>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Cohort>(null as any);
    }

    delete(id: number, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Cohorts/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    saveCreate(cohortVm: Cohort, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Cohorts/saveCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cohortVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreate(_response));
        });
    }

    protected processSaveCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveUpdate(cohortVm: Cohort, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Cohorts/saveUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cohortVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdate(_response));
        });
    }

    protected processSaveUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class IEPClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getAll( cancelToken?: CancelToken): Promise<IEPListDto[]> {
        let url_ = this.baseUrl + "/IEP";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<IEPListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<IEPListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IEPListDto[]>(null as any);
    }

    getListResource( cancelToken?: CancelToken): Promise<IEPListResource> {
        let url_ = this.baseUrl + "/IEP/GetListResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListResource(_response));
        });
    }

    protected processGetListResource(response: AxiosResponse): Promise<IEPListResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<IEPListResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IEPListResource>(null as any);
    }

    getViewResource( cancelToken?: CancelToken): Promise<IEPViewResource> {
        let url_ = this.baseUrl + "/IEP/GetViewResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetViewResource(_response));
        });
    }

    protected processGetViewResource(response: AxiosResponse): Promise<IEPViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<IEPViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IEPViewResource>(null as any);
    }

    getEditResource( cancelToken?: CancelToken): Promise<IEPEditResource> {
        let url_ = this.baseUrl + "/IEP/GetEditResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEditResource(_response));
        });
    }

    protected processGetEditResource(response: AxiosResponse): Promise<IEPEditResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<IEPEditResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IEPEditResource>(null as any);
    }

    get(id: number, cancelToken?: CancelToken): Promise<Iep> {
        let url_ = this.baseUrl + "/IEP/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<Iep> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<Iep>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Iep>(null as any);
    }

    delete(id: number, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/IEP/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    saveCreate(iepVm: Iep, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/IEP/saveCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(iepVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreate(_response));
        });
    }

    protected processSaveCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveUpdate(iepVm: Iep, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/IEP/saveUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(iepVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdate(_response));
        });
    }

    protected processSaveUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class LEPClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getAll( cancelToken?: CancelToken): Promise<LEPListDto[]> {
        let url_ = this.baseUrl + "/LEP";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<LEPListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<LEPListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LEPListDto[]>(null as any);
    }

    getListResource( cancelToken?: CancelToken): Promise<LEPListResource> {
        let url_ = this.baseUrl + "/LEP/GetListResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListResource(_response));
        });
    }

    protected processGetListResource(response: AxiosResponse): Promise<LEPListResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<LEPListResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LEPListResource>(null as any);
    }

    getViewResource( cancelToken?: CancelToken): Promise<LEPViewResource> {
        let url_ = this.baseUrl + "/LEP/GetViewResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetViewResource(_response));
        });
    }

    protected processGetViewResource(response: AxiosResponse): Promise<LEPViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<LEPViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LEPViewResource>(null as any);
    }

    getEditResource( cancelToken?: CancelToken): Promise<LEPEditResource> {
        let url_ = this.baseUrl + "/LEP/GetEditResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEditResource(_response));
        });
    }

    protected processGetEditResource(response: AxiosResponse): Promise<LEPEditResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<LEPEditResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LEPEditResource>(null as any);
    }

    get(id: number, cancelToken?: CancelToken): Promise<Lep> {
        let url_ = this.baseUrl + "/LEP/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<Lep> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<Lep>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Lep>(null as any);
    }

    delete(id: number, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/LEP/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    saveCreate(lepVm: Lep, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/LEP/saveCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(lepVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreate(_response));
        });
    }

    protected processSaveCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveUpdate(lepVm: Lep, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/LEP/saveUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(lepVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdate(_response));
        });
    }

    protected processSaveUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class PostHSPlanStatusClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getList( cancelToken?: CancelToken): Promise<SimpleDto[]> {
        let url_ = this.baseUrl + "/PostHSPlanStatus/GetList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetList(_response));
        });
    }

    protected processGetList(response: AxiosResponse): Promise<SimpleDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SimpleDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SimpleDto[]>(null as any);
    }

    getListResource( cancelToken?: CancelToken): Promise<PostHSPlanStatusListResource> {
        let url_ = this.baseUrl + "/PostHSPlanStatus/GetListResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListResource(_response));
        });
    }

    protected processGetListResource(response: AxiosResponse): Promise<PostHSPlanStatusListResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<PostHSPlanStatusListResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PostHSPlanStatusListResource>(null as any);
    }

    getViewResource( cancelToken?: CancelToken): Promise<PostHSPlanStatusViewResource> {
        let url_ = this.baseUrl + "/PostHSPlanStatus/GetViewResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetViewResource(_response));
        });
    }

    protected processGetViewResource(response: AxiosResponse): Promise<PostHSPlanStatusViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<PostHSPlanStatusViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PostHSPlanStatusViewResource>(null as any);
    }

    getEditResource( cancelToken?: CancelToken): Promise<PostHSPlanStatusEditResource> {
        let url_ = this.baseUrl + "/PostHSPlanStatus/GetEditResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEditResource(_response));
        });
    }

    protected processGetEditResource(response: AxiosResponse): Promise<PostHSPlanStatusEditResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<PostHSPlanStatusEditResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PostHSPlanStatusEditResource>(null as any);
    }

    get(id: number, cancelToken?: CancelToken): Promise<PostHighSchoolStatus> {
        let url_ = this.baseUrl + "/PostHSPlanStatus/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<PostHighSchoolStatus> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<PostHighSchoolStatus>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PostHighSchoolStatus>(null as any);
    }

    delete(id: number, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/PostHSPlanStatus/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    saveCreate(postHSPlanStatusVm: PostHighSchoolStatus, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/PostHSPlanStatus/saveCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(postHSPlanStatusVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreate(_response));
        });
    }

    protected processSaveCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveUpdate(postHSPlanStatusVm: PostHighSchoolStatus, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/PostHSPlanStatus/saveUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(postHSPlanStatusVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdate(_response));
        });
    }

    protected processSaveUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class RegionsClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getList(listFilter: ListFilterBase, cancelToken?: CancelToken): Promise<RegionListDto[]> {
        let url_ = this.baseUrl + "/Regions/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetList(_response));
        });
    }

    protected processGetList(response: AxiosResponse): Promise<RegionListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<RegionListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RegionListDto[]>(null as any);
    }

    getListTotal(listFilter: ListFilterBase, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Regions/GetListTotal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListTotal(_response));
        });
    }

    protected processGetListTotal(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getListResource( cancelToken?: CancelToken): Promise<RegionListResource> {
        let url_ = this.baseUrl + "/Regions/GetListResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListResource(_response));
        });
    }

    protected processGetListResource(response: AxiosResponse): Promise<RegionListResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<RegionListResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RegionListResource>(null as any);
    }

    get(id: number | undefined, cancelToken?: CancelToken): Promise<Region> {
        let url_ = this.baseUrl + "/Regions/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<Region> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<Region>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Region>(null as any);
    }

    getViewResource( cancelToken?: CancelToken): Promise<RegionViewResource> {
        let url_ = this.baseUrl + "/Regions/GetViewResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetViewResource(_response));
        });
    }

    protected processGetViewResource(response: AxiosResponse): Promise<RegionViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<RegionViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RegionViewResource>(null as any);
    }

    getEditResource( cancelToken?: CancelToken): Promise<RegionEditResource> {
        let url_ = this.baseUrl + "/Regions/GetEditResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEditResource(_response));
        });
    }

    protected processGetEditResource(response: AxiosResponse): Promise<RegionEditResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<RegionEditResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RegionEditResource>(null as any);
    }

    saveCreate(regionVm: Region, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Regions/SaveCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(regionVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreate(_response));
        });
    }

    protected processSaveCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveUpdate(regionVm: Region, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Regions/SaveUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(regionVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdate(_response));
        });
    }

    protected processSaveUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    delete(id: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Regions/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class ScholarshipPaymentMethodClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getAll( cancelToken?: CancelToken): Promise<ScholarshipPaymentMethodListDto[]> {
        let url_ = this.baseUrl + "/ScholarshipPaymentMethod/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<ScholarshipPaymentMethodListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ScholarshipPaymentMethodListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ScholarshipPaymentMethodListDto[]>(null as any);
    }

    getListResource( cancelToken?: CancelToken): Promise<ScholarshipPaymentMethodListResource> {
        let url_ = this.baseUrl + "/ScholarshipPaymentMethod/GetListResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListResource(_response));
        });
    }

    protected processGetListResource(response: AxiosResponse): Promise<ScholarshipPaymentMethodListResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ScholarshipPaymentMethodListResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ScholarshipPaymentMethodListResource>(null as any);
    }

    getViewResource( cancelToken?: CancelToken): Promise<ScholarshipPaymentMethodViewResource> {
        let url_ = this.baseUrl + "/ScholarshipPaymentMethod/GetViewResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetViewResource(_response));
        });
    }

    protected processGetViewResource(response: AxiosResponse): Promise<ScholarshipPaymentMethodViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ScholarshipPaymentMethodViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ScholarshipPaymentMethodViewResource>(null as any);
    }

    getEditResource( cancelToken?: CancelToken): Promise<ScholarshipPaymentMethodEditResource> {
        let url_ = this.baseUrl + "/ScholarshipPaymentMethod/GetEditResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEditResource(_response));
        });
    }

    protected processGetEditResource(response: AxiosResponse): Promise<ScholarshipPaymentMethodEditResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ScholarshipPaymentMethodEditResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ScholarshipPaymentMethodEditResource>(null as any);
    }

    get(id: number, cancelToken?: CancelToken): Promise<ScholarshipPaymentMethod> {
        let url_ = this.baseUrl + "/ScholarshipPaymentMethod/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<ScholarshipPaymentMethod> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ScholarshipPaymentMethod>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ScholarshipPaymentMethod>(null as any);
    }

    delete(id: number, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/ScholarshipPaymentMethod/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    saveCreate(scholarshipPaymentMethodVm: ScholarshipPaymentMethod, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/ScholarshipPaymentMethod/saveCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(scholarshipPaymentMethodVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreate(_response));
        });
    }

    protected processSaveCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveUpdate(scholarshipPaymentMethodVm: ScholarshipPaymentMethod, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/ScholarshipPaymentMethod/saveUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(scholarshipPaymentMethodVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdate(_response));
        });
    }

    protected processSaveUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class ScholarshipStatusClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    get_scholarshipStatusRepo( cancelToken?: CancelToken): Promise<IScholarshipStatusRepo> {
        let url_ = this.baseUrl + "/ScholarshipStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet_scholarshipStatusRepo(_response));
        });
    }

    protected processGet_scholarshipStatusRepo(response: AxiosResponse): Promise<IScholarshipStatusRepo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<IScholarshipStatusRepo>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IScholarshipStatusRepo>(null as any);
    }

    getAll( cancelToken?: CancelToken): Promise<ScholarshipStatusListDto[]> {
        let url_ = this.baseUrl + "/ScholarshipStatus/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<ScholarshipStatusListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ScholarshipStatusListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ScholarshipStatusListDto[]>(null as any);
    }

    getListResource( cancelToken?: CancelToken): Promise<ScholarshipStatusListResource> {
        let url_ = this.baseUrl + "/ScholarshipStatus/GetListResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListResource(_response));
        });
    }

    protected processGetListResource(response: AxiosResponse): Promise<ScholarshipStatusListResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ScholarshipStatusListResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ScholarshipStatusListResource>(null as any);
    }

    getViewResource( cancelToken?: CancelToken): Promise<ScholarshipStatusViewResource> {
        let url_ = this.baseUrl + "/ScholarshipStatus/GetViewResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetViewResource(_response));
        });
    }

    protected processGetViewResource(response: AxiosResponse): Promise<ScholarshipStatusViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ScholarshipStatusViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ScholarshipStatusViewResource>(null as any);
    }

    getEditResource( cancelToken?: CancelToken): Promise<ScholarshipStatusEditResource> {
        let url_ = this.baseUrl + "/ScholarshipStatus/GetEditResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEditResource(_response));
        });
    }

    protected processGetEditResource(response: AxiosResponse): Promise<ScholarshipStatusEditResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ScholarshipStatusEditResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ScholarshipStatusEditResource>(null as any);
    }

    get(id: number, cancelToken?: CancelToken): Promise<ScholarshipStatus> {
        let url_ = this.baseUrl + "/ScholarshipStatus/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<ScholarshipStatus> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ScholarshipStatus>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ScholarshipStatus>(null as any);
    }

    delete(id: number, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/ScholarshipStatus/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    saveCreate(scholarshipStatusVm: ScholarshipStatus, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/ScholarshipStatus/saveCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(scholarshipStatusVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreate(_response));
        });
    }

    protected processSaveCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveUpdate(scholarshipStatusVm: ScholarshipStatus, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/ScholarshipStatus/saveUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(scholarshipStatusVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdate(_response));
        });
    }

    protected processSaveUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class ScholarshipTypesClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getAll( cancelToken?: CancelToken): Promise<ScholarshipTypeListDto[]> {
        let url_ = this.baseUrl + "/ScholarshipTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<ScholarshipTypeListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ScholarshipTypeListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ScholarshipTypeListDto[]>(null as any);
    }

    getListResource( cancelToken?: CancelToken): Promise<ScholarshipTypeListResource> {
        let url_ = this.baseUrl + "/ScholarshipTypes/GetListResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListResource(_response));
        });
    }

    protected processGetListResource(response: AxiosResponse): Promise<ScholarshipTypeListResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ScholarshipTypeListResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ScholarshipTypeListResource>(null as any);
    }

    getViewResource( cancelToken?: CancelToken): Promise<ScholarshipTypeViewResource> {
        let url_ = this.baseUrl + "/ScholarshipTypes/GetViewResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetViewResource(_response));
        });
    }

    protected processGetViewResource(response: AxiosResponse): Promise<ScholarshipTypeViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ScholarshipTypeViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ScholarshipTypeViewResource>(null as any);
    }

    getEditResource( cancelToken?: CancelToken): Promise<ScholarshipTypeEditResource> {
        let url_ = this.baseUrl + "/ScholarshipTypes/GetEditResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEditResource(_response));
        });
    }

    protected processGetEditResource(response: AxiosResponse): Promise<ScholarshipTypeEditResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ScholarshipTypeEditResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ScholarshipTypeEditResource>(null as any);
    }

    get(id: number, cancelToken?: CancelToken): Promise<ScholarshipType> {
        let url_ = this.baseUrl + "/ScholarshipTypes/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<ScholarshipType> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ScholarshipType>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ScholarshipType>(null as any);
    }

    delete(id: number, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/ScholarshipTypes/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    saveCreate(scholarshipTypeVm: ScholarshipType, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/ScholarshipTypes/saveCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(scholarshipTypeVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreate(_response));
        });
    }

    protected processSaveCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveUpdate(scholarshipTypeVm: ScholarshipType, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/ScholarshipTypes/saveUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(scholarshipTypeVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdate(_response));
        });
    }

    protected processSaveUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class StaffPositionsClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getList(filter: StaffPositionFilter, cancelToken?: CancelToken): Promise<StaffPositionListDto[]> {
        let url_ = this.baseUrl + "/StaffPositions/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetList(_response));
        });
    }

    protected processGetList(response: AxiosResponse): Promise<StaffPositionListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StaffPositionListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StaffPositionListDto[]>(null as any);
    }

    getListTotal(filter: StaffPositionFilter, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StaffPositions/GetListTotal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListTotal(_response));
        });
    }

    protected processGetListTotal(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getListResource( cancelToken?: CancelToken): Promise<StaffPositionListResource> {
        let url_ = this.baseUrl + "/StaffPositions/GetListResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListResource(_response));
        });
    }

    protected processGetListResource(response: AxiosResponse): Promise<StaffPositionListResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StaffPositionListResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StaffPositionListResource>(null as any);
    }

    get(id: number, cancelToken?: CancelToken): Promise<StaffPosition> {
        let url_ = this.baseUrl + "/StaffPositions/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<StaffPosition> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StaffPosition>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StaffPosition>(null as any);
    }

    delete(id: number, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/StaffPositions/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getViewResource( cancelToken?: CancelToken): Promise<StaffPositionViewResource> {
        let url_ = this.baseUrl + "/StaffPositions/GetViewResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetViewResource(_response));
        });
    }

    protected processGetViewResource(response: AxiosResponse): Promise<StaffPositionViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StaffPositionViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StaffPositionViewResource>(null as any);
    }

    saveCreate(staffPositionVm: StaffPosition, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StaffPositions/SaveCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(staffPositionVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreate(_response));
        });
    }

    protected processSaveCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveUpdate(staffPositionVm: StaffPosition, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StaffPositions/SaveUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(staffPositionVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdate(_response));
        });
    }

    protected processSaveUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class CustomDataModelFieldsClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getList(dataModelTypeId: number | undefined, cancelToken?: CancelToken): Promise<CustomDataModelField[]> {
        let url_ = this.baseUrl + "/CustomDataModelFields/GetList?";
        if (dataModelTypeId === null)
            throw new globalThis.Error("The parameter 'dataModelTypeId' cannot be null.");
        else if (dataModelTypeId !== undefined)
            url_ += "dataModelTypeId=" + encodeURIComponent("" + dataModelTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetList(_response));
        });
    }

    protected processGetList(response: AxiosResponse): Promise<CustomDataModelField[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<CustomDataModelField[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomDataModelField[]>(null as any);
    }

    getListResource( cancelToken?: CancelToken): Promise<CustomDataModelFieldListResource> {
        let url_ = this.baseUrl + "/CustomDataModelFields/GetListResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListResource(_response));
        });
    }

    protected processGetListResource(response: AxiosResponse): Promise<CustomDataModelFieldListResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<CustomDataModelFieldListResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomDataModelFieldListResource>(null as any);
    }

    get(id: number | undefined, cancelToken?: CancelToken): Promise<CustomDataModelField> {
        let url_ = this.baseUrl + "/CustomDataModelFields/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<CustomDataModelField> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<CustomDataModelField>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomDataModelField>(null as any);
    }

    getViewResource( cancelToken?: CancelToken): Promise<CustomDataModelFieldViewResource> {
        let url_ = this.baseUrl + "/CustomDataModelFields/GetViewResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetViewResource(_response));
        });
    }

    protected processGetViewResource(response: AxiosResponse): Promise<CustomDataModelFieldViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<CustomDataModelFieldViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomDataModelFieldViewResource>(null as any);
    }

    saveUpdate(customDataModelFieldVm: CustomDataModelField, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/CustomDataModelFields/SaveUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(customDataModelFieldVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdate(_response));
        });
    }

    protected processSaveUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    assignDisplayOrders(dataModelTypeId: number | undefined, ids: number[], cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/CustomDataModelFields/AssignDisplayOrders?";
        if (dataModelTypeId === null)
            throw new globalThis.Error("The parameter 'dataModelTypeId' cannot be null.");
        else if (dataModelTypeId !== undefined)
            url_ += "dataModelTypeId=" + encodeURIComponent("" + dataModelTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processAssignDisplayOrders(_response));
        });
    }

    protected processAssignDisplayOrders(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class CustomDataModelFieldSelectListItemsClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getListResource( cancelToken?: CancelToken): Promise<CustomDataModelFieldSelectListItemListResource> {
        let url_ = this.baseUrl + "/CustomDataModelFieldSelectListItems/GetListResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListResource(_response));
        });
    }

    protected processGetListResource(response: AxiosResponse): Promise<CustomDataModelFieldSelectListItemListResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<CustomDataModelFieldSelectListItemListResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomDataModelFieldSelectListItemListResource>(null as any);
    }

    get(id: number | undefined, cancelToken?: CancelToken): Promise<CustomDataModelFieldSelectListItem> {
        let url_ = this.baseUrl + "/CustomDataModelFieldSelectListItems/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<CustomDataModelFieldSelectListItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<CustomDataModelFieldSelectListItem>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomDataModelFieldSelectListItem>(null as any);
    }

    getViewResource( cancelToken?: CancelToken): Promise<CustomDataModelFieldSelectListItemViewResource> {
        let url_ = this.baseUrl + "/CustomDataModelFieldSelectListItems/GetViewResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetViewResource(_response));
        });
    }

    protected processGetViewResource(response: AxiosResponse): Promise<CustomDataModelFieldSelectListItemViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<CustomDataModelFieldSelectListItemViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomDataModelFieldSelectListItemViewResource>(null as any);
    }

    saveCreate(customDataModelFieldSelectListItemVm: CustomDataModelFieldSelectListItem, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/CustomDataModelFieldSelectListItems/SaveCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(customDataModelFieldSelectListItemVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreate(_response));
        });
    }

    protected processSaveCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveUpdate(customDataModelFieldSelectListItemVm: CustomDataModelFieldSelectListItem, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/CustomDataModelFieldSelectListItems/SaveUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(customDataModelFieldSelectListItemVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdate(_response));
        });
    }

    protected processSaveUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    delete(id: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/CustomDataModelFieldSelectListItems/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    autoAssignAllDisplayOrders(fieldId: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/CustomDataModelFieldSelectListItems/AutoAssignAllDisplayOrders?";
        if (fieldId === null)
            throw new globalThis.Error("The parameter 'fieldId' cannot be null.");
        else if (fieldId !== undefined)
            url_ += "fieldId=" + encodeURIComponent("" + fieldId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processAutoAssignAllDisplayOrders(_response));
        });
    }

    protected processAutoAssignAllDisplayOrders(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    clearAssignAllDisplayOrders(fieldId: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/CustomDataModelFieldSelectListItems/ClearAssignAllDisplayOrders?";
        if (fieldId === null)
            throw new globalThis.Error("The parameter 'fieldId' cannot be null.");
        else if (fieldId !== undefined)
            url_ += "fieldId=" + encodeURIComponent("" + fieldId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processClearAssignAllDisplayOrders(_response));
        });
    }

    protected processClearAssignAllDisplayOrders(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    assignDisplayOrders(customDataModelFieldId: number | undefined, ids: number[], cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/CustomDataModelFieldSelectListItems/AssignDisplayOrders?";
        if (customDataModelFieldId === null)
            throw new globalThis.Error("The parameter 'customDataModelFieldId' cannot be null.");
        else if (customDataModelFieldId !== undefined)
            url_ += "customDataModelFieldId=" + encodeURIComponent("" + customDataModelFieldId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processAssignDisplayOrders(_response));
        });
    }

    protected processAssignDisplayOrders(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class StaffServicesClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    initListFilter( cancelToken?: CancelToken): Promise<StaffServiceListFilter> {
        let url_ = this.baseUrl + "/StaffServices/InitListFilter";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processInitListFilter(_response));
        });
    }

    protected processInitListFilter(response: AxiosResponse): Promise<StaffServiceListFilter> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StaffServiceListFilter>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StaffServiceListFilter>(null as any);
    }

    getList(listFilter: StaffServiceListFilter, cancelToken?: CancelToken): Promise<StaffServiceListDto[]> {
        let url_ = this.baseUrl + "/StaffServices/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetList(_response));
        });
    }

    protected processGetList(response: AxiosResponse): Promise<StaffServiceListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StaffServiceListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StaffServiceListDto[]>(null as any);
    }

    getListTotal(listFilter: StaffServiceListFilter, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StaffServices/GetListTotal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListTotal(_response));
        });
    }

    protected processGetListTotal(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getIds(listFilter: StaffServiceListFilter, cancelToken?: CancelToken): Promise<number[]> {
        let url_ = this.baseUrl + "/StaffServices/GetIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetIds(_response));
        });
    }

    protected processGetIds(response: AxiosResponse): Promise<number[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number[]>(null as any);
    }

    getListResource( cancelToken?: CancelToken): Promise<StaffServiceListResource> {
        let url_ = this.baseUrl + "/StaffServices/GetListResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListResource(_response));
        });
    }

    protected processGetListResource(response: AxiosResponse): Promise<StaffServiceListResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StaffServiceListResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StaffServiceListResource>(null as any);
    }

    getFilterResource( cancelToken?: CancelToken): Promise<StaffServiceFilterResource> {
        let url_ = this.baseUrl + "/StaffServices/GetFilterResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetFilterResource(_response));
        });
    }

    protected processGetFilterResource(response: AxiosResponse): Promise<StaffServiceFilterResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StaffServiceFilterResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StaffServiceFilterResource>(null as any);
    }

    get(id: number | undefined, cancelToken?: CancelToken): Promise<StaffService> {
        let url_ = this.baseUrl + "/StaffServices/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<StaffService> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StaffService>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StaffService>(null as any);
    }

    getViewResource( cancelToken?: CancelToken): Promise<StaffServiceViewResource> {
        let url_ = this.baseUrl + "/StaffServices/GetViewResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetViewResource(_response));
        });
    }

    protected processGetViewResource(response: AxiosResponse): Promise<StaffServiceViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StaffServiceViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StaffServiceViewResource>(null as any);
    }

    getEditResource( cancelToken?: CancelToken): Promise<StaffServiceEditResource> {
        let url_ = this.baseUrl + "/StaffServices/GetEditResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEditResource(_response));
        });
    }

    protected processGetEditResource(response: AxiosResponse): Promise<StaffServiceEditResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StaffServiceEditResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StaffServiceEditResource>(null as any);
    }

    saveCreate(serviceVm: StaffService, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StaffServices/SaveCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(serviceVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreate(_response));
        });
    }

    protected processSaveCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveUpdate(serviceVm: StaffService, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StaffServices/SaveUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(serviceVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdate(_response));
        });
    }

    protected processSaveUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    delete(id: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StaffServices/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getBulkUpdate(ids: number[], cancelToken?: CancelToken): Promise<StaffServiceBulkUpdate> {
        let url_ = this.baseUrl + "/StaffServices/GetBulkUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetBulkUpdate(_response));
        });
    }

    protected processGetBulkUpdate(response: AxiosResponse): Promise<StaffServiceBulkUpdate> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StaffServiceBulkUpdate>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StaffServiceBulkUpdate>(null as any);
    }

    getBulkUpdateResource( cancelToken?: CancelToken): Promise<StaffServiceBulkUpdateResource> {
        let url_ = this.baseUrl + "/StaffServices/GetBulkUpdateResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetBulkUpdateResource(_response));
        });
    }

    protected processGetBulkUpdateResource(response: AxiosResponse): Promise<StaffServiceBulkUpdateResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StaffServiceBulkUpdateResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StaffServiceBulkUpdateResource>(null as any);
    }

    saveBulkUpdate(bulkUpdate: StaffServiceBulkUpdate, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StaffServices/SaveBulkUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bulkUpdate);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveBulkUpdate(_response));
        });
    }

    protected processSaveBulkUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getStaffSchools(staffId: number | undefined, cancelToken?: CancelToken): Promise<School[]> {
        let url_ = this.baseUrl + "/StaffServices/GetStaffSchools?";
        if (staffId === null)
            throw new globalThis.Error("The parameter 'staffId' cannot be null.");
        else if (staffId !== undefined)
            url_ += "staffId=" + encodeURIComponent("" + staffId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetStaffSchools(_response));
        });
    }

    protected processGetStaffSchools(response: AxiosResponse): Promise<School[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<School[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<School[]>(null as any);
    }

    getStaffName(staffId: number | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/StaffServices/GetStaffName?";
        if (staffId === null)
            throw new globalThis.Error("The parameter 'staffId' cannot be null.");
        else if (staffId !== undefined)
            url_ += "staffId=" + encodeURIComponent("" + staffId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetStaffName(_response));
        });
    }

    protected processGetStaffName(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    duplicate(id: number | undefined, cancelToken?: CancelToken): Promise<StaffService> {
        let url_ = this.baseUrl + "/StaffServices/Duplicate?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDuplicate(_response));
        });
    }

    protected processDuplicate(response: AxiosResponse): Promise<StaffService> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StaffService>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StaffService>(null as any);
    }
}

export class StudentServicesClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    initListFilter( cancelToken?: CancelToken): Promise<StudentServiceListFilter> {
        let url_ = this.baseUrl + "/StudentServices/InitListFilter";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processInitListFilter(_response));
        });
    }

    protected processInitListFilter(response: AxiosResponse): Promise<StudentServiceListFilter> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentServiceListFilter>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentServiceListFilter>(null as any);
    }

    getList(listFilter: StudentServiceListFilter, cancelToken?: CancelToken): Promise<StudentServiceListDto[]> {
        let url_ = this.baseUrl + "/StudentServices/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetList(_response));
        });
    }

    protected processGetList(response: AxiosResponse): Promise<StudentServiceListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentServiceListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentServiceListDto[]>(null as any);
    }

    getListTotal(listFilter: StudentServiceListFilter, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentServices/GetListTotal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListTotal(_response));
        });
    }

    protected processGetListTotal(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getIds(listFilter: StudentServiceListFilter, cancelToken?: CancelToken): Promise<number[]> {
        let url_ = this.baseUrl + "/StudentServices/GetIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetIds(_response));
        });
    }

    protected processGetIds(response: AxiosResponse): Promise<number[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number[]>(null as any);
    }

    getListResource( cancelToken?: CancelToken): Promise<StudentServiceListResource> {
        let url_ = this.baseUrl + "/StudentServices/GetListResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListResource(_response));
        });
    }

    protected processGetListResource(response: AxiosResponse): Promise<StudentServiceListResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentServiceListResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentServiceListResource>(null as any);
    }

    getStudentServiceFiles(studentServiceId: number | undefined, cancelToken?: CancelToken): Promise<StudentServiceFile[]> {
        let url_ = this.baseUrl + "/StudentServices/GetStudentServiceFiles?";
        if (studentServiceId === null)
            throw new globalThis.Error("The parameter 'studentServiceId' cannot be null.");
        else if (studentServiceId !== undefined)
            url_ += "studentServiceId=" + encodeURIComponent("" + studentServiceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetStudentServiceFiles(_response));
        });
    }

    protected processGetStudentServiceFiles(response: AxiosResponse): Promise<StudentServiceFile[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentServiceFile[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentServiceFile[]>(null as any);
    }

    getStudentServiceFile(studentServiceFileId: number | undefined, cancelToken?: CancelToken): Promise<StudentServiceFile> {
        let url_ = this.baseUrl + "/StudentServices/GetStudentServiceFile?";
        if (studentServiceFileId === null)
            throw new globalThis.Error("The parameter 'studentServiceFileId' cannot be null.");
        else if (studentServiceFileId !== undefined)
            url_ += "studentServiceFileId=" + encodeURIComponent("" + studentServiceFileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetStudentServiceFile(_response));
        });
    }

    protected processGetStudentServiceFile(response: AxiosResponse): Promise<StudentServiceFile> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentServiceFile>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentServiceFile>(null as any);
    }

    saveCreateStudentFile(fileVm: StudentServiceFile, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentServices/SaveCreateStudentFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(fileVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreateStudentFile(_response));
        });
    }

    protected processSaveCreateStudentFile(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveUpdateStudentFile(fileVm: StudentServiceFile, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentServices/SaveUpdateStudentFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(fileVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdateStudentFile(_response));
        });
    }

    protected processSaveUpdateStudentFile(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getFilterResource( cancelToken?: CancelToken): Promise<StudentServiceFilterResource> {
        let url_ = this.baseUrl + "/StudentServices/GetFilterResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetFilterResource(_response));
        });
    }

    protected processGetFilterResource(response: AxiosResponse): Promise<StudentServiceFilterResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentServiceFilterResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentServiceFilterResource>(null as any);
    }

    get(id: number | undefined, cancelToken?: CancelToken): Promise<StudentService> {
        let url_ = this.baseUrl + "/StudentServices/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<StudentService> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentService>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentService>(null as any);
    }

    duplicate(id: number | undefined, cancelToken?: CancelToken): Promise<StudentService> {
        let url_ = this.baseUrl + "/StudentServices/Duplicate?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDuplicate(_response));
        });
    }

    protected processDuplicate(response: AxiosResponse): Promise<StudentService> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentService>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentService>(null as any);
    }

    getViewResource( cancelToken?: CancelToken): Promise<StudentServiceViewResource> {
        let url_ = this.baseUrl + "/StudentServices/GetViewResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetViewResource(_response));
        });
    }

    protected processGetViewResource(response: AxiosResponse): Promise<StudentServiceViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentServiceViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentServiceViewResource>(null as any);
    }

    getEditResource( cancelToken?: CancelToken): Promise<StudentServiceEditResource> {
        let url_ = this.baseUrl + "/StudentServices/GetEditResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEditResource(_response));
        });
    }

    protected processGetEditResource(response: AxiosResponse): Promise<StudentServiceEditResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentServiceEditResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentServiceEditResource>(null as any);
    }

    saveCreate(serviceVm: StudentService, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentServices/SaveCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(serviceVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreate(_response));
        });
    }

    protected processSaveCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveCreateAdditionalEntries(createBulkVm: StudentServiceCreateBulk, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentServices/SaveCreateAdditionalEntries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createBulkVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreateAdditionalEntries(_response));
        });
    }

    protected processSaveCreateAdditionalEntries(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveUpdate(serviceVm: StudentService, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentServices/SaveUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(serviceVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdate(_response));
        });
    }

    protected processSaveUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    sendUnallowableEmail(studentId: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentServices/SendUnallowableEmail?";
        if (studentId === null)
            throw new globalThis.Error("The parameter 'studentId' cannot be null.");
        else if (studentId !== undefined)
            url_ += "studentId=" + encodeURIComponent("" + studentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSendUnallowableEmail(_response));
        });
    }

    protected processSendUnallowableEmail(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    toggleLock(id: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentServices/ToggleLock?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processToggleLock(_response));
        });
    }

    protected processToggleLock(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    delete(id: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentServices/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getBulkUpdate(ids: number[], cancelToken?: CancelToken): Promise<StudentServiceBulkUpdate> {
        let url_ = this.baseUrl + "/StudentServices/GetBulkUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetBulkUpdate(_response));
        });
    }

    protected processGetBulkUpdate(response: AxiosResponse): Promise<StudentServiceBulkUpdate> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentServiceBulkUpdate>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentServiceBulkUpdate>(null as any);
    }

    getBulkUpdateResource( cancelToken?: CancelToken): Promise<StudentServiceBulkUpdateResource> {
        let url_ = this.baseUrl + "/StudentServices/GetBulkUpdateResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetBulkUpdateResource(_response));
        });
    }

    protected processGetBulkUpdateResource(response: AxiosResponse): Promise<StudentServiceBulkUpdateResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentServiceBulkUpdateResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentServiceBulkUpdateResource>(null as any);
    }

    saveBulkUpdate(bulkUpdate: StudentServiceBulkUpdate, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentServices/SaveBulkUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bulkUpdate);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveBulkUpdate(_response));
        });
    }

    protected processSaveBulkUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    postBulkDelete(ids: number[], cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentServices/PostBulkDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPostBulkDelete(_response));
        });
    }

    protected processPostBulkDelete(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    postBulkUnlock(ids: number[], cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentServices/PostBulkUnlock";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPostBulkUnlock(_response));
        });
    }

    protected processPostBulkUnlock(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    postBulkLock(ids: number[], cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentServices/PostBulkLock";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPostBulkLock(_response));
        });
    }

    protected processPostBulkLock(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getStudentSchools(studentId: number | undefined, cancelToken?: CancelToken): Promise<School[]> {
        let url_ = this.baseUrl + "/StudentServices/GetStudentSchools?";
        if (studentId === null)
            throw new globalThis.Error("The parameter 'studentId' cannot be null.");
        else if (studentId !== undefined)
            url_ += "studentId=" + encodeURIComponent("" + studentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetStudentSchools(_response));
        });
    }

    protected processGetStudentSchools(response: AxiosResponse): Promise<School[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<School[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<School[]>(null as any);
    }

    getStudentName(studentId: number | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/StudentServices/GetStudentName?";
        if (studentId === null)
            throw new globalThis.Error("The parameter 'studentId' cannot be null.");
        else if (studentId !== undefined)
            url_ += "studentId=" + encodeURIComponent("" + studentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetStudentName(_response));
        });
    }

    protected processGetStudentName(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class StaffClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getList(listFilter: StaffListFilter, cancelToken?: CancelToken): Promise<StaffListDto[]> {
        let url_ = this.baseUrl + "/Staff/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetList(_response));
        });
    }

    protected processGetList(response: AxiosResponse): Promise<StaffListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StaffListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StaffListDto[]>(null as any);
    }

    getListTotal(listFilter: StaffListFilter, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Staff/GetListTotal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListTotal(_response));
        });
    }

    protected processGetListTotal(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getIds(listFilter: StaffListFilter, cancelToken?: CancelToken): Promise<number[]> {
        let url_ = this.baseUrl + "/Staff/GetIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetIds(_response));
        });
    }

    protected processGetIds(response: AxiosResponse): Promise<number[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number[]>(null as any);
    }

    getListResource( cancelToken?: CancelToken): Promise<StaffListResource> {
        let url_ = this.baseUrl + "/Staff/GetListResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListResource(_response));
        });
    }

    protected processGetListResource(response: AxiosResponse): Promise<StaffListResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StaffListResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StaffListResource>(null as any);
    }

    getFilterResource( cancelToken?: CancelToken): Promise<StaffFilterResource> {
        let url_ = this.baseUrl + "/Staff/GetFilterResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetFilterResource(_response));
        });
    }

    protected processGetFilterResource(response: AxiosResponse): Promise<StaffFilterResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StaffFilterResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StaffFilterResource>(null as any);
    }

    get(id: number | undefined, cancelToken?: CancelToken): Promise<Staff> {
        let url_ = this.baseUrl + "/Staff/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<Staff> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<Staff>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Staff>(null as any);
    }

    getViewResource(id: number | undefined, cancelToken?: CancelToken): Promise<StaffViewResource> {
        let url_ = this.baseUrl + "/Staff/GetViewResource?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetViewResource(_response));
        });
    }

    protected processGetViewResource(response: AxiosResponse): Promise<StaffViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StaffViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StaffViewResource>(null as any);
    }

    getEditResource( cancelToken?: CancelToken): Promise<StaffEditResource> {
        let url_ = this.baseUrl + "/Staff/GetEditResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEditResource(_response));
        });
    }

    protected processGetEditResource(response: AxiosResponse): Promise<StaffEditResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StaffEditResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StaffEditResource>(null as any);
    }

    saveCreate(staffVm: Staff, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Staff/SaveCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(staffVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreate(_response));
        });
    }

    protected processSaveCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveUpdate(staffVm: Staff, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Staff/SaveUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(staffVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdate(_response));
        });
    }

    protected processSaveUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    delete(id: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Staff/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getBulkCreateServices(ids: number[], cancelToken?: CancelToken): Promise<StaffBulkCreateServices> {
        let url_ = this.baseUrl + "/Staff/GetBulkCreateServices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetBulkCreateServices(_response));
        });
    }

    protected processGetBulkCreateServices(response: AxiosResponse): Promise<StaffBulkCreateServices> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StaffBulkCreateServices>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StaffBulkCreateServices>(null as any);
    }

    getBulkCreateServicesResource( cancelToken?: CancelToken): Promise<StaffBulkCreateServicesResource> {
        let url_ = this.baseUrl + "/Staff/GetBulkCreateServicesResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetBulkCreateServicesResource(_response));
        });
    }

    protected processGetBulkCreateServicesResource(response: AxiosResponse): Promise<StaffBulkCreateServicesResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StaffBulkCreateServicesResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StaffBulkCreateServicesResource>(null as any);
    }

    saveBulkCreateServices(bulkCreateServices: StaffBulkCreateServices, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Staff/SaveBulkCreateServices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bulkCreateServices);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveBulkCreateServices(_response));
        });
    }

    protected processSaveBulkCreateServices(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class TestsClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    test( cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Tests/Test";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processTest(_response));
        });
    }

    protected processTest(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getStudentNestedModelProperties( cancelToken?: CancelToken): Promise<ModelPropertyBase[]> {
        let url_ = this.baseUrl + "/Tests/GetStudentNestedModelProperties";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetStudentNestedModelProperties(_response));
        });
    }

    protected processGetStudentNestedModelProperties(response: AxiosResponse): Promise<ModelPropertyBase[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ModelPropertyBase[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ModelPropertyBase[]>(null as any);
    }

    testRepositories( cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Tests/TestRepositories";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processTestRepositories(_response));
        });
    }

    protected processTestRepositories(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class StudentReportsClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getEventTrackingRequest( cancelToken?: CancelToken): Promise<StudentReportEventTrackingRequest> {
        let url_ = this.baseUrl + "/StudentReports/GetEventTrackingRequest";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEventTrackingRequest(_response));
        });
    }

    protected processGetEventTrackingRequest(response: AxiosResponse): Promise<StudentReportEventTrackingRequest> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentReportEventTrackingRequest>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentReportEventTrackingRequest>(null as any);
    }

    getEventTrackingResource( cancelToken?: CancelToken): Promise<StudentReportEventTrackingResource> {
        let url_ = this.baseUrl + "/StudentReports/GetEventTrackingResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEventTrackingResource(_response));
        });
    }

    protected processGetEventTrackingResource(response: AxiosResponse): Promise<StudentReportEventTrackingResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentReportEventTrackingResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentReportEventTrackingResource>(null as any);
    }

    generateEventTracking(req: StudentReportEventTrackingRequest, cancelToken?: CancelToken): Promise<StudentReportEventTrackingResponse> {
        let url_ = this.baseUrl + "/StudentReports/GenerateEventTracking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGenerateEventTracking(_response));
        });
    }

    protected processGenerateEventTracking(response: AxiosResponse): Promise<StudentReportEventTrackingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentReportEventTrackingResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentReportEventTrackingResponse>(null as any);
    }

    getNscRequest( cancelToken?: CancelToken): Promise<StudentReportNscRequest> {
        let url_ = this.baseUrl + "/StudentReports/GetNscRequest";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetNscRequest(_response));
        });
    }

    protected processGetNscRequest(response: AxiosResponse): Promise<StudentReportNscRequest> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentReportNscRequest>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentReportNscRequest>(null as any);
    }

    getNscResource( cancelToken?: CancelToken): Promise<StudentReportNscResource> {
        let url_ = this.baseUrl + "/StudentReports/GetNscResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetNscResource(_response));
        });
    }

    protected processGetNscResource(response: AxiosResponse): Promise<StudentReportNscResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentReportNscResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentReportNscResource>(null as any);
    }

    validateNsc(req: StudentReportNscRequest, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/StudentReports/ValidateNsc";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processValidateNsc(_response));
        });
    }

    protected processValidateNsc(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    generateNsc(req: StudentReportNscRequest, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/StudentReports/GenerateNsc";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGenerateNsc(_response));
        });
    }

    protected processGenerateNsc(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getParticipantStatusReport(req: ParticipantStatusReportRequest, cancelToken?: CancelToken): Promise<ParticipantStatusReportResponse> {
        let url_ = this.baseUrl + "/StudentReports/GetParticipantStatusReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetParticipantStatusReport(_response));
        });
    }

    protected processGetParticipantStatusReport(response: AxiosResponse): Promise<ParticipantStatusReportResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ParticipantStatusReportResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ParticipantStatusReportResponse>(null as any);
    }

    getServiceDetailRequest( cancelToken?: CancelToken): Promise<StudentReportServiceDetailRequest> {
        let url_ = this.baseUrl + "/StudentReports/GetServiceDetailRequest";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetServiceDetailRequest(_response));
        });
    }

    protected processGetServiceDetailRequest(response: AxiosResponse): Promise<StudentReportServiceDetailRequest> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentReportServiceDetailRequest>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentReportServiceDetailRequest>(null as any);
    }

    getServiceDetailResource( cancelToken?: CancelToken): Promise<StudentReportServiceDetailResource> {
        let url_ = this.baseUrl + "/StudentReports/GetServiceDetailResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetServiceDetailResource(_response));
        });
    }

    protected processGetServiceDetailResource(response: AxiosResponse): Promise<StudentReportServiceDetailResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentReportServiceDetailResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentReportServiceDetailResource>(null as any);
    }

    generateServiceDetail(req: StudentReportServiceDetailRequest, cancelToken?: CancelToken): Promise<StudentReportServiceDetailResponse> {
        let url_ = this.baseUrl + "/StudentReports/GenerateServiceDetail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGenerateServiceDetail(_response));
        });
    }

    protected processGenerateServiceDetail(response: AxiosResponse): Promise<StudentReportServiceDetailResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentReportServiceDetailResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentReportServiceDetailResponse>(null as any);
    }

    getServiceSummaryRequest( cancelToken?: CancelToken): Promise<StudentReportServiceSummaryRequest> {
        let url_ = this.baseUrl + "/StudentReports/GetServiceSummaryRequest";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetServiceSummaryRequest(_response));
        });
    }

    protected processGetServiceSummaryRequest(response: AxiosResponse): Promise<StudentReportServiceSummaryRequest> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentReportServiceSummaryRequest>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentReportServiceSummaryRequest>(null as any);
    }

    getServiceSummaryResource( cancelToken?: CancelToken): Promise<StudentReportServiceSummaryResource> {
        let url_ = this.baseUrl + "/StudentReports/GetServiceSummaryResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetServiceSummaryResource(_response));
        });
    }

    protected processGetServiceSummaryResource(response: AxiosResponse): Promise<StudentReportServiceSummaryResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentReportServiceSummaryResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentReportServiceSummaryResource>(null as any);
    }

    generateServiceSummary(req: StudentReportServiceSummaryRequest, cancelToken?: CancelToken): Promise<StudentReportServiceSummaryResponse> {
        let url_ = this.baseUrl + "/StudentReports/GenerateServiceSummary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGenerateServiceSummary(_response));
        });
    }

    protected processGenerateServiceSummary(response: AxiosResponse): Promise<StudentReportServiceSummaryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentReportServiceSummaryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentReportServiceSummaryResponse>(null as any);
    }
}

export class SurveyReportsClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getListResource( cancelToken?: CancelToken): Promise<SurveyListResource> {
        let url_ = this.baseUrl + "/SurveyReports/GetListResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListResource(_response));
        });
    }

    protected processGetListResource(response: AxiosResponse): Promise<SurveyListResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SurveyListResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SurveyListResource>(null as any);
    }

    getList( cancelToken?: CancelToken): Promise<SurveyReportListDto[]> {
        let url_ = this.baseUrl + "/SurveyReports/GetList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetList(_response));
        });
    }

    protected processGetList(response: AxiosResponse): Promise<SurveyReportListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SurveyReportListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SurveyReportListDto[]>(null as any);
    }

    getListTotal( cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/SurveyReports/GetListTotal";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListTotal(_response));
        });
    }

    protected processGetListTotal(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getSurveyReport(id: number | undefined, cancelToken?: CancelToken): Promise<Survey> {
        let url_ = this.baseUrl + "/SurveyReports/GetSurveyReport?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSurveyReport(_response));
        });
    }

    protected processGetSurveyReport(response: AxiosResponse): Promise<Survey> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<Survey>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Survey>(null as any);
    }

    getViewResource( cancelToken?: CancelToken): Promise<SurveyReportViewResource> {
        let url_ = this.baseUrl + "/SurveyReports/GetViewResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetViewResource(_response));
        });
    }

    protected processGetViewResource(response: AxiosResponse): Promise<SurveyReportViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SurveyReportViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SurveyReportViewResource>(null as any);
    }

    saveCreate(surveyVm: Survey, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/SurveyReports/SaveCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(surveyVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreate(_response));
        });
    }

    protected processSaveCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveUpdate(surveyVm: Survey, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/SurveyReports/SaveUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(surveyVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdate(_response));
        });
    }

    protected processSaveUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    generateSurveyReport(request: SurveyReportRequest, cancelToken?: CancelToken): Promise<SurveyReportResponse> {
        let url_ = this.baseUrl + "/SurveyReports/GenerateSurveyReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGenerateSurveyReport(_response));
        });
    }

    protected processGenerateSurveyReport(response: AxiosResponse): Promise<SurveyReportResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SurveyReportResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SurveyReportResponse>(null as any);
    }

    delete(id: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/SurveyReports/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class StaffReportsClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getServiceDetailRequest( cancelToken?: CancelToken): Promise<StaffReportServiceDetailRequest> {
        let url_ = this.baseUrl + "/StaffReports/GetServiceDetailRequest";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetServiceDetailRequest(_response));
        });
    }

    protected processGetServiceDetailRequest(response: AxiosResponse): Promise<StaffReportServiceDetailRequest> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StaffReportServiceDetailRequest>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StaffReportServiceDetailRequest>(null as any);
    }

    getServiceDetailResource( cancelToken?: CancelToken): Promise<StaffReportServiceDetailResource> {
        let url_ = this.baseUrl + "/StaffReports/GetServiceDetailResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetServiceDetailResource(_response));
        });
    }

    protected processGetServiceDetailResource(response: AxiosResponse): Promise<StaffReportServiceDetailResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StaffReportServiceDetailResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StaffReportServiceDetailResource>(null as any);
    }

    generateServiceDetail(req: StaffReportServiceDetailRequest, cancelToken?: CancelToken): Promise<StaffReportServiceDetailResponse> {
        let url_ = this.baseUrl + "/StaffReports/GenerateServiceDetail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGenerateServiceDetail(_response));
        });
    }

    protected processGenerateServiceDetail(response: AxiosResponse): Promise<StaffReportServiceDetailResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StaffReportServiceDetailResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StaffReportServiceDetailResponse>(null as any);
    }

    getServiceSummaryRequest( cancelToken?: CancelToken): Promise<StaffReportServiceSummaryRequest> {
        let url_ = this.baseUrl + "/StaffReports/GetServiceSummaryRequest";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetServiceSummaryRequest(_response));
        });
    }

    protected processGetServiceSummaryRequest(response: AxiosResponse): Promise<StaffReportServiceSummaryRequest> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StaffReportServiceSummaryRequest>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StaffReportServiceSummaryRequest>(null as any);
    }

    getServiceSummaryResource( cancelToken?: CancelToken): Promise<StaffReportServiceSummaryResource> {
        let url_ = this.baseUrl + "/StaffReports/GetServiceSummaryResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetServiceSummaryResource(_response));
        });
    }

    protected processGetServiceSummaryResource(response: AxiosResponse): Promise<StaffReportServiceSummaryResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StaffReportServiceSummaryResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StaffReportServiceSummaryResource>(null as any);
    }

    generateServiceSummary(req: StaffReportServiceSummaryRequest, cancelToken?: CancelToken): Promise<StaffReportServiceSummaryResponse> {
        let url_ = this.baseUrl + "/StaffReports/GenerateServiceSummary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGenerateServiceSummary(_response));
        });
    }

    protected processGenerateServiceSummary(response: AxiosResponse): Promise<StaffReportServiceSummaryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StaffReportServiceSummaryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StaffReportServiceSummaryResponse>(null as any);
    }
}

export class ObjectiveReportsClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    get( cancelToken?: CancelToken): Promise<ObjectiveReportsRequest> {
        let url_ = this.baseUrl + "/ObjectiveReports/Get";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<ObjectiveReportsRequest> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ObjectiveReportsRequest>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ObjectiveReportsRequest>(null as any);
    }

    getResource( cancelToken?: CancelToken): Promise<ObjectiveReportsResource> {
        let url_ = this.baseUrl + "/ObjectiveReports/GetResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetResource(_response));
        });
    }

    protected processGetResource(response: AxiosResponse): Promise<ObjectiveReportsResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ObjectiveReportsResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ObjectiveReportsResource>(null as any);
    }

    generateReport(request: ObjectiveReportsRequest, cancelToken?: CancelToken): Promise<ObjectiveReportsResult> {
        let url_ = this.baseUrl + "/ObjectiveReports/GenerateReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGenerateReport(_response));
        });
    }

    protected processGenerateReport(response: AxiosResponse): Promise<ObjectiveReportsResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ObjectiveReportsResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ObjectiveReportsResult>(null as any);
    }
}

export class ExportsClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    get( cancelToken?: CancelToken): Promise<Export> {
        let url_ = this.baseUrl + "/Exports/Get";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<Export> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<Export>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Export>(null as any);
    }

    getResource( cancelToken?: CancelToken): Promise<ExportResource> {
        let url_ = this.baseUrl + "/Exports/GetResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetResource(_response));
        });
    }

    protected processGetResource(response: AxiosResponse): Promise<ExportResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ExportResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExportResource>(null as any);
    }

    getDisplayProperties(exportTypeId: number | null | undefined, exportSubTypeId: number | null | undefined, cancelToken?: CancelToken): Promise<ReportPropertyBase[]> {
        let url_ = this.baseUrl + "/Exports/GetDisplayProperties?";
        if (exportTypeId !== undefined && exportTypeId !== null)
            url_ += "exportTypeId=" + encodeURIComponent("" + exportTypeId) + "&";
        if (exportSubTypeId !== undefined && exportSubTypeId !== null)
            url_ += "exportSubTypeId=" + encodeURIComponent("" + exportSubTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetDisplayProperties(_response));
        });
    }

    protected processGetDisplayProperties(response: AxiosResponse): Promise<ReportPropertyBase[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ReportPropertyBase[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReportPropertyBase[]>(null as any);
    }

    getDisplayFieldsSnapshots(exportTypeId: number | null | undefined, exportSubTypeId: number | null | undefined, cancelToken?: CancelToken): Promise<UserExportDisplayFieldsSnapshot[]> {
        let url_ = this.baseUrl + "/Exports/GetDisplayFieldsSnapshots?";
        if (exportTypeId !== undefined && exportTypeId !== null)
            url_ += "exportTypeId=" + encodeURIComponent("" + exportTypeId) + "&";
        if (exportSubTypeId !== undefined && exportSubTypeId !== null)
            url_ += "exportSubTypeId=" + encodeURIComponent("" + exportSubTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetDisplayFieldsSnapshots(_response));
        });
    }

    protected processGetDisplayFieldsSnapshots(response: AxiosResponse): Promise<UserExportDisplayFieldsSnapshot[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<UserExportDisplayFieldsSnapshot[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserExportDisplayFieldsSnapshot[]>(null as any);
    }

    getDisplayFieldsSnapshot(id: number | undefined, cancelToken?: CancelToken): Promise<UserExportDisplayFieldsSnapshot> {
        let url_ = this.baseUrl + "/Exports/GetDisplayFieldsSnapshot?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetDisplayFieldsSnapshot(_response));
        });
    }

    protected processGetDisplayFieldsSnapshot(response: AxiosResponse): Promise<UserExportDisplayFieldsSnapshot> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<UserExportDisplayFieldsSnapshot>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserExportDisplayFieldsSnapshot>(null as any);
    }

    saveDisplayFieldsSnapshot(snapshotVm: UserExportDisplayFieldsSnapshot, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Exports/SaveDisplayFieldsSnapshot";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(snapshotVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveDisplayFieldsSnapshot(_response));
        });
    }

    protected processSaveDisplayFieldsSnapshot(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    deleteDisplayFieldsSnapshot(id: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Exports/DeleteDisplayFieldsSnapshot?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteDisplayFieldsSnapshot(_response));
        });
    }

    protected processDeleteDisplayFieldsSnapshot(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getExportPreview(_export: Export, cancelToken?: CancelToken): Promise<ExportPreviewInfo> {
        let url_ = this.baseUrl + "/Exports/GetExportPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(_export);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetExportPreview(_response));
        });
    }

    protected processGetExportPreview(response: AxiosResponse): Promise<ExportPreviewInfo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ExportPreviewInfo>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExportPreviewInfo>(null as any);
    }

    generateGridData(_export: Export, cancelToken?: CancelToken): Promise<ExportGridData> {
        let url_ = this.baseUrl + "/Exports/GenerateGridData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(_export);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGenerateGridData(_response));
        });
    }

    protected processGenerateGridData(response: AxiosResponse): Promise<ExportGridData> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ExportGridData>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExportGridData>(null as any);
    }
}

export class DashboardReportClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    get( cancelToken?: CancelToken): Promise<DashboardReport> {
        let url_ = this.baseUrl + "/DashboardReport/Get";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<DashboardReport> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<DashboardReport>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DashboardReport>(null as any);
    }
}

export class ProviderEmploymentsClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getList(listFilter: ProviderEmploymentListFilter, cancelToken?: CancelToken): Promise<ProviderEmploymentListDto[]> {
        let url_ = this.baseUrl + "/ProviderEmployments/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetList(_response));
        });
    }

    protected processGetList(response: AxiosResponse): Promise<ProviderEmploymentListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ProviderEmploymentListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProviderEmploymentListDto[]>(null as any);
    }

    getListTotal(listFilter: ProviderEmploymentListFilter, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/ProviderEmployments/GetListTotal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListTotal(_response));
        });
    }

    protected processGetListTotal(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getListResource( cancelToken?: CancelToken): Promise<ProviderEmploymentListResource> {
        let url_ = this.baseUrl + "/ProviderEmployments/GetListResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListResource(_response));
        });
    }

    protected processGetListResource(response: AxiosResponse): Promise<ProviderEmploymentListResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ProviderEmploymentListResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProviderEmploymentListResource>(null as any);
    }

    get(id: number | undefined, cancelToken?: CancelToken): Promise<ProviderEmployment> {
        let url_ = this.baseUrl + "/ProviderEmployments/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<ProviderEmployment> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ProviderEmployment>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProviderEmployment>(null as any);
    }

    getViewResource( cancelToken?: CancelToken): Promise<ProviderEmploymentViewResource> {
        let url_ = this.baseUrl + "/ProviderEmployments/GetViewResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetViewResource(_response));
        });
    }

    protected processGetViewResource(response: AxiosResponse): Promise<ProviderEmploymentViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ProviderEmploymentViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProviderEmploymentViewResource>(null as any);
    }

    getEditResource( cancelToken?: CancelToken): Promise<ProviderEmploymentEditResource> {
        let url_ = this.baseUrl + "/ProviderEmployments/GetEditResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEditResource(_response));
        });
    }

    protected processGetEditResource(response: AxiosResponse): Promise<ProviderEmploymentEditResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ProviderEmploymentEditResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProviderEmploymentEditResource>(null as any);
    }

    saveCreate(employmentVm: ProviderEmployment, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/ProviderEmployments/SaveCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(employmentVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreate(_response));
        });
    }

    protected processSaveCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveUpdate(employmentVm: ProviderEmployment, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/ProviderEmployments/SaveUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(employmentVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdate(_response));
        });
    }

    protected processSaveUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    delete(id: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/ProviderEmployments/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class ProvidersClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getList(listFilter: ProviderListFilter, cancelToken?: CancelToken): Promise<ProviderListDto[]> {
        let url_ = this.baseUrl + "/Providers/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetList(_response));
        });
    }

    protected processGetList(response: AxiosResponse): Promise<ProviderListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ProviderListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProviderListDto[]>(null as any);
    }

    getListTotal(listFilter: ProviderListFilter, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Providers/GetListTotal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListTotal(_response));
        });
    }

    protected processGetListTotal(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getIds(listFilter: ProviderListFilter, cancelToken?: CancelToken): Promise<number[]> {
        let url_ = this.baseUrl + "/Providers/GetIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetIds(_response));
        });
    }

    protected processGetIds(response: AxiosResponse): Promise<number[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number[]>(null as any);
    }

    getListResource( cancelToken?: CancelToken): Promise<ProviderListResource> {
        let url_ = this.baseUrl + "/Providers/GetListResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListResource(_response));
        });
    }

    protected processGetListResource(response: AxiosResponse): Promise<ProviderListResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ProviderListResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProviderListResource>(null as any);
    }

    getFilterResource( cancelToken?: CancelToken): Promise<ProviderFilterResource> {
        let url_ = this.baseUrl + "/Providers/GetFilterResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetFilterResource(_response));
        });
    }

    protected processGetFilterResource(response: AxiosResponse): Promise<ProviderFilterResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ProviderFilterResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProviderFilterResource>(null as any);
    }

    get(id: number | undefined, cancelToken?: CancelToken): Promise<Provider> {
        let url_ = this.baseUrl + "/Providers/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<Provider> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<Provider>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Provider>(null as any);
    }

    getViewResource(id: number | undefined, cancelToken?: CancelToken): Promise<ProviderViewResource> {
        let url_ = this.baseUrl + "/Providers/GetViewResource?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetViewResource(_response));
        });
    }

    protected processGetViewResource(response: AxiosResponse): Promise<ProviderViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ProviderViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProviderViewResource>(null as any);
    }

    getEditResource( cancelToken?: CancelToken): Promise<ProviderEditResource> {
        let url_ = this.baseUrl + "/Providers/GetEditResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEditResource(_response));
        });
    }

    protected processGetEditResource(response: AxiosResponse): Promise<ProviderEditResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ProviderEditResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProviderEditResource>(null as any);
    }

    saveCreate(providerVm: Provider, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Providers/SaveCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(providerVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreate(_response));
        });
    }

    protected processSaveCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveUpdate(providerVm: Provider, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Providers/SaveUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(providerVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdate(_response));
        });
    }

    protected processSaveUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    delete(id: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Providers/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getProviderPositionList(filter: ProviderPositionListFilter, cancelToken?: CancelToken): Promise<ProviderPositionListDto[]> {
        let url_ = this.baseUrl + "/Providers/provider-positions/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetProviderPositionList(_response));
        });
    }

    protected processGetProviderPositionList(response: AxiosResponse): Promise<ProviderPositionListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ProviderPositionListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProviderPositionListDto[]>(null as any);
    }

    getProviderPositionListTotal(filter: ProviderPositionListFilter, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Providers/provider-positions/GetListTotal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetProviderPositionListTotal(_response));
        });
    }

    protected processGetProviderPositionListTotal(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getProviderPositions( cancelToken?: CancelToken): Promise<ProviderPositionListDto[]> {
        let url_ = this.baseUrl + "/Providers/provider-positions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetProviderPositions(_response));
        });
    }

    protected processGetProviderPositions(response: AxiosResponse): Promise<ProviderPositionListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ProviderPositionListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProviderPositionListDto[]>(null as any);
    }

    getProviderPositionListResource( cancelToken?: CancelToken): Promise<ProviderPositionListResource> {
        let url_ = this.baseUrl + "/Providers/provider-positions/GetListResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetProviderPositionListResource(_response));
        });
    }

    protected processGetProviderPositionListResource(response: AxiosResponse): Promise<ProviderPositionListResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ProviderPositionListResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProviderPositionListResource>(null as any);
    }

    getProviderPositionViewResource( cancelToken?: CancelToken): Promise<ProviderPositionViewResource> {
        let url_ = this.baseUrl + "/Providers/provider-positions/GetViewResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetProviderPositionViewResource(_response));
        });
    }

    protected processGetProviderPositionViewResource(response: AxiosResponse): Promise<ProviderPositionViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ProviderPositionViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProviderPositionViewResource>(null as any);
    }

    getProviderPositionEditResource( cancelToken?: CancelToken): Promise<ProviderPositionEditResource> {
        let url_ = this.baseUrl + "/Providers/provider-positions/GetEditResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetProviderPositionEditResource(_response));
        });
    }

    protected processGetProviderPositionEditResource(response: AxiosResponse): Promise<ProviderPositionEditResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ProviderPositionEditResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProviderPositionEditResource>(null as any);
    }

    getProviderPosition(id: number, cancelToken?: CancelToken): Promise<ProviderPosition> {
        let url_ = this.baseUrl + "/Providers/provider-positions/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetProviderPosition(_response));
        });
    }

    protected processGetProviderPosition(response: AxiosResponse): Promise<ProviderPosition> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ProviderPosition>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProviderPosition>(null as any);
    }

    deleteProviderPosition(id: number, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Providers/provider-positions/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteProviderPosition(_response));
        });
    }

    protected processDeleteProviderPosition(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    saveCreateProviderPosition(positionVm: ProviderPosition, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Providers/provider-positions/saveCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(positionVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreateProviderPosition(_response));
        });
    }

    protected processSaveCreateProviderPosition(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveUpdateProviderPosition(positionVm: ProviderPosition, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Providers/provider-positions/saveUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(positionVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdateProviderPosition(_response));
        });
    }

    protected processSaveUpdateProviderPosition(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class NscCollegesClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getFilterResource( cancelToken?: CancelToken): Promise<NscCollegeFilterResource> {
        let url_ = this.baseUrl + "/NscColleges/GetFilterResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetFilterResource(_response));
        });
    }

    protected processGetFilterResource(response: AxiosResponse): Promise<NscCollegeFilterResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<NscCollegeFilterResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NscCollegeFilterResource>(null as any);
    }

    getList(listFilter: NscCollegeListFilter, cancelToken?: CancelToken): Promise<NscCollegeListDto[]> {
        let url_ = this.baseUrl + "/NscColleges/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetList(_response));
        });
    }

    protected processGetList(response: AxiosResponse): Promise<NscCollegeListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<NscCollegeListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NscCollegeListDto[]>(null as any);
    }

    getListResource( cancelToken?: CancelToken): Promise<NscCollegeListResource> {
        let url_ = this.baseUrl + "/NscColleges/GetListResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListResource(_response));
        });
    }

    protected processGetListResource(response: AxiosResponse): Promise<NscCollegeListResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<NscCollegeListResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NscCollegeListResource>(null as any);
    }

    get(id: number | undefined, cancelToken?: CancelToken): Promise<NscCollege> {
        let url_ = this.baseUrl + "/NscColleges/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<NscCollege> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<NscCollege>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NscCollege>(null as any);
    }

    getCreate(identification: string | null | undefined, cancelToken?: CancelToken): Promise<NscCollege> {
        let url_ = this.baseUrl + "/NscColleges/GetCreate?";
        if (identification !== undefined && identification !== null)
            url_ += "identification=" + encodeURIComponent("" + identification) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetCreate(_response));
        });
    }

    protected processGetCreate(response: AxiosResponse): Promise<NscCollege> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<NscCollege>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NscCollege>(null as any);
    }

    getViewResource( cancelToken?: CancelToken): Promise<NscCollegeViewResource> {
        let url_ = this.baseUrl + "/NscColleges/GetViewResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetViewResource(_response));
        });
    }

    protected processGetViewResource(response: AxiosResponse): Promise<NscCollegeViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<NscCollegeViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NscCollegeViewResource>(null as any);
    }

    getEditResource( cancelToken?: CancelToken): Promise<NscCollegeEditResource> {
        let url_ = this.baseUrl + "/NscColleges/GetEditResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEditResource(_response));
        });
    }

    protected processGetEditResource(response: AxiosResponse): Promise<NscCollegeEditResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<NscCollegeEditResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NscCollegeEditResource>(null as any);
    }

    saveCreate(nscCollegeVm: NscCollege, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/NscColleges/SaveCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(nscCollegeVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreate(_response));
        });
    }

    protected processSaveCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveUpdate(nscCollegeVm: NscCollege, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/NscColleges/SaveUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(nscCollegeVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdate(_response));
        });
    }

    protected processSaveUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    delete(id: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/NscColleges/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class StudentAbsencesClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getList(listFilter: StudentAbsenceListFilter, cancelToken?: CancelToken): Promise<StudentAbsenceListDto[]> {
        let url_ = this.baseUrl + "/StudentAbsences/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetList(_response));
        });
    }

    protected processGetList(response: AxiosResponse): Promise<StudentAbsenceListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentAbsenceListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentAbsenceListDto[]>(null as any);
    }

    getListTotal(listFilter: StudentAbsenceListFilter, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentAbsences/GetListTotal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListTotal(_response));
        });
    }

    protected processGetListTotal(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getFilterResource( cancelToken?: CancelToken): Promise<StudentAbsenceFilterResource> {
        let url_ = this.baseUrl + "/StudentAbsences/GetFilterResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetFilterResource(_response));
        });
    }

    protected processGetFilterResource(response: AxiosResponse): Promise<StudentAbsenceFilterResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentAbsenceFilterResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentAbsenceFilterResource>(null as any);
    }

    get(id: number | undefined, cancelToken?: CancelToken): Promise<StudentAbsence> {
        let url_ = this.baseUrl + "/StudentAbsences/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<StudentAbsence> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentAbsence>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentAbsence>(null as any);
    }

    getListResource( cancelToken?: CancelToken): Promise<StudentAbsenceListResource> {
        let url_ = this.baseUrl + "/StudentAbsences/GetListResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListResource(_response));
        });
    }

    protected processGetListResource(response: AxiosResponse): Promise<StudentAbsenceListResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentAbsenceListResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentAbsenceListResource>(null as any);
    }

    getViewResource( cancelToken?: CancelToken): Promise<StudentAbsenceViewResource> {
        let url_ = this.baseUrl + "/StudentAbsences/GetViewResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetViewResource(_response));
        });
    }

    protected processGetViewResource(response: AxiosResponse): Promise<StudentAbsenceViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentAbsenceViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentAbsenceViewResource>(null as any);
    }

    getEditResource( cancelToken?: CancelToken): Promise<StudentAbsenceEditResource> {
        let url_ = this.baseUrl + "/StudentAbsences/GetEditResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEditResource(_response));
        });
    }

    protected processGetEditResource(response: AxiosResponse): Promise<StudentAbsenceEditResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentAbsenceEditResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentAbsenceEditResource>(null as any);
    }

    saveCreate(absenceVm: StudentAbsence, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentAbsences/SaveCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(absenceVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreate(_response));
        });
    }

    protected processSaveCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveUpdate(absenceVm: StudentAbsence, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentAbsences/SaveUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(absenceVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdate(_response));
        });
    }

    protected processSaveUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    delete(id: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentAbsences/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class StudentApplicationsClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getList(listFilter: StudentApplicationListFilter, cancelToken?: CancelToken): Promise<StudentApplicationListDto[]> {
        let url_ = this.baseUrl + "/StudentApplications/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetList(_response));
        });
    }

    protected processGetList(response: AxiosResponse): Promise<StudentApplicationListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentApplicationListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentApplicationListDto[]>(null as any);
    }

    getStudentList(listFilter: StudentApplicationListFilter, studentId: number | undefined, cancelToken?: CancelToken): Promise<StudentApplicationListDto[]> {
        let url_ = this.baseUrl + "/StudentApplications/GetStudentList?";
        if (studentId === null)
            throw new globalThis.Error("The parameter 'studentId' cannot be null.");
        else if (studentId !== undefined)
            url_ += "studentId=" + encodeURIComponent("" + studentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetStudentList(_response));
        });
    }

    protected processGetStudentList(response: AxiosResponse): Promise<StudentApplicationListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentApplicationListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentApplicationListDto[]>(null as any);
    }

    getListTotal(listFilter: StudentApplicationListFilter, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentApplications/GetListTotal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListTotal(_response));
        });
    }

    protected processGetListTotal(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getIds(listFilter: StudentApplicationListFilter, cancelToken?: CancelToken): Promise<number[]> {
        let url_ = this.baseUrl + "/StudentApplications/GetIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetIds(_response));
        });
    }

    protected processGetIds(response: AxiosResponse): Promise<number[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number[]>(null as any);
    }

    getListResource( cancelToken?: CancelToken): Promise<StudentApplicationListResource> {
        let url_ = this.baseUrl + "/StudentApplications/GetListResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListResource(_response));
        });
    }

    protected processGetListResource(response: AxiosResponse): Promise<StudentApplicationListResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentApplicationListResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentApplicationListResource>(null as any);
    }

    getFilterResource( cancelToken?: CancelToken): Promise<StudentApplicationFilterResource> {
        let url_ = this.baseUrl + "/StudentApplications/GetFilterResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetFilterResource(_response));
        });
    }

    protected processGetFilterResource(response: AxiosResponse): Promise<StudentApplicationFilterResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentApplicationFilterResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentApplicationFilterResource>(null as any);
    }

    getFileEditResource( cancelToken?: CancelToken): Promise<StudentApplicationEditResource> {
        let url_ = this.baseUrl + "/StudentApplications/GetFileEditResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetFileEditResource(_response));
        });
    }

    protected processGetFileEditResource(response: AxiosResponse): Promise<StudentApplicationEditResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentApplicationEditResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentApplicationEditResource>(null as any);
    }

    getApplicationResponse(applicationResponseId: number | undefined, cancelToken?: CancelToken): Promise<StudentApplicationResponseDto> {
        let url_ = this.baseUrl + "/StudentApplications/GetApplicationResponse?";
        if (applicationResponseId === null)
            throw new globalThis.Error("The parameter 'applicationResponseId' cannot be null.");
        else if (applicationResponseId !== undefined)
            url_ += "applicationResponseId=" + encodeURIComponent("" + applicationResponseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetApplicationResponse(_response));
        });
    }

    protected processGetApplicationResponse(response: AxiosResponse): Promise<StudentApplicationResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentApplicationResponseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentApplicationResponseDto>(null as any);
    }

    getApplicationResponseFiles(applicationResponseId: number | undefined, cancelToken?: CancelToken): Promise<ApplicationResponseFile[]> {
        let url_ = this.baseUrl + "/StudentApplications/GetApplicationResponseFiles?";
        if (applicationResponseId === null)
            throw new globalThis.Error("The parameter 'applicationResponseId' cannot be null.");
        else if (applicationResponseId !== undefined)
            url_ += "applicationResponseId=" + encodeURIComponent("" + applicationResponseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetApplicationResponseFiles(_response));
        });
    }

    protected processGetApplicationResponseFiles(response: AxiosResponse): Promise<ApplicationResponseFile[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ApplicationResponseFile[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApplicationResponseFile[]>(null as any);
    }

    getApplicationResponseFile(applicationResponseFileId: number | undefined, cancelToken?: CancelToken): Promise<ApplicationResponseFile> {
        let url_ = this.baseUrl + "/StudentApplications/GetApplicationResponseFile?";
        if (applicationResponseFileId === null)
            throw new globalThis.Error("The parameter 'applicationResponseFileId' cannot be null.");
        else if (applicationResponseFileId !== undefined)
            url_ += "applicationResponseFileId=" + encodeURIComponent("" + applicationResponseFileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetApplicationResponseFile(_response));
        });
    }

    protected processGetApplicationResponseFile(response: AxiosResponse): Promise<ApplicationResponseFile> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ApplicationResponseFile>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApplicationResponseFile>(null as any);
    }

    saveCreateFile(fileVm: ApplicationResponseFile, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentApplications/SaveCreateFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(fileVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreateFile(_response));
        });
    }

    protected processSaveCreateFile(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    deleteFile(applicationResponseFileId: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentApplications/DeleteFile?";
        if (applicationResponseFileId === null)
            throw new globalThis.Error("The parameter 'applicationResponseFileId' cannot be null.");
        else if (applicationResponseFileId !== undefined)
            url_ += "applicationResponseFileId=" + encodeURIComponent("" + applicationResponseFileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteFile(_response));
        });
    }

    protected processDeleteFile(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    updateApplicationStatus(applicationResponseDto: StudentApplicationResponseDto, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentApplications/UpdateApplicationStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(applicationResponseDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateApplicationStatus(_response));
        });
    }

    protected processUpdateApplicationStatus(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class StudentDiplomasClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getList(listFilter: StudentDiplomaListFilter, cancelToken?: CancelToken): Promise<StudentDiplomaListDto[]> {
        let url_ = this.baseUrl + "/StudentDiplomas/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetList(_response));
        });
    }

    protected processGetList(response: AxiosResponse): Promise<StudentDiplomaListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentDiplomaListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentDiplomaListDto[]>(null as any);
    }

    getListTotal(listFilter: StudentDiplomaListFilter, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentDiplomas/GetListTotal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListTotal(_response));
        });
    }

    protected processGetListTotal(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    get(id: number | undefined, cancelToken?: CancelToken): Promise<StudentDiploma> {
        let url_ = this.baseUrl + "/StudentDiplomas/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<StudentDiploma> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentDiploma>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentDiploma>(null as any);
    }

    getViewResource( cancelToken?: CancelToken): Promise<StudentDiplomaViewResource> {
        let url_ = this.baseUrl + "/StudentDiplomas/GetViewResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetViewResource(_response));
        });
    }

    protected processGetViewResource(response: AxiosResponse): Promise<StudentDiplomaViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentDiplomaViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentDiplomaViewResource>(null as any);
    }

    getEditResource( cancelToken?: CancelToken): Promise<StudentDiplomaEditResource> {
        let url_ = this.baseUrl + "/StudentDiplomas/GetEditResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEditResource(_response));
        });
    }

    protected processGetEditResource(response: AxiosResponse): Promise<StudentDiplomaEditResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentDiplomaEditResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentDiplomaEditResource>(null as any);
    }

    saveCreate(diplomaVm: StudentDiploma, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentDiplomas/SaveCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(diplomaVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreate(_response));
        });
    }

    protected processSaveCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveUpdate(diplomaVm: StudentDiploma, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentDiplomas/SaveUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(diplomaVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdate(_response));
        });
    }

    protected processSaveUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    delete(id: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentDiplomas/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class StudentEnrollmentsClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    initListFilter( cancelToken?: CancelToken): Promise<StudentEnrollmentListFilter> {
        let url_ = this.baseUrl + "/StudentEnrollments/InitListFilter";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processInitListFilter(_response));
        });
    }

    protected processInitListFilter(response: AxiosResponse): Promise<StudentEnrollmentListFilter> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentEnrollmentListFilter>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentEnrollmentListFilter>(null as any);
    }

    getList(listFilter: StudentEnrollmentListFilter, cancelToken?: CancelToken): Promise<StudentEnrollmentListDto[]> {
        let url_ = this.baseUrl + "/StudentEnrollments/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetList(_response));
        });
    }

    protected processGetList(response: AxiosResponse): Promise<StudentEnrollmentListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentEnrollmentListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentEnrollmentListDto[]>(null as any);
    }

    getListTotal(listFilter: StudentEnrollmentListFilter, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentEnrollments/GetListTotal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListTotal(_response));
        });
    }

    protected processGetListTotal(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getIds(listFilter: StudentEnrollmentListFilter, cancelToken?: CancelToken): Promise<number[]> {
        let url_ = this.baseUrl + "/StudentEnrollments/GetIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetIds(_response));
        });
    }

    protected processGetIds(response: AxiosResponse): Promise<number[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number[]>(null as any);
    }

    getFilterResource( cancelToken?: CancelToken): Promise<StudentEnrollmentFilterResource> {
        let url_ = this.baseUrl + "/StudentEnrollments/GetFilterResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetFilterResource(_response));
        });
    }

    protected processGetFilterResource(response: AxiosResponse): Promise<StudentEnrollmentFilterResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentEnrollmentFilterResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentEnrollmentFilterResource>(null as any);
    }

    getListResource( cancelToken?: CancelToken): Promise<StudentEnrollmentListResource> {
        let url_ = this.baseUrl + "/StudentEnrollments/GetListResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListResource(_response));
        });
    }

    protected processGetListResource(response: AxiosResponse): Promise<StudentEnrollmentListResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentEnrollmentListResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentEnrollmentListResource>(null as any);
    }

    get(id: number | undefined, cancelToken?: CancelToken): Promise<StudentEnrollment> {
        let url_ = this.baseUrl + "/StudentEnrollments/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<StudentEnrollment> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentEnrollment>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentEnrollment>(null as any);
    }

    getEnrollmentByStudentId(studentId: number | undefined, cancelToken?: CancelToken): Promise<StudentEnrollment> {
        let url_ = this.baseUrl + "/StudentEnrollments/GetEnrollmentByStudentId?";
        if (studentId === null)
            throw new globalThis.Error("The parameter 'studentId' cannot be null.");
        else if (studentId !== undefined)
            url_ += "studentId=" + encodeURIComponent("" + studentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEnrollmentByStudentId(_response));
        });
    }

    protected processGetEnrollmentByStudentId(response: AxiosResponse): Promise<StudentEnrollment> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentEnrollment>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentEnrollment>(null as any);
    }

    getEnrollmentsByStudentId(studentId: number | undefined, cancelToken?: CancelToken): Promise<StudentEnrollment[]> {
        let url_ = this.baseUrl + "/StudentEnrollments/GetEnrollmentsByStudentId?";
        if (studentId === null)
            throw new globalThis.Error("The parameter 'studentId' cannot be null.");
        else if (studentId !== undefined)
            url_ += "studentId=" + encodeURIComponent("" + studentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEnrollmentsByStudentId(_response));
        });
    }

    protected processGetEnrollmentsByStudentId(response: AxiosResponse): Promise<StudentEnrollment[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentEnrollment[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentEnrollment[]>(null as any);
    }

    getViewResource( cancelToken?: CancelToken): Promise<StudentEnrollmentViewResource> {
        let url_ = this.baseUrl + "/StudentEnrollments/GetViewResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetViewResource(_response));
        });
    }

    protected processGetViewResource(response: AxiosResponse): Promise<StudentEnrollmentViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentEnrollmentViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentEnrollmentViewResource>(null as any);
    }

    getEditResource( cancelToken?: CancelToken): Promise<StudentEnrollmentEditResource> {
        let url_ = this.baseUrl + "/StudentEnrollments/GetEditResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEditResource(_response));
        });
    }

    protected processGetEditResource(response: AxiosResponse): Promise<StudentEnrollmentEditResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentEnrollmentEditResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentEnrollmentEditResource>(null as any);
    }

    saveCreate(enrollmentVm: StudentEnrollment, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentEnrollments/SaveCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(enrollmentVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreate(_response));
        });
    }

    protected processSaveCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveUpdate(enrollmentVm: StudentEnrollment, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentEnrollments/SaveUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(enrollmentVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdate(_response));
        });
    }

    protected processSaveUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    delete(id: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentEnrollments/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getBulkUpdate(ids: number[], cancelToken?: CancelToken): Promise<StudentEnrollmentBulkUpdate> {
        let url_ = this.baseUrl + "/StudentEnrollments/GetBulkUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetBulkUpdate(_response));
        });
    }

    protected processGetBulkUpdate(response: AxiosResponse): Promise<StudentEnrollmentBulkUpdate> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentEnrollmentBulkUpdate>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentEnrollmentBulkUpdate>(null as any);
    }

    getBulkUpdateResource( cancelToken?: CancelToken): Promise<StudentEnrollmentBulkUpdateResource> {
        let url_ = this.baseUrl + "/StudentEnrollments/GetBulkUpdateResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetBulkUpdateResource(_response));
        });
    }

    protected processGetBulkUpdateResource(response: AxiosResponse): Promise<StudentEnrollmentBulkUpdateResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentEnrollmentBulkUpdateResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentEnrollmentBulkUpdateResource>(null as any);
    }

    saveBulkUpdate(bulkUpdate: StudentEnrollmentBulkUpdate, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentEnrollments/SaveBulkUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bulkUpdate);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveBulkUpdate(_response));
        });
    }

    protected processSaveBulkUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getEndReasonTypeStats(filter: EndReasonTypeStatsFilter, cancelToken?: CancelToken): Promise<EndReasonTypeStatsResponse> {
        let url_ = this.baseUrl + "/StudentEnrollments/GetEndReasonTypeStats";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEndReasonTypeStats(_response));
        });
    }

    protected processGetEndReasonTypeStats(response: AxiosResponse): Promise<EndReasonTypeStatsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<EndReasonTypeStatsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EndReasonTypeStatsResponse>(null as any);
    }
}

export class StudentFafsasClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getList(listFilter: StudentFafsaListFilter, cancelToken?: CancelToken): Promise<StudentFafsaListDto[]> {
        let url_ = this.baseUrl + "/StudentFafsas/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetList(_response));
        });
    }

    protected processGetList(response: AxiosResponse): Promise<StudentFafsaListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentFafsaListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentFafsaListDto[]>(null as any);
    }

    getListTotal(listFilter: StudentFafsaListFilter, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentFafsas/GetListTotal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListTotal(_response));
        });
    }

    protected processGetListTotal(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    get(id: number | undefined, cancelToken?: CancelToken): Promise<StudentFafsa> {
        let url_ = this.baseUrl + "/StudentFafsas/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<StudentFafsa> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentFafsa>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentFafsa>(null as any);
    }

    getViewResource( cancelToken?: CancelToken): Promise<StudentFafsaViewResource> {
        let url_ = this.baseUrl + "/StudentFafsas/GetViewResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetViewResource(_response));
        });
    }

    protected processGetViewResource(response: AxiosResponse): Promise<StudentFafsaViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentFafsaViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentFafsaViewResource>(null as any);
    }

    getEditResource( cancelToken?: CancelToken): Promise<StudentFafsaEditResource> {
        let url_ = this.baseUrl + "/StudentFafsas/GetEditResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEditResource(_response));
        });
    }

    protected processGetEditResource(response: AxiosResponse): Promise<StudentFafsaEditResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentFafsaEditResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentFafsaEditResource>(null as any);
    }

    saveCreate(fafsaVm: StudentFafsa, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentFafsas/SaveCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(fafsaVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreate(_response));
        });
    }

    protected processSaveCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveUpdate(fafsaVm: StudentFafsa, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentFafsas/SaveUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(fafsaVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdate(_response));
        });
    }

    protected processSaveUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    delete(id: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentFafsas/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class StudentFilesClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getListResource( cancelToken?: CancelToken): Promise<StudentApplicationListResource> {
        let url_ = this.baseUrl + "/StudentFiles/GetListResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListResource(_response));
        });
    }

    protected processGetListResource(response: AxiosResponse): Promise<StudentApplicationListResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentApplicationListResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentApplicationListResource>(null as any);
    }

    getFilterResource( cancelToken?: CancelToken): Promise<StudentFileFilterResource> {
        let url_ = this.baseUrl + "/StudentFiles/GetFilterResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetFilterResource(_response));
        });
    }

    protected processGetFilterResource(response: AxiosResponse): Promise<StudentFileFilterResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentFileFilterResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentFileFilterResource>(null as any);
    }

    getCategorizedList(listFilter: StudentFileCategorizedListFilter, studentId: number | undefined, cancelToken?: CancelToken): Promise<StudentFileListDto[]> {
        let url_ = this.baseUrl + "/StudentFiles/GetCategorizedList?";
        if (studentId === null)
            throw new globalThis.Error("The parameter 'studentId' cannot be null.");
        else if (studentId !== undefined)
            url_ += "studentId=" + encodeURIComponent("" + studentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetCategorizedList(_response));
        });
    }

    protected processGetCategorizedList(response: AxiosResponse): Promise<StudentFileListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentFileListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentFileListDto[]>(null as any);
    }

    getList(listFilter: StudentFileListFilter, cancelToken?: CancelToken): Promise<StudentFile[]> {
        let url_ = this.baseUrl + "/StudentFiles/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetList(_response));
        });
    }

    protected processGetList(response: AxiosResponse): Promise<StudentFile[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentFile[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentFile[]>(null as any);
    }

    getListTotal(listFilter: StudentFileListFilter, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentFiles/GetListTotal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListTotal(_response));
        });
    }

    protected processGetListTotal(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getCategorizedListTotal(listFilter: StudentFileCategorizedListFilter, studentId: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentFiles/GetCategorizedListTotal?";
        if (studentId === null)
            throw new globalThis.Error("The parameter 'studentId' cannot be null.");
        else if (studentId !== undefined)
            url_ += "studentId=" + encodeURIComponent("" + studentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetCategorizedListTotal(_response));
        });
    }

    protected processGetCategorizedListTotal(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    get(id: number | undefined, cancelToken?: CancelToken): Promise<StudentFile> {
        let url_ = this.baseUrl + "/StudentFiles/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<StudentFile> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentFile>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentFile>(null as any);
    }

    saveCreate(fileVm: StudentFile, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentFiles/SaveCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(fileVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreate(_response));
        });
    }

    protected processSaveCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveUpdate(fileVm: StudentFile, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentFiles/SaveUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(fileVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdate(_response));
        });
    }

    protected processSaveUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    delete(id: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentFiles/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    deleteStudentServiceFile(id: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentFiles/DeleteStudentServiceFile?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteStudentServiceFile(_response));
        });
    }

    protected processDeleteStudentServiceFile(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class StudentGpasClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getList(listFilter: StudentGpaListFilter, cancelToken?: CancelToken): Promise<StudentGpaListDto[]> {
        let url_ = this.baseUrl + "/StudentGpas/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetList(_response));
        });
    }

    protected processGetList(response: AxiosResponse): Promise<StudentGpaListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentGpaListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentGpaListDto[]>(null as any);
    }

    getListTotal(listFilter: StudentGpaListFilter, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentGpas/GetListTotal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListTotal(_response));
        });
    }

    protected processGetListTotal(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getListResource( cancelToken?: CancelToken): Promise<StudentGpaListResource> {
        let url_ = this.baseUrl + "/StudentGpas/GetListResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListResource(_response));
        });
    }

    protected processGetListResource(response: AxiosResponse): Promise<StudentGpaListResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentGpaListResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentGpaListResource>(null as any);
    }

    getFilterResource( cancelToken?: CancelToken): Promise<StudentGpaFilterResource> {
        let url_ = this.baseUrl + "/StudentGpas/GetFilterResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetFilterResource(_response));
        });
    }

    protected processGetFilterResource(response: AxiosResponse): Promise<StudentGpaFilterResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentGpaFilterResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentGpaFilterResource>(null as any);
    }

    get(id: number | undefined, cancelToken?: CancelToken): Promise<StudentGpa> {
        let url_ = this.baseUrl + "/StudentGpas/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<StudentGpa> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentGpa>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentGpa>(null as any);
    }

    getViewResource( cancelToken?: CancelToken): Promise<StudentGpaViewResource> {
        let url_ = this.baseUrl + "/StudentGpas/GetViewResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetViewResource(_response));
        });
    }

    protected processGetViewResource(response: AxiosResponse): Promise<StudentGpaViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentGpaViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentGpaViewResource>(null as any);
    }

    getEditResource( cancelToken?: CancelToken): Promise<StudentGpaEditResource> {
        let url_ = this.baseUrl + "/StudentGpas/GetEditResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEditResource(_response));
        });
    }

    protected processGetEditResource(response: AxiosResponse): Promise<StudentGpaEditResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentGpaEditResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentGpaEditResource>(null as any);
    }

    saveCreate(gpaVm: StudentGpa, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentGpas/SaveCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(gpaVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreate(_response));
        });
    }

    protected processSaveCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveUpdate(gpaVm: StudentGpa, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentGpas/SaveUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(gpaVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdate(_response));
        });
    }

    protected processSaveUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    delete(id: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentGpas/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class StudentGradesClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getList(listFilter: StudentGradeListFilter, cancelToken?: CancelToken): Promise<StudentGradeListDto[]> {
        let url_ = this.baseUrl + "/StudentGrades/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetList(_response));
        });
    }

    protected processGetList(response: AxiosResponse): Promise<StudentGradeListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentGradeListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentGradeListDto[]>(null as any);
    }

    getListTotal(listFilter: StudentGradeListFilter, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentGrades/GetListTotal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListTotal(_response));
        });
    }

    protected processGetListTotal(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getListResource( cancelToken?: CancelToken): Promise<StudentGradeListResource> {
        let url_ = this.baseUrl + "/StudentGrades/GetListResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListResource(_response));
        });
    }

    protected processGetListResource(response: AxiosResponse): Promise<StudentGradeListResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentGradeListResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentGradeListResource>(null as any);
    }

    getFilterResource( cancelToken?: CancelToken): Promise<StudentGradeFilterResource> {
        let url_ = this.baseUrl + "/StudentGrades/GetFilterResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetFilterResource(_response));
        });
    }

    protected processGetFilterResource(response: AxiosResponse): Promise<StudentGradeFilterResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentGradeFilterResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentGradeFilterResource>(null as any);
    }

    get(id: number | undefined, cancelToken?: CancelToken): Promise<StudentGrade> {
        let url_ = this.baseUrl + "/StudentGrades/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<StudentGrade> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentGrade>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentGrade>(null as any);
    }

    getViewResource( cancelToken?: CancelToken): Promise<StudentGradeViewResource> {
        let url_ = this.baseUrl + "/StudentGrades/GetViewResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetViewResource(_response));
        });
    }

    protected processGetViewResource(response: AxiosResponse): Promise<StudentGradeViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentGradeViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentGradeViewResource>(null as any);
    }

    getEditResource( cancelToken?: CancelToken): Promise<StudentGradeEditResource> {
        let url_ = this.baseUrl + "/StudentGrades/GetEditResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEditResource(_response));
        });
    }

    protected processGetEditResource(response: AxiosResponse): Promise<StudentGradeEditResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentGradeEditResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentGradeEditResource>(null as any);
    }

    saveCreate(gradeVm: StudentGrade, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentGrades/SaveCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(gradeVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreate(_response));
        });
    }

    protected processSaveCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveUpdate(gradeVm: StudentGrade, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentGrades/SaveUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(gradeVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdate(_response));
        });
    }

    protected processSaveUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    delete(id: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentGrades/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getBulkCreate(studentId: number | undefined, schoolYear: number | null | undefined, cancelToken?: CancelToken): Promise<StudentGradeBulkCreate> {
        let url_ = this.baseUrl + "/StudentGrades/GetBulkCreate?";
        if (studentId === null)
            throw new globalThis.Error("The parameter 'studentId' cannot be null.");
        else if (studentId !== undefined)
            url_ += "studentId=" + encodeURIComponent("" + studentId) + "&";
        if (schoolYear !== undefined && schoolYear !== null)
            url_ += "schoolYear=" + encodeURIComponent("" + schoolYear) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetBulkCreate(_response));
        });
    }

    protected processGetBulkCreate(response: AxiosResponse): Promise<StudentGradeBulkCreate> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentGradeBulkCreate>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentGradeBulkCreate>(null as any);
    }

    getBulkCreateResource( cancelToken?: CancelToken): Promise<StudentGradeBulkCreateResource> {
        let url_ = this.baseUrl + "/StudentGrades/GetBulkCreateResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetBulkCreateResource(_response));
        });
    }

    protected processGetBulkCreateResource(response: AxiosResponse): Promise<StudentGradeBulkCreateResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentGradeBulkCreateResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentGradeBulkCreateResource>(null as any);
    }

    saveBulkCreate(bulkCreate: StudentGradeBulkCreate, cancelToken?: CancelToken): Promise<StudentGradeBulkCreate> {
        let url_ = this.baseUrl + "/StudentGrades/SaveBulkCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bulkCreate);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveBulkCreate(_response));
        });
    }

    protected processSaveBulkCreate(response: AxiosResponse): Promise<StudentGradeBulkCreate> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentGradeBulkCreate>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentGradeBulkCreate>(null as any);
    }

    getClassesFromStudent(studentId: number | undefined, year: number | undefined, termTypeId: number | undefined, schoolId: number | undefined, cancelToken?: CancelToken): Promise<Class[]> {
        let url_ = this.baseUrl + "/StudentGrades/GetClassesFromStudent?";
        if (studentId === null)
            throw new globalThis.Error("The parameter 'studentId' cannot be null.");
        else if (studentId !== undefined)
            url_ += "studentId=" + encodeURIComponent("" + studentId) + "&";
        if (year === null)
            throw new globalThis.Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (termTypeId === null)
            throw new globalThis.Error("The parameter 'termTypeId' cannot be null.");
        else if (termTypeId !== undefined)
            url_ += "termTypeId=" + encodeURIComponent("" + termTypeId) + "&";
        if (schoolId === null)
            throw new globalThis.Error("The parameter 'schoolId' cannot be null.");
        else if (schoolId !== undefined)
            url_ += "schoolId=" + encodeURIComponent("" + schoolId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetClassesFromStudent(_response));
        });
    }

    protected processGetClassesFromStudent(response: AxiosResponse): Promise<Class[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<Class[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Class[]>(null as any);
    }
}

export class StudentGroupsClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getList(listFilter: StudentGroupListFilter, cancelToken?: CancelToken): Promise<StudentGroupListDto[]> {
        let url_ = this.baseUrl + "/StudentGroups/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetList(_response));
        });
    }

    protected processGetList(response: AxiosResponse): Promise<StudentGroupListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentGroupListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentGroupListDto[]>(null as any);
    }

    getListTotal(listFilter: StudentGroupListFilter, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentGroups/GetListTotal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListTotal(_response));
        });
    }

    protected processGetListTotal(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getIds(listFilter: StudentGroupListFilter, cancelToken?: CancelToken): Promise<number[]> {
        let url_ = this.baseUrl + "/StudentGroups/GetIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetIds(_response));
        });
    }

    protected processGetIds(response: AxiosResponse): Promise<number[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number[]>(null as any);
    }

    getListResource( cancelToken?: CancelToken): Promise<StudentGroupListResource> {
        let url_ = this.baseUrl + "/StudentGroups/GetListResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListResource(_response));
        });
    }

    protected processGetListResource(response: AxiosResponse): Promise<StudentGroupListResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentGroupListResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentGroupListResource>(null as any);
    }

    getFilterResource( cancelToken?: CancelToken): Promise<StudentGroupFilterResource> {
        let url_ = this.baseUrl + "/StudentGroups/GetFilterResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetFilterResource(_response));
        });
    }

    protected processGetFilterResource(response: AxiosResponse): Promise<StudentGroupFilterResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentGroupFilterResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentGroupFilterResource>(null as any);
    }

    get(id: number | undefined, cancelToken?: CancelToken): Promise<StudentGroup> {
        let url_ = this.baseUrl + "/StudentGroups/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<StudentGroup> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentGroup>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentGroup>(null as any);
    }

    getViewResource( cancelToken?: CancelToken): Promise<StudentGroupViewResource> {
        let url_ = this.baseUrl + "/StudentGroups/GetViewResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetViewResource(_response));
        });
    }

    protected processGetViewResource(response: AxiosResponse): Promise<StudentGroupViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentGroupViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentGroupViewResource>(null as any);
    }

    getEditResource( cancelToken?: CancelToken): Promise<StudentGroupEditResource> {
        let url_ = this.baseUrl + "/StudentGroups/GetEditResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEditResource(_response));
        });
    }

    protected processGetEditResource(response: AxiosResponse): Promise<StudentGroupEditResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentGroupEditResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentGroupEditResource>(null as any);
    }

    saveCreate(groupVm: StudentGroup, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentGroups/SaveCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(groupVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreate(_response));
        });
    }

    protected processSaveCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveUpdate(groupVm: StudentGroup, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentGroups/SaveUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(groupVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdate(_response));
        });
    }

    protected processSaveUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    delete(id: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentGroups/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getBulkUpdate(ids: number[], cancelToken?: CancelToken): Promise<StudentGroupBulkUpdate> {
        let url_ = this.baseUrl + "/StudentGroups/GetBulkUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetBulkUpdate(_response));
        });
    }

    protected processGetBulkUpdate(response: AxiosResponse): Promise<StudentGroupBulkUpdate> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentGroupBulkUpdate>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentGroupBulkUpdate>(null as any);
    }

    getBulkUpdateResource( cancelToken?: CancelToken): Promise<StudentGroupBulkUpdateResource> {
        let url_ = this.baseUrl + "/StudentGroups/GetBulkUpdateResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetBulkUpdateResource(_response));
        });
    }

    protected processGetBulkUpdateResource(response: AxiosResponse): Promise<StudentGroupBulkUpdateResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentGroupBulkUpdateResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentGroupBulkUpdateResource>(null as any);
    }

    saveBulkUpdate(bulkUpdate: StudentGroupBulkUpdate, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentGroups/SaveBulkUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bulkUpdate);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveBulkUpdate(_response));
        });
    }

    protected processSaveBulkUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class StudentParentsClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getList(listFilter: StudentParentListFilter, cancelToken?: CancelToken): Promise<StudentParentListDto[]> {
        let url_ = this.baseUrl + "/StudentParents/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetList(_response));
        });
    }

    protected processGetList(response: AxiosResponse): Promise<StudentParentListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentParentListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentParentListDto[]>(null as any);
    }

    getListTotal(listFilter: StudentParentListFilter, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentParents/GetListTotal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListTotal(_response));
        });
    }

    protected processGetListTotal(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    get(id: number | undefined, cancelToken?: CancelToken): Promise<StudentParent> {
        let url_ = this.baseUrl + "/StudentParents/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<StudentParent> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentParent>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentParent>(null as any);
    }

    getViewResource( cancelToken?: CancelToken): Promise<StudentParentViewResource> {
        let url_ = this.baseUrl + "/StudentParents/GetViewResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetViewResource(_response));
        });
    }

    protected processGetViewResource(response: AxiosResponse): Promise<StudentParentViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentParentViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentParentViewResource>(null as any);
    }

    getEditResource( cancelToken?: CancelToken): Promise<StudentParentEditResource> {
        let url_ = this.baseUrl + "/StudentParents/GetEditResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEditResource(_response));
        });
    }

    protected processGetEditResource(response: AxiosResponse): Promise<StudentParentEditResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentParentEditResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentParentEditResource>(null as any);
    }

    saveCreate(studentParentVm: StudentParent, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentParents/SaveCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(studentParentVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreate(_response));
        });
    }

    protected processSaveCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveUpdate(studentParentVm: StudentParent, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentParents/SaveUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(studentParentVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdate(_response));
        });
    }

    protected processSaveUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    delete(id: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentParents/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getParentsByName(firstName: string | null | undefined, lastName: string | null | undefined, cancelToken?: CancelToken): Promise<ParentAssignDto[]> {
        let url_ = this.baseUrl + "/StudentParents/GetParentsByName?";
        if (firstName !== undefined && firstName !== null)
            url_ += "firstName=" + encodeURIComponent("" + firstName) + "&";
        if (lastName !== undefined && lastName !== null)
            url_ += "lastName=" + encodeURIComponent("" + lastName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetParentsByName(_response));
        });
    }

    protected processGetParentsByName(response: AxiosResponse): Promise<ParentAssignDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ParentAssignDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ParentAssignDto[]>(null as any);
    }

    getStudentAddress(studentId: number | undefined, cancelToken?: CancelToken): Promise<Address> {
        let url_ = this.baseUrl + "/StudentParents/GetStudentAddress?";
        if (studentId === null)
            throw new globalThis.Error("The parameter 'studentId' cannot be null.");
        else if (studentId !== undefined)
            url_ += "studentId=" + encodeURIComponent("" + studentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetStudentAddress(_response));
        });
    }

    protected processGetStudentAddress(response: AxiosResponse): Promise<Address> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<Address>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Address>(null as any);
    }
}

export class StudentPostHighSchoolsClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getList(listFilter: StudentPostHighSchoolListFilter, cancelToken?: CancelToken): Promise<StudentPostHighSchoolListDto[]> {
        let url_ = this.baseUrl + "/StudentPostHighSchools/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetList(_response));
        });
    }

    protected processGetList(response: AxiosResponse): Promise<StudentPostHighSchoolListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentPostHighSchoolListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentPostHighSchoolListDto[]>(null as any);
    }

    getListTotal(listFilter: StudentPostHighSchoolListFilter, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentPostHighSchools/GetListTotal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListTotal(_response));
        });
    }

    protected processGetListTotal(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    get(id: number | undefined, cancelToken?: CancelToken): Promise<StudentPostHighSchool> {
        let url_ = this.baseUrl + "/StudentPostHighSchools/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<StudentPostHighSchool> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentPostHighSchool>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentPostHighSchool>(null as any);
    }

    getViewResource( cancelToken?: CancelToken): Promise<StudentPostHighSchoolViewResource> {
        let url_ = this.baseUrl + "/StudentPostHighSchools/GetViewResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetViewResource(_response));
        });
    }

    protected processGetViewResource(response: AxiosResponse): Promise<StudentPostHighSchoolViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentPostHighSchoolViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentPostHighSchoolViewResource>(null as any);
    }

    getEditResource( cancelToken?: CancelToken): Promise<StudentPostHighSchoolEditResource> {
        let url_ = this.baseUrl + "/StudentPostHighSchools/GetEditResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEditResource(_response));
        });
    }

    protected processGetEditResource(response: AxiosResponse): Promise<StudentPostHighSchoolEditResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentPostHighSchoolEditResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentPostHighSchoolEditResource>(null as any);
    }

    saveCreate(diplomaVm: StudentPostHighSchool, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentPostHighSchools/SaveCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(diplomaVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreate(_response));
        });
    }

    protected processSaveCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveUpdate(diplomaVm: StudentPostHighSchool, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentPostHighSchools/SaveUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(diplomaVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdate(_response));
        });
    }

    protected processSaveUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    delete(id: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentPostHighSchools/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class StudentScholarshipsClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getList(listFilter: StudentScholarshipListFilter, cancelToken?: CancelToken): Promise<StudentScholarshipListDto[]> {
        let url_ = this.baseUrl + "/StudentScholarships/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetList(_response));
        });
    }

    protected processGetList(response: AxiosResponse): Promise<StudentScholarshipListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentScholarshipListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentScholarshipListDto[]>(null as any);
    }

    getListTotal(listFilter: StudentScholarshipListFilter, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentScholarships/GetListTotal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListTotal(_response));
        });
    }

    protected processGetListTotal(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    get(id: number | undefined, cancelToken?: CancelToken): Promise<StudentScholarship> {
        let url_ = this.baseUrl + "/StudentScholarships/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<StudentScholarship> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentScholarship>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentScholarship>(null as any);
    }

    getViewResource( cancelToken?: CancelToken): Promise<StudentScholarshipViewResource> {
        let url_ = this.baseUrl + "/StudentScholarships/GetViewResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetViewResource(_response));
        });
    }

    protected processGetViewResource(response: AxiosResponse): Promise<StudentScholarshipViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentScholarshipViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentScholarshipViewResource>(null as any);
    }

    getEditResource( cancelToken?: CancelToken): Promise<StudentScholarshipEditResource> {
        let url_ = this.baseUrl + "/StudentScholarships/GetEditResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEditResource(_response));
        });
    }

    protected processGetEditResource(response: AxiosResponse): Promise<StudentScholarshipEditResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentScholarshipEditResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentScholarshipEditResource>(null as any);
    }

    saveCreate(scholarshipVm: StudentScholarship, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentScholarships/SaveCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(scholarshipVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreate(_response));
        });
    }

    protected processSaveCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveUpdate(scholarshipVm: StudentScholarship, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentScholarships/SaveUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(scholarshipVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdate(_response));
        });
    }

    protected processSaveUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    delete(id: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentScholarships/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class StudentsClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getList(listFilter: StudentListFilter, cancelToken?: CancelToken): Promise<StudentListDto[]> {
        let url_ = this.baseUrl + "/Students/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetList(_response));
        });
    }

    protected processGetList(response: AxiosResponse): Promise<StudentListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentListDto[]>(null as any);
    }

    getDeletedList(listFilter: StudentListFilter, cancelToken?: CancelToken): Promise<StudentListDto[]> {
        let url_ = this.baseUrl + "/Students/GetDeletedList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetDeletedList(_response));
        });
    }

    protected processGetDeletedList(response: AxiosResponse): Promise<StudentListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentListDto[]>(null as any);
    }

    getListTotal(listFilter: StudentListFilter, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Students/GetListTotal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListTotal(_response));
        });
    }

    protected processGetListTotal(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getDeletedListTotal(listFilter: StudentListFilter, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Students/GetDeletedListTotal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetDeletedListTotal(_response));
        });
    }

    protected processGetDeletedListTotal(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getIds(listFilter: StudentListFilter, cancelToken?: CancelToken): Promise<number[]> {
        let url_ = this.baseUrl + "/Students/GetIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetIds(_response));
        });
    }

    protected processGetIds(response: AxiosResponse): Promise<number[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number[]>(null as any);
    }

    getListResource( cancelToken?: CancelToken): Promise<StudentListResource> {
        let url_ = this.baseUrl + "/Students/GetListResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListResource(_response));
        });
    }

    protected processGetListResource(response: AxiosResponse): Promise<StudentListResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentListResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentListResource>(null as any);
    }

    getFilterResource( cancelToken?: CancelToken): Promise<StudentFilterResource> {
        let url_ = this.baseUrl + "/Students/GetFilterResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetFilterResource(_response));
        });
    }

    protected processGetFilterResource(response: AxiosResponse): Promise<StudentFilterResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentFilterResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentFilterResource>(null as any);
    }

    get(id: number | undefined, cancelToken?: CancelToken): Promise<Student> {
        let url_ = this.baseUrl + "/Students/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<Student> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<Student>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Student>(null as any);
    }

    getViewResource(id: number | undefined, cancelToken?: CancelToken): Promise<StudentViewResource> {
        let url_ = this.baseUrl + "/Students/GetViewResource?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetViewResource(_response));
        });
    }

    protected processGetViewResource(response: AxiosResponse): Promise<StudentViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentViewResource>(null as any);
    }

    getEditResource( cancelToken?: CancelToken): Promise<StudentEditResource> {
        let url_ = this.baseUrl + "/Students/GetEditResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEditResource(_response));
        });
    }

    protected processGetEditResource(response: AxiosResponse): Promise<StudentEditResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentEditResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentEditResource>(null as any);
    }

    saveCreateValidate(studentVm: Student, step: number | null | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Students/SaveCreateValidate?";
        if (step !== undefined && step !== null)
            url_ += "step=" + encodeURIComponent("" + step) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(studentVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreateValidate(_response));
        });
    }

    protected processSaveCreateValidate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveCreate(studentVm: Student, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Students/SaveCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(studentVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreate(_response));
        });
    }

    protected processSaveCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveUpdate(studentVm: Student, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Students/SaveUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(studentVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdate(_response));
        });
    }

    protected processSaveUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    delete(id: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Students/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getTranscript(id: number | undefined, cancelToken?: CancelToken): Promise<StudentTranscript> {
        let url_ = this.baseUrl + "/Students/GetTranscript?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetTranscript(_response));
        });
    }

    protected processGetTranscript(response: AxiosResponse): Promise<StudentTranscript> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentTranscript>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentTranscript>(null as any);
    }

    getAprUb(id: number | undefined, schoolYear: number | undefined, cancelToken?: CancelToken): Promise<AprUbResponseRow> {
        let url_ = this.baseUrl + "/Students/GetAprUb?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (schoolYear === null)
            throw new globalThis.Error("The parameter 'schoolYear' cannot be null.");
        else if (schoolYear !== undefined)
            url_ += "schoolYear=" + encodeURIComponent("" + schoolYear) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAprUb(_response));
        });
    }

    protected processGetAprUb(response: AxiosResponse): Promise<AprUbResponseRow> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<AprUbResponseRow>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AprUbResponseRow>(null as any);
    }

    getAprUbResource( cancelToken?: CancelToken): Promise<StudentAprUbResource> {
        let url_ = this.baseUrl + "/Students/GetAprUbResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAprUbResource(_response));
        });
    }

    protected processGetAprUbResource(response: AxiosResponse): Promise<StudentAprUbResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentAprUbResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentAprUbResource>(null as any);
    }

    getComments(id: number | undefined, cancelToken?: CancelToken): Promise<Comment[]> {
        let url_ = this.baseUrl + "/Students/GetComments?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetComments(_response));
        });
    }

    protected processGetComments(response: AxiosResponse): Promise<Comment[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<Comment[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Comment[]>(null as any);
    }

    saveCreateComment(id: number | undefined, comment: Comment, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Students/SaveCreateComment?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(comment);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreateComment(_response));
        });
    }

    protected processSaveCreateComment(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    generatedCustomId1( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/Students/GeneratedCustomId1";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGeneratedCustomId1(_response));
        });
    }

    protected processGeneratedCustomId1(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    getBulkCreateServices(ids: number[], cancelToken?: CancelToken): Promise<StudentBulkCreateServices> {
        let url_ = this.baseUrl + "/Students/GetBulkCreateServices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetBulkCreateServices(_response));
        });
    }

    protected processGetBulkCreateServices(response: AxiosResponse): Promise<StudentBulkCreateServices> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentBulkCreateServices>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentBulkCreateServices>(null as any);
    }

    getBulkCreateServicesResource( cancelToken?: CancelToken): Promise<StudentBulkCreateServicesResource> {
        let url_ = this.baseUrl + "/Students/GetBulkCreateServicesResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetBulkCreateServicesResource(_response));
        });
    }

    protected processGetBulkCreateServicesResource(response: AxiosResponse): Promise<StudentBulkCreateServicesResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentBulkCreateServicesResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentBulkCreateServicesResource>(null as any);
    }

    saveBulkCreateServices(bulkCreateServices: StudentBulkCreateServices, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Students/SaveBulkCreateServices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bulkCreateServices);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveBulkCreateServices(_response));
        });
    }

    protected processSaveBulkCreateServices(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getBulkUpdate(ids: number[], cancelToken?: CancelToken): Promise<StudentBulkUpdate> {
        let url_ = this.baseUrl + "/Students/GetBulkUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetBulkUpdate(_response));
        });
    }

    protected processGetBulkUpdate(response: AxiosResponse): Promise<StudentBulkUpdate> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentBulkUpdate>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentBulkUpdate>(null as any);
    }

    getBulkUpdateResource( cancelToken?: CancelToken): Promise<StudentBulkUpdateResource> {
        let url_ = this.baseUrl + "/Students/GetBulkUpdateResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetBulkUpdateResource(_response));
        });
    }

    protected processGetBulkUpdateResource(response: AxiosResponse): Promise<StudentBulkUpdateResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentBulkUpdateResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentBulkUpdateResource>(null as any);
    }

    saveBulkUpdate(bulkUpdate: StudentBulkUpdate, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Students/SaveBulkUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bulkUpdate);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveBulkUpdate(_response));
        });
    }

    protected processSaveBulkUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getBulkAssignGroup(ids: number[], cancelToken?: CancelToken): Promise<StudentBulkAssignGroup> {
        let url_ = this.baseUrl + "/Students/GetBulkAssignGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetBulkAssignGroup(_response));
        });
    }

    protected processGetBulkAssignGroup(response: AxiosResponse): Promise<StudentBulkAssignGroup> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentBulkAssignGroup>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentBulkAssignGroup>(null as any);
    }

    getBulkAssignGroupResource( cancelToken?: CancelToken): Promise<StudentBulkAssignGroupResource> {
        let url_ = this.baseUrl + "/Students/GetBulkAssignGroupResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetBulkAssignGroupResource(_response));
        });
    }

    protected processGetBulkAssignGroupResource(response: AxiosResponse): Promise<StudentBulkAssignGroupResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentBulkAssignGroupResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentBulkAssignGroupResource>(null as any);
    }

    saveBulkAssignGroup(bulkAssignGroup: StudentBulkAssignGroup, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Students/SaveBulkAssignGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bulkAssignGroup);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveBulkAssignGroup(_response));
        });
    }

    protected processSaveBulkAssignGroup(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getCustomIdTypes( cancelToken?: CancelToken): Promise<StudentCustomIdType[]> {
        let url_ = this.baseUrl + "/Students/GetCustomIdTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetCustomIdTypes(_response));
        });
    }

    protected processGetCustomIdTypes(response: AxiosResponse): Promise<StudentCustomIdType[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentCustomIdType[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentCustomIdType[]>(null as any);
    }

    getByCustomIds(request: StudentCustomIdsRequest, cancelToken?: CancelToken): Promise<Student[]> {
        let url_ = this.baseUrl + "/Students/GetByCustomIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetByCustomIds(_response));
        });
    }

    protected processGetByCustomIds(response: AxiosResponse): Promise<Student[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<Student[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Student[]>(null as any);
    }

    getGroupStudents(groupId: number | undefined, cancelToken?: CancelToken): Promise<Student[]> {
        let url_ = this.baseUrl + "/Students/GetGroupStudents?";
        if (groupId === null)
            throw new globalThis.Error("The parameter 'groupId' cannot be null.");
        else if (groupId !== undefined)
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetGroupStudents(_response));
        });
    }

    protected processGetGroupStudents(response: AxiosResponse): Promise<Student[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<Student[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Student[]>(null as any);
    }

    getStudentByCustomId(customId: string | null | undefined, customIdType: number | undefined, cancelToken?: CancelToken): Promise<Student> {
        let url_ = this.baseUrl + "/Students/GetStudentByCustomId?";
        if (customId !== undefined && customId !== null)
            url_ += "customId=" + encodeURIComponent("" + customId) + "&";
        if (customIdType === null)
            throw new globalThis.Error("The parameter 'customIdType' cannot be null.");
        else if (customIdType !== undefined)
            url_ += "customIdType=" + encodeURIComponent("" + customIdType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetStudentByCustomId(_response));
        });
    }

    protected processGetStudentByCustomId(response: AxiosResponse): Promise<Student> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<Student>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Student>(null as any);
    }

    getEmail(studentId: number | undefined, cancelToken?: CancelToken): Promise<EmailModel> {
        let url_ = this.baseUrl + "/Students/GetEmail?";
        if (studentId === null)
            throw new globalThis.Error("The parameter 'studentId' cannot be null.");
        else if (studentId !== undefined)
            url_ += "studentId=" + encodeURIComponent("" + studentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEmail(_response));
        });
    }

    protected processGetEmail(response: AxiosResponse): Promise<EmailModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<EmailModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmailModel>(null as any);
    }

    getBulkEmail(ids: number[], cancelToken?: CancelToken): Promise<StudentBulkEmail> {
        let url_ = this.baseUrl + "/Students/GetBulkEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetBulkEmail(_response));
        });
    }

    protected processGetBulkEmail(response: AxiosResponse): Promise<StudentBulkEmail> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentBulkEmail>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentBulkEmail>(null as any);
    }

    getBulkMerge(ids: number[], cancelToken?: CancelToken): Promise<StudentBulkMerge> {
        let url_ = this.baseUrl + "/Students/GetBulkMerge";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetBulkMerge(_response));
        });
    }

    protected processGetBulkMerge(response: AxiosResponse): Promise<StudentBulkMerge> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentBulkMerge>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentBulkMerge>(null as any);
    }

    getBulkMergeResource( cancelToken?: CancelToken): Promise<StudentBulkMergeResource> {
        let url_ = this.baseUrl + "/Students/GetBulkMergeResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetBulkMergeResource(_response));
        });
    }

    protected processGetBulkMergeResource(response: AxiosResponse): Promise<StudentBulkMergeResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentBulkMergeResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentBulkMergeResource>(null as any);
    }

    saveBulkMerge(bulkMerge: StudentBulkMerge, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Students/SaveBulkMerge";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bulkMerge);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveBulkMerge(_response));
        });
    }

    protected processSaveBulkMerge(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    generateQrCode(id: number | undefined, cancelToken?: CancelToken): Promise<UploadFile> {
        let url_ = this.baseUrl + "/Students/GenerateQrCode?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGenerateQrCode(_response));
        });
    }

    protected processGenerateQrCode(response: AxiosResponse): Promise<UploadFile> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<UploadFile>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UploadFile>(null as any);
    }
}

export class StudentServiceIndexesClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getList(listFilter: StudentServiceIndexListFilter, cancelToken?: CancelToken): Promise<StudentServiceIndexListDto[]> {
        let url_ = this.baseUrl + "/StudentServiceIndexes/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetList(_response));
        });
    }

    protected processGetList(response: AxiosResponse): Promise<StudentServiceIndexListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentServiceIndexListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentServiceIndexListDto[]>(null as any);
    }

    getListTotal(listFilter: StudentServiceIndexListFilter, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentServiceIndexes/GetListTotal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListTotal(_response));
        });
    }

    protected processGetListTotal(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getListResource( cancelToken?: CancelToken): Promise<StudentServiceIndexListResource> {
        let url_ = this.baseUrl + "/StudentServiceIndexes/GetListResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListResource(_response));
        });
    }

    protected processGetListResource(response: AxiosResponse): Promise<StudentServiceIndexListResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentServiceIndexListResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentServiceIndexListResource>(null as any);
    }

    getFilterResource( cancelToken?: CancelToken): Promise<StudentServiceIndexFilterResource> {
        let url_ = this.baseUrl + "/StudentServiceIndexes/GetFilterResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetFilterResource(_response));
        });
    }

    protected processGetFilterResource(response: AxiosResponse): Promise<StudentServiceIndexFilterResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentServiceIndexFilterResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentServiceIndexFilterResource>(null as any);
    }

    get(id: number | undefined, cancelToken?: CancelToken): Promise<StudentServiceIndex> {
        let url_ = this.baseUrl + "/StudentServiceIndexes/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<StudentServiceIndex> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentServiceIndex>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentServiceIndex>(null as any);
    }

    getViewResource( cancelToken?: CancelToken): Promise<StudentServiceIndexViewResource> {
        let url_ = this.baseUrl + "/StudentServiceIndexes/GetViewResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetViewResource(_response));
        });
    }

    protected processGetViewResource(response: AxiosResponse): Promise<StudentServiceIndexViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentServiceIndexViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentServiceIndexViewResource>(null as any);
    }

    getEditResource( cancelToken?: CancelToken): Promise<StudentServiceIndexEditResource> {
        let url_ = this.baseUrl + "/StudentServiceIndexes/GetEditResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEditResource(_response));
        });
    }

    protected processGetEditResource(response: AxiosResponse): Promise<StudentServiceIndexEditResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentServiceIndexEditResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentServiceIndexEditResource>(null as any);
    }

    saveCreate(indexVm: StudentServiceIndex, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentServiceIndexes/SaveCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(indexVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreate(_response));
        });
    }

    protected processSaveCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveUpdate(indexVm: StudentServiceIndex, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentServiceIndexes/SaveUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(indexVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdate(_response));
        });
    }

    protected processSaveUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    delete(id: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentServiceIndexes/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class StudentServiceTemplatesClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getList(listFilter: StudentServiceTemplateListFilter, cancelToken?: CancelToken): Promise<StudentServiceTemplateListDto[]> {
        let url_ = this.baseUrl + "/StudentServiceTemplates/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetList(_response));
        });
    }

    protected processGetList(response: AxiosResponse): Promise<StudentServiceTemplateListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentServiceTemplateListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentServiceTemplateListDto[]>(null as any);
    }

    getFilterResource( cancelToken?: CancelToken): Promise<StudentServiceTemplateFilterResource> {
        let url_ = this.baseUrl + "/StudentServiceTemplates/GetFilterResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetFilterResource(_response));
        });
    }

    protected processGetFilterResource(response: AxiosResponse): Promise<StudentServiceTemplateFilterResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentServiceTemplateFilterResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentServiceTemplateFilterResource>(null as any);
    }

    getListTotal(listFilter: StudentServiceTemplateListFilter, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentServiceTemplates/GetListTotal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListTotal(_response));
        });
    }

    protected processGetListTotal(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getListResource( cancelToken?: CancelToken): Promise<StudentServiceTemplateListResource> {
        let url_ = this.baseUrl + "/StudentServiceTemplates/GetListResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListResource(_response));
        });
    }

    protected processGetListResource(response: AxiosResponse): Promise<StudentServiceTemplateListResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentServiceTemplateListResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentServiceTemplateListResource>(null as any);
    }

    get(id: number | undefined, cancelToken?: CancelToken): Promise<StudentServiceTemplate> {
        let url_ = this.baseUrl + "/StudentServiceTemplates/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<StudentServiceTemplate> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentServiceTemplate>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentServiceTemplate>(null as any);
    }

    getPartialStudent(partialStudentId: number | undefined, cancelToken?: CancelToken): Promise<StudentServicePartialStudent> {
        let url_ = this.baseUrl + "/StudentServiceTemplates/GetPartialStudent?";
        if (partialStudentId === null)
            throw new globalThis.Error("The parameter 'partialStudentId' cannot be null.");
        else if (partialStudentId !== undefined)
            url_ += "partialStudentId=" + encodeURIComponent("" + partialStudentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPartialStudent(_response));
        });
    }

    protected processGetPartialStudent(response: AxiosResponse): Promise<StudentServicePartialStudent> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentServicePartialStudent>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentServicePartialStudent>(null as any);
    }

    getServiceTemplateAttendees(serviceTemplateId: number | undefined, cancelToken?: CancelToken): Promise<StudentServiceTemplateAttendee[]> {
        let url_ = this.baseUrl + "/StudentServiceTemplates/GetServiceTemplateAttendees?";
        if (serviceTemplateId === null)
            throw new globalThis.Error("The parameter 'serviceTemplateId' cannot be null.");
        else if (serviceTemplateId !== undefined)
            url_ += "serviceTemplateId=" + encodeURIComponent("" + serviceTemplateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetServiceTemplateAttendees(_response));
        });
    }

    protected processGetServiceTemplateAttendees(response: AxiosResponse): Promise<StudentServiceTemplateAttendee[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentServiceTemplateAttendee[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentServiceTemplateAttendee[]>(null as any);
    }

    getViewResource(templateId: number | undefined, cancelToken?: CancelToken): Promise<StudentServiceTemplateViewResource> {
        let url_ = this.baseUrl + "/StudentServiceTemplates/GetViewResource?";
        if (templateId === null)
            throw new globalThis.Error("The parameter 'templateId' cannot be null.");
        else if (templateId !== undefined)
            url_ += "templateId=" + encodeURIComponent("" + templateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetViewResource(_response));
        });
    }

    protected processGetViewResource(response: AxiosResponse): Promise<StudentServiceTemplateViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentServiceTemplateViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentServiceTemplateViewResource>(null as any);
    }

    getEditResource( cancelToken?: CancelToken): Promise<StudentServiceTemplateEditResource> {
        let url_ = this.baseUrl + "/StudentServiceTemplates/GetEditResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEditResource(_response));
        });
    }

    protected processGetEditResource(response: AxiosResponse): Promise<StudentServiceTemplateEditResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentServiceTemplateEditResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentServiceTemplateEditResource>(null as any);
    }

    saveCreate(templateVm: StudentServiceTemplate, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentServiceTemplates/SaveCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(templateVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreate(_response));
        });
    }

    protected processSaveCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveUpdate(templateVm: StudentServiceTemplate, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentServiceTemplates/SaveUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(templateVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdate(_response));
        });
    }

    protected processSaveUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    addAttendees(request: StudentServiceAddAttendeeRequest, cancelToken?: CancelToken): Promise<StudentServiceAddAttendeeResponse> {
        let url_ = this.baseUrl + "/StudentServiceTemplates/AddAttendees";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processAddAttendees(_response));
        });
    }

    protected processAddAttendees(response: AxiosResponse): Promise<StudentServiceAddAttendeeResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentServiceAddAttendeeResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentServiceAddAttendeeResponse>(null as any);
    }

    linkExistingStudent(existingVm: StudentServiceTemplateLinkExisting, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/StudentServiceTemplates/LinkExistingStudent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(existingVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processLinkExistingStudent(_response));
        });
    }

    protected processLinkExistingStudent(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    generateQrCode(id: number | undefined, cancelToken?: CancelToken): Promise<UploadFile> {
        let url_ = this.baseUrl + "/StudentServiceTemplates/GenerateQrCode?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGenerateQrCode(_response));
        });
    }

    protected processGenerateQrCode(response: AxiosResponse): Promise<UploadFile> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<UploadFile>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UploadFile>(null as any);
    }

    delete(id: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentServiceTemplates/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getSignUpRequest(tenantName: string | null | undefined, templateId: number | undefined, validationToken: string | null | undefined, cancelToken?: CancelToken): Promise<StudentServiceTemplateSignUpRequest> {
        let url_ = this.baseUrl + "/StudentServiceTemplates/GetSignUpRequest?";
        if (tenantName !== undefined && tenantName !== null)
            url_ += "tenantName=" + encodeURIComponent("" + tenantName) + "&";
        if (templateId === null)
            throw new globalThis.Error("The parameter 'templateId' cannot be null.");
        else if (templateId !== undefined)
            url_ += "templateId=" + encodeURIComponent("" + templateId) + "&";
        if (validationToken !== undefined && validationToken !== null)
            url_ += "validationToken=" + encodeURIComponent("" + validationToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSignUpRequest(_response));
        });
    }

    protected processGetSignUpRequest(response: AxiosResponse): Promise<StudentServiceTemplateSignUpRequest> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentServiceTemplateSignUpRequest>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentServiceTemplateSignUpRequest>(null as any);
    }

    getSignUpResource(tenantName: string | null | undefined, cancelToken?: CancelToken): Promise<StudentServiceTemplateSignUpResource> {
        let url_ = this.baseUrl + "/StudentServiceTemplates/GetSignUpResource?";
        if (tenantName !== undefined && tenantName !== null)
            url_ += "tenantName=" + encodeURIComponent("" + tenantName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSignUpResource(_response));
        });
    }

    protected processGetSignUpResource(response: AxiosResponse): Promise<StudentServiceTemplateSignUpResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentServiceTemplateSignUpResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentServiceTemplateSignUpResource>(null as any);
    }

    signUpConfirmation(request: StudentServiceTemplateSignUpRequest, cancelToken?: CancelToken): Promise<StudentServiceTemplateSignUpConfirmation> {
        let url_ = this.baseUrl + "/StudentServiceTemplates/SignUpConfirmation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSignUpConfirmation(_response));
        });
    }

    protected processSignUpConfirmation(response: AxiosResponse): Promise<StudentServiceTemplateSignUpConfirmation> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentServiceTemplateSignUpConfirmation>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentServiceTemplateSignUpConfirmation>(null as any);
    }

    signUp(request: StudentServiceTemplateSignUpRequest, cancelToken?: CancelToken): Promise<StudentServiceTemplateSignUpResource> {
        let url_ = this.baseUrl + "/StudentServiceTemplates/SignUp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSignUp(_response));
        });
    }

    protected processSignUp(response: AxiosResponse): Promise<StudentServiceTemplateSignUpResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentServiceTemplateSignUpResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentServiceTemplateSignUpResource>(null as any);
    }
}

export class StudentTestsClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getList(listFilter: StudentTestListFilter, cancelToken?: CancelToken): Promise<StudentTestListDto[]> {
        let url_ = this.baseUrl + "/StudentTests/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetList(_response));
        });
    }

    protected processGetList(response: AxiosResponse): Promise<StudentTestListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentTestListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentTestListDto[]>(null as any);
    }

    getListTotal(listFilter: StudentTestListFilter, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentTests/GetListTotal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListTotal(_response));
        });
    }

    protected processGetListTotal(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getListResource( cancelToken?: CancelToken): Promise<StudentTestListResource> {
        let url_ = this.baseUrl + "/StudentTests/GetListResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListResource(_response));
        });
    }

    protected processGetListResource(response: AxiosResponse): Promise<StudentTestListResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentTestListResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentTestListResource>(null as any);
    }

    get(id: number | undefined, cancelToken?: CancelToken): Promise<StudentTest> {
        let url_ = this.baseUrl + "/StudentTests/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<StudentTest> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentTest>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentTest>(null as any);
    }

    getViewResource( cancelToken?: CancelToken): Promise<StudentTestViewResource> {
        let url_ = this.baseUrl + "/StudentTests/GetViewResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetViewResource(_response));
        });
    }

    protected processGetViewResource(response: AxiosResponse): Promise<StudentTestViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentTestViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentTestViewResource>(null as any);
    }

    getEditResource( cancelToken?: CancelToken): Promise<StudentTestEditResource> {
        let url_ = this.baseUrl + "/StudentTests/GetEditResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEditResource(_response));
        });
    }

    protected processGetEditResource(response: AxiosResponse): Promise<StudentTestEditResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentTestEditResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentTestEditResource>(null as any);
    }

    saveCreate(testVm: StudentTest, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentTests/SaveCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(testVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreate(_response));
        });
    }

    protected processSaveCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveUpdate(testVm: StudentTest, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentTests/SaveUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(testVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdate(_response));
        });
    }

    protected processSaveUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    delete(id: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentTests/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class ContributorMatchServicesClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getList(listFilter: ListFilterBase, cancelToken?: CancelToken): Promise<ContributorMatchServiceListDto[]> {
        let url_ = this.baseUrl + "/ContributorMatchServices/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetList(_response));
        });
    }

    protected processGetList(response: AxiosResponse): Promise<ContributorMatchServiceListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ContributorMatchServiceListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContributorMatchServiceListDto[]>(null as any);
    }

    getListTotal(listFilter: ListFilterBase, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/ContributorMatchServices/GetListTotal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListTotal(_response));
        });
    }

    protected processGetListTotal(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getListResource( cancelToken?: CancelToken): Promise<ContributorMatchServiceListResource> {
        let url_ = this.baseUrl + "/ContributorMatchServices/GetListResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListResource(_response));
        });
    }

    protected processGetListResource(response: AxiosResponse): Promise<ContributorMatchServiceListResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ContributorMatchServiceListResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContributorMatchServiceListResource>(null as any);
    }

    get(id: number | undefined, cancelToken?: CancelToken): Promise<ContributorMatchService> {
        let url_ = this.baseUrl + "/ContributorMatchServices/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<ContributorMatchService> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ContributorMatchService>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContributorMatchService>(null as any);
    }

    getViewResource( cancelToken?: CancelToken): Promise<ContributorMatchServiceViewResource> {
        let url_ = this.baseUrl + "/ContributorMatchServices/GetViewResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetViewResource(_response));
        });
    }

    protected processGetViewResource(response: AxiosResponse): Promise<ContributorMatchServiceViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ContributorMatchServiceViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContributorMatchServiceViewResource>(null as any);
    }

    saveCreate(contributorMatchServiceVm: ContributorMatchService, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/ContributorMatchServices/SaveCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(contributorMatchServiceVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreate(_response));
        });
    }

    protected processSaveCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveUpdate(contributorMatchServiceVm: ContributorMatchService, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/ContributorMatchServices/SaveUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(contributorMatchServiceVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdate(_response));
        });
    }

    protected processSaveUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    delete(id: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/ContributorMatchServices/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class PartnerIndirectCostsClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getList(listFilter: PartnerIndirectCostListFilter, cancelToken?: CancelToken): Promise<PartnerIndirectCostListDto[]> {
        let url_ = this.baseUrl + "/PartnerIndirectCosts/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetList(_response));
        });
    }

    protected processGetList(response: AxiosResponse): Promise<PartnerIndirectCostListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<PartnerIndirectCostListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PartnerIndirectCostListDto[]>(null as any);
    }

    getListTotal(listFilter: PartnerIndirectCostListFilter, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/PartnerIndirectCosts/GetListTotal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListTotal(_response));
        });
    }

    protected processGetListTotal(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    get(id: number | undefined, cancelToken?: CancelToken): Promise<PartnerIndirectCost> {
        let url_ = this.baseUrl + "/PartnerIndirectCosts/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<PartnerIndirectCost> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<PartnerIndirectCost>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PartnerIndirectCost>(null as any);
    }

    getViewResource( cancelToken?: CancelToken): Promise<PartnerIndirectCostViewResource> {
        let url_ = this.baseUrl + "/PartnerIndirectCosts/GetViewResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetViewResource(_response));
        });
    }

    protected processGetViewResource(response: AxiosResponse): Promise<PartnerIndirectCostViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<PartnerIndirectCostViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PartnerIndirectCostViewResource>(null as any);
    }

    getListResource( cancelToken?: CancelToken): Promise<PartnerIndirectCostListResource> {
        let url_ = this.baseUrl + "/PartnerIndirectCosts/GetListResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListResource(_response));
        });
    }

    protected processGetListResource(response: AxiosResponse): Promise<PartnerIndirectCostListResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<PartnerIndirectCostListResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PartnerIndirectCostListResource>(null as any);
    }

    saveCreate(indirectCostVm: PartnerIndirectCost, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/PartnerIndirectCosts/SaveCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(indirectCostVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreate(_response));
        });
    }

    protected processSaveCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveUpdate(indirectCostVm: PartnerIndirectCost, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/PartnerIndirectCosts/SaveUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(indirectCostVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdate(_response));
        });
    }

    protected processSaveUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    delete(id: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/PartnerIndirectCosts/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class SubPartnersClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getList(listFilter: SubPartnerListFilter, cancelToken?: CancelToken): Promise<SubPartnerListDto[]> {
        let url_ = this.baseUrl + "/SubPartners/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetList(_response));
        });
    }

    protected processGetList(response: AxiosResponse): Promise<SubPartnerListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SubPartnerListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SubPartnerListDto[]>(null as any);
    }

    getListTotal(listFilter: SubPartnerListFilter, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/SubPartners/GetListTotal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListTotal(_response));
        });
    }

    protected processGetListTotal(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    get(id: number | undefined, cancelToken?: CancelToken): Promise<SubPartner> {
        let url_ = this.baseUrl + "/SubPartners/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<SubPartner> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SubPartner>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SubPartner>(null as any);
    }

    getViewResource( cancelToken?: CancelToken): Promise<SubPartnerViewResource> {
        let url_ = this.baseUrl + "/SubPartners/GetViewResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetViewResource(_response));
        });
    }

    protected processGetViewResource(response: AxiosResponse): Promise<SubPartnerViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SubPartnerViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SubPartnerViewResource>(null as any);
    }

    getListResource( cancelToken?: CancelToken): Promise<SubPartnerListResource> {
        let url_ = this.baseUrl + "/SubPartners/GetListResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListResource(_response));
        });
    }

    protected processGetListResource(response: AxiosResponse): Promise<SubPartnerListResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SubPartnerListResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SubPartnerListResource>(null as any);
    }

    saveCreate(subPartnerVm: SubPartner, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/SubPartners/SaveCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(subPartnerVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreate(_response));
        });
    }

    protected processSaveCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveUpdate(subPartnerVm: SubPartner, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/SubPartners/SaveUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(subPartnerVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdate(_response));
        });
    }

    protected processSaveUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    delete(id: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/SubPartners/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class SuppliesDetailsClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getList(listFilter: ListFilterBase, cancelToken?: CancelToken): Promise<SuppliesDetailListDto[]> {
        let url_ = this.baseUrl + "/SuppliesDetails/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetList(_response));
        });
    }

    protected processGetList(response: AxiosResponse): Promise<SuppliesDetailListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SuppliesDetailListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuppliesDetailListDto[]>(null as any);
    }

    getListTotal(listFilter: ListFilterBase, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/SuppliesDetails/GetListTotal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListTotal(_response));
        });
    }

    protected processGetListTotal(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getListResource( cancelToken?: CancelToken): Promise<SuppliesDetailListResource> {
        let url_ = this.baseUrl + "/SuppliesDetails/GetListResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListResource(_response));
        });
    }

    protected processGetListResource(response: AxiosResponse): Promise<SuppliesDetailListResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SuppliesDetailListResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuppliesDetailListResource>(null as any);
    }

    get(id: number | undefined, cancelToken?: CancelToken): Promise<SuppliesDetail> {
        let url_ = this.baseUrl + "/SuppliesDetails/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<SuppliesDetail> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SuppliesDetail>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuppliesDetail>(null as any);
    }

    getViewResource( cancelToken?: CancelToken): Promise<SuppliesDetailViewResource> {
        let url_ = this.baseUrl + "/SuppliesDetails/GetViewResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetViewResource(_response));
        });
    }

    protected processGetViewResource(response: AxiosResponse): Promise<SuppliesDetailViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SuppliesDetailViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuppliesDetailViewResource>(null as any);
    }

    saveCreate(suppliesDetailVm: SuppliesDetail, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/SuppliesDetails/SaveCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(suppliesDetailVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreate(_response));
        });
    }

    protected processSaveCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveUpdate(suppliesDetailVm: SuppliesDetail, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/SuppliesDetails/SaveUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(suppliesDetailVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdate(_response));
        });
    }

    protected processSaveUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    delete(id: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/SuppliesDetails/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class CollegesClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getList(listFilter: ListFilterBase, cancelToken?: CancelToken): Promise<CollegeListDto[]> {
        let url_ = this.baseUrl + "/Colleges/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetList(_response));
        });
    }

    protected processGetList(response: AxiosResponse): Promise<CollegeListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<CollegeListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CollegeListDto[]>(null as any);
    }

    getListTotal(listFilter: ListFilterBase, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Colleges/GetListTotal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListTotal(_response));
        });
    }

    protected processGetListTotal(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getListResource( cancelToken?: CancelToken): Promise<CollegeListResource> {
        let url_ = this.baseUrl + "/Colleges/GetListResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListResource(_response));
        });
    }

    protected processGetListResource(response: AxiosResponse): Promise<CollegeListResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<CollegeListResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CollegeListResource>(null as any);
    }

    get(id: number | undefined, cancelToken?: CancelToken): Promise<College> {
        let url_ = this.baseUrl + "/Colleges/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<College> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<College>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<College>(null as any);
    }

    getViewResource( cancelToken?: CancelToken): Promise<CollegeViewResource> {
        let url_ = this.baseUrl + "/Colleges/GetViewResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetViewResource(_response));
        });
    }

    protected processGetViewResource(response: AxiosResponse): Promise<CollegeViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<CollegeViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CollegeViewResource>(null as any);
    }

    getEditResource( cancelToken?: CancelToken): Promise<CollegeEditResource> {
        let url_ = this.baseUrl + "/Colleges/GetEditResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEditResource(_response));
        });
    }

    protected processGetEditResource(response: AxiosResponse): Promise<CollegeEditResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<CollegeEditResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CollegeEditResource>(null as any);
    }

    saveCreate(collegeVm: College, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Colleges/SaveCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(collegeVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreate(_response));
        });
    }

    protected processSaveCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveUpdate(collegeVm: College, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Colleges/SaveUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(collegeVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdate(_response));
        });
    }

    protected processSaveUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    delete(id: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Colleges/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class DisciplinesClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getList(listFilter: DisciplineListFilter, cancelToken?: CancelToken): Promise<DisciplineListDto[]> {
        let url_ = this.baseUrl + "/Disciplines/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetList(_response));
        });
    }

    protected processGetList(response: AxiosResponse): Promise<DisciplineListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<DisciplineListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DisciplineListDto[]>(null as any);
    }

    getListTotal(listFilter: DisciplineListFilter, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Disciplines/GetListTotal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListTotal(_response));
        });
    }

    protected processGetListTotal(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getListResource( cancelToken?: CancelToken): Promise<DisciplineListResource> {
        let url_ = this.baseUrl + "/Disciplines/GetListResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListResource(_response));
        });
    }

    protected processGetListResource(response: AxiosResponse): Promise<DisciplineListResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<DisciplineListResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DisciplineListResource>(null as any);
    }

    get(id: number | undefined, cancelToken?: CancelToken): Promise<Discipline> {
        let url_ = this.baseUrl + "/Disciplines/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<Discipline> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<Discipline>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Discipline>(null as any);
    }

    getViewResource( cancelToken?: CancelToken): Promise<DisciplineViewResource> {
        let url_ = this.baseUrl + "/Disciplines/GetViewResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetViewResource(_response));
        });
    }

    protected processGetViewResource(response: AxiosResponse): Promise<DisciplineViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<DisciplineViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DisciplineViewResource>(null as any);
    }

    getEditResource( cancelToken?: CancelToken): Promise<DisciplineEditResource> {
        let url_ = this.baseUrl + "/Disciplines/GetEditResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEditResource(_response));
        });
    }

    protected processGetEditResource(response: AxiosResponse): Promise<DisciplineEditResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<DisciplineEditResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DisciplineEditResource>(null as any);
    }

    saveCreate(disciplineVm: Discipline, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Disciplines/SaveCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(disciplineVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreate(_response));
        });
    }

    protected processSaveCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveUpdate(disciplineVm: Discipline, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Disciplines/SaveUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(disciplineVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdate(_response));
        });
    }

    protected processSaveUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    delete(id: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Disciplines/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class DistrictsClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getList(listFilter: ListFilterBase, cancelToken?: CancelToken): Promise<DistrictListDto[]> {
        let url_ = this.baseUrl + "/Districts/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetList(_response));
        });
    }

    protected processGetList(response: AxiosResponse): Promise<DistrictListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<DistrictListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DistrictListDto[]>(null as any);
    }

    getListTotal(listFilter: ListFilterBase, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Districts/GetListTotal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListTotal(_response));
        });
    }

    protected processGetListTotal(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getListResource( cancelToken?: CancelToken): Promise<DistrictListResource> {
        let url_ = this.baseUrl + "/Districts/GetListResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListResource(_response));
        });
    }

    protected processGetListResource(response: AxiosResponse): Promise<DistrictListResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<DistrictListResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DistrictListResource>(null as any);
    }

    get(id: number | undefined, cancelToken?: CancelToken): Promise<District> {
        let url_ = this.baseUrl + "/Districts/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<District> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<District>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<District>(null as any);
    }

    getViewResource( cancelToken?: CancelToken): Promise<DistrictViewResource> {
        let url_ = this.baseUrl + "/Districts/GetViewResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetViewResource(_response));
        });
    }

    protected processGetViewResource(response: AxiosResponse): Promise<DistrictViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<DistrictViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DistrictViewResource>(null as any);
    }

    getEditResource( cancelToken?: CancelToken): Promise<DistrictEditResource> {
        let url_ = this.baseUrl + "/Districts/GetEditResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEditResource(_response));
        });
    }

    protected processGetEditResource(response: AxiosResponse): Promise<DistrictEditResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<DistrictEditResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DistrictEditResource>(null as any);
    }

    saveCreate(districtVm: District, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Districts/SaveCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(districtVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreate(_response));
        });
    }

    protected processSaveCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveUpdate(districtVm: District, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Districts/SaveUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(districtVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdate(_response));
        });
    }

    protected processSaveUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    delete(id: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Districts/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class EndReasonsClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getList(listFilter: ListFilterBase, cancelToken?: CancelToken): Promise<EndReasonListDto[]> {
        let url_ = this.baseUrl + "/EndReasons/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetList(_response));
        });
    }

    protected processGetList(response: AxiosResponse): Promise<EndReasonListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<EndReasonListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EndReasonListDto[]>(null as any);
    }

    getListTotal(listFilter: ListFilterBase, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/EndReasons/GetListTotal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListTotal(_response));
        });
    }

    protected processGetListTotal(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getListResource( cancelToken?: CancelToken): Promise<EndReasonListResource> {
        let url_ = this.baseUrl + "/EndReasons/GetListResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListResource(_response));
        });
    }

    protected processGetListResource(response: AxiosResponse): Promise<EndReasonListResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<EndReasonListResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EndReasonListResource>(null as any);
    }

    get(id: number | undefined, cancelToken?: CancelToken): Promise<EndReason> {
        let url_ = this.baseUrl + "/EndReasons/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<EndReason> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<EndReason>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EndReason>(null as any);
    }

    getViewResource( cancelToken?: CancelToken): Promise<EndReasonViewResource> {
        let url_ = this.baseUrl + "/EndReasons/GetViewResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetViewResource(_response));
        });
    }

    protected processGetViewResource(response: AxiosResponse): Promise<EndReasonViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<EndReasonViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EndReasonViewResource>(null as any);
    }

    getEditResource( cancelToken?: CancelToken): Promise<EndReasonEditResource> {
        let url_ = this.baseUrl + "/EndReasons/GetEditResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEditResource(_response));
        });
    }

    protected processGetEditResource(response: AxiosResponse): Promise<EndReasonEditResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<EndReasonEditResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EndReasonEditResource>(null as any);
    }

    saveCreate(endReasonVm: EndReason, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/EndReasons/SaveCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(endReasonVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreate(_response));
        });
    }

    protected processSaveCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveUpdate(endReasonVm: EndReason, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/EndReasons/SaveUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(endReasonVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdate(_response));
        });
    }

    protected processSaveUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    delete(id: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/EndReasons/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class FeederSchoolsClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getList(listFilter: ListFilterBase, cancelToken?: CancelToken): Promise<FeederSchoolListDto[]> {
        let url_ = this.baseUrl + "/FeederSchools/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetList(_response));
        });
    }

    protected processGetList(response: AxiosResponse): Promise<FeederSchoolListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<FeederSchoolListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FeederSchoolListDto[]>(null as any);
    }

    getListTotal(listFilter: ListFilterBase, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/FeederSchools/GetListTotal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListTotal(_response));
        });
    }

    protected processGetListTotal(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getListResource( cancelToken?: CancelToken): Promise<FeederSchoolListResource> {
        let url_ = this.baseUrl + "/FeederSchools/GetListResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListResource(_response));
        });
    }

    protected processGetListResource(response: AxiosResponse): Promise<FeederSchoolListResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<FeederSchoolListResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FeederSchoolListResource>(null as any);
    }

    get(id: number | undefined, cancelToken?: CancelToken): Promise<FeederSchool> {
        let url_ = this.baseUrl + "/FeederSchools/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<FeederSchool> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<FeederSchool>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FeederSchool>(null as any);
    }

    getViewResource( cancelToken?: CancelToken): Promise<FeederSchoolViewResource> {
        let url_ = this.baseUrl + "/FeederSchools/GetViewResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetViewResource(_response));
        });
    }

    protected processGetViewResource(response: AxiosResponse): Promise<FeederSchoolViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<FeederSchoolViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FeederSchoolViewResource>(null as any);
    }

    getEditResource( cancelToken?: CancelToken): Promise<FeederSchoolEditResource> {
        let url_ = this.baseUrl + "/FeederSchools/GetEditResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEditResource(_response));
        });
    }

    protected processGetEditResource(response: AxiosResponse): Promise<FeederSchoolEditResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<FeederSchoolEditResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FeederSchoolEditResource>(null as any);
    }

    saveCreate(feederSchoolVm: FeederSchool, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/FeederSchools/SaveCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(feederSchoolVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreate(_response));
        });
    }

    protected processSaveCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveUpdate(feederSchoolVm: FeederSchool, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/FeederSchools/SaveUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(feederSchoolVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdate(_response));
        });
    }

    protected processSaveUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    delete(id: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/FeederSchools/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class FileCategoriesClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getList(listFilter: ListFilterBase, cancelToken?: CancelToken): Promise<FileCategoryListDto[]> {
        let url_ = this.baseUrl + "/FileCategories/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetList(_response));
        });
    }

    protected processGetList(response: AxiosResponse): Promise<FileCategoryListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<FileCategoryListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileCategoryListDto[]>(null as any);
    }

    getListTotal(listFilter: ListFilterBase, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/FileCategories/GetListTotal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListTotal(_response));
        });
    }

    protected processGetListTotal(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getListResource( cancelToken?: CancelToken): Promise<DistrictListResource> {
        let url_ = this.baseUrl + "/FileCategories/GetListResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListResource(_response));
        });
    }

    protected processGetListResource(response: AxiosResponse): Promise<DistrictListResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<DistrictListResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DistrictListResource>(null as any);
    }

    get(id: number | undefined, cancelToken?: CancelToken): Promise<FileCategory> {
        let url_ = this.baseUrl + "/FileCategories/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<FileCategory> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<FileCategory>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileCategory>(null as any);
    }

    getViewResource( cancelToken?: CancelToken): Promise<DistrictViewResource> {
        let url_ = this.baseUrl + "/FileCategories/GetViewResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetViewResource(_response));
        });
    }

    protected processGetViewResource(response: AxiosResponse): Promise<DistrictViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<DistrictViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DistrictViewResource>(null as any);
    }

    getEditResource( cancelToken?: CancelToken): Promise<DistrictEditResource> {
        let url_ = this.baseUrl + "/FileCategories/GetEditResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEditResource(_response));
        });
    }

    protected processGetEditResource(response: AxiosResponse): Promise<DistrictEditResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<DistrictEditResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DistrictEditResource>(null as any);
    }

    saveCreate(fileCategoryVm: FileCategory, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/FileCategories/SaveCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(fileCategoryVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreate(_response));
        });
    }

    protected processSaveCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveUpdate(fileCategoryVm: FileCategory, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/FileCategories/SaveUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(fileCategoryVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdate(_response));
        });
    }

    protected processSaveUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    delete(id: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/FileCategories/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class GradesClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getList(listFilter: ListFilterBase, cancelToken?: CancelToken): Promise<GradeListDto[]> {
        let url_ = this.baseUrl + "/Grades/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetList(_response));
        });
    }

    protected processGetList(response: AxiosResponse): Promise<GradeListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<GradeListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GradeListDto[]>(null as any);
    }

    getListTotal(listFilter: ListFilterBase, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Grades/GetListTotal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListTotal(_response));
        });
    }

    protected processGetListTotal(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getListResource( cancelToken?: CancelToken): Promise<GradeListResource> {
        let url_ = this.baseUrl + "/Grades/GetListResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListResource(_response));
        });
    }

    protected processGetListResource(response: AxiosResponse): Promise<GradeListResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<GradeListResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GradeListResource>(null as any);
    }

    get(id: number | undefined, cancelToken?: CancelToken): Promise<Grade> {
        let url_ = this.baseUrl + "/Grades/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<Grade> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<Grade>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Grade>(null as any);
    }

    getViewResource( cancelToken?: CancelToken): Promise<GradeViewResource> {
        let url_ = this.baseUrl + "/Grades/GetViewResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetViewResource(_response));
        });
    }

    protected processGetViewResource(response: AxiosResponse): Promise<GradeViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<GradeViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GradeViewResource>(null as any);
    }

    saveCreate(gradeVm: Grade, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Grades/SaveCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(gradeVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreate(_response));
        });
    }

    protected processSaveCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveUpdate(gradeVm: Grade, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Grades/SaveUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(gradeVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdate(_response));
        });
    }

    protected processSaveUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    delete(id: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Grades/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class SchoolsClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getList(listFilter: SchoolListFilter, cancelToken?: CancelToken): Promise<SchoolListDto[]> {
        let url_ = this.baseUrl + "/Schools/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetList(_response));
        });
    }

    protected processGetList(response: AxiosResponse): Promise<SchoolListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SchoolListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SchoolListDto[]>(null as any);
    }

    getListTotal(listFilter: SchoolListFilter, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Schools/GetListTotal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListTotal(_response));
        });
    }

    protected processGetListTotal(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getListResource( cancelToken?: CancelToken): Promise<SchoolListResource> {
        let url_ = this.baseUrl + "/Schools/GetListResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListResource(_response));
        });
    }

    protected processGetListResource(response: AxiosResponse): Promise<SchoolListResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SchoolListResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SchoolListResource>(null as any);
    }

    getFilterResource( cancelToken?: CancelToken): Promise<SchoolFilterResource> {
        let url_ = this.baseUrl + "/Schools/GetFilterResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetFilterResource(_response));
        });
    }

    protected processGetFilterResource(response: AxiosResponse): Promise<SchoolFilterResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SchoolFilterResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SchoolFilterResource>(null as any);
    }

    get(id: number | undefined, cancelToken?: CancelToken): Promise<School> {
        let url_ = this.baseUrl + "/Schools/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<School> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<School>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<School>(null as any);
    }

    getViewResource( cancelToken?: CancelToken): Promise<SchoolViewResource> {
        let url_ = this.baseUrl + "/Schools/GetViewResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetViewResource(_response));
        });
    }

    protected processGetViewResource(response: AxiosResponse): Promise<SchoolViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SchoolViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SchoolViewResource>(null as any);
    }

    getEditResource( cancelToken?: CancelToken): Promise<SchoolEditResource> {
        let url_ = this.baseUrl + "/Schools/GetEditResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEditResource(_response));
        });
    }

    protected processGetEditResource(response: AxiosResponse): Promise<SchoolEditResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SchoolEditResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SchoolEditResource>(null as any);
    }

    saveCreate(schoolVm: School, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Schools/SaveCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(schoolVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreate(_response));
        });
    }

    protected processSaveCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveUpdate(schoolVm: School, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Schools/SaveUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(schoolVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdate(_response));
        });
    }

    protected processSaveUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    delete(id: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Schools/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class StaffServiceTypesClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getList(listFilter: StaffServiceTypeListFilter, cancelToken?: CancelToken): Promise<StaffServiceTypeListDto[]> {
        let url_ = this.baseUrl + "/StaffServiceTypes/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetList(_response));
        });
    }

    protected processGetList(response: AxiosResponse): Promise<StaffServiceTypeListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StaffServiceTypeListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StaffServiceTypeListDto[]>(null as any);
    }

    getListTotal(listFilter: StaffServiceTypeListFilter, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StaffServiceTypes/GetListTotal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListTotal(_response));
        });
    }

    protected processGetListTotal(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getListResource( cancelToken?: CancelToken): Promise<StaffServiceTypeListResource> {
        let url_ = this.baseUrl + "/StaffServiceTypes/GetListResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListResource(_response));
        });
    }

    protected processGetListResource(response: AxiosResponse): Promise<StaffServiceTypeListResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StaffServiceTypeListResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StaffServiceTypeListResource>(null as any);
    }

    getFilterResource( cancelToken?: CancelToken): Promise<StaffServiceTypeFilterResource> {
        let url_ = this.baseUrl + "/StaffServiceTypes/GetFilterResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetFilterResource(_response));
        });
    }

    protected processGetFilterResource(response: AxiosResponse): Promise<StaffServiceTypeFilterResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StaffServiceTypeFilterResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StaffServiceTypeFilterResource>(null as any);
    }

    get(id: number | undefined, cancelToken?: CancelToken): Promise<StaffServiceType> {
        let url_ = this.baseUrl + "/StaffServiceTypes/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<StaffServiceType> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StaffServiceType>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StaffServiceType>(null as any);
    }

    getViewResource( cancelToken?: CancelToken): Promise<StaffServiceTypeViewResource> {
        let url_ = this.baseUrl + "/StaffServiceTypes/GetViewResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetViewResource(_response));
        });
    }

    protected processGetViewResource(response: AxiosResponse): Promise<StaffServiceTypeViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StaffServiceTypeViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StaffServiceTypeViewResource>(null as any);
    }

    getEditResource( cancelToken?: CancelToken): Promise<StaffServiceTypeEditResource> {
        let url_ = this.baseUrl + "/StaffServiceTypes/GetEditResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEditResource(_response));
        });
    }

    protected processGetEditResource(response: AxiosResponse): Promise<StaffServiceTypeEditResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StaffServiceTypeEditResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StaffServiceTypeEditResource>(null as any);
    }

    saveCreate(staffServiceTypeVm: StaffServiceType, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StaffServiceTypes/SaveCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(staffServiceTypeVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreate(_response));
        });
    }

    protected processSaveCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveUpdate(staffServiceTypeVm: StaffServiceType, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StaffServiceTypes/SaveUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(staffServiceTypeVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdate(_response));
        });
    }

    protected processSaveUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    delete(id: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StaffServiceTypes/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class StudentServiceSubTypesClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getViewResource( cancelToken?: CancelToken): Promise<StudentServiceSubTypeViewResource> {
        let url_ = this.baseUrl + "/StudentServiceSubTypes/GetViewResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetViewResource(_response));
        });
    }

    protected processGetViewResource(response: AxiosResponse): Promise<StudentServiceSubTypeViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentServiceSubTypeViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentServiceSubTypeViewResource>(null as any);
    }

    getEditResource( cancelToken?: CancelToken): Promise<StudentServiceSubTypeEditResource> {
        let url_ = this.baseUrl + "/StudentServiceSubTypes/GetEditResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEditResource(_response));
        });
    }

    protected processGetEditResource(response: AxiosResponse): Promise<StudentServiceSubTypeEditResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentServiceSubTypeEditResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentServiceSubTypeEditResource>(null as any);
    }
}

export class StudentServiceTypesClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getList(listFilter: StudentServiceTypeListFilter, cancelToken?: CancelToken): Promise<StudentServiceTypeListDto[]> {
        let url_ = this.baseUrl + "/StudentServiceTypes/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetList(_response));
        });
    }

    protected processGetList(response: AxiosResponse): Promise<StudentServiceTypeListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentServiceTypeListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentServiceTypeListDto[]>(null as any);
    }

    getListTotal(listFilter: StudentServiceTypeListFilter, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentServiceTypes/GetListTotal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListTotal(_response));
        });
    }

    protected processGetListTotal(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getListResource( cancelToken?: CancelToken): Promise<StudentServiceTypeListResource> {
        let url_ = this.baseUrl + "/StudentServiceTypes/GetListResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListResource(_response));
        });
    }

    protected processGetListResource(response: AxiosResponse): Promise<StudentServiceTypeListResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentServiceTypeListResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentServiceTypeListResource>(null as any);
    }

    getFilterResource( cancelToken?: CancelToken): Promise<StudentServiceTypeFilterResource> {
        let url_ = this.baseUrl + "/StudentServiceTypes/GetFilterResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetFilterResource(_response));
        });
    }

    protected processGetFilterResource(response: AxiosResponse): Promise<StudentServiceTypeFilterResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentServiceTypeFilterResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentServiceTypeFilterResource>(null as any);
    }

    get(id: number | undefined, cancelToken?: CancelToken): Promise<StudentServiceType> {
        let url_ = this.baseUrl + "/StudentServiceTypes/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<StudentServiceType> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentServiceType>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentServiceType>(null as any);
    }

    getViewResource( cancelToken?: CancelToken): Promise<StudentServiceTypeViewResource> {
        let url_ = this.baseUrl + "/StudentServiceTypes/GetViewResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetViewResource(_response));
        });
    }

    protected processGetViewResource(response: AxiosResponse): Promise<StudentServiceTypeViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentServiceTypeViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentServiceTypeViewResource>(null as any);
    }

    getEditResource( cancelToken?: CancelToken): Promise<StudentServiceTypeEditResource> {
        let url_ = this.baseUrl + "/StudentServiceTypes/GetEditResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEditResource(_response));
        });
    }

    protected processGetEditResource(response: AxiosResponse): Promise<StudentServiceTypeEditResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentServiceTypeEditResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentServiceTypeEditResource>(null as any);
    }

    saveCreate(studentServiceTypeVm: StudentServiceType, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentServiceTypes/SaveCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(studentServiceTypeVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreate(_response));
        });
    }

    protected processSaveCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveUpdate(studentServiceTypeVm: StudentServiceType, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentServiceTypes/SaveUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(studentServiceTypeVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdate(_response));
        });
    }

    protected processSaveUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    delete(id: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StudentServiceTypes/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class TestLevelClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getList(listFilter: TestLevelListFilter, cancelToken?: CancelToken): Promise<TestLevelListDto[]> {
        let url_ = this.baseUrl + "/TestLevel/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetList(_response));
        });
    }

    protected processGetList(response: AxiosResponse): Promise<TestLevelListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<TestLevelListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TestLevelListDto[]>(null as any);
    }

    getListTotal(listFilter: TestLevelListFilter, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/TestLevel/GetListTotal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListTotal(_response));
        });
    }

    protected processGetListTotal(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getListResource( cancelToken?: CancelToken): Promise<TestLevelListResource> {
        let url_ = this.baseUrl + "/TestLevel/GetListResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListResource(_response));
        });
    }

    protected processGetListResource(response: AxiosResponse): Promise<TestLevelListResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<TestLevelListResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TestLevelListResource>(null as any);
    }

    getFilterResource( cancelToken?: CancelToken): Promise<TestLevelFilterResource> {
        let url_ = this.baseUrl + "/TestLevel/GetFilterResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetFilterResource(_response));
        });
    }

    protected processGetFilterResource(response: AxiosResponse): Promise<TestLevelFilterResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<TestLevelFilterResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TestLevelFilterResource>(null as any);
    }

    get(id: number | undefined, cancelToken?: CancelToken): Promise<TestLevel> {
        let url_ = this.baseUrl + "/TestLevel/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<TestLevel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<TestLevel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TestLevel>(null as any);
    }

    getViewResource( cancelToken?: CancelToken): Promise<TestLevelViewResource> {
        let url_ = this.baseUrl + "/TestLevel/GetViewResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetViewResource(_response));
        });
    }

    protected processGetViewResource(response: AxiosResponse): Promise<TestLevelViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<TestLevelViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TestLevelViewResource>(null as any);
    }

    getEditResource( cancelToken?: CancelToken): Promise<TestLevelEditResource> {
        let url_ = this.baseUrl + "/TestLevel/GetEditResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEditResource(_response));
        });
    }

    protected processGetEditResource(response: AxiosResponse): Promise<TestLevelEditResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<TestLevelEditResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TestLevelEditResource>(null as any);
    }

    saveCreate(testLevelVm: TestLevel, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/TestLevel/SaveCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(testLevelVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreate(_response));
        });
    }

    protected processSaveCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveUpdate(testLevelVm: TestLevel, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/TestLevel/SaveUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(testLevelVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdate(_response));
        });
    }

    protected processSaveUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    delete(id: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/TestLevel/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class TestTypesClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getList(listFilter: TestTypeListFilter, cancelToken?: CancelToken): Promise<TestTypeListDto[]> {
        let url_ = this.baseUrl + "/TestTypes/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetList(_response));
        });
    }

    protected processGetList(response: AxiosResponse): Promise<TestTypeListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<TestTypeListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TestTypeListDto[]>(null as any);
    }

    getListTotal(listFilter: TestTypeListFilter, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/TestTypes/GetListTotal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListTotal(_response));
        });
    }

    protected processGetListTotal(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getListResource( cancelToken?: CancelToken): Promise<TestTypeListResource> {
        let url_ = this.baseUrl + "/TestTypes/GetListResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListResource(_response));
        });
    }

    protected processGetListResource(response: AxiosResponse): Promise<TestTypeListResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<TestTypeListResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TestTypeListResource>(null as any);
    }

    getFilterResource( cancelToken?: CancelToken): Promise<TestTypeFilterResource> {
        let url_ = this.baseUrl + "/TestTypes/GetFilterResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetFilterResource(_response));
        });
    }

    protected processGetFilterResource(response: AxiosResponse): Promise<TestTypeFilterResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<TestTypeFilterResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TestTypeFilterResource>(null as any);
    }

    get(id: number | undefined, cancelToken?: CancelToken): Promise<TestType> {
        let url_ = this.baseUrl + "/TestTypes/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<TestType> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<TestType>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TestType>(null as any);
    }

    getViewResource( cancelToken?: CancelToken): Promise<TestTypeViewResource> {
        let url_ = this.baseUrl + "/TestTypes/GetViewResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetViewResource(_response));
        });
    }

    protected processGetViewResource(response: AxiosResponse): Promise<TestTypeViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<TestTypeViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TestTypeViewResource>(null as any);
    }

    getEditResource( cancelToken?: CancelToken): Promise<TestTypeEditResource> {
        let url_ = this.baseUrl + "/TestTypes/GetEditResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEditResource(_response));
        });
    }

    protected processGetEditResource(response: AxiosResponse): Promise<TestTypeEditResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<TestTypeEditResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TestTypeEditResource>(null as any);
    }

    saveCreate(testTypeVm: TestType, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/TestTypes/SaveCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(testTypeVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreate(_response));
        });
    }

    protected processSaveCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveUpdate(testTypeVm: TestType, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/TestTypes/SaveUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(testTypeVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdate(_response));
        });
    }

    protected processSaveUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    delete(id: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/TestTypes/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class ContributorsClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getList(listFilter: ContributorListFilter, cancelToken?: CancelToken): Promise<ContributorListDto[]> {
        let url_ = this.baseUrl + "/Contributors/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetList(_response));
        });
    }

    protected processGetList(response: AxiosResponse): Promise<ContributorListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ContributorListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContributorListDto[]>(null as any);
    }

    getListTotal(listFilter: ContributorListFilter, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Contributors/GetListTotal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListTotal(_response));
        });
    }

    protected processGetListTotal(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getIds(listFilter: ContributorListFilter, cancelToken?: CancelToken): Promise<number[]> {
        let url_ = this.baseUrl + "/Contributors/GetIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetIds(_response));
        });
    }

    protected processGetIds(response: AxiosResponse): Promise<number[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number[]>(null as any);
    }

    getListResource( cancelToken?: CancelToken): Promise<ContributorListResource> {
        let url_ = this.baseUrl + "/Contributors/GetListResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListResource(_response));
        });
    }

    protected processGetListResource(response: AxiosResponse): Promise<ContributorListResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ContributorListResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContributorListResource>(null as any);
    }

    getFilterResource( cancelToken?: CancelToken): Promise<ContributorFilterResource> {
        let url_ = this.baseUrl + "/Contributors/GetFilterResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetFilterResource(_response));
        });
    }

    protected processGetFilterResource(response: AxiosResponse): Promise<ContributorFilterResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ContributorFilterResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContributorFilterResource>(null as any);
    }

    getCustomFilterProperties( cancelToken?: CancelToken): Promise<ReportPropertyBase[]> {
        let url_ = this.baseUrl + "/Contributors";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetCustomFilterProperties(_response));
        });
    }

    protected processGetCustomFilterProperties(response: AxiosResponse): Promise<ReportPropertyBase[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ReportPropertyBase[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReportPropertyBase[]>(null as any);
    }

    get(id: number | undefined, cancelToken?: CancelToken): Promise<Contributor> {
        let url_ = this.baseUrl + "/Contributors/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<Contributor> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<Contributor>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Contributor>(null as any);
    }

    getViewResource(id: number | undefined, cancelToken?: CancelToken): Promise<ContributorViewResource> {
        let url_ = this.baseUrl + "/Contributors/GetViewResource?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetViewResource(_response));
        });
    }

    protected processGetViewResource(response: AxiosResponse): Promise<ContributorViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ContributorViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContributorViewResource>(null as any);
    }

    getEditResource(id: number | undefined, cancelToken?: CancelToken): Promise<ContributorEditResource> {
        let url_ = this.baseUrl + "/Contributors/GetEditResource?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEditResource(_response));
        });
    }

    protected processGetEditResource(response: AxiosResponse): Promise<ContributorEditResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ContributorEditResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContributorEditResource>(null as any);
    }

    saveCreate(contributorVm: Contributor, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Contributors/SaveCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(contributorVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreate(_response));
        });
    }

    protected processSaveCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveUpdate(contributorVm: Contributor, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Contributors/SaveUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(contributorVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdate(_response));
        });
    }

    protected processSaveUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    delete(id: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Contributors/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getBulkCreateMatches(ids: number[], cancelToken?: CancelToken): Promise<ContributorBulkCreateMatches> {
        let url_ = this.baseUrl + "/Contributors/GetBulkCreateMatches";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetBulkCreateMatches(_response));
        });
    }

    protected processGetBulkCreateMatches(response: AxiosResponse): Promise<ContributorBulkCreateMatches> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ContributorBulkCreateMatches>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContributorBulkCreateMatches>(null as any);
    }

    saveBulkCreateMatches(bulkCreateMatches: ContributorBulkCreateMatches, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Contributors/SaveBulkCreateMatches";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bulkCreateMatches);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveBulkCreateMatches(_response));
        });
    }

    protected processSaveBulkCreateMatches(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getBulkMerge(ids: number[], cancelToken?: CancelToken): Promise<ContributorBulkMerge> {
        let url_ = this.baseUrl + "/Contributors/GetBulkMerge";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetBulkMerge(_response));
        });
    }

    protected processGetBulkMerge(response: AxiosResponse): Promise<ContributorBulkMerge> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ContributorBulkMerge>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContributorBulkMerge>(null as any);
    }

    getBulkMergeResource( cancelToken?: CancelToken): Promise<ContributorBulkMergeResource> {
        let url_ = this.baseUrl + "/Contributors/GetBulkMergeResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetBulkMergeResource(_response));
        });
    }

    protected processGetBulkMergeResource(response: AxiosResponse): Promise<ContributorBulkMergeResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ContributorBulkMergeResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContributorBulkMergeResource>(null as any);
    }

    saveBulkMerge(bulkMerge: ContributorBulkMerge, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Contributors/SaveBulkMerge";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bulkMerge);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveBulkMerge(_response));
        });
    }

    protected processSaveBulkMerge(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class ContributorMatchesClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getList(listFilter: ContributorMatchListFilter, cancelToken?: CancelToken): Promise<ContributorMatchListDto[]> {
        let url_ = this.baseUrl + "/ContributorMatches/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetList(_response));
        });
    }

    protected processGetList(response: AxiosResponse): Promise<ContributorMatchListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ContributorMatchListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContributorMatchListDto[]>(null as any);
    }

    getListTotal(listFilter: ContributorMatchListFilter, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/ContributorMatches/GetListTotal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListTotal(_response));
        });
    }

    protected processGetListTotal(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getIds(listFilter: ContributorMatchListFilter, cancelToken?: CancelToken): Promise<number[]> {
        let url_ = this.baseUrl + "/ContributorMatches/GetIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetIds(_response));
        });
    }

    protected processGetIds(response: AxiosResponse): Promise<number[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number[]>(null as any);
    }

    getListResource( cancelToken?: CancelToken): Promise<ContributorMatchListResource> {
        let url_ = this.baseUrl + "/ContributorMatches/GetListResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListResource(_response));
        });
    }

    protected processGetListResource(response: AxiosResponse): Promise<ContributorMatchListResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ContributorMatchListResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContributorMatchListResource>(null as any);
    }

    getFilterResource( cancelToken?: CancelToken): Promise<ContributorMatchFilterResource> {
        let url_ = this.baseUrl + "/ContributorMatches/GetFilterResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetFilterResource(_response));
        });
    }

    protected processGetFilterResource(response: AxiosResponse): Promise<ContributorMatchFilterResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ContributorMatchFilterResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContributorMatchFilterResource>(null as any);
    }

    getCustomFilterProperties( cancelToken?: CancelToken): Promise<ReportPropertyBase[]> {
        let url_ = this.baseUrl + "/ContributorMatches";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetCustomFilterProperties(_response));
        });
    }

    protected processGetCustomFilterProperties(response: AxiosResponse): Promise<ReportPropertyBase[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ReportPropertyBase[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReportPropertyBase[]>(null as any);
    }

    getContributorEmployments(contributorId: number | undefined, cancelToken?: CancelToken): Promise<ContributorEmployment[]> {
        let url_ = this.baseUrl + "/ContributorMatches/GetContributorEmployments?";
        if (contributorId === null)
            throw new globalThis.Error("The parameter 'contributorId' cannot be null.");
        else if (contributorId !== undefined)
            url_ += "contributorId=" + encodeURIComponent("" + contributorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetContributorEmployments(_response));
        });
    }

    protected processGetContributorEmployments(response: AxiosResponse): Promise<ContributorEmployment[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ContributorEmployment[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContributorEmployment[]>(null as any);
    }

    get(id: number | undefined, cancelToken?: CancelToken): Promise<ContributorMatch> {
        let url_ = this.baseUrl + "/ContributorMatches/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<ContributorMatch> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ContributorMatch>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContributorMatch>(null as any);
    }

    getViewResource( cancelToken?: CancelToken): Promise<ContributorMatchViewResource> {
        let url_ = this.baseUrl + "/ContributorMatches/GetViewResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetViewResource(_response));
        });
    }

    protected processGetViewResource(response: AxiosResponse): Promise<ContributorMatchViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ContributorMatchViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContributorMatchViewResource>(null as any);
    }

    getEditResource( cancelToken?: CancelToken): Promise<ContributorMatchEditResource> {
        let url_ = this.baseUrl + "/ContributorMatches/GetEditResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEditResource(_response));
        });
    }

    protected processGetEditResource(response: AxiosResponse): Promise<ContributorMatchEditResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ContributorMatchEditResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContributorMatchEditResource>(null as any);
    }

    saveCreate(matchVm: ContributorMatch, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/ContributorMatches/SaveCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(matchVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreate(_response));
        });
    }

    protected processSaveCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveUpdate(matchVm: ContributorMatch, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/ContributorMatches/SaveUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(matchVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdate(_response));
        });
    }

    protected processSaveUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveCreateBulk(matchVm: ContributorMatch, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/ContributorMatches/SaveCreateBulk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(matchVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreateBulk(_response));
        });
    }

    protected processSaveCreateBulk(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    sendUnallowableEmail(id: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/ContributorMatches/SendUnallowableEmail?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSendUnallowableEmail(_response));
        });
    }

    protected processSendUnallowableEmail(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    toggleLock(id: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/ContributorMatches/ToggleLock?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processToggleLock(_response));
        });
    }

    protected processToggleLock(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    delete(id: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/ContributorMatches/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getBulkUpdate(ids: number[], cancelToken?: CancelToken): Promise<ContributorMatchBulkUpdate> {
        let url_ = this.baseUrl + "/ContributorMatches/GetBulkUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetBulkUpdate(_response));
        });
    }

    protected processGetBulkUpdate(response: AxiosResponse): Promise<ContributorMatchBulkUpdate> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ContributorMatchBulkUpdate>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContributorMatchBulkUpdate>(null as any);
    }

    getBulkUpdateResource( cancelToken?: CancelToken): Promise<ContributorMatchBulkUpdateResource> {
        let url_ = this.baseUrl + "/ContributorMatches/GetBulkUpdateResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetBulkUpdateResource(_response));
        });
    }

    protected processGetBulkUpdateResource(response: AxiosResponse): Promise<ContributorMatchBulkUpdateResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ContributorMatchBulkUpdateResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContributorMatchBulkUpdateResource>(null as any);
    }

    saveBulkUpdate(bulkUpdate: ContributorMatchBulkUpdate, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/ContributorMatches/SaveBulkUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bulkUpdate);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveBulkUpdate(_response));
        });
    }

    protected processSaveBulkUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    postBulkDelete(ids: number[], cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/ContributorMatches/PostBulkDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPostBulkDelete(_response));
        });
    }

    protected processPostBulkDelete(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    postBulkUnlock(ids: number[], cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/ContributorMatches/PostBulkUnlock";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPostBulkUnlock(_response));
        });
    }

    protected processPostBulkUnlock(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    postBulkLock(ids: number[], cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/ContributorMatches/PostBulkLock";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPostBulkLock(_response));
        });
    }

    protected processPostBulkLock(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class NonPersonnelsClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getList(listFilter: NonPersonnelListFilter, cancelToken?: CancelToken): Promise<NonPersonnelListDto[]> {
        let url_ = this.baseUrl + "/NonPersonnels/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetList(_response));
        });
    }

    protected processGetList(response: AxiosResponse): Promise<NonPersonnelListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<NonPersonnelListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NonPersonnelListDto[]>(null as any);
    }

    getListTotal(listFilter: NonPersonnelListFilter, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/NonPersonnels/GetListTotal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListTotal(_response));
        });
    }

    protected processGetListTotal(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getListResource( cancelToken?: CancelToken): Promise<NonPersonnelListResource> {
        let url_ = this.baseUrl + "/NonPersonnels/GetListResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListResource(_response));
        });
    }

    protected processGetListResource(response: AxiosResponse): Promise<NonPersonnelListResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<NonPersonnelListResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NonPersonnelListResource>(null as any);
    }

    getFilterResource( cancelToken?: CancelToken): Promise<NonPersonnelFilterResource> {
        let url_ = this.baseUrl + "/NonPersonnels/GetFilterResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetFilterResource(_response));
        });
    }

    protected processGetFilterResource(response: AxiosResponse): Promise<NonPersonnelFilterResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<NonPersonnelFilterResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NonPersonnelFilterResource>(null as any);
    }

    getCustomFilterProperties( cancelToken?: CancelToken): Promise<ReportPropertyBase[]> {
        let url_ = this.baseUrl + "/NonPersonnels";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetCustomFilterProperties(_response));
        });
    }

    protected processGetCustomFilterProperties(response: AxiosResponse): Promise<ReportPropertyBase[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ReportPropertyBase[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReportPropertyBase[]>(null as any);
    }

    get(id: number | undefined, cancelToken?: CancelToken): Promise<NonPersonnel> {
        let url_ = this.baseUrl + "/NonPersonnels/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<NonPersonnel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<NonPersonnel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NonPersonnel>(null as any);
    }

    getViewResource( cancelToken?: CancelToken): Promise<NonPersonnelViewResource> {
        let url_ = this.baseUrl + "/NonPersonnels/GetViewResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetViewResource(_response));
        });
    }

    protected processGetViewResource(response: AxiosResponse): Promise<NonPersonnelViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<NonPersonnelViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NonPersonnelViewResource>(null as any);
    }

    getEditResource( cancelToken?: CancelToken): Promise<NonPersonnelEditResource> {
        let url_ = this.baseUrl + "/NonPersonnels/GetEditResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEditResource(_response));
        });
    }

    protected processGetEditResource(response: AxiosResponse): Promise<NonPersonnelEditResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<NonPersonnelEditResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NonPersonnelEditResource>(null as any);
    }

    saveCreate(nonPersonnelVm: NonPersonnel, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/NonPersonnels/SaveCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(nonPersonnelVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreate(_response));
        });
    }

    protected processSaveCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveUpdate(nonPersonnelVm: NonPersonnel, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/NonPersonnels/SaveUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(nonPersonnelVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdate(_response));
        });
    }

    protected processSaveUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    toggleLock(id: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/NonPersonnels/ToggleLock?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processToggleLock(_response));
        });
    }

    protected processToggleLock(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    delete(id: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/NonPersonnels/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class MatchExportsClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    get( cancelToken?: CancelToken): Promise<Export> {
        let url_ = this.baseUrl + "/MatchExports/Get";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<Export> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<Export>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Export>(null as any);
    }

    getResource( cancelToken?: CancelToken): Promise<ExportResource> {
        let url_ = this.baseUrl + "/MatchExports/GetResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetResource(_response));
        });
    }

    protected processGetResource(response: AxiosResponse): Promise<ExportResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ExportResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExportResource>(null as any);
    }
}

export class MatchReportsClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getActualMatchResource( cancelToken?: CancelToken): Promise<MatchReportActualMatchResource> {
        let url_ = this.baseUrl + "/MatchReports/GetActualMatchResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetActualMatchResource(_response));
        });
    }

    protected processGetActualMatchResource(response: AxiosResponse): Promise<MatchReportActualMatchResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<MatchReportActualMatchResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MatchReportActualMatchResource>(null as any);
    }

    generateActualMatch(filter: MatchReportActualMatchFilter, cancelToken?: CancelToken): Promise<MatchReportActualMatch> {
        let url_ = this.baseUrl + "/MatchReports/GenerateActualMatch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGenerateActualMatch(_response));
        });
    }

    protected processGenerateActualMatch(response: AxiosResponse): Promise<MatchReportActualMatch> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<MatchReportActualMatch>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MatchReportActualMatch>(null as any);
    }

    getActualYearlyResource( cancelToken?: CancelToken): Promise<MatchReportActualYearlyResource> {
        let url_ = this.baseUrl + "/MatchReports/GetActualYearlyResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetActualYearlyResource(_response));
        });
    }

    protected processGetActualYearlyResource(response: AxiosResponse): Promise<MatchReportActualYearlyResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<MatchReportActualYearlyResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MatchReportActualYearlyResource>(null as any);
    }

    generateActualYearly(filter: MatchReportActualYearlyFilter, cancelToken?: CancelToken): Promise<MatchReportActualYearly> {
        let url_ = this.baseUrl + "/MatchReports/GenerateActualYearly";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGenerateActualYearly(_response));
        });
    }

    protected processGenerateActualYearly(response: AxiosResponse): Promise<MatchReportActualYearly> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<MatchReportActualYearly>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MatchReportActualYearly>(null as any);
    }

    getAllPartnersResource( cancelToken?: CancelToken): Promise<MatchReportAllPartnersResource> {
        let url_ = this.baseUrl + "/MatchReports/GetAllPartnersResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAllPartnersResource(_response));
        });
    }

    protected processGetAllPartnersResource(response: AxiosResponse): Promise<MatchReportAllPartnersResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<MatchReportAllPartnersResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MatchReportAllPartnersResource>(null as any);
    }

    generateAllPartners(filter: MatchReportAllPartnersFilter, cancelToken?: CancelToken): Promise<MatchReportAllPartners> {
        let url_ = this.baseUrl + "/MatchReports/GenerateAllPartners";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGenerateAllPartners(_response));
        });
    }

    protected processGenerateAllPartners(response: AxiosResponse): Promise<MatchReportAllPartners> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<MatchReportAllPartners>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MatchReportAllPartners>(null as any);
    }

    getContributorResource( cancelToken?: CancelToken): Promise<MatchReportContributorResource> {
        let url_ = this.baseUrl + "/MatchReports/GetContributorResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetContributorResource(_response));
        });
    }

    protected processGetContributorResource(response: AxiosResponse): Promise<MatchReportContributorResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<MatchReportContributorResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MatchReportContributorResource>(null as any);
    }

    generateContributor(filter: MatchReportContributorFilter, cancelToken?: CancelToken): Promise<MatchReportContributor> {
        let url_ = this.baseUrl + "/MatchReports/GenerateContributor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGenerateContributor(_response));
        });
    }

    protected processGenerateContributor(response: AxiosResponse): Promise<MatchReportContributor> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<MatchReportContributor>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MatchReportContributor>(null as any);
    }

    getContributorDetailResource( cancelToken?: CancelToken): Promise<MatchReportContributorDetailResource> {
        let url_ = this.baseUrl + "/MatchReports/GetContributorDetailResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetContributorDetailResource(_response));
        });
    }

    protected processGetContributorDetailResource(response: AxiosResponse): Promise<MatchReportContributorDetailResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<MatchReportContributorDetailResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MatchReportContributorDetailResource>(null as any);
    }

    generateContributorDetail(filter: MatchReportContributorDetailFilter, cancelToken?: CancelToken): Promise<MatchReportContributorDetail> {
        let url_ = this.baseUrl + "/MatchReports/GenerateContributorDetail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGenerateContributorDetail(_response));
        });
    }

    protected processGenerateContributorDetail(response: AxiosResponse): Promise<MatchReportContributorDetail> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<MatchReportContributorDetail>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MatchReportContributorDetail>(null as any);
    }

    getContributorSummaryResource( cancelToken?: CancelToken): Promise<MatchReportContributorSummaryResource> {
        let url_ = this.baseUrl + "/MatchReports/GetContributorSummaryResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetContributorSummaryResource(_response));
        });
    }

    protected processGetContributorSummaryResource(response: AxiosResponse): Promise<MatchReportContributorSummaryResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<MatchReportContributorSummaryResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MatchReportContributorSummaryResource>(null as any);
    }

    generateContributorSummary(filter: MatchReportContributorSummaryFilter, cancelToken?: CancelToken): Promise<MatchReportContributorSummary> {
        let url_ = this.baseUrl + "/MatchReports/GenerateContributorSummary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGenerateContributorSummary(_response));
        });
    }

    protected processGenerateContributorSummary(response: AxiosResponse): Promise<MatchReportContributorSummary> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<MatchReportContributorSummary>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MatchReportContributorSummary>(null as any);
    }

    getNonPersonnelDetailResource( cancelToken?: CancelToken): Promise<MatchReportNonPersonnelDetailResource> {
        let url_ = this.baseUrl + "/MatchReports/GetNonPersonnelDetailResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetNonPersonnelDetailResource(_response));
        });
    }

    protected processGetNonPersonnelDetailResource(response: AxiosResponse): Promise<MatchReportNonPersonnelDetailResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<MatchReportNonPersonnelDetailResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MatchReportNonPersonnelDetailResource>(null as any);
    }

    generateNonPersonnelDetail(filter: MatchReportNonPersonnelDetailFilter, cancelToken?: CancelToken): Promise<MatchReportNonPersonnelDetail> {
        let url_ = this.baseUrl + "/MatchReports/GenerateNonPersonnelDetail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGenerateNonPersonnelDetail(_response));
        });
    }

    protected processGenerateNonPersonnelDetail(response: AxiosResponse): Promise<MatchReportNonPersonnelDetail> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<MatchReportNonPersonnelDetail>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MatchReportNonPersonnelDetail>(null as any);
    }

    getPartnerResource( cancelToken?: CancelToken): Promise<MatchReportPartnerResource> {
        let url_ = this.baseUrl + "/MatchReports/GetPartnerResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPartnerResource(_response));
        });
    }

    protected processGetPartnerResource(response: AxiosResponse): Promise<MatchReportPartnerResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<MatchReportPartnerResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MatchReportPartnerResource>(null as any);
    }

    generatePartner(filter: MatchReportPartnerFilter, cancelToken?: CancelToken): Promise<MatchReportPartner> {
        let url_ = this.baseUrl + "/MatchReports/GeneratePartner";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGeneratePartner(_response));
        });
    }

    protected processGeneratePartner(response: AxiosResponse): Promise<MatchReportPartner> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<MatchReportPartner>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MatchReportPartner>(null as any);
    }

    getTimeCardResource( cancelToken?: CancelToken): Promise<MatchReportTimeCardResource> {
        let url_ = this.baseUrl + "/MatchReports/GetTimeCardResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetTimeCardResource(_response));
        });
    }

    protected processGetTimeCardResource(response: AxiosResponse): Promise<MatchReportTimeCardResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<MatchReportTimeCardResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MatchReportTimeCardResource>(null as any);
    }

    generateTimeCard(filter: MatchReportTimeCardFilter, cancelToken?: CancelToken): Promise<MatchReportTimeCard> {
        let url_ = this.baseUrl + "/MatchReports/GenerateTimeCard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGenerateTimeCard(_response));
        });
    }

    protected processGenerateTimeCard(response: AxiosResponse): Promise<MatchReportTimeCard> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<MatchReportTimeCard>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MatchReportTimeCard>(null as any);
    }
}

export class ContributorEmploymentsClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getList(listFilter: ContributorEmploymentListFilter, cancelToken?: CancelToken): Promise<ContributorEmploymentListDto[]> {
        let url_ = this.baseUrl + "/ContributorEmployments/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetList(_response));
        });
    }

    protected processGetList(response: AxiosResponse): Promise<ContributorEmploymentListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ContributorEmploymentListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContributorEmploymentListDto[]>(null as any);
    }

    getListTotal(listFilter: ContributorEmploymentListFilter, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/ContributorEmployments/GetListTotal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListTotal(_response));
        });
    }

    protected processGetListTotal(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    get(id: number | undefined, cancelToken?: CancelToken): Promise<ContributorEmployment> {
        let url_ = this.baseUrl + "/ContributorEmployments/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<ContributorEmployment> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ContributorEmployment>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContributorEmployment>(null as any);
    }

    getViewResource( cancelToken?: CancelToken): Promise<ContributorEmploymentViewResource> {
        let url_ = this.baseUrl + "/ContributorEmployments/GetViewResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetViewResource(_response));
        });
    }

    protected processGetViewResource(response: AxiosResponse): Promise<ContributorEmploymentViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ContributorEmploymentViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContributorEmploymentViewResource>(null as any);
    }

    getEditResource( cancelToken?: CancelToken): Promise<ContributorEmploymentEditResource> {
        let url_ = this.baseUrl + "/ContributorEmployments/GetEditResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEditResource(_response));
        });
    }

    protected processGetEditResource(response: AxiosResponse): Promise<ContributorEmploymentEditResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ContributorEmploymentEditResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContributorEmploymentEditResource>(null as any);
    }

    getListResource( cancelToken?: CancelToken): Promise<ContributorEmploymentListResource> {
        let url_ = this.baseUrl + "/ContributorEmployments/GetListResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListResource(_response));
        });
    }

    protected processGetListResource(response: AxiosResponse): Promise<ContributorEmploymentListResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ContributorEmploymentListResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContributorEmploymentListResource>(null as any);
    }

    saveCreate(employmentVm: ContributorEmployment, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/ContributorEmployments/SaveCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(employmentVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreate(_response));
        });
    }

    protected processSaveCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveUpdate(employmentVm: ContributorEmployment, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/ContributorEmployments/SaveUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(employmentVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdate(_response));
        });
    }

    protected processSaveUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    delete(id: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/ContributorEmployments/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getContributorCurrentEmployment(contributorId: number | undefined, cancelToken?: CancelToken): Promise<ContributorEmployment> {
        let url_ = this.baseUrl + "/ContributorEmployments/GetContributorCurrentEmployment?";
        if (contributorId === null)
            throw new globalThis.Error("The parameter 'contributorId' cannot be null.");
        else if (contributorId !== undefined)
            url_ += "contributorId=" + encodeURIComponent("" + contributorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetContributorCurrentEmployment(_response));
        });
    }

    protected processGetContributorCurrentEmployment(response: AxiosResponse): Promise<ContributorEmployment> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ContributorEmployment>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContributorEmployment>(null as any);
    }
}

export class StaffEmploymentsClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getList(listFilter: StaffEmploymentListFilter, cancelToken?: CancelToken): Promise<StaffEmploymentListDto[]> {
        let url_ = this.baseUrl + "/StaffEmployments/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetList(_response));
        });
    }

    protected processGetList(response: AxiosResponse): Promise<StaffEmploymentListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StaffEmploymentListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StaffEmploymentListDto[]>(null as any);
    }

    getListTotal(listFilter: StaffEmploymentListFilter, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StaffEmployments/GetListTotal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListTotal(_response));
        });
    }

    protected processGetListTotal(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    get(id: number | undefined, cancelToken?: CancelToken): Promise<StaffEmployment> {
        let url_ = this.baseUrl + "/StaffEmployments/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<StaffEmployment> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StaffEmployment>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StaffEmployment>(null as any);
    }

    getViewResource( cancelToken?: CancelToken): Promise<StaffEmploymentViewResource> {
        let url_ = this.baseUrl + "/StaffEmployments/GetViewResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetViewResource(_response));
        });
    }

    protected processGetViewResource(response: AxiosResponse): Promise<StaffEmploymentViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StaffEmploymentViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StaffEmploymentViewResource>(null as any);
    }

    getEditResource( cancelToken?: CancelToken): Promise<StaffEmploymentEditResource> {
        let url_ = this.baseUrl + "/StaffEmployments/GetEditResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEditResource(_response));
        });
    }

    protected processGetEditResource(response: AxiosResponse): Promise<StaffEmploymentEditResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StaffEmploymentEditResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StaffEmploymentEditResource>(null as any);
    }

    getListResource( cancelToken?: CancelToken): Promise<StaffEmploymentListResource> {
        let url_ = this.baseUrl + "/StaffEmployments/GetListResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListResource(_response));
        });
    }

    protected processGetListResource(response: AxiosResponse): Promise<StaffEmploymentListResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StaffEmploymentListResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StaffEmploymentListResource>(null as any);
    }

    saveCreate(employmentVm: StaffEmployment, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StaffEmployments/SaveCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(employmentVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreate(_response));
        });
    }

    protected processSaveCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveUpdate(employmentVm: StaffEmployment, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StaffEmployments/SaveUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(employmentVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdate(_response));
        });
    }

    protected processSaveUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    delete(id: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/StaffEmployments/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getStaffCurrentEmployment(staffId: number | undefined, cancelToken?: CancelToken): Promise<StaffEmployment> {
        let url_ = this.baseUrl + "/StaffEmployments/GetStaffCurrentEmployment?";
        if (staffId === null)
            throw new globalThis.Error("The parameter 'staffId' cannot be null.");
        else if (staffId !== undefined)
            url_ += "staffId=" + encodeURIComponent("" + staffId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetStaffCurrentEmployment(_response));
        });
    }

    protected processGetStaffCurrentEmployment(response: AxiosResponse): Promise<StaffEmployment> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StaffEmployment>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StaffEmployment>(null as any);
    }
}

export class AprClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getRequest( cancelToken?: CancelToken): Promise<AprRequest> {
        let url_ = this.baseUrl + "/Apr/GetRequest";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetRequest(_response));
        });
    }

    protected processGetRequest(response: AxiosResponse): Promise<AprRequest> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<AprRequest>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AprRequest>(null as any);
    }

    getResource( cancelToken?: CancelToken): Promise<AprResource> {
        let url_ = this.baseUrl + "/Apr/GetResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetResource(_response));
        });
    }

    protected processGetResource(response: AxiosResponse): Promise<AprResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<AprResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AprResource>(null as any);
    }

    generateApr(request: AprRequest, cancelToken?: CancelToken): Promise<AprResponse> {
        let url_ = this.baseUrl + "/Apr/GenerateApr";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGenerateApr(_response));
        });
    }

    protected processGenerateApr(response: AxiosResponse): Promise<AprResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<AprResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AprResponse>(null as any);
    }

    generateAprSss(request: AprRequest, cancelToken?: CancelToken): Promise<AprSssResponse> {
        let url_ = this.baseUrl + "/Apr/GenerateAprSss";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGenerateAprSss(_response));
        });
    }

    protected processGenerateAprSss(response: AxiosResponse): Promise<AprSssResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<AprSssResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AprSssResponse>(null as any);
    }

    generateAprUb(request: AprRequest, cancelToken?: CancelToken): Promise<AprUBResponse> {
        let url_ = this.baseUrl + "/Apr/GenerateAprUb";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGenerateAprUb(_response));
        });
    }

    protected processGenerateAprUb(response: AxiosResponse): Promise<AprUBResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<AprUBResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AprUBResponse>(null as any);
    }

    generateAprEts(request: AprRequest, cancelToken?: CancelToken): Promise<AprEtsResponse> {
        let url_ = this.baseUrl + "/Apr/GenerateAprEts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGenerateAprEts(_response));
        });
    }

    protected processGenerateAprEts(response: AxiosResponse): Promise<AprEtsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<AprEtsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AprEtsResponse>(null as any);
    }

    generateAprEoc(request: AprRequest, cancelToken?: CancelToken): Promise<AprEocResponse> {
        let url_ = this.baseUrl + "/Apr/GenerateAprEoc";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGenerateAprEoc(_response));
        });
    }

    protected processGenerateAprEoc(response: AxiosResponse): Promise<AprEocResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<AprEocResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AprEocResponse>(null as any);
    }
}

export class EligibilityDashboardClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getEligibilityDistribution(filter: EligibilityDashboardFilter, cancelToken?: CancelToken): Promise<EligibilityDashboardResponse> {
        let url_ = this.baseUrl + "/EligibilityDashboard/GetEligibilityDistribution";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEligibilityDistribution(_response));
        });
    }

    protected processGetEligibilityDistribution(response: AxiosResponse): Promise<EligibilityDashboardResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<EligibilityDashboardResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EligibilityDashboardResponse>(null as any);
    }
}

export class EthnicityDashboardClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getEthnicityDistribution(filter: EthnicityDashboardFilter, cancelToken?: CancelToken): Promise<EthnicityDashboardResponse> {
        let url_ = this.baseUrl + "/EthnicityDashboard/GetEthnicityDistribution";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEthnicityDistribution(_response));
        });
    }

    protected processGetEthnicityDistribution(response: AxiosResponse): Promise<EthnicityDashboardResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<EthnicityDashboardResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EthnicityDashboardResponse>(null as any);
    }
}

export class FafsaDashboardClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getFafsaSubmissionRates(filter: FafsaDashboardFilter, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/FafsaDashboard/GetFafsaSubmissionRates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetFafsaSubmissionRates(_response));
        });
    }

    protected processGetFafsaSubmissionRates(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class GenderDashboardClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getGenderDistribution(filter: GenderDashboardFilter, cancelToken?: CancelToken): Promise<GenderDashboardResponse> {
        let url_ = this.baseUrl + "/GenderDashboard/GetGenderDistribution";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetGenderDistribution(_response));
        });
    }

    protected processGetGenderDistribution(response: AxiosResponse): Promise<GenderDashboardResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<GenderDashboardResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GenderDashboardResponse>(null as any);
    }
}

export class IEPDashboardClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getIEPDistribution(filter: IEPDashboardFilter, cancelToken?: CancelToken): Promise<IEPDashboardResponse> {
        let url_ = this.baseUrl + "/IEPDashboard/GetIEPDistribution";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetIEPDistribution(_response));
        });
    }

    protected processGetIEPDistribution(response: AxiosResponse): Promise<IEPDashboardResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<IEPDashboardResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IEPDashboardResponse>(null as any);
    }
}

export class LEPDashboardClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getLEPDistribution(filter: LEPDashboardFilter, cancelToken?: CancelToken): Promise<LEPDashboardResponse> {
        let url_ = this.baseUrl + "/LEPDashboard/GetLEPDistribution";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetLEPDistribution(_response));
        });
    }

    protected processGetLEPDistribution(response: AxiosResponse): Promise<LEPDashboardResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<LEPDashboardResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LEPDashboardResponse>(null as any);
    }
}

export class RaceDashboardClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getRaceDistribution(filter: RaceDashboardFilter, cancelToken?: CancelToken): Promise<RaceDashboardResponse> {
        let url_ = this.baseUrl + "/RaceDashboard/GetRaceDistribution";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetRaceDistribution(_response));
        });
    }

    protected processGetRaceDistribution(response: AxiosResponse): Promise<RaceDashboardResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<RaceDashboardResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RaceDashboardResponse>(null as any);
    }
}

export class ControlGroupStudentsClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getFilterResource( cancelToken?: CancelToken): Promise<ControlGroupStudentFilterResource> {
        let url_ = this.baseUrl + "/ControlGroupStudents/GetFilterResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetFilterResource(_response));
        });
    }

    protected processGetFilterResource(response: AxiosResponse): Promise<ControlGroupStudentFilterResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ControlGroupStudentFilterResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ControlGroupStudentFilterResource>(null as any);
    }
}

export class ControlGroupStudentEnrollmentsClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    initListFilter( cancelToken?: CancelToken): Promise<ControlGroupStudentEnrollmentListFilter> {
        let url_ = this.baseUrl + "/ControlGroupStudentEnrollments/InitListFilter";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processInitListFilter(_response));
        });
    }

    protected processInitListFilter(response: AxiosResponse): Promise<ControlGroupStudentEnrollmentListFilter> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ControlGroupStudentEnrollmentListFilter>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ControlGroupStudentEnrollmentListFilter>(null as any);
    }

    getFilterResource( cancelToken?: CancelToken): Promise<ControlGroupStudentEnrollmentFilterResource> {
        let url_ = this.baseUrl + "/ControlGroupStudentEnrollments/GetFilterResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetFilterResource(_response));
        });
    }

    protected processGetFilterResource(response: AxiosResponse): Promise<ControlGroupStudentEnrollmentFilterResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ControlGroupStudentEnrollmentFilterResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ControlGroupStudentEnrollmentFilterResource>(null as any);
    }

    getListResource( cancelToken?: CancelToken): Promise<ControlGroupStudentEnrollmentListResource> {
        let url_ = this.baseUrl + "/ControlGroupStudentEnrollments/GetListResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListResource(_response));
        });
    }

    protected processGetListResource(response: AxiosResponse): Promise<ControlGroupStudentEnrollmentListResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ControlGroupStudentEnrollmentListResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ControlGroupStudentEnrollmentListResource>(null as any);
    }

    get(id: number | undefined, cancelToken?: CancelToken): Promise<ControlGroupStudentEnrollment> {
        let url_ = this.baseUrl + "/ControlGroupStudentEnrollments/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<ControlGroupStudentEnrollment> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ControlGroupStudentEnrollment>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ControlGroupStudentEnrollment>(null as any);
    }

    getEnrollmentByStudentId(studentId: number | undefined, cancelToken?: CancelToken): Promise<ControlGroupStudentEnrollment> {
        let url_ = this.baseUrl + "/ControlGroupStudentEnrollments/GetEnrollmentByStudentId?";
        if (studentId === null)
            throw new globalThis.Error("The parameter 'studentId' cannot be null.");
        else if (studentId !== undefined)
            url_ += "studentId=" + encodeURIComponent("" + studentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEnrollmentByStudentId(_response));
        });
    }

    protected processGetEnrollmentByStudentId(response: AxiosResponse): Promise<ControlGroupStudentEnrollment> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ControlGroupStudentEnrollment>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ControlGroupStudentEnrollment>(null as any);
    }

    getViewResource( cancelToken?: CancelToken): Promise<ControlGroupStudentEnrollmentViewResource> {
        let url_ = this.baseUrl + "/ControlGroupStudentEnrollments/GetViewResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetViewResource(_response));
        });
    }

    protected processGetViewResource(response: AxiosResponse): Promise<ControlGroupStudentEnrollmentViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ControlGroupStudentEnrollmentViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ControlGroupStudentEnrollmentViewResource>(null as any);
    }

    getEditResource( cancelToken?: CancelToken): Promise<ControlGroupStudentEnrollmentEditResource> {
        let url_ = this.baseUrl + "/ControlGroupStudentEnrollments/GetEditResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEditResource(_response));
        });
    }

    protected processGetEditResource(response: AxiosResponse): Promise<ControlGroupStudentEnrollmentEditResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ControlGroupStudentEnrollmentEditResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ControlGroupStudentEnrollmentEditResource>(null as any);
    }

    saveCreate(controlGroupStudentEnrollmentVm: ControlGroupStudentEnrollment, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/ControlGroupStudentEnrollments/SaveCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(controlGroupStudentEnrollmentVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreate(_response));
        });
    }

    protected processSaveCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveUpdate(controlGroupStudentEnrollmentVm: ControlGroupStudentEnrollment, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/ControlGroupStudentEnrollments/SaveUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(controlGroupStudentEnrollmentVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdate(_response));
        });
    }

    protected processSaveUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    delete(id: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/ControlGroupStudentEnrollments/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getBulkUpdate(ids: number[], cancelToken?: CancelToken): Promise<ControlGroupStudentEnrollmentBulkUpdate> {
        let url_ = this.baseUrl + "/ControlGroupStudentEnrollments/GetBulkUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetBulkUpdate(_response));
        });
    }

    protected processGetBulkUpdate(response: AxiosResponse): Promise<ControlGroupStudentEnrollmentBulkUpdate> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ControlGroupStudentEnrollmentBulkUpdate>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ControlGroupStudentEnrollmentBulkUpdate>(null as any);
    }

    getBulkUpdateResource( cancelToken?: CancelToken): Promise<ControlGroupStudentEnrollmentBulkUpdateResource> {
        let url_ = this.baseUrl + "/ControlGroupStudentEnrollments/GetBulkUpdateResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetBulkUpdateResource(_response));
        });
    }

    protected processGetBulkUpdateResource(response: AxiosResponse): Promise<ControlGroupStudentEnrollmentBulkUpdateResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ControlGroupStudentEnrollmentBulkUpdateResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ControlGroupStudentEnrollmentBulkUpdateResource>(null as any);
    }

    saveBulkUpdate(bulkUpdate: ControlGroupStudentEnrollmentBulkUpdate, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/ControlGroupStudentEnrollments/SaveBulkUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bulkUpdate);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveBulkUpdate(_response));
        });
    }

    protected processSaveBulkUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getEndReasonTypeStats(filter: EndReasonTypeStatsFilter, cancelToken?: CancelToken): Promise<EndReasonTypeStatsResponse> {
        let url_ = this.baseUrl + "/ControlGroupStudentEnrollments/GetEndReasonTypeStats";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEndReasonTypeStats(_response));
        });
    }

    protected processGetEndReasonTypeStats(response: AxiosResponse): Promise<EndReasonTypeStatsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<EndReasonTypeStatsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EndReasonTypeStatsResponse>(null as any);
    }
}

export class ApplicationsClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getList(listFilter: ListFilterBase, cancelToken?: CancelToken): Promise<ApplicationListDto[]> {
        let url_ = this.baseUrl + "/Applications/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetList(_response));
        });
    }

    protected processGetList(response: AxiosResponse): Promise<ApplicationListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ApplicationListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApplicationListDto[]>(null as any);
    }

    getListTotal(listFilter: ListFilterBase, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Applications/GetListTotal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListTotal(_response));
        });
    }

    protected processGetListTotal(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getListResource( cancelToken?: CancelToken): Promise<ApplicationListResource> {
        let url_ = this.baseUrl + "/Applications/GetListResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListResource(_response));
        });
    }

    protected processGetListResource(response: AxiosResponse): Promise<ApplicationListResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ApplicationListResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApplicationListResource>(null as any);
    }

    get(id: number | undefined, cancelToken?: CancelToken): Promise<Application> {
        let url_ = this.baseUrl + "/Applications/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<Application> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<Application>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Application>(null as any);
    }

    getViewResource(applicationId: number | undefined, cancelToken?: CancelToken): Promise<ApplicationViewResource> {
        let url_ = this.baseUrl + "/Applications/GetViewResource?";
        if (applicationId === null)
            throw new globalThis.Error("The parameter 'applicationId' cannot be null.");
        else if (applicationId !== undefined)
            url_ += "applicationId=" + encodeURIComponent("" + applicationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetViewResource(_response));
        });
    }

    protected processGetViewResource(response: AxiosResponse): Promise<ApplicationViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ApplicationViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApplicationViewResource>(null as any);
    }

    generateQrCode(applicationId: number | undefined, cancelToken?: CancelToken): Promise<UploadFile> {
        let url_ = this.baseUrl + "/Applications/GenerateQrCode?";
        if (applicationId === null)
            throw new globalThis.Error("The parameter 'applicationId' cannot be null.");
        else if (applicationId !== undefined)
            url_ += "applicationId=" + encodeURIComponent("" + applicationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGenerateQrCode(_response));
        });
    }

    protected processGenerateQrCode(response: AxiosResponse): Promise<UploadFile> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<UploadFile>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UploadFile>(null as any);
    }

    getEditResource(applicationId: number | undefined, cancelToken?: CancelToken): Promise<ApplicationEditResource> {
        let url_ = this.baseUrl + "/Applications/GetEditResource?";
        if (applicationId === null)
            throw new globalThis.Error("The parameter 'applicationId' cannot be null.");
        else if (applicationId !== undefined)
            url_ += "applicationId=" + encodeURIComponent("" + applicationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEditResource(_response));
        });
    }

    protected processGetEditResource(response: AxiosResponse): Promise<ApplicationEditResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ApplicationEditResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApplicationEditResource>(null as any);
    }

    saveCreate(applicationVm: Application, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Applications/SaveCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(applicationVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreate(_response));
        });
    }

    protected processSaveCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveUpdate(applicationVm: Application, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Applications/SaveUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(applicationVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdate(_response));
        });
    }

    protected processSaveUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    delete(id: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Applications/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class DevelopersClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getList(listFilter: DeveloperListFilter, cancelToken?: CancelToken): Promise<DeveloperListDto[]> {
        let url_ = this.baseUrl + "/Developers/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetList(_response));
        });
    }

    protected processGetList(response: AxiosResponse): Promise<DeveloperListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<DeveloperListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeveloperListDto[]>(null as any);
    }

    getListTotal(listFilter: DeveloperListFilter, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Developers/GetListTotal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListTotal(_response));
        });
    }

    protected processGetListTotal(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getIds(listFilter: DeveloperListFilter, cancelToken?: CancelToken): Promise<number[]> {
        let url_ = this.baseUrl + "/Developers/GetIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetIds(_response));
        });
    }

    protected processGetIds(response: AxiosResponse): Promise<number[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number[]>(null as any);
    }

    getListResource( cancelToken?: CancelToken): Promise<DeveloperListResource> {
        let url_ = this.baseUrl + "/Developers/GetListResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListResource(_response));
        });
    }

    protected processGetListResource(response: AxiosResponse): Promise<DeveloperListResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<DeveloperListResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeveloperListResource>(null as any);
    }

    getFilterResource( cancelToken?: CancelToken): Promise<DeveloperFilterResource> {
        let url_ = this.baseUrl + "/Developers/GetFilterResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetFilterResource(_response));
        });
    }

    protected processGetFilterResource(response: AxiosResponse): Promise<DeveloperFilterResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<DeveloperFilterResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeveloperFilterResource>(null as any);
    }

    get(id: number | undefined, cancelToken?: CancelToken): Promise<Developer> {
        let url_ = this.baseUrl + "/Developers/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<Developer> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<Developer>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Developer>(null as any);
    }

    getViewResource( cancelToken?: CancelToken): Promise<DeveloperViewResource> {
        let url_ = this.baseUrl + "/Developers/GetViewResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetViewResource(_response));
        });
    }

    protected processGetViewResource(response: AxiosResponse): Promise<DeveloperViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<DeveloperViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeveloperViewResource>(null as any);
    }

    getEditResource( cancelToken?: CancelToken): Promise<DeveloperEditResource> {
        let url_ = this.baseUrl + "/Developers/GetEditResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEditResource(_response));
        });
    }

    protected processGetEditResource(response: AxiosResponse): Promise<DeveloperEditResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<DeveloperEditResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeveloperEditResource>(null as any);
    }

    saveCreate(developerVm: Developer, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Developers/SaveCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(developerVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreate(_response));
        });
    }

    protected processSaveCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveUpdate(developerVm: Developer, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Developers/SaveUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(developerVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdate(_response));
        });
    }

    protected processSaveUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    delete(id: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Developers/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getBulkUpdate(ids: number[], cancelToken?: CancelToken): Promise<DeveloperBulkUpdate> {
        let url_ = this.baseUrl + "/Developers/GetBulkUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetBulkUpdate(_response));
        });
    }

    protected processGetBulkUpdate(response: AxiosResponse): Promise<DeveloperBulkUpdate> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<DeveloperBulkUpdate>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeveloperBulkUpdate>(null as any);
    }

    getBulkUpdateResource( cancelToken?: CancelToken): Promise<DeveloperBulkUpdateResource> {
        let url_ = this.baseUrl + "/Developers/GetBulkUpdateResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetBulkUpdateResource(_response));
        });
    }

    protected processGetBulkUpdateResource(response: AxiosResponse): Promise<DeveloperBulkUpdateResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<DeveloperBulkUpdateResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeveloperBulkUpdateResource>(null as any);
    }

    saveBulkUpdate(bulkUpdate: DeveloperBulkUpdate, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Developers/SaveBulkUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bulkUpdate);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveBulkUpdate(_response));
        });
    }

    protected processSaveBulkUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class SurveyExportClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getSurveyExportResource( cancelToken?: CancelToken): Promise<SurveyExportResource> {
        let url_ = this.baseUrl + "/SurveyExport/GetSurveyExportResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSurveyExportResource(_response));
        });
    }

    protected processGetSurveyExportResource(response: AxiosResponse): Promise<SurveyExportResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SurveyExportResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SurveyExportResource>(null as any);
    }

    generateSurveyReport(request: SurveyExportRequest, cancelToken?: CancelToken): Promise<GeneratedFile> {
        let url_ = this.baseUrl + "/SurveyExport/GenerateSurveyReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGenerateSurveyReport(_response));
        });
    }

    protected processGenerateSurveyReport(response: AxiosResponse): Promise<GeneratedFile> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<GeneratedFile>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GeneratedFile>(null as any);
    }
}

export class SurveyResponsesClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getList(listFilter: SurveyResponseListFilter, cancelToken?: CancelToken): Promise<SurveyResponseListDto[]> {
        let url_ = this.baseUrl + "/SurveyResponses/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetList(_response));
        });
    }

    protected processGetList(response: AxiosResponse): Promise<SurveyResponseListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SurveyResponseListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SurveyResponseListDto[]>(null as any);
    }

    getStudentList(listFilter: SurveyResponseListFilter, studentId: number | undefined, cancelToken?: CancelToken): Promise<SurveyResponseListDto[]> {
        let url_ = this.baseUrl + "/SurveyResponses/GetStudentList?";
        if (studentId === null)
            throw new globalThis.Error("The parameter 'studentId' cannot be null.");
        else if (studentId !== undefined)
            url_ += "studentId=" + encodeURIComponent("" + studentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetStudentList(_response));
        });
    }

    protected processGetStudentList(response: AxiosResponse): Promise<SurveyResponseListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SurveyResponseListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SurveyResponseListDto[]>(null as any);
    }

    getSurveyResponse(surveyResponseId: number | undefined, cancelToken?: CancelToken): Promise<SurveyResponseDto> {
        let url_ = this.baseUrl + "/SurveyResponses/GetSurveyResponse?";
        if (surveyResponseId === null)
            throw new globalThis.Error("The parameter 'surveyResponseId' cannot be null.");
        else if (surveyResponseId !== undefined)
            url_ += "surveyResponseId=" + encodeURIComponent("" + surveyResponseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSurveyResponse(_response));
        });
    }

    protected processGetSurveyResponse(response: AxiosResponse): Promise<SurveyResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SurveyResponseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SurveyResponseDto>(null as any);
    }

    deleteSurveyResponse(surveyResponseId: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/SurveyResponses/DeleteSurveyResponse?";
        if (surveyResponseId === null)
            throw new globalThis.Error("The parameter 'surveyResponseId' cannot be null.");
        else if (surveyResponseId !== undefined)
            url_ += "surveyResponseId=" + encodeURIComponent("" + surveyResponseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteSurveyResponse(_response));
        });
    }

    protected processDeleteSurveyResponse(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveUpdate(surveyResponse: SurveyResponseUpdateDto, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/SurveyResponses/SaveUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(surveyResponse);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdate(_response));
        });
    }

    protected processSaveUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getListTotal(listFilter: SurveyResponseListFilter, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/SurveyResponses/GetListTotal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListTotal(_response));
        });
    }

    protected processGetListTotal(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getListResource( cancelToken?: CancelToken): Promise<SurveyResponseListResource> {
        let url_ = this.baseUrl + "/SurveyResponses/GetListResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListResource(_response));
        });
    }

    protected processGetListResource(response: AxiosResponse): Promise<SurveyResponseListResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SurveyResponseListResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SurveyResponseListResource>(null as any);
    }

    getFilterResource( cancelToken?: CancelToken): Promise<SurveyResponseFilterResource> {
        let url_ = this.baseUrl + "/SurveyResponses/GetFilterResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetFilterResource(_response));
        });
    }

    protected processGetFilterResource(response: AxiosResponse): Promise<SurveyResponseFilterResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SurveyResponseFilterResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SurveyResponseFilterResource>(null as any);
    }
}

export class SurveysClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getList(listFilter: SurveyListFilter, cancelToken?: CancelToken): Promise<SurveyListDto[]> {
        let url_ = this.baseUrl + "/Surveys/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetList(_response));
        });
    }

    protected processGetList(response: AxiosResponse): Promise<SurveyListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SurveyListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SurveyListDto[]>(null as any);
    }

    getListTotal(listFilter: SurveyListFilter, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Surveys/GetListTotal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListTotal(_response));
        });
    }

    protected processGetListTotal(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getListResource( cancelToken?: CancelToken): Promise<SurveyListResource> {
        let url_ = this.baseUrl + "/Surveys/GetListResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListResource(_response));
        });
    }

    protected processGetListResource(response: AxiosResponse): Promise<SurveyListResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SurveyListResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SurveyListResource>(null as any);
    }

    getFilterResource( cancelToken?: CancelToken): Promise<SurveyFilterResource> {
        let url_ = this.baseUrl + "/Surveys/GetFilterResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetFilterResource(_response));
        });
    }

    protected processGetFilterResource(response: AxiosResponse): Promise<SurveyFilterResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SurveyFilterResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SurveyFilterResource>(null as any);
    }

    generateQrCode(formId: number | undefined, cancelToken?: CancelToken): Promise<UploadFile> {
        let url_ = this.baseUrl + "/Surveys/GenerateQrCode?";
        if (formId === null)
            throw new globalThis.Error("The parameter 'formId' cannot be null.");
        else if (formId !== undefined)
            url_ += "formId=" + encodeURIComponent("" + formId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGenerateQrCode(_response));
        });
    }

    protected processGenerateQrCode(response: AxiosResponse): Promise<UploadFile> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<UploadFile>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UploadFile>(null as any);
    }

    get(id: number | undefined, cancelToken?: CancelToken): Promise<Form> {
        let url_ = this.baseUrl + "/Surveys/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<Form> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<Form>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Form>(null as any);
    }

    getViewResource(formId: number | undefined, cancelToken?: CancelToken): Promise<SurveyViewResource> {
        let url_ = this.baseUrl + "/Surveys/GetViewResource?";
        if (formId === null)
            throw new globalThis.Error("The parameter 'formId' cannot be null.");
        else if (formId !== undefined)
            url_ += "formId=" + encodeURIComponent("" + formId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetViewResource(_response));
        });
    }

    protected processGetViewResource(response: AxiosResponse): Promise<SurveyViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SurveyViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SurveyViewResource>(null as any);
    }

    getEditResource( cancelToken?: CancelToken): Promise<SurveyEditResource> {
        let url_ = this.baseUrl + "/Surveys/GetEditResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEditResource(_response));
        });
    }

    protected processGetEditResource(response: AxiosResponse): Promise<SurveyEditResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SurveyEditResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SurveyEditResource>(null as any);
    }

    saveCreate(formVm: Form, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Surveys/SaveCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(formVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreate(_response));
        });
    }

    protected processSaveCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveUpdate(formVm: Form, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Surveys/SaveUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(formVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdate(_response));
        });
    }

    protected processSaveUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    delete(id: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Surveys/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class DataCenterFilesClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getList(listFilter: DataCenterFileListFilter, cancelToken?: CancelToken): Promise<DataCenterFileListDto[]> {
        let url_ = this.baseUrl + "/DataCenterFiles/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetList(_response));
        });
    }

    protected processGetList(response: AxiosResponse): Promise<DataCenterFileListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<DataCenterFileListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataCenterFileListDto[]>(null as any);
    }

    getListTotal(listFilter: DataCenterFileListFilter, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/DataCenterFiles/GetListTotal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListTotal(_response));
        });
    }

    protected processGetListTotal(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getListResource( cancelToken?: CancelToken): Promise<DataCenterFileListResource> {
        let url_ = this.baseUrl + "/DataCenterFiles/GetListResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListResource(_response));
        });
    }

    protected processGetListResource(response: AxiosResponse): Promise<DataCenterFileListResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<DataCenterFileListResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataCenterFileListResource>(null as any);
    }

    getFilterResource( cancelToken?: CancelToken): Promise<DataCenterFileFilterResource> {
        let url_ = this.baseUrl + "/DataCenterFiles/GetFilterResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetFilterResource(_response));
        });
    }

    protected processGetFilterResource(response: AxiosResponse): Promise<DataCenterFileFilterResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<DataCenterFileFilterResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataCenterFileFilterResource>(null as any);
    }

    get(id: number | undefined, cancelToken?: CancelToken): Promise<DataCenterFile> {
        let url_ = this.baseUrl + "/DataCenterFiles/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<DataCenterFile> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<DataCenterFile>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataCenterFile>(null as any);
    }

    getViewResource(id: number | undefined, cancelToken?: CancelToken): Promise<DataCenterFileViewResource> {
        let url_ = this.baseUrl + "/DataCenterFiles/GetViewResource?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetViewResource(_response));
        });
    }

    protected processGetViewResource(response: AxiosResponse): Promise<DataCenterFileViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<DataCenterFileViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataCenterFileViewResource>(null as any);
    }

    getEditResource( cancelToken?: CancelToken): Promise<DataCenterFileEditResource> {
        let url_ = this.baseUrl + "/DataCenterFiles/GetEditResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEditResource(_response));
        });
    }

    protected processGetEditResource(response: AxiosResponse): Promise<DataCenterFileEditResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<DataCenterFileEditResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataCenterFileEditResource>(null as any);
    }

    saveCreate(dataCenterFileVm: DataCenterFile, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/DataCenterFiles/SaveCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dataCenterFileVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreate(_response));
        });
    }

    protected processSaveCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    delete(id: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/DataCenterFiles/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class DataCenterFileTasksClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getList(listFilter: DataCenterFileTaskListFilter, cancelToken?: CancelToken): Promise<DataCenterFileTask[]> {
        let url_ = this.baseUrl + "/DataCenterFileTasks/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetList(_response));
        });
    }

    protected processGetList(response: AxiosResponse): Promise<DataCenterFileTask[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<DataCenterFileTask[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataCenterFileTask[]>(null as any);
    }

    get(id: number | undefined, dataCenterFileId: number | null | undefined, cancelToken?: CancelToken): Promise<DataCenterFileTask> {
        let url_ = this.baseUrl + "/DataCenterFileTasks/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (dataCenterFileId !== undefined && dataCenterFileId !== null)
            url_ += "dataCenterFileId=" + encodeURIComponent("" + dataCenterFileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<DataCenterFileTask> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<DataCenterFileTask>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataCenterFileTask>(null as any);
    }
}

export class PartnersClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getList(listFilter: ListFilterBase, cancelToken?: CancelToken): Promise<PartnerListDto[]> {
        let url_ = this.baseUrl + "/Partners/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetList(_response));
        });
    }

    protected processGetList(response: AxiosResponse): Promise<PartnerListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<PartnerListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PartnerListDto[]>(null as any);
    }

    getListTotal(listFilter: ListFilterBase, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Partners/GetListTotal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListTotal(_response));
        });
    }

    protected processGetListTotal(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getListResource( cancelToken?: CancelToken): Promise<PartnerListResource> {
        let url_ = this.baseUrl + "/Partners/GetListResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListResource(_response));
        });
    }

    protected processGetListResource(response: AxiosResponse): Promise<PartnerListResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<PartnerListResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PartnerListResource>(null as any);
    }

    get(id: number | undefined, cancelToken?: CancelToken): Promise<Partner> {
        let url_ = this.baseUrl + "/Partners/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<Partner> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<Partner>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Partner>(null as any);
    }

    getViewResource(id: number | undefined, cancelToken?: CancelToken): Promise<PartnerViewResource> {
        let url_ = this.baseUrl + "/Partners/GetViewResource?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetViewResource(_response));
        });
    }

    protected processGetViewResource(response: AxiosResponse): Promise<PartnerViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<PartnerViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PartnerViewResource>(null as any);
    }

    saveCreate(partnerVm: Partner, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Partners/SaveCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(partnerVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreate(_response));
        });
    }

    protected processSaveCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveUpdate(partnerVm: Partner, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Partners/SaveUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(partnerVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdate(_response));
        });
    }

    protected processSaveUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    delete(id: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Partners/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class ClientSurveyExportClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getSurveyExportResource( cancelToken?: CancelToken): Promise<SurveyExportResource> {
        let url_ = this.baseUrl + "/ClientSurveyExport/GetSurveyExportResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSurveyExportResource(_response));
        });
    }

    protected processGetSurveyExportResource(response: AxiosResponse): Promise<SurveyExportResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SurveyExportResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SurveyExportResource>(null as any);
    }

    generateClientSurveyReport(request: SurveyExportRequest, cancelToken?: CancelToken): Promise<GeneratedFile> {
        let url_ = this.baseUrl + "/ClientSurveyExport/GenerateClientSurveyReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGenerateClientSurveyReport(_response));
        });
    }

    protected processGenerateClientSurveyReport(response: AxiosResponse): Promise<GeneratedFile> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<GeneratedFile>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GeneratedFile>(null as any);
    }
}

export class ClassClient extends ApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    saveCreate(classVm: Class, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Class/SaveCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(classVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCreate(_response));
        });
    }

    protected processSaveCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    saveUpdate(classVm: Class, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Class/SaveUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(classVm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveUpdate(_response));
        });
    }

    protected processSaveUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    get(id: number | undefined, cancelToken?: CancelToken): Promise<Class> {
        let url_ = this.baseUrl + "/Class/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<Class> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<Class>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Class>(null as any);
    }

    getEditResource( cancelToken?: CancelToken): Promise<ClassEditResource> {
        let url_ = this.baseUrl + "/Class/GetEditResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEditResource(_response));
        });
    }

    protected processGetEditResource(response: AxiosResponse): Promise<ClassEditResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ClassEditResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ClassEditResource>(null as any);
    }

    getViewResource( cancelToken?: CancelToken): Promise<ClassViewResource> {
        let url_ = this.baseUrl + "/Class/GetViewResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetViewResource(_response));
        });
    }

    protected processGetViewResource(response: AxiosResponse): Promise<ClassViewResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ClassViewResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ClassViewResource>(null as any);
    }

    getList(filter: ClassListFilter, cancelToken?: CancelToken): Promise<ClassListDto[]> {
        let url_ = this.baseUrl + "/Class/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetList(_response));
        });
    }

    protected processGetList(response: AxiosResponse): Promise<ClassListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ClassListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ClassListDto[]>(null as any);
    }

    getListTotal(filter: ClassListFilter, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Class/GetListTotal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListTotal(_response));
        });
    }

    protected processGetListTotal(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getFilterResource( cancelToken?: CancelToken): Promise<ClassFilterResource> {
        let url_ = this.baseUrl + "/Class/GetFilterResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetFilterResource(_response));
        });
    }

    protected processGetFilterResource(response: AxiosResponse): Promise<ClassFilterResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ClassFilterResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ClassFilterResource>(null as any);
    }

    getListResource( cancelToken?: CancelToken): Promise<ClassListResource> {
        let url_ = this.baseUrl + "/Class/GetListResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListResource(_response));
        });
    }

    protected processGetListResource(response: AxiosResponse): Promise<ClassListResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ClassListResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ClassListResource>(null as any);
    }

    delete(id: number, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Class/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getIds(filter: ClassListFilter, cancelToken?: CancelToken): Promise<number[]> {
        let url_ = this.baseUrl + "/Class/GetIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetIds(_response));
        });
    }

    protected processGetIds(response: AxiosResponse): Promise<number[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number[]>(null as any);
    }

    saveBulkUpdate(dto: ClassBulkUpdateDto, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Class/SaveBulkUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveBulkUpdate(_response));
        });
    }

    protected processSaveBulkUpdate(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getBulkEditResource(ids: number[], cancelToken?: CancelToken): Promise<ClassBulkEditResource> {
        let url_ = this.baseUrl + "/Class/GetBulkEditResource";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetBulkEditResource(_response));
        });
    }

    protected processGetBulkEditResource(response: AxiosResponse): Promise<ClassBulkEditResource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ClassBulkEditResource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ClassBulkEditResource>(null as any);
    }

    deleteList(ids: number[], cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Class/DeleteList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteList(_response));
        });
    }

    protected processDeleteList(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export interface AiSearchFavoriteDto {
    id: number;
    name?: string | undefined;
    query?: string | undefined;
    searchContext?: string | undefined;
    isFavorite: boolean;
    useCount: number;
    displayOrder?: number | undefined;
    createdDate?: Date | undefined;
    modifiedDate?: Date | undefined;
    lastUsedDate?: Date | undefined;
}

export interface AiSearchFavoriteEditDto {
    id: number;
    name?: string | undefined;
    query?: string | undefined;
    searchContext?: string | undefined;
    isFavorite: boolean;
    displayOrder?: number | undefined;
}

export interface AiSearchFavoriteOrderDto {
    id: number;
    displayOrder: number;
}

export interface AuthResult {
    authResultType: AuthResultType;
    jwtToken?: string | undefined;
    refreshToken?: string | undefined;
    jwtTokenExpiration?: Date | undefined;
    refreshTokenExpiration?: Date | undefined;
    multipleGrants: boolean;
}

export enum AuthResultType {
    Authenticated = 0,
    PasswordExpired = 1,
    UserMigration = 2,
}

export interface AuthRequest {
    generalValidationErrors?: string | undefined;
    tenantName: string;
    username: string;
    password: string;
    newPassword?: string | undefined;
    confirmNewPassword?: string | undefined;
    isChangingPassword: boolean;
}

export interface AuthViewResource {
    properties?: ModelPropertyBase[] | undefined;
}

export interface ModelPropertyBase {
    propertyName: string;
    displayName: string;
    required: boolean;
    maxLength?: number | undefined;
    type?: ModelPropertyType | undefined;
    children?: ModelPropertyBase[] | undefined;
}

export enum ModelPropertyType {
    Unknown = 0,
    String = 1,
    Int = 2,
    Decimal = 3,
    Bool = 4,
    NullableBool = 5,
    Date = 6,
    DateTimeOffset = 7,
    TimeSpan = 8,
}

export interface ForgotCredentialViewResource {
    properties?: ModelPropertyBase[] | undefined;
}

export interface ForgotCredential {
    generalValidationErrors?: string | undefined;
    tenantName: string;
    email: string;
    forgotCredentialType: ForgotCredentialType;
}

export enum ForgotCredentialType {
    ForgotUsername = 0,
    ForgotPassword = 1,
}

export interface ResetPasswordViewResource {
    properties?: ModelPropertyBase[] | undefined;
}

export interface ResetPassword {
    generalValidationErrors?: string | undefined;
    tenantName: string;
    userId: number;
    validationToken: string;
    username: string;
    newPassword: string;
    confirmNewPassword: string;
}

export interface UserRegisterViewResource {
    properties?: ModelPropertyBase[] | undefined;
}

export interface UserRegister {
    tenantName: string;
    userId: number;
    validationToken: string;
    username: string;
    email: string;
    firstName: string;
    lastName: string;
    password: string;
    confirmPassword: string;
    centralUserValidationToken?: string | undefined;
    generalValidationErrors?: string | undefined;
}

export interface AuthRequestV2 {
    generalValidationErrors?: string | undefined;
    email: string;
    password: string;
    newPassword?: string | undefined;
    confirmNewPassword?: string | undefined;
    isChangingPassword: boolean;
}

export interface ForgotCredentialV2 {
    generalValidationErrors?: string | undefined;
    email: string;
    forgotCredentialType: ForgotCredentialType;
}

export interface ResetPasswordV2 {
    generalValidationErrors?: string | undefined;
    userId: number;
    validationToken: string;
    newPassword: string;
    confirmNewPassword: string;
}

export interface UserDto {
    user?: User | undefined;
    centralUserMembership?: string | undefined;
    isLinked?: boolean | undefined;
    isPending?: boolean | undefined;
}

export interface Entity {
    id: number;
    deleted: boolean;
    hardDeleted: boolean;
    displayOrder?: number | undefined;
}

export interface DataModel extends Entity {
    createdById?: number | undefined;
    createdDate?: Date | undefined;
    modifiedById?: number | undefined;
    modifiedDate?: Date | undefined;
    fileId?: number | undefined;
    isLocked: boolean;
    isNotUi: boolean;
    uniqueIdentifier?: string | undefined;
    touched: boolean;
}

export interface User extends DataModel {
    generalValidationErrors?: string | undefined;
    username?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    isApproved: boolean;
    deactivated: boolean;
    failedLoginAttempts: number;
    lastLoginDate?: Date | undefined;
    lastPasswordChangedDate?: Date | undefined;
    lastLockedDate?: Date | undefined;
    passwordExpirationDate?: Date | undefined;
    registeredDate?: Date | undefined;
    membershipId: number;
    roleId?: number | undefined;
    role?: LkRole | undefined;
    roleName?: string | undefined;
    settingId: number;
    setting?: UserSetting | undefined;
    regions?: Region[] | undefined;
    districts?: District[] | undefined;
    schools?: School[] | undefined;
    programs?: Program[] | undefined;
    partners?: Partner[] | undefined;
    subPartners?: SubPartner[] | undefined;
    lastViewedApplicationUpdateId?: number | undefined;
    dataAssignmentTypeId?: number | undefined;
    dataAssignmentType?: LkUserDataAssignmentType | undefined;
    partnerAssignmentTypeId?: number | undefined;
    partnerAssignmentType?: LkUserPartnerAssignmentType | undefined;
    canConfigureAndUseTexting: boolean;
    avatarColor?: string | undefined;
    contact?: string | undefined;
    contactMethod?: string | undefined;
    aggregatedDataAssignedDistrictIds?: number[] | undefined;
    aggregatedDataAssignedSchoolIds?: number[] | undefined;
    exportDisplayFieldsSnapshots?: UserExportDisplayFieldsSnapshot[] | undefined;
    notifyForUnresponsiveStudent: boolean;
}

export interface LookUp extends Entity {
    name: string;
    code?: string | undefined;
}

export interface LkRole extends LookUp {
    description?: string | undefined;
    canUseDataAssignment: boolean;
    canUsePartnerAssignment: boolean;
    canAccessAllDataCenterFiles: boolean;
    canConfigureTexting: boolean;
}

export interface UserSetting extends DataModel {
    navPinned: boolean;
    pageSize?: number | undefined;
    multiSort: boolean;
    bulkGridView: boolean;
    serviceSequentialCreateRetainData: boolean;
    maxScreenWidth?: string | undefined;
    importAutoMapMode?: string | undefined;
    importSimilarityPercent?: number | undefined;
    keyboardListNavigationEnabled: boolean;
}

export interface Region extends DataModel {
    isInUse: boolean;
    name: string;
    districts?: District[] | undefined;
}

export interface District extends DataModel {
    isInUse: boolean;
    name: string;
    schools?: School[] | undefined;
}

export interface School extends DataModel {
    isInUse: boolean;
    name: string;
    officialSchoolName?: string | undefined;
    actCode?: string | undefined;
    serviceLocationOnly: boolean;
    addressId: number;
    address?: Address | undefined;
    nces?: string | undefined;
    inactive: boolean;
    schoolCode?: string | undefined;
    schoolTypeId?: number | undefined;
    schoolType?: LkSchoolType | undefined;
    termTypeId?: number | undefined;
    termType?: LkTermType | undefined;
    isTitle1?: boolean | undefined;
    contactId?: number | undefined;
    isTargetSchool?: boolean | undefined;
    gradeLevels?: LkGradeLevel[] | undefined;
    contactName?: string | undefined;
}

export interface Address extends DataModel {
    addressLine?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    postal?: string | undefined;
}

export interface LkSchoolType extends LookUp {
}

export interface LkTermType extends LookUp {
    termCount?: number | undefined;
    edReport: boolean;
    progressOrder?: number | undefined;
}

export interface LkGradeLevel extends LookUp {
    edReportGradeLevel?: string | undefined;
    progressOrder?: number | undefined;
    displayStudentMaidenName: boolean;
    displayStudentGradeLevelTerm: boolean;
    tapr?: number | undefined;
}

export interface Program extends DataModel {
    name: string;
    prNumber?: string | undefined;
    tapr?: number | undefined;
}

export interface Partner extends DataModel {
    isInUse: boolean;
    name: string;
    addressId: number;
    address?: Address | undefined;
    formattedAddress?: string | undefined;
    phone?: string | undefined;
    fax?: string | undefined;
    contactContributorId?: number | undefined;
    contactContributor?: Contributor | undefined;
    contactContributorTitle?: string | undefined;
    oldCompassMatchId?: string | undefined;
    creatingFirstIndirectCost?: PartnerIndirectCost | undefined;
}

export interface Contributor extends DataModel {
    firstName: string;
    lastName: string;
    currentTitle?: string | undefined;
    employeeIdentification?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    phoneExtension?: string | undefined;
    fax?: string | undefined;
    federal: boolean;
    note?: string | undefined;
    oldCompassMatchId?: number | undefined;
    creatingFirstEmployment?: ContributorEmployment | undefined;
}

export interface ContributorEmployment extends DataModel {
    contributorId: number;
    partnerId: number;
    partner?: Partner | undefined;
    subPartnerId?: number | undefined;
    subPartner?: SubPartner | undefined;
    title?: string | undefined;
    startDate: Date;
    endDate?: Date | undefined;
    hourlySalary: number;
    groupBenefit?: number | undefined;
    medicalBenefit?: number | undefined;
    annualSalary?: number | undefined;
    annualPercent?: number | undefined;
    isBeforeMatchStaticEndDate: boolean;
    hasContributorMatchesLinked: boolean;
}

export interface SubPartner extends DataModel {
    isInUse: boolean;
    name: string;
    partnerId: number;
    partner?: Partner | undefined;
    addressId: number;
    address?: Address | undefined;
    phone?: string | undefined;
    fax?: string | undefined;
    contactContributorId?: number | undefined;
    contactContributor?: Contributor | undefined;
    oldCompassMatchId?: string | undefined;
}

export interface PartnerIndirectCost extends DataModel {
    partnerId: number;
    startDate: Date;
    endDate?: Date | undefined;
    mileage?: number | undefined;
    indirectPercent?: number | undefined;
}

export interface LkUserDataAssignmentType extends LookUp {
}

export interface LkUserPartnerAssignmentType extends LookUp {
}

export interface UserExportDisplayFieldsSnapshot extends DataModel {
    generalValidationErrors?: string | undefined;
    userId: number;
    exportSubTypeId?: number | undefined;
    exportSubType?: LkExportSubType | undefined;
    exportTypeId?: number | undefined;
    exportType?: LkExportType | undefined;
    name: string;
    displayFields?: UserExportDisplayField[] | undefined;
}

export interface LkExportSubType extends LookUp {
    exportTypeId: number;
}

export interface LkExportType extends LookUp {
    subTypes?: LkExportSubType[] | undefined;
}

export interface UserExportDisplayField extends DataModel {
    snapshotId: number;
    name: string;
}

export interface UserRegisterV2 {
    userId: number;
    validationToken: string;
    email: string;
    firstName: string;
    lastName: string;
    password: string;
    confirmPassword: string;
    generalValidationErrors?: string | undefined;
}

export interface Comment extends DataModel {
    message: string;
    isActivity: boolean;
    createdByName?: string | undefined;
}

export interface HtmlToPdf {
    html?: string | undefined;
    landscape?: boolean | undefined;
    filename?: string | undefined;
}

export interface DataModelInfo {
    id: number;
    createdBy?: string | undefined;
    createdDate?: Date | undefined;
    modifiedBy?: string | undefined;
    modifiedDate?: Date | undefined;
    fileId?: number | undefined;
}

export enum DataModelEnum {
    Staff = 0,
    StaffService = 1,
    StaffEmployment = 2,
    NscCollege = 3,
    StudentServiceIndex = 4,
    ContributorMatchService = 5,
    SuppliesDetail = 6,
    Developer = 7,
    Application = 8,
    Contributor = 9,
    ContributorEmployment = 10,
    ContributorMatch = 11,
    NonPersonnel = 12,
    PartnerIndirectCost = 13,
    Partner = 14,
    SubPartner = 15,
    StudentAbsence = 16,
    StudentDiploma = 17,
    StudentPostHighSchool = 18,
    StudentEnrollment = 19,
    StudentFafsa = 20,
    StudentGpa = 21,
    StudentGrade = 22,
    StudentParent = 23,
    StudentScholarship = 24,
    StudentServiceTemplate = 25,
    StudentService = 26,
    StudentTest = 27,
    StudentGroup = 28,
    Student = 29,
    CustomDataModelFieldSelectListItem = 30,
    School = 31,
    District = 32,
    EndReason = 33,
    StudentServiceType = 34,
    College = 35,
    Provider = 36,
    ProviderEmployment = 37,
    Grade = 38,
    StaffServiceType = 39,
    StaffPosition = 40,
    FileCategory = 41,
    Class = 42,
    DiplomaType = 43,
    Discipline = 44,
    FeederSchool = 45,
    Region = 46,
    User = 47,
    TestType = 48,
    ApplicationUpdateEntry = 49,
    StudentFile = 50,
}

export interface BulkSelectResource {
    gridView: boolean;
}

export interface EmailOutput {
    sent: number;
    total: number;
    errorMessages?: string[] | undefined;
}

export interface EmailModel {
    senderId: EmailModelSenderId;
    recipients: string[];
    subject: string;
    body: string;
}

export enum EmailModelSenderId {
    System = 1,
    User = 2,
    Bulk = 3,
}

export interface DashboardTabDto {
    id: number;
    label?: string | undefined;
    isDefault: boolean;
    displayOrder?: number | undefined;
    color?: string | undefined;
    cards?: DashboardTabCardDto[] | undefined;
}

export interface DashboardTabCardDto {
    id: number;
    cardId: number;
    displayOrder?: number | undefined;
}

export interface DashboardTabEditDto {
    id: number;
    label: string;
    color?: string | undefined;
    displayOrder?: number | undefined;
    cards?: DashboardTabCardEditDto[] | undefined;
}

export interface DashboardTabCardEditDto {
    cardId: number;
    displayOrder?: number | undefined;
}

export interface DashboardTabOrderDto {
    id: number;
    displayOrder?: number | undefined;
}

export interface TextingMessage extends DataModel {
    sid?: string | undefined;
    textingConversationId: number;
    dateSent?: Date | undefined;
    sentByUserId?: number | undefined;
    sentByUser?: User | undefined;
    inbound: boolean;
    messageBody?: string | undefined;
    flags?: TextingMessageFlag[] | undefined;
}

export interface TextingMessageFlag extends DataModel {
    userId: number;
    user?: User | undefined;
    textingMessageId: number;
}

export interface SendMessageRequestDto {
    conversationId: number;
    messageBody?: string | undefined;
}

export interface AppResource {
    tenantName?: string | undefined;
    timezone?: string | undefined;
    userId?: number | undefined;
    roleId?: number | undefined;
    userMembership?: string | undefined;
    centralUserMembership?: string | undefined;
    userFullName?: string | undefined;
    rolePermissions?: RolePermission[] | undefined;
    userSetting?: UserSetting | undefined;
    reactMenus?: LkReactMenu[] | undefined;
}

export interface RolePermission {
    permission: Permission;
    roleId: LkRoleId;
    actions?: PermissionAction[] | undefined;
}

export enum Permission {
    Analysis = 0,
    AnticipatedMatch = 1,
    Class = 2,
    Contributor = 3,
    ContributorEmployment = 4,
    ContributorMatch = 5,
    DataCenterFile = 6,
    Developer = 7,
    EdReport = 8,
    Event = 9,
    Form = 10,
    MatchReport = 11,
    TimeAndEffortReview = 12,
    MatchUtility = 13,
    MatchExport = 14,
    NonPersonnel = 15,
    Parent = 16,
    Provider = 17,
    ProviderEmployment = 18,
    Report = 19,
    Staff = 20,
    StaffEmployment = 21,
    StaffService = 22,
    Student = 23,
    StudentAbsence = 24,
    StudentApplication = 25,
    StudentAttendance = 26,
    StudentDiploma = 27,
    StudentEnrollment = 28,
    StudentFafsa = 29,
    StudentFile = 30,
    StudentGpa = 31,
    StudentGrade = 32,
    StudentGroup = 33,
    StudentIsp = 34,
    StudentNote = 35,
    StudentNscCollege = 36,
    StudentParent = 37,
    StudentQuestionnaire = 38,
    StudentScholarship = 39,
    StudentService = 40,
    StudentServiceTemplate = 41,
    StudentTest = 42,
    StudentPostHighSchool = 43,
    SystemAnnouncement = 44,
    SystemExport = 45,
    SystemCollege = 46,
    SystemUtility = 47,
    Teacher = 48,
    TeacherEmployment = 49,
    TeacherService = 50,
    Texting = 51,
    User = 52,
    AprSss = 53,
    AprEts = 54,
    AprUb = 55,
    UtilitySchools = 56,
    AprEoc = 57,
    SurveyReport = 58,
    WalletPass = 59,
}

export enum LkRoleId {
    Cobro = 1,
    Administrator = 2,
    Grant = 3,
    Report = 7,
    DataEntry = 8,
    View = 9,
    Coach = 10,
    MatchAdmin = 11,
    Match = 12,
    DataCenter = 13,
    Evaluator = 14,
    MatchViewOnly = 15,
    GrantMatchViewOnly = 16,
}

export enum PermissionAction {
    List = 0,
    View = 1,
    Create = 2,
    Update = 3,
    Delete = 4,
    BulkDelete = 5,
    Lock = 6,
    BulkLock = 7,
}

export interface LkReactMenu extends LookUp {
}

export interface Home {
    userFirstName?: string | undefined;
    role?: string | undefined;
    dashboardCards?: LkDashboardCard[] | undefined;
}

export interface LkDashboardCard extends LookUp {
    description?: string | undefined;
    icon?: string | undefined;
    category?: string | undefined;
    createdDate: Date;
    isNew: boolean;
}

export interface HomeServiceDashboard {
    thisMonthRows?: HomeServiceDashboardRow[] | undefined;
    previousMonthRows?: HomeServiceDashboardRow[] | undefined;
}

export interface HomeServiceDashboardRow {
    serviceTypeId: number;
    serviceType?: string | undefined;
    totalStudents: number;
    totalDurationInMinutes: number;
}

export interface HomeMatchDashboard {
    pieChartRows?: HomeMatchDashboardRow[] | undefined;
    tableRows?: HomeMatchDashboardRow[] | undefined;
    reportDateFrom?: Date | undefined;
    reportDateTo?: Date | undefined;
}

export interface HomeMatchDashboardRow {
    label?: string | undefined;
    amount?: number | undefined;
    isBold: boolean;
}

export interface StudentCountsByGradeResponse {
    schoolYear: number;
    schoolYearDisplay?: string | undefined;
    groupBy: StudentGroupBy;
    data?: StudentCountsByGradeDto[] | undefined;
    total: number;
    activeSchoolYear: number;
}

export enum StudentGroupBy {
    Grade = 0,
    School = 1,
    Year = 2,
}

export interface StudentCountsByGradeDto {
    groupId: number;
    groupName?: string | undefined;
    studentCount: number;
    year?: number | undefined;
    percentage: number;
}

export interface StudentCountsByGradeRequest {
    schoolYear?: number | undefined;
    programId?: number | undefined;
    groupBy: StudentGroupBy;
    schoolYears?: number[] | undefined;
    schoolId?: number | undefined;
    gradeLevelId?: number | undefined;
}

export interface GeneratedFile {
    fileName?: string | undefined;
    contentType?: string | undefined;
    base64String?: string | undefined;
}

export interface SchoolEnrollmentSummaryResponse {
    schoolYear: number;
    schoolYearDisplay?: string | undefined;
    data?: SchoolEnrollmentSummaryDto[] | undefined;
    activeSchoolYear: number;
}

export interface SchoolEnrollmentSummaryDto {
    schoolId: number;
    schoolName?: string | undefined;
    enrollmentCount: number;
}

export interface SchoolEnrollmentSummaryRequest {
    schoolYear?: number | undefined;
}

export interface NswagModels {
    permission: Permission;
    permissionAction: PermissionAction;
    bulkSecondLevelValidation?: BulkSecondLevelValidation | undefined;
    customFilterOperator: CustomFilterOperator;
    customFilterEntity: CustomFilterEntity;
    dataModelEnum: DataModelEnum;
    aprSectionId: AprSectionId;
    aprSectionItemId: AprSectionItemId;
    studentReportNscReportById: StudentReportNscReportById;
    hubName: HubName;
    textingConversationsHub?: TextingConversationsHub | undefined;
    textingConversationsHubAction: TextingConversationsHubAction;
    broadcastConversationUpdate?: BroadcastConversationUpdate | undefined;
    textingChatHub?: TextingChatHub | undefined;
    textingChatHubAction: TextingChatHubAction;
    textingChatHubConnectParams: TextingChatHubConnectParams;
    lkReactMenuId: LkReactMenuId;
    lkUserDataAssignmentTypeId: LkUserDataAssignmentTypeId;
    lkUserPartnerAssignmentTypeId: LkUserPartnerAssignmentTypeId;
    lkMatchReviewId: LkMatchReviewId;
    lkDataCenterFileTaskContentId: LkDataCenterFileTaskContentId;
    lkExportTypeId: LkExportTypeId;
    lkExportSubTypeId: LkExportSubTypeId;
    lkStudentTabId: LkStudentTabId;
    lkCustomDataModelFieldTypeId: LkCustomDataModelFieldTypeId;
    lkAcademicNeedId: LkAcademicNeedId;
    lkEligibilityId: LkEligibilityId;
    lkTermTypeId: LkTermTypeId;
    lkRaceId: LkRaceId;
    lkStudentDisplayFieldId: LkStudentDisplayFieldId;
    lkStudentServiceDisplayFieldId: LkStudentServiceDisplayFieldId;
    lkStudentTestDisplayFieldId: LkStudentTestDisplayFieldId;
    lkHomeDashboardId: LkHomeDashboardId;
    lkStudentParentDisplayFieldId: LkStudentParentDisplayFieldId;
    lkStudentDisplayFilterId: LkStudentDisplayFilterId;
    lkStudentEnrollmentDisplayFieldId: LkStudentEnrollmentDisplayFieldId;
    lkEndReasonTypeId: LkEndReasonTypeId;
    lkStudentFafsaDisplayFieldId: LkStudentFafsaDisplayFieldId;
    lkStudentDiplomaDisplayFieldId: LkStudentDiplomaDisplayFieldId;
    lkObjectiveReportId: LkObjectiveReportId;
    lkPersonTypeId: LkPersonTypeId;
}

export interface BulkSecondLevelValidation {
    badRequest: boolean;
    selectedItemsErrors?: BulkSelectedItemErrors[] | undefined;
}

export interface BulkSelectedItemErrors {
    id: number;
    errors?: string[] | undefined;
}

export enum CustomFilterOperator {
    Equal = 0,
    NotEqual = 1,
    LessThan = 2,
    LessEqualThan = 3,
    GreaterThan = 4,
    GreaterEqualThan = 5,
    Contains = 6,
    BeginsWith = 7,
    EndsWith = 8,
    IsNull = 9,
    IsNotNull = 10,
}

export enum CustomFilterEntity {
    Student = 0,
    StudentFafsa = 1,
    StudentService = 2,
    StudentEnrollment = 3,
    Staff = 4,
    StaffService = 5,
    Contributor = 6,
    ContributorMatch = 7,
    NonPersonnel = 8,
    StudentParent = 9,
    StudentScholarship = 10,
    StudentDiploma = 11,
    StudentPostHighSchool = 12,
    StudentTest = 13,
    StudentAbsence = 14,
    StudentGpa = 15,
    StudentGrades = 16,
    StudentApplication = 17,
    StudentForm = 18,
    PostSecondary = 19,
}

export enum AprSectionId {
    SectionIV = 1,
    SectionV = 2,
    SectionVI = 3,
    SectionVII = 4,
    FprSectionIV = 5,
    FprSectionV = 6,
    FprSectionVI = 7,
    InterimReportIV = 8,
    InterimReportV = 9,
    InterimReportVI = 10,
}

export enum AprSectionItemId {
    StudentParticipation = 1,
    StudentParticipationByEthnicBackground = 2,
    StudentParticipationByGender = 3,
    StudentParticipationByLep = 4,
    StudentParticipationByIep = 5,
    StudentsByShelter = 6,
    ActivitiesAndServices = 7,
    StudentsByAnotherFederallyFundedProgram = 8,
    StudentActivitiesAndServices = 9,
    CoreActivitiesProvidedToFamilyMembers = 10,
    ProfessionalDevelopmentActivities = 11,
    AlgebraI = 12,
    AcademicEngagement = 13,
    FafsaCompletion = 14,
    HighSchoolGraduation = 15,
    PostsecondaryEnrollment = 16,
    FprStudentsServed = 17,
    FprStudentParticipationByEthnicBackground = 18,
    FprFafsa = 19,
    FprHighSchoolGraduation = 20,
    FprPostSecondaryEnrollment = 21,
    FprPostSecondaryPersistence = 22,
}

export enum StudentReportNscReportById {
    Request = 1,
    ComparisonGroup = 2,
}

export enum HubName {
    TextingConversationsHub = 1,
    TextingChatHub = 2,
}

export interface Hub {
    clients: IHubCallerClients;
    context: HubCallerContext;
    groups: IGroupManager;
}

export interface TextingConversationsHub extends Hub {
}

export interface IHubCallerClients {
    caller: ISingleClientProxy;
}

export interface ISingleClientProxy {
}

export interface HubCallerContext {
}

export interface IGroupManager {
}

export enum TextingConversationsHubAction {
    BroadcastConversationUpdate = 0,
}

export interface BroadcastConversationUpdate {
    conversationId: number;
    personTypeId: number;
    isFromDestination: boolean;
}

export interface TextingChatHub extends Hub {
}

export enum TextingChatHubAction {
    BroadcastNewMessage = 0,
}

export enum TextingChatHubConnectParams {
    ConversationId = 0,
}

export enum LkReactMenuId {
    System_Utility = 1000,
    System_Users = 1001,
    System_Imports = 1002,
    System_Announcements = 1004,
    Students_Students = 2000,
    Students_Services = 2001,
    Students_Fafsa = 2002,
    Students_Groups = 2003,
    Students_Applications = 2005,
    Students_QrCode = 2006,
    Students_Enrollments = 2007,
    Staff_Staff = 4000,
    Staff_Services = 4001,
    Match_Contributors = 5000,
    Match_TimeAndEfforts = 5001,
    Match_NonPersonnels = 5002,
    Match_Anticipated = 5003,
    Match_Reports = 5004,
    Match_TiReports = 5005,
    Match_Exports = 5006,
    Match_Users = 5007,
    Match_Resources = 5008,
    Match_Utility = 5009,
    DataCenter_DataCenterFiles = 6000,
    DataCenter_Classes = 6001,
    DataCenter_Exports = 6002,
    Reports_Students = 7000,
    Reports_StudentAcademic = 7001,
    Reports_Staff = 7002,
    Reports_DataStatus = 7003,
    Reports_Objectives = 7004,
    Reports_AtRisk = 7005,
    Reports_Dashboard = 7006,
    Reports_Gpra = 7007,
    Reports_SurveyReport = 7008,
    Reports_Eval = 7009,
    Reports_Exports = 7999,
    EdReports_Apr = 8000,
    EdReports_Fpr = 8001,
    EdReports_Interim = 8002,
    EdReports_AprSSS = 8003,
    EdReports_AprETS = 8004,
    EdReports_AprUb = 8005,
    EdReports_AprEoc = 8006,
    Texting_Conversations = 9000,
}

export enum LkUserDataAssignmentTypeId {
    Region = 1,
    District = 2,
    School = 3,
    Program = 4,
}

export enum LkUserPartnerAssignmentTypeId {
    Partner = 1,
    NoAccess = 2,
    SubPartner = 3,
    MatchAdmin = 4,
}

export enum LkMatchReviewId {
    Pending = 1,
    Approved = 2,
    Unallowable = 3,
}

export enum LkDataCenterFileTaskContentId {
    Updates = 15,
}

export enum LkExportTypeId {
    Student = 1,
    Staff = 2,
    Provider = 3,
    Codes = 4,
    Class = 5,
    Teacher = 6,
    ControlGroupStudent = 7,
    Contributor = 8,
    NscCollege = 9,
    StudentServiceIndex = 10,
    StaffServiceIndex = 11,
    NSpire = 12,
    Application = 13,
    PotentialStudent = 15,
}

export enum LkExportSubTypeId {
    StudentEnrollment = 1,
    StudentService = 2,
    StudentParent = 3,
    StudentGrade = 4,
    StudentAbsence = 5,
    StudentTest = 6,
    StudentGpa = 7,
    StaffEmployment = 8,
    StaffService = 9,
    ProviderEmployment = 10,
    TeacherService = 11,
    TeacherEmployment = 12,
    ControlGroupStudentEnrollment = 13,
    ControlGroupStudentGrade = 14,
    ControlGroupStudentAbsence = 15,
    ControlGroupStudentTest = 16,
    ControlGroupStudentGpa = 17,
    ContributorEmployment = 18,
    StudentFafsa = 19,
    StudentScholarship = 20,
    StudentDiploma = 21,
    StudentPostHS = 22,
    NSC = 23,
    StudentFile = 24,
}

export enum LkStudentTabId {
    Enrollment = 1,
    Service = 2,
    Parent = 3,
    Grade = 4,
    Absence = 5,
    Test = 6,
    Gpa = 7,
    PostHs = 8,
    Fafsa = 9,
    Attendance = 10,
    Scholarship = 11,
    Questionnaire = 12,
    Nsc = 13,
    File = 14,
    Isp = 15,
    Demographics = 16,
    Diploma = 17,
    ApplicationResponse = 18,
    AprUb = 19,
    Texting = 20,
}

export enum LkCustomDataModelFieldTypeId {
    TextNumber = 1,
    NullableBool = 2,
    Date = 3,
    SelectList = 4,
}

export enum LkAcademicNeedId {
    Other = 13,
}

export enum LkEligibilityId {
    LowIncomeAndFirstGenerationCollegeStudent = 1,
    LowIncomeOnly = 2,
    FirstGenerationCollegeStudentOnly = 3,
    Other = 6,
    LowIncomeFirstGenerationHighRiskFailure = 13,
}

export enum LkTermTypeId {
    Semester = 1,
    Trimester = 2,
    Quarter = 3,
    Term = 4,
    Summer = 5,
    Annual = 6,
    CumulativeSemester = 7,
    CumulativeTrimester = 8,
    CumulativeQuarter = 9,
    Term1ProgressReport = 10,
    Term2ProgressReport = 11,
    Term3ProgressReport = 12,
    Term4ProgressReport = 13,
}

export enum LkRaceId {
    AmericanIndianAlaskaNative = 1,
    Asian = 2,
    BlackAfricanAmerican = 3,
    White = 4,
    NativeHawaiianPacificIslander = 5,
    TwoOrMoreRaces = 6,
    NotIdentified = 7,
    DeclineToState = 8,
}

export enum LkStudentDisplayFieldId {
    AssignedUser = 1,
    Unresponsive = 2,
    MaidenName = 3,
    FeederSchool = 4,
    PhoneNumber = 5,
    Program = 6,
    EnrollmentDate = 7,
    UsCitizen = 8,
    SecondaryEmail = 9,
    AtRiskStdTest = 10,
    AtRiskAlgebra = 11,
    AtRiskLowGpa = 12,
    OtherNeed = 13,
    Disconnected = 14,
    WorkPhoneNumber = 15,
    ProgramStatus = 16,
    OtherSecondaryNeed = 17,
    Deceased = 18,
    PseCohort = 19,
    PseFirstEnrollmentDate = 20,
    NinthGradeYear = 21,
    PermissionSlip = 22,
    CollegeBound = 23,
    MentorProgram = 24,
    Migrant = 25,
    SixYearsEsl = 26,
    DualEnrollment = 27,
    Poverty = 28,
    FirstGeneration = 29,
    Trio = 30,
    UpwardBound = 31,
    Eops = 32,
    ReferralType = 33,
    PrimaryTransportation = 34,
    ReasonForEnrollment = 35,
    GraduationYear = 36,
    GraduationType = 37,
    FamilyIncome = 38,
    Cohort = 39,
    NoCollegeReason = 40,
    Eligibility = 41,
    AcademicNeed = 42,
    IsPartial = 43,
    Disabled = 44,
}

export enum LkStudentServiceDisplayFieldId {
    Duration = 1,
    StartTime = 2,
    EndTime = 3,
    ServiceLocation = 4,
    Language = 5,
    FollowUp = 6,
    Referral = 7,
    IsService = 8,
    Signature = 9,
    StaffUser = 10,
    Room = 11,
    StaffSignature = 12,
    Name = 13,
    Modality = 14,
    SplitDuration = 15,
    FlagForReview = 16,
    Topics = 17,
    SubType = 18,
}

export enum LkStudentTestDisplayFieldId {
    Language = 1,
}

export enum LkHomeDashboardId {
    Service = 1,
    Match = 2,
}

export enum LkStudentParentDisplayFieldId {
    Relation = 1,
    ParentId = 2,
    Address = 3,
    Language = 4,
    EducationLevel = 5,
    SecondaryEmail = 6,
    PhoneNumber = 7,
    CellPhone = 8,
    WorkPhone = 9,
    WorkExtension = 10,
    Note = 11,
}

export enum LkStudentDisplayFilterId {
    Region = 1,
    District = 2,
    GradeLevelTerm = 3,
    Program = 4,
}

export enum LkStudentEnrollmentDisplayFieldId {
    StartDate = 1,
    School = 2,
    College = 3,
    Advisor = 4,
    EnrollmentStatus = 5,
    Credits = 6,
    DependentStatus = 7,
    Nih = 8,
    Agi = 9,
    UnmetNeed = 10,
    LoanAmount = 11,
    PellRecipient = 12,
    AcademicStanding = 13,
    Ccp = 14,
    RigorousC = 15,
    DualEnrollment = 16,
    PersistantStatus = 17,
    GradeLevel = 18,
    EndGradeLevel = 19,
    ParticipantLevel = 20,
    DualEnrollmentParticipation = 21,
    DualEnrollmentCredentials = 22,
    EmploymentUB = 23,
    Cultural = 24,
    WorkStudy = 25,
    CommunityService = 26,
    LEPInstruction = 27,
    DiplomaType = 28,
}

export enum LkEndReasonTypeId {
    DropOut = 1,
    Withdrawal = 2,
    Na = 3,
    Other = 4,
    Graduated = 5,
    PersistedNextGrade = 6,
    PersistedSameGrade = 7,
    GraduatedWithRigorous = 8,
    GraduatedWithoutRigorous = 9,
    Deceased = 10,
    Unknown = 11,
    DidNotGraduateNoCredential = 12,
}

export enum LkStudentFafsaDisplayFieldId {
    Date = 1,
    Verified = 2,
    Completed = 3,
    NotApplicable = 4,
    Amount = 5,
}

export enum LkStudentDiplomaDisplayFieldId {
    Date = 1,
    DegreeMajor = 2,
}

export enum LkObjectiveReportId {
    EligibilityCriteria = 1,
    SecondarySchoolPersistence = 2,
    SecondarySchoolGraduation = 3,
    PostsecondaryEducationEnrollment = 4,
    PostsecondaryAttainment = 5,
    ProjectServices = 6,
}

export enum LkPersonTypeId {
    Student = 1,
    Parent = 2,
    Staff = 3,
    Teacher = 4,
    User = 5,
}

export interface NotificationListResponse {
    notifications?: NotificationDto[] | undefined;
    totalCount: number;
    page: number;
    pageSize: number;
}

export interface NotificationDto {
    id: number;
    title?: string | undefined;
    createdDate: Date;
    content?: string | undefined;
    isRead: boolean;
    isBug: boolean;
    userManualLink?: string | undefined;
}

export interface NotificationListRequest {
    unreadOnly?: boolean | undefined;
    readOnly?: boolean | undefined;
    page: number;
    pageSize: number;
}

export interface ListFilterBase {
    page?: number | undefined;
    pageSize?: number | undefined;
    skip?: number | undefined;
    sortObjects?: SortObject[] | undefined;
    searchString?: string | undefined;
}

export interface StudentListFilter extends ListFilterBase {
    customFilters?: CustomFilter[] | undefined;
    studentFilter?: StudentFilter | undefined;
    logic?: string | undefined;
}

export interface CustomFilter {
    entity: CustomFilterEntity;
    isValid: boolean;
    property?: ReportPropertyBase | undefined;
    propertyType: ReportPropertyType;
    operator: CustomFilterOperator;
    values?: string[] | undefined;
    logic?: string | undefined;
    isGroup: boolean;
    nestedFilters?: CustomFilter[] | undefined;
}

export interface ReportPropertyBase {
    propertyName: string;
    propertyNameCamel: string;
    propertyNames: string[];
    displayName: string;
    identifier: string;
    fullIdentifier: string;
    className: string;
    classDisplayName: string;
    propertyType: ReportPropertyType;
    propertySubType?: ReportPropertySubType | undefined;
    selectList?: SimpleDto[] | undefined;
    displayOrderProperty?: ReportPropertyBase | undefined;
    defaultSort?: TupleOfIntegerAndBoolean | undefined;
    summaryTypes?: ReportPropertySummaryType[] | undefined;
    queryExpression?: string | undefined;
    groupBeginName?: string | undefined;
    breakLine: boolean;
    hidden: boolean;
    width?: string | undefined;
    selected: boolean;
}

export enum ReportPropertyType {
    General = 0,
    String = 1,
    Int = 2,
    Decimal = 3,
    Date = 4,
    DateTimeOffset = 5,
    NullableBool = 6,
    Bool = 7,
    TimeSpan = 8,
}

export enum ReportPropertySubType {
    SchoolYear = 0,
    Currency = 1,
    DurationInMinutes = 2,
}

export interface SimpleDto {
    id: number;
    name: string;
    code?: string | undefined;
    parentId?: number | undefined;
    description?: string | undefined;
    group?: string | undefined;
}

export interface TupleOfIntegerAndBoolean {
    item1: number;
    item2: boolean;
}

export enum ReportPropertySummaryType {
    Sum = 0,
    SumCurrency = 1,
    Avg = 2,
    Min = 3,
    Max = 4,
    Count = 5,
    SumLabel = 6,
    AvgLabel = 7,
    MinLabel = 8,
    MaxLabel = 9,
    CountLabel = 10,
}

export interface StudentFilter {
    customFilters?: CustomFilter[] | undefined;
    activelyEnrolledStudentsOnly?: boolean | undefined;
    schoolYears?: number[] | undefined;
    gradeLevelIds?: number[] | undefined;
    regionIds?: number[] | undefined;
    districtIds?: number[] | undefined;
    schoolIds?: number[] | undefined;
    gradeLevelTermIds?: number[] | undefined;
    endReasonTypeIds?: number[] | undefined;
    cohortIds?: number[] | undefined;
    studentGroupIds?: number[] | undefined;
    fileId?: number | undefined;
    hasNoEnrollment?: boolean | undefined;
    customIds?: string[] | undefined;
    customIdTypeId?: number | undefined;
    duplicateByProperties?: string[] | undefined;
    programIds?: number[] | undefined;
    textingOptInFilterIds?: StudentTextingOptInFilterId[] | undefined;
    textingOptInFilterId?: StudentTextingOptInFilterId | undefined;
    serviceCounts?: ServiceCountFilter | undefined;
}

export enum StudentTextingOptInFilterId {
    StudentOptedOut = 1,
    StudentNotOptedIn = 1,
    StudentOptedIn = 2,
    ParentOptedOut = 3,
    ParentNotOptedIn = 3,
    ParentOptedIn = 4,
}

export interface ServiceCountFilter {
    operator?: string | undefined;
    value: number;
}

export interface SortObject {
    property?: string | undefined;
    isDesc: boolean;
}

export interface AiPrompt {
    prompt?: string | undefined;
    customFilterEntities?: CustomFilterEntity[] | undefined;
    todayDate?: string | undefined;
}

export interface AiProcessedAttendee {
    studentName?: string | undefined;
    studentId?: number | undefined;
    customId1?: string | undefined;
    in?: string | undefined;
    out?: string | undefined;
    duration?: string | undefined;
    index: number;
}

export interface UploadFile extends DataModel {
    fileName: string;
    fileRef?: string | undefined;
    fileSize: number;
    uploadingData?: string | undefined;
    imagePreviewData?: string | undefined;
}

export interface PublicApplicationDto {
    application: Application;
    hasBranches: boolean;
}

export interface Application extends DataModel {
    name: string;
    title: string;
    subTitle?: string | undefined;
    instruction?: string | undefined;
    submitMessage?: string | undefined;
    applicationSections?: ApplicationSection[] | undefined;
    editingApplicationSections?: ApplicationSection[] | undefined;
    editingApplicationQuestions?: ApplicationQuestion[] | undefined;
    guid?: string | undefined;
    optionalSignatures: boolean;
    leftLogoUploadFileId?: number | undefined;
    leftLogoUploadFile?: UploadFile | undefined;
    centerLogoUploadFileId?: number | undefined;
    centerLogoUploadFile?: UploadFile | undefined;
    rightLogoUploadFileId?: number | undefined;
    rightLogoUploadFile?: UploadFile | undefined;
    leftLogoFileDataId?: number | undefined;
    leftLogoFileName?: string | undefined;
    rightLogoFileDataId?: number | undefined;
    rightLogoFileName?: string | undefined;
    languageId: number;
    themeColor?: string | undefined;
    language?: LkLanguage | undefined;
    parentApplicationId?: number | undefined;
    parentApplication?: string | undefined;
    leftLogoBase64?: string | undefined;
    centerLogoBase64?: string | undefined;
    rightLogoBase64?: string | undefined;
    childApplications?: Application[] | undefined;
    qrCodeUploadFileId?: number | undefined;
    qrCodeUploadFile?: UploadFile | undefined;
}

export interface ApplicationSection extends DataModel {
    tempId: string;
    name: string;
    displayOrder: number;
    applicationId: number;
    description?: string | undefined;
    pageIndex: number;
    canExport: boolean;
    applicationSubSections?: number[] | undefined;
    applicationQuestions?: ApplicationQuestion[] | undefined;
    branchToApplicationQuestionId?: number | undefined;
    branchedFromApplicationQuestions?: ApplicationQuestion[] | undefined;
    branchToApplicationQuestionTempId?: string | undefined;
    branchedFromApplicationQuestionIds?: number[] | undefined;
}

export interface ApplicationQuestion extends DataModel {
    tempId: string;
    displayOrder: number;
    label?: string | undefined;
    name: string;
    instruction?: string | undefined;
    applicationSectionId: number;
    isMandatory: boolean;
    formQuestionTypeId: number;
    formQuestionType?: LkFormQuestionType | undefined;
    applicationPropertyId?: number | undefined;
    applicationProperty?: LkApplicationProperty | undefined;
    customEntityFieldId?: number | undefined;
    customEntityField?: CustomDataModelField | undefined;
    formQuestionWriteInTypeId?: number | undefined;
    formQuestionWriteInType?: LkFormQuestionWriteInType | undefined;
    applicationSubsection?: number | undefined;
    questionWidth?: string | undefined;
    defaultAnswer?: string | undefined;
    markedForReview?: boolean | undefined;
    isReviewerEmail?: boolean | undefined;
    requiredString?: string | undefined;
    applicationSubQuestions?: ApplicationSubQuestion[] | undefined;
    applicationAnswers?: ApplicationAnswer[] | undefined;
    branchedFromApplicationAnswerIds?: number[] | undefined;
    branchedFromApplicationQuestionIds?: number[] | undefined;
    branchedFromApplicationSectionIds?: number[] | undefined;
    branchToApplicationQuestionTempId?: string | undefined;
    branchToApplicationSectionTempId?: string | undefined;
    branchToApplicationQuestionId?: number | undefined;
    branchToApplicationSectionId?: number | undefined;
}

export interface LkFormQuestionType extends LookUp {
}

export interface LkApplicationProperty extends LookUp {
}

export interface CustomDataModelField extends DataModel {
    dataModelTypeId: number;
    dataModelType?: LkCustomDataModelType | undefined;
    fieldTypeId: number;
    fieldType?: LkCustomDataModelFieldType | undefined;
    name: string;
    number: number;
    isMandatory: boolean;
    isActive: boolean;
    selectList?: CustomDataModelFieldSelectListItem[] | undefined;
    fieldName?: string | undefined;
    fieldNameCamelCase?: string | undefined;
    selectListName?: string | undefined;
    selectListNameCamelCase?: string | undefined;
}

export interface LkCustomDataModelType extends LookUp {
    dataModelName: string;
}

export interface LkCustomDataModelFieldType extends LookUp {
    baseFieldName: string;
}

export interface CustomDataModelFieldSelectListItem extends DataModel {
    fieldId: number;
    name: string;
}

export interface LkFormQuestionWriteInType extends LookUp {
}

export interface ApplicationSubQuestion extends DataModel {
    label: string;
    name: string;
    applicationQuestionId: number;
    isOther: boolean;
}

export interface ApplicationAnswer extends DataModel {
    name?: string | undefined;
    applicationQuestionId: number;
    applicationPropertyEntityId?: number | undefined;
    isOther: boolean;
    otherWriteInTypeId?: number | undefined;
    otherWriteInType?: LkFormQuestionWriteInType | undefined;
    branchToApplicationQuestionTempId?: string | undefined;
    branchToApplicationQuestionId?: number | undefined;
    branchToApplicationQuestionLabel?: string | undefined;
    isEndAnswer: boolean;
    endAnswerText?: string | undefined;
    entityId?: number | undefined;
}

export interface LkLanguage extends LookUp {
}

export interface ApplicationResponse extends DataModel {
    isPublic: boolean;
    applicationId: number;
    application?: Application | undefined;
    studentId?: number | undefined;
    guid?: string | undefined;
    applicationStatusId: number;
    applicationStatus?: LkApplicationStatus | undefined;
    programStatusId?: number | undefined;
    programStatus?: LkProgramStatus | undefined;
    parentSignatureUploadFileId?: number | undefined;
    parentSignatureUploadFile?: UploadFile | undefined;
    studentSignatureUploadFileId?: number | undefined;
    studentSignatureUploadFile?: UploadFile | undefined;
    applicationQuestionResponses?: ApplicationQuestionResponse[] | undefined;
    applicationResponseEvents?: ApplicationResponseEventLog[] | undefined;
    reviewerId?: number | undefined;
    reviewer?: User | undefined;
    email?: string | undefined;
    notes?: string | undefined;
}

export interface LkApplicationStatus extends LookUp {
}

export interface LkProgramStatus extends LookUp {
}

export interface ApplicationQuestionResponse extends DataModel {
    applicationResponseId: number;
    applicationQuestionId?: number | undefined;
    applicationSubQuestionId?: number | undefined;
    applicationAnswerId?: number | undefined;
    applicationAnswer?: ApplicationAnswer | undefined;
    applicationPropertyEntityId?: number | undefined;
    ratingScale?: number | undefined;
    writeIn?: string | undefined;
    writeInDate?: Date | undefined;
    writeInDecimal?: number | undefined;
    other?: string | undefined;
    signatureUploadData?: string | undefined;
    signatureUploadFileId?: number | undefined;
    signatureUploadFile?: UploadFile | undefined;
    fileUploadData?: string | undefined;
    fileUploadFileId?: number | undefined;
    fileUploadFile?: UploadFile | undefined;
}

export interface ApplicationResponseEventLog extends DataModel {
    applicationResponseId: number;
    applicationResponseEventId: number;
    applicationResponseEvent?: LkApplicationResponseEvent | undefined;
    description?: string | undefined;
}

export interface LkApplicationResponseEvent extends LookUp {
}

export interface PublicApplicationViewResource {
    sections: PublicApplicationSectionDto[];
    schools?: PublicApplicationSchoolDto[] | undefined;
    programStatuses?: LkProgramStatus[] | undefined;
    parentApplicationGuid?: string | undefined;
    childApplicationGuid?: string | undefined;
}

export interface PublicApplicationSectionDto {
    section: ApplicationSection;
    subSections: PublicApplicationSubSectionDto[];
}

export interface PublicApplicationSubSectionDto {
    subSectionId: number;
    questions: PublicApplicationQuestionDto[];
}

export interface PublicApplicationQuestionDto {
    applicationQuestion: ApplicationQuestion;
    applicationAnswers?: PublicApplicationAnswerDto[] | undefined;
    displayOrder: number;
}

export interface PublicApplicationAnswerDto {
    applicationAnswerId: number;
    name: string;
    applicationQuestionId: number;
    applicationPropertyEntityId: number;
    isOther: boolean;
    otherWriteInTypeId: number;
    isEndAnswer: boolean;
    endAnswerText?: string | undefined;
}

export interface PublicApplicationSchoolDto {
    schoolId: number;
    isTitle1: boolean;
}

export interface PublicApplicationResponseDto {
    applicationGuid: string;
    studentSignatureData: string;
    parentSignatureData: string;
    isReviewer: boolean;
    applicationResponseGuid?: string | undefined;
    endAnswerDisplayOrder?: number | undefined;
    applicationQuestionResponses: ApplicationQuestionResponse[];
}

export interface PublicSurveyDto {
    form: Form;
    hasBranches: boolean;
    leftLogoBase64?: string | undefined;
    centerLogoBase64?: string | undefined;
    rightLogoBase64?: string | undefined;
    pages: PublicSurveyPageDto[];
}

export interface Form extends DataModel {
    name: string;
    title: string;
    subTitle?: string | undefined;
    instruction?: string | undefined;
    submitMessage?: string | undefined;
    formQuestions?: FormQuestion[] | undefined;
    formSections?: FormSection[] | undefined;
    editingFormQuestions?: FormQuestion[] | undefined;
    editingFormSections?: FormSection[] | undefined;
    formTypeId: number;
    formType?: LkFormType | undefined;
    emailTemplate?: string | undefined;
    password?: string | undefined;
    removeCobroLogo: boolean;
    guid?: string | undefined;
    inactive: boolean;
    deactivatedByUserId?: number | undefined;
    deactivatedByUser?: User | undefined;
    deactivatedDate?: Date | undefined;
    languageId: number;
    language?: LkLanguage | undefined;
    leftLogoUploadFileId?: number | undefined;
    leftLogoUploadFile?: UploadFile | undefined;
    centerLogoUploadFileId?: number | undefined;
    centerLogoUploadFile?: UploadFile | undefined;
    rightLogoUploadFileId?: number | undefined;
    rightLogoUploadFile?: UploadFile | undefined;
    leftLogoFileDataId?: number | undefined;
    leftLogoFileName?: string | undefined;
    rightLogoFileDataId?: number | undefined;
    rightLogoFileName?: string | undefined;
    formModeId: number;
    formMode?: LkFormMode | undefined;
    qrCodeUploadFileId?: number | undefined;
    qrCodeUploadFile?: UploadFile | undefined;
    themeColor?: string | undefined;
}

export interface FormQuestion extends DataModel {
    tempId: string;
    displayOrder: number;
    label?: string | undefined;
    name: string;
    instruction?: string | undefined;
    alternativeText1?: string | undefined;
    alternativeText2?: string | undefined;
    isAlternatingRowColor: boolean;
    isEndQuestion: boolean;
    formId: number;
    isMandatory: boolean;
    defaultAnswer?: string | undefined;
    formQuestionTypeId: number;
    formQuestionType?: LkFormQuestionType | undefined;
    formQuestionWriteInTypeId?: number | undefined;
    formQuestionWriteInType?: LkFormQuestionWriteInType | undefined;
    formSubQuestions?: FormSubQuestion[] | undefined;
    formAnswers?: FormAnswer[] | undefined;
    questionWidthPercent?: number | undefined;
    writeInWidthPercent?: number | undefined;
    branchedFromFormAnswerIds?: number[] | undefined;
    branchedFromFormQuestionIds?: number[] | undefined;
    branchedFromFormSectionIds?: number[] | undefined;
    isActive: boolean;
    startNewPage: boolean;
    hideLabel: boolean;
    hideQuestionName: boolean;
    hideSubQuestionName: boolean;
    hideSubQuestionLabel: boolean;
    hideFromExport: boolean;
    verticalAnswerText: boolean;
    pageIndex: number;
    branchToFormQuestionTempId?: string | undefined;
    branchToFormSectionTempId?: string | undefined;
    branchToFormQuestionId?: number | undefined;
    branchToFormSectionId?: number | undefined;
    formPropertyId?: number | undefined;
    formProperty?: LkApplicationProperty | undefined;
}

export interface FormSubQuestion extends DataModel {
    label: string;
    name: string;
    formQuestionId: number;
    isOther: boolean;
    tempId: string;
    branchToSubQuestionTempId?: string | undefined;
    branchedFromSubQuestionId?: number | undefined;
}

export interface FormAnswer extends DataModel {
    name: string;
    formQuestionId: number;
    branchToFormQuestionTempId?: string | undefined;
    branchToFormQuestionId?: number | undefined;
    branchToFormQuestionLabel?: string | undefined;
    isOther: boolean;
    otherWidthPercent?: number | undefined;
    otherWriteInTypeId?: number | undefined;
    otherWriteInType?: LkFormQuestionWriteInType | undefined;
}

export interface FormSection extends DataModel {
    tempId: string;
    name: string;
    instruction?: string | undefined;
    formId: number;
    pageIndex?: number | undefined;
    branchToFormQuestionId?: number | undefined;
    branchedFromFormQuestions?: FormQuestion[] | undefined;
    branchToFormQuestionTempId?: string | undefined;
    branchedFromFormQuestionIds?: number[] | undefined;
}

export interface LkFormType extends LookUp {
}

export interface LkFormMode extends LookUp {
}

export interface PublicSurveyPageDto {
    pageNumber: number;
    sections: PublicSurveySectionDto[];
}

export interface PublicSurveySectionDto {
    section: FormSection;
    questions: FormQuestion[];
}

export interface FormResponse extends DataModel {
    isPublic: boolean;
    formId: number;
    form?: Form | undefined;
    personId?: number | undefined;
    guid?: string | undefined;
    isCompleted: boolean;
    completedDate?: Date | undefined;
    formQuestionResponses?: FormQuestionResponse[] | undefined;
    isTest: boolean;
    isPersonal: boolean;
    email?: string | undefined;
    formModeId: number;
    formMode?: LkFormMode | undefined;
}

export interface FormQuestionResponse extends DataModel {
    formResponseId: number;
    formQuestionId: number;
    formSubQuestionId?: number | undefined;
    formAnswerId?: number | undefined;
    ratingScale?: number | undefined;
    writeIn?: string | undefined;
    writeInDate?: Date | undefined;
    writeInDecimal?: number | undefined;
    other?: string | undefined;
    signatureUploadData?: string | undefined;
    signatureUploadFileId?: number | undefined;
    signatureUploadFile?: UploadFile | undefined;
    fileUploadData?: string | undefined;
    fileUploadFileId?: number | undefined;
    fileUploadFile?: UploadFile | undefined;
}

export interface PublicSurveyViewResource {
    surveyId: number;
}

export interface PublicSurveyResponseDto {
    formGuid: string;
    formQuestionResponses: FormQuestionResponse[];
}

export interface Developer extends DataModel {
    name: string;
    serviceName?: string | undefined;
    genderId?: number | undefined;
    gender?: LkGender | undefined;
    developerTypeId?: number | undefined;
    developerType?: DeveloperType | undefined;
    carCount?: number | undefined;
    hourlySalary?: number | undefined;
    dateOfBirth?: Date | undefined;
    phone?: string | undefined;
    isMarried: boolean;
    hasChildren?: boolean | undefined;
    workDurationInMinutes?: number | undefined;
    startTime?: string | undefined;
    note?: string | undefined;
    colleges?: College[] | undefined;
    date1?: Date | undefined;
    date2?: Date | undefined;
    date3?: Date | undefined;
    date4?: Date | undefined;
    studentId?: number | undefined;
    student?: Student | undefined;
    overrideTimezone?: string | undefined;
}

export interface LkGender extends LookUp {
}

export interface DeveloperType extends DataModel {
    name: string;
}

export interface College extends DataModel {
    isInUse: boolean;
    name: string;
    ipeds: number;
}

export interface CustomDataModel extends DataModel {
    customString1?: string | undefined;
    customString2?: string | undefined;
    customString3?: string | undefined;
    customString4?: string | undefined;
    customString5?: string | undefined;
    customString6?: string | undefined;
    customString7?: string | undefined;
    customString8?: string | undefined;
    customString9?: string | undefined;
    customString10?: string | undefined;
    customString11?: string | undefined;
    customString12?: string | undefined;
    customDateTime1?: Date | undefined;
    customDateTime2?: Date | undefined;
    customDateTime3?: Date | undefined;
    customDateTime4?: Date | undefined;
    customDateTime5?: Date | undefined;
    customDateTime6?: Date | undefined;
    customDateTime7?: Date | undefined;
    customDateTime8?: Date | undefined;
    customDateTime9?: Date | undefined;
    customDateTime10?: Date | undefined;
    customDateTime11?: Date | undefined;
    customDateTime12?: Date | undefined;
    customNullableBool1?: boolean | undefined;
    customNullableBool2?: boolean | undefined;
    customNullableBool3?: boolean | undefined;
    customNullableBool4?: boolean | undefined;
    customNullableBool5?: boolean | undefined;
    customNullableBool6?: boolean | undefined;
    customNullableBool7?: boolean | undefined;
    customNullableBool8?: boolean | undefined;
    customNullableBool9?: boolean | undefined;
    customNullableBool10?: boolean | undefined;
    customNullableBool11?: boolean | undefined;
    customNullableBool12?: boolean | undefined;
    customSelectListId1?: number | undefined;
    customSelectList1?: CustomDataModelFieldSelectListItem | undefined;
    customSelectListId2?: number | undefined;
    customSelectList2?: CustomDataModelFieldSelectListItem | undefined;
    customSelectListId3?: number | undefined;
    customSelectList3?: CustomDataModelFieldSelectListItem | undefined;
    customSelectListId4?: number | undefined;
    customSelectList4?: CustomDataModelFieldSelectListItem | undefined;
    customSelectListId5?: number | undefined;
    customSelectList5?: CustomDataModelFieldSelectListItem | undefined;
    customSelectListId6?: number | undefined;
    customSelectList6?: CustomDataModelFieldSelectListItem | undefined;
    customSelectListId7?: number | undefined;
    customSelectList7?: CustomDataModelFieldSelectListItem | undefined;
    customSelectListId8?: number | undefined;
    customSelectList8?: CustomDataModelFieldSelectListItem | undefined;
    customSelectListId9?: number | undefined;
    customSelectList9?: CustomDataModelFieldSelectListItem | undefined;
    customSelectListId10?: number | undefined;
    customSelectList10?: CustomDataModelFieldSelectListItem | undefined;
    customSelectListId11?: number | undefined;
    customSelectList11?: CustomDataModelFieldSelectListItem | undefined;
    customSelectListId12?: number | undefined;
    customSelectList12?: CustomDataModelFieldSelectListItem | undefined;
}

export interface Student extends CustomDataModel {
    customId1?: string | undefined;
    customId2?: string | undefined;
    customId3?: string | undefined;
    customId4?: string | undefined;
    firstName: string;
    lastName: string;
    middleName?: string | undefined;
    suffix?: string | undefined;
    nickName?: string | undefined;
    maidenName?: string | undefined;
    fullName?: string | undefined;
    genderId?: number | undefined;
    gender?: LkGender | undefined;
    raceId?: number | undefined;
    race?: LkRace | undefined;
    races?: LkRace[] | undefined;
    ethnicityId?: number | undefined;
    ethnicity?: LkEthnicity | undefined;
    dateOfBirth: Date;
    addressId: number;
    address?: Address | undefined;
    email?: string | undefined;
    secondaryEmail?: string | undefined;
    phone?: string | undefined;
    cellPhone?: string | undefined;
    creatingTextingOptIn?: TextingOptIn | undefined;
    note?: string | undefined;
    familyIncomeId?: number | undefined;
    familyIncome?: LkFamilyIncome | undefined;
    enrollmentDate?: Date | undefined;
    feederSchoolId?: number | undefined;
    feederSchool?: FeederSchool | undefined;
    questionnaireValidationToken: string;
    assignedUserId?: number | undefined;
    assignedUser?: User | undefined;
    unresponsive: boolean;
    programId?: number | undefined;
    program?: Program | undefined;
    qrCodeUploadFileId?: number | undefined;
    qrCodeUploadFile?: UploadFile | undefined;
    cohortId?: number | undefined;
    cohort?: LkCohort | undefined;
    graduationYear?: number | undefined;
    graduationType?: string | undefined;
    permissionSlip?: boolean | undefined;
    collegeBound?: boolean | undefined;
    mentorProgram?: boolean | undefined;
    migrant?: boolean | undefined;
    sixYearsEsl?: boolean | undefined;
    dualEnrollment?: boolean | undefined;
    poverty?: boolean | undefined;
    firstGeneration?: boolean | undefined;
    ninthGradeYear?: number | undefined;
    trio?: boolean | undefined;
    upwardBound?: boolean | undefined;
    eops?: boolean | undefined;
    noCollegeReasonId?: number | undefined;
    noCollegeReason?: NoCollegeReason | undefined;
    referralTypeId?: number | undefined;
    referralType?: LkReferralType | undefined;
    reasonForEnrollmentId?: number | undefined;
    reasonForEnrollment?: LkReasonForEnrollment | undefined;
    primaryTransportationId?: number | undefined;
    primaryTransportation?: LkPrimaryTransportation | undefined;
    eligibilityId?: number | undefined;
    eligibility?: LkEligibility | undefined;
    eligibilityNote?: string | undefined;
    usCitizen?: boolean | undefined;
    academicNeedId?: number | undefined;
    academicNeed?: LkAcademicNeed | undefined;
    academicNeedNote?: string | undefined;
    atRiskLowGpaId?: number | undefined;
    atRiskLowGpa?: LkAtRiskLowGpa | undefined;
    atRiskStdTestId?: number | undefined;
    atRiskStdTest?: LkAtRiskStdTest | undefined;
    atRiskAlgebraId?: number | undefined;
    atRiskAlgebra?: LkAtRiskAlgebra | undefined;
    otherNeedId?: number | undefined;
    otherNeed?: LkOtherNeed | undefined;
    otherSecondaryNeedId?: number | undefined;
    otherSecondaryNeed?: LkOtherNeed | undefined;
    deceasedId?: number | undefined;
    deceased?: LkDeceased | undefined;
    disabledId?: number | undefined;
    disabled?: LkDisabled | undefined;
    disconnected?: boolean | undefined;
    isPartial?: boolean | undefined;
    workPhone?: string | undefined;
    pseCohort?: number | undefined;
    pseFirstEnrollment?: string | undefined;
    creatingFirstEnrollment?: StudentEnrollment | undefined;
    creatingStudentParents?: StudentParent[] | undefined;
    exportFullName?: string | undefined;
}

export interface LkRace extends LookUp {
    spanishName?: string | undefined;
}

export interface LkEthnicity extends LookUp {
    spanishName?: string | undefined;
}

export interface TextingOptIn extends DataModel {
    generalValidationErrors?: string | undefined;
    phoneNumber: string;
    optInDate?: Date | undefined;
    optInMethodId?: number | undefined;
    optInMethod?: LkOptInMethod | undefined;
    optInByUserId?: number | undefined;
    optInByUser?: User | undefined;
    optInByParentId?: number | undefined;
    optInByParent?: Parent | undefined;
    optOutDate?: Date | undefined;
    optOutByUserId?: number | undefined;
    optOutByUser?: User | undefined;
    uploadFileId?: number | undefined;
    uploadFile?: UploadFile | undefined;
    isVerified?: boolean | undefined;
    optedIn: boolean;
}

export interface LkOptInMethod extends LookUp {
}

export interface Parent extends DataModel {
    firstName: string;
    lastName: string;
    addressId: number;
    address?: Address | undefined;
    languageId?: number | undefined;
    sameStudentAddress: boolean;
    language?: LkLanguage | undefined;
    workPlace?: string | undefined;
    phoneNumber?: string | undefined;
    cellPhone?: string | undefined;
    workPhone?: string | undefined;
    email?: string | undefined;
    secondaryEmail?: string | undefined;
    districtIdentification?: number | undefined;
    educationLevelId?: number | undefined;
    educationLevel?: LkEducationLevel | undefined;
    workExtension?: string | undefined;
    relativeCount?: number | undefined;
    note?: string | undefined;
}

export interface LkEducationLevel extends LookUp {
    spanishName?: string | undefined;
}

export interface LkFamilyIncome extends LookUp {
}

export interface FeederSchool extends DataModel {
    name: string;
}

export interface LkCohort extends LookUp {
}

export interface NoCollegeReason extends DataModel {
    name: string;
}

export interface LkReferralType extends LookUp {
}

export interface LkReasonForEnrollment extends LookUp {
}

export interface LkPrimaryTransportation extends LookUp {
}

export interface LkEligibility extends LookUp {
    tapr?: number | undefined;
}

export interface LkAcademicNeed extends LookUp {
    tapr?: number | undefined;
}

export interface LkAtRiskLowGpa extends LookUp {
    tapr?: number | undefined;
}

export interface LkAtRiskStdTest extends LookUp {
    tapr?: number | undefined;
}

export interface LkAtRiskAlgebra extends LookUp {
    tapr?: number | undefined;
}

export interface LkOtherNeed extends LookUp {
    tapr?: number | undefined;
}

export interface LkDeceased extends LookUp {
    tapr?: number | undefined;
}

export interface LkDisabled extends LookUp {
    tapr?: number | undefined;
}

export interface StudentEnrollment extends CustomDataModel {
    studentId: number;
    student?: Student | undefined;
    year: number;
    schoolId: number;
    school?: School | undefined;
    gradeLevelId?: number | undefined;
    gradeLevel?: LkGradeLevel | undefined;
    gradeLevelTermId?: number | undefined;
    gradeLevelTerm?: LkGradeLevelTerm | undefined;
    startDate: Date;
    endDate?: Date | undefined;
    endReasonId?: number | undefined;
    endReason?: EndReason | undefined;
    advisorId?: number | undefined;
    advisor?: User | undefined;
    collegeId?: number | undefined;
    college?: College | undefined;
    cohortId?: number | undefined;
    cohort?: LkCohort | undefined;
    enrollmentStatusId?: number | undefined;
    enrollmentStatus?: LkEnrollmentStatus | undefined;
    credits?: number | undefined;
    dependentStatusId?: number | undefined;
    dependentStatus?: LkDependentStatus | undefined;
    nih?: number | undefined;
    agi?: number | undefined;
    unmetNeed?: number | undefined;
    loanAmount?: number | undefined;
    pellRecipient?: boolean | undefined;
    academicStandingId?: number | undefined;
    academicStanding?: LkAcademicStanding | undefined;
    ccpId?: number | undefined;
    ccp?: LkCcp | undefined;
    rigorousCId?: number | undefined;
    rigorousC?: LkRigorousC | undefined;
    dualEnrollment?: boolean | undefined;
    iepId?: number | undefined;
    iep?: Iep | undefined;
    lepId?: number | undefined;
    lep?: Lep | undefined;
    freeReducedLunch?: boolean | undefined;
    magnet?: boolean | undefined;
    heldBack?: boolean | undefined;
    avid?: boolean | undefined;
    mediaRelease?: boolean | undefined;
    cacg?: boolean | undefined;
    twentyFirstCentury?: boolean | undefined;
    dropTransferForm?: boolean | undefined;
    atRisk?: boolean | undefined;
    homeless?: boolean | undefined;
    fosterCare?: boolean | undefined;
    atRiskReason?: string | undefined;
    ub?: boolean | undefined;
    ubms?: boolean | undefined;
    vub?: boolean | undefined;
    ts?: boolean | undefined;
    sss?: boolean | undefined;
    gearUp?: boolean | undefined;
    eoc?: boolean | undefined;
    initialEnrollmentStatusId?: number | undefined;
    initialEnrollmentStatus?: LkEnrollmentStatus | undefined;
    finalEnrollmentStatusId?: number | undefined;
    finalEnrollmentStatus?: LkEnrollmentStatus | undefined;
    participantStatusId?: number | undefined;
    participantStatus?: LkParticipantStatus | undefined;
    participantLevelId?: number | undefined;
    participantLevel?: LkParticipantLevel | undefined;
    dualEnrollmentParticipationId?: number | undefined;
    dualEnrollmentParticipation?: LkDualEnrollmentParticipation | undefined;
    dualEnrollmentCredentialsId?: number | undefined;
    dualEnrollmentCredentials?: LkDualEnrollmentCredentials | undefined;
    militaryConnectionId?: number | undefined;
    militaryConnection?: LkMilitaryConnection | undefined;
    persistantStatusId?: number | undefined;
    persistantStatus?: LkPersistantStatus | undefined;
    endGradeLevelId?: number | undefined;
    endGradeLevel?: LkGradeLevel | undefined;
    employmentUBId?: number | undefined;
    employmentUB?: LkEmploymentUB | undefined;
    culturalId?: number | undefined;
    cultural?: LkWorkStudyCulturalCommunity | undefined;
    workStudyId?: number | undefined;
    workStudy?: LkWorkStudyCulturalCommunity | undefined;
    communityServiceId?: number | undefined;
    communityService?: LkWorkStudyCulturalCommunity | undefined;
    lepInstructionId?: number | undefined;
    lepInstruction?: LkWorkStudyCulturalCommunity | undefined;
    diplomaTypeId?: number | undefined;
    diplomaType?: DiplomaType | undefined;
    isCurrent: boolean;
}

export interface LkGradeLevelTerm extends LookUp {
}

export interface EndReason extends DataModel {
    isInUse: boolean;
    name: string;
    endReasonTypeId?: number | undefined;
    taprw?: number | undefined;
    taprt?: number | undefined;
    endReasonType?: LkEndReasonType | undefined;
}

export interface LkEndReasonType extends LookUp {
}

export interface LkEnrollmentStatus extends LookUp {
    tapr?: number | undefined;
}

export interface LkDependentStatus extends LookUp {
}

export interface LkAcademicStanding extends LookUp {
    tapr?: number | undefined;
}

export interface LkCcp extends LookUp {
}

export interface LkRigorousC extends LookUp {
}

export interface Iep extends DataModel {
    name: string;
    isIep: boolean;
}

export interface Lep extends DataModel {
    name: string;
    isLep: boolean;
}

export interface LkParticipantStatus extends LookUp {
    tapr?: number | undefined;
}

export interface LkParticipantLevel extends LookUp {
    tapr?: number | undefined;
}

export interface LkDualEnrollmentParticipation extends LookUp {
    tapr?: number | undefined;
}

export interface LkDualEnrollmentCredentials extends LookUp {
    tapr?: number | undefined;
}

export interface LkMilitaryConnection extends LookUp {
}

export interface LkPersistantStatus extends LookUp {
    tapr?: number | undefined;
}

export interface LkEmploymentUB extends LookUp {
    tapr?: number | undefined;
}

export interface LkWorkStudyCulturalCommunity extends LookUp {
    tapr?: number | undefined;
}

export interface DiplomaType extends DataModel {
    isInUse: boolean;
    name: string;
    lengthId?: number | undefined;
    tapr?: number | undefined;
    diplomaFieldId?: number | undefined;
    diplomaField?: LkDiplomaField | undefined;
    length?: LkDiplomaTypeLength | undefined;
}

export interface LkDiplomaField extends LookUp {
    tapr?: number | undefined;
}

export interface LkDiplomaTypeLength extends LookUp {
}

export interface StudentParent extends DataModel {
    studentId: number;
    parentId: number;
    parent?: Parent | undefined;
    relationId?: number | undefined;
    relation?: LkRelation | undefined;
}

export interface LkRelation extends LookUp {
    spanishName?: string | undefined;
}

export interface Staff extends DataModel {
    identification?: string | undefined;
    firstName: string;
    lastName: string;
    fullName?: string | undefined;
    email?: string | undefined;
    cellPhone?: string | undefined;
    note?: string | undefined;
    disciplineId?: number | undefined;
    discipline?: Discipline | undefined;
    staffPositionId?: number | undefined;
    staffPosition?: StaffPosition | undefined;
    employmentStatusId?: number | undefined;
    employmentStatus?: LkStaffEmploymentStatus | undefined;
    backgroundCheck?: boolean | undefined;
    cprFirstAidCertified?: boolean | undefined;
    creatingFirstEmployment?: StaffEmployment | undefined;
}

export interface Discipline extends DataModel {
    name: string;
}

export interface StaffPosition extends DataModel {
    name: string;
}

export interface LkStaffEmploymentStatus extends LookUp {
}

export interface StaffEmployment extends DataModel {
    staffId: number;
    year: number;
    startDate: Date;
    endDate?: Date | undefined;
    schoolId?: number | undefined;
    school?: School | undefined;
    isTeacher: boolean;
    isCurrent: boolean;
}

export interface Provider extends DataModel {
    isInUse: boolean;
    firstName: string;
    lastName: string;
    fullName?: string | undefined;
    enrollmentDate?: Date | undefined;
    homePhone?: string | undefined;
    cellPhone?: string | undefined;
    cellPhoneVerified: boolean;
    email?: string | undefined;
    school?: string | undefined;
    addressId: number;
    address?: Address | undefined;
    positionId?: number | undefined;
    position?: ProviderPosition | undefined;
    note?: string | undefined;
    creatingFirstEmployment?: ProviderEmployment | undefined;
    activeSchool?: string | undefined;
}

export interface ProviderPosition extends DataModel {
    name: string;
}

export interface ProviderEmployment extends DataModel {
    providerId: number;
    schoolId: number;
    school?: School | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    endReason?: string | undefined;
}

export interface Class extends DataModel {
    generalValidationErrors?: string | undefined;
    name: string;
    identification?: string | undefined;
    units?: number | undefined;
    classLevelId?: number | undefined;
    classLevel?: LkClassLevel | undefined;
    classTypeId?: number | undefined;
    classType?: LkClassType | undefined;
    classModeId?: number | undefined;
    classMode?: LkClassMode | undefined;
    schoolId?: number | undefined;
    school?: School | undefined;
    classSection?: string | undefined;
    onTrack?: string | undefined;
}

export interface LkClassLevel extends LookUp {
    isAdvanced: boolean;
}

export interface LkClassType extends LookUp {
    isMath: boolean;
    isAtLeastTwoYearsBeyondAlgebraI: boolean;
    mathProgressOrder?: number | undefined;
    isAprMath: boolean;
}

export interface LkClassMode extends LookUp {
}

export interface StudentServiceName extends DataModel {
    name: string;
    schools?: School[] | undefined;
}

export interface StaffServiceName extends DataModel {
    name: string;
}

export interface LkIpeds extends LookUp {
    unitId: number;
    instnm?: string | undefined;
    ialias?: string | undefined;
    addr?: string | undefined;
    city?: string | undefined;
    stabbr?: string | undefined;
    zip?: string | undefined;
    fips?: string | undefined;
    obereg?: string | undefined;
    chftitle?: string | undefined;
    chfnm?: string | undefined;
    gentele?: string | undefined;
    ein: number;
    duns?: string | undefined;
    opeid: number;
    opeflag: number;
    webaddr?: string | undefined;
    adminUrl?: string | undefined;
    faidUrl?: string | undefined;
    applurl?: string | undefined;
    appUrl?: string | undefined;
    npricurl?: string | undefined;
    vetUrl?: string | undefined;
    athUrl?: string | undefined;
    disaUrl?: string | undefined;
    sector: number;
    iclevel: number;
    control: number;
    hloffer: number;
    ugoffer: number;
    groffer: number;
    hdegofr1: number;
    deggrant: number;
    hbcu: number;
    hospital: number;
    medical: number;
    tribal: number;
    locale: number;
    openPubl: number;
    act?: string | undefined;
    newId?: number | undefined;
    deathYr?: number | undefined;
    closeDat?: number | undefined;
    cyactive: number;
    postsec: number;
    pseflag: number;
    pset4flg: number;
    rptmth: number;
    instcat: number;
    c18Basic: number;
    c18ipug: number;
    c18Ipgrd: number;
    c18ugprf: number;
    c18Enprf: number;
    c18Szset: number;
    c15Basic: number;
    ccBasic: number;
    carnegie: number;
    landGrnt: number;
    instsize: number;
    f1SystYp: number;
    f1SysNam?: string | undefined;
    f1SysCod: number;
    cbsa: number;
    cbsaType: number;
    csa: number;
    necta: number;
    countycd: number;
    countyNm?: string | undefined;
    cngdstcd: number;
    longitud: number;
    latitude: number;
    dfrcgid: number;
    dfrcuscg: number;
}

export interface TextingConversationListDto {
    id: number;
    sourcePhoneNumber?: string | undefined;
    destinationPhoneNumber?: string | undefined;
    personName?: string | undefined;
    personTypeName?: string | undefined;
    personTypeId?: number | undefined;
    personType?: string | undefined;
    personId?: number | undefined;
    lastMessageDate?: Date | undefined;
    isLastMessageFromDestination: boolean;
    lastMessage?: string | undefined;
    unseenMessages?: number | undefined;
    serviceType?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    notOptedIn: boolean;
    archived: boolean;
}

export interface TextingConversationListFilter extends ListFilterBase {
    conversationFilter?: TextingConversationFilter | undefined;
}

export interface TextingConversationFilter {
    dateFrom?: Date | undefined;
    dateTo?: Date | undefined;
    isArchived?: boolean | undefined;
    serviceTypeIds?: number[] | undefined;
    serviceSubTypeIds?: number[] | undefined;
    currentSchoolId?: number | undefined;
    hasFlaggedMessages: boolean;
    unseenMessages: boolean;
    personTypeId?: number | undefined;
    personId?: number | undefined;
}

export interface GetCreateTextingConversationsResponseDto {
    personTypeId: LkPersonTypeId;
    persons?: PersonDto[] | undefined;
    savingRequestProperties?: ModelPropertyBase[] | undefined;
    studentServiceTypes?: StudentServiceType[] | undefined;
    studentServiceSubTypes?: StudentServiceSubType[] | undefined;
    staffServiceTypes?: StaffServiceType[] | undefined;
    studentGroups?: StudentGroup[] | undefined;
}

export interface PersonDto {
    id: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    cellPhone?: string | undefined;
    personTypeId: number;
    personTypeName?: string | undefined;
    identification?: string | undefined;
    gradeLevel?: string | undefined;
    isUnder13: boolean;
    isParent: boolean;
}

export interface StudentServiceType extends DataModel {
    isInUse: boolean;
    name: string;
    schools?: School[] | undefined;
    aprStudentServiceId?: number | undefined;
    aprStudentService?: LkAprStudentService | undefined;
    apr2StudentServiceId?: number | undefined;
    apr2StudentService?: LkApr2StudentService | undefined;
    aprCategoryId?: number | undefined;
    aprCategory?: LkAprCategory | undefined;
    ccrecServiceTypeId?: number | undefined;
    ccrecServiceType?: LkCcrecStudentServiceType | undefined;
    inactive: boolean;
    isForParent: boolean;
    oldParentServiceTypeId?: number | undefined;
    isNameMandatory: boolean;
    isModalityMandatory: boolean;
    isServiceLocationMandatory: boolean;
    isProviderMandatory: boolean;
    excludeFromAPR: boolean;
    manualServiceSubTypes?: StudentServiceSubType[] | undefined;
    manualServiceSubTypesGeneralValidationErrors?: string | undefined;
}

export interface LkAprStudentService extends LookUp {
    isForParent: boolean;
    isServiceLocationForCollege: boolean;
    hasDescription: boolean;
}

export interface LkApr2StudentService extends LookUp {
}

export interface LkAprCategory extends LookUp {
    isForParent: boolean;
    isServiceLocationForCollege: boolean;
    hasDescription: boolean;
}

export interface LkCcrecStudentServiceType extends LookUp {
}

export interface StudentServiceSubType extends DataModel {
    isInUse: boolean;
    name: string;
    serviceTypeId: number;
    serviceTypeName?: string | undefined;
    inactive: boolean;
    oldParentServiceSubCategoryIndex?: number | undefined;
    ccrecStudentServiceSubTypeId?: number | undefined;
    ccrecStudentServiceSubType?: LkCcrecStudentServiceSubType | undefined;
}

export interface LkCcrecStudentServiceSubType extends LookUp {
}

export interface StaffServiceType extends DataModel {
    isInUse: boolean;
    name: string;
    inactive: boolean;
    schoolId?: number | undefined;
    school?: School | undefined;
}

export interface StudentGroup extends DataModel {
    name: string;
    schoolId?: number | undefined;
    school?: School | undefined;
    inactive: boolean;
    manualStudents?: Student[] | undefined;
}

export interface GetCreateTextingConversationsRequestDto {
    personTypeId: LkPersonTypeId;
    personIds?: number[] | undefined;
}

export interface SaveCreateTextingOptInDto {
    personTypeId: LkPersonTypeId;
    personIds: number[];
}

export interface SaveCreateTextingConversationsRequestDto {
    personTypeId: LkPersonTypeId;
    recipients: TextingRecipientDto[];
    messageBody: string;
    studentServiceTypeId?: number | undefined;
    studentServiceSubTypeId?: number | undefined;
    staffServiceTypeId?: number | undefined;
}

export interface TextingRecipientDto {
    id: number;
    phoneNumber?: string | undefined;
    isParent: boolean;
}

export interface TenantInfo extends Entity {
    lastExportDate: Date;
    lastExportDateExportCount: number;
    activeSchoolYear: number;
    sendEventAttendantReminderEmailTrigger: boolean;
    studentScholarshipLimit?: number | undefined;
    hasStudentSsn: boolean;
    canAutoAssignCustomId: boolean;
    grandAwardNotificationDate?: Date | undefined;
    powerBiDataRequestReportUrlPostfix?: string | undefined;
    twilioSourceNumber?: string | undefined;
    canTwilio: boolean;
    optInKeyword?: string | undefined;
    irYear?: number | undefined;
    timezone: string;
    defaultState?: string | undefined;
    defaultCity?: string | undefined;
    studentServiceFilterDateFromConfigId?: number | undefined;
    studentServiceFilterDateFromConfig?: LkStudentServiceFilterDateFromConfig | undefined;
    studentServiceFilterDateFrom?: Date | undefined;
    prNumber?: string | undefined;
    nscAccount?: string | undefined;
    nscOrganization?: string | undefined;
    canAutoIncrementCustomId: boolean;
    autoIncrementCustomId?: string | undefined;
    infobipSourceNumber?: string | undefined;
    canInfobip: boolean;
    infobipOptInMessage?: string | undefined;
    infobipOptInConfirmationMessage?: string | undefined;
    infobipOptOutConfirmationMessage?: string | undefined;
    infobipKeywordAutoResponse?: string | undefined;
    canOpenAi: boolean;
    openAiMaxTokens?: number | undefined;
    emailSenderName?: string | undefined;
}

export interface LkStudentServiceFilterDateFromConfig extends LookUp {
}

export interface TextingOptInDto {
    phoneNumber?: string | undefined;
    studentId?: number | undefined;
    customId1?: string | undefined;
    studentFirstName?: string | undefined;
    studentLastName?: string | undefined;
    isUnder13: boolean;
    parentId?: number | undefined;
    isParent: boolean;
    parentFirstName?: string | undefined;
    parentLastName?: string | undefined;
    students?: TextingStudentDto[] | undefined;
}

export interface TextingStudentDto {
    studentInfo?: string | undefined;
    studentId: number;
}

export interface TextingConversation extends DataModel {
    sourcePhoneNumber: string;
    destinationPhoneNumber: string;
    personId?: number | undefined;
    person?: PersonDto | undefined;
    personTypeId?: number | undefined;
    personType?: LkPersonType | undefined;
    studentId?: number | undefined;
    parentId?: number | undefined;
    staffId?: number | undefined;
    identification?: string | undefined;
    lastMessageDate?: Date | undefined;
    lastMessage?: string | undefined;
    isLastMessageFromDestination: boolean;
    unseenMessages: number;
    textingMessages?: TextingMessage[] | undefined;
    notOptedIn: boolean;
    archived: boolean;
}

export interface LkPersonType extends LookUp {
}

export interface TextingConversationListResource {
    properties?: ListPropertyBase[] | undefined;
    personTypes?: LkPersonType[] | undefined;
}

export interface ListPropertyBase {
    propertyName?: string | undefined;
    displayName?: string | undefined;
    sortProperty?: string | undefined;
    isSearchable: boolean;
}

export interface StudentTextingOptInViewResource {
    properties?: ModelPropertyBase[] | undefined;
}

export interface StudentTextingOptInEditResource {
    optInMethods?: SimpleDto[] | undefined;
}

export interface UserManualSectionDto {
    id: number;
    name: string;
    displayOrder: number;
    subSections?: UserManualSubSectionDto[] | undefined;
    expanded: boolean;
}

export interface UserManualSubSectionDto {
    id: number;
    name: string;
    sectionId: number;
    displayOrder: number;
    uniqueIdentifier: string;
    contentId: number;
    content?: UserManualContentDto | undefined;
    tags?: UserManualSubSectionTag[] | undefined;
    selected: boolean;
}

export interface UserManualContentDto {
    content: string;
    displayOrder: number;
    modifiedDate: Date;
}

export interface DataModel2 extends Entity {
    createdById?: number | undefined;
    createdDate?: Date | undefined;
    modifiedById?: number | undefined;
    modifiedDate?: Date | undefined;
    touched: boolean;
    uniqueIdentifier?: string | undefined;
}

export interface UserManualSubSectionTag extends DataModel2 {
    name: string;
    subSectionId: number;
}

export interface UserListDto {
    id: number;
    userMembership?: string | undefined;
    username?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    roleId?: number | undefined;
    role?: string | undefined;
    roleDisplayOrder?: number | undefined;
    email?: string | undefined;
    lastLoginDate?: Date | undefined;
    registeredDate?: Date | undefined;
    deactivated: boolean;
}

export interface UserListFilter extends ListFilterBase {
    userFilter?: UserFilter | undefined;
}

export interface UserFilter {
    roleId?: number | undefined;
    isActive?: boolean | undefined;
}

export interface UserListResource {
    properties?: ListPropertyBase[] | undefined;
}

export interface UserFilterResource {
    properties?: ModelPropertyBase[] | undefined;
    roles?: LkRole[] | undefined;
}

export interface UserViewResource {
    properties?: ModelPropertyBase[] | undefined;
    roles?: LkRole[] | undefined;
    studentDisplayFields?: LkStudentDisplayField[] | undefined;
}

export interface LkStudentDisplayField extends LookUp {
    required: boolean;
    displayName: string;
}

export interface UserEditResource {
    roles?: LkRole[] | undefined;
    userDataAssignmentTypes?: LkUserDataAssignmentType[] | undefined;
    userPartnerAssignmentTypes?: LkUserPartnerAssignmentType[] | undefined;
    regions?: Region[] | undefined;
    districts?: District[] | undefined;
    schools?: School[] | undefined;
    programs?: Program[] | undefined;
    partners?: Partner[] | undefined;
    subPartners?: SubPartner[] | undefined;
    permissions?: LkAspNetPermission[] | undefined;
}

export interface LkAspNetPermission extends LookUp {
}

export interface AspNetUserPermission extends DataModel {
    userId: number;
    user?: User | undefined;
    permissionId: number;
    permission?: LkAspNetPermission | undefined;
}

export interface DiplomaTypeListDto {
    id: number;
    name?: string | undefined;
}

export interface DiplomaTypeListFilter extends ListFilterBase {
    diplomaTypeFilter?: DiplomaTypeFilter | undefined;
}

export interface DiplomaTypeFilter {
    schoolId?: number | undefined;
    inactive?: boolean | undefined;
    schoolYears?: number[] | undefined;
}

export interface DiplomaTypeListResource {
    properties?: ListPropertyBase[] | undefined;
}

export interface DiplomaTypeFilterResource {
    properties?: ModelPropertyBase[] | undefined;
    schools?: SimpleDto[] | undefined;
}

export interface DiplomaTypeViewResource {
    properties?: ModelPropertyBase[] | undefined;
}

export interface DiplomaTypeEditResource {
    properties?: ModelPropertyBase[] | undefined;
    schools?: SimpleDto[] | undefined;
}

export interface TopicListFilter extends ListFilterBase {
    topicFilter?: TopicFilter | undefined;
}

export interface TopicFilter {
    inactive?: boolean | undefined;
}

export interface Topic extends DataModel {
    name: string;
    isReferral: boolean;
    isService: boolean;
}

export interface CohortListDto {
    id: number;
    name?: string | undefined;
}

export interface CohortListResource {
    properties?: ListPropertyBase[] | undefined;
}

export interface CohortViewResource {
    properties?: ModelPropertyBase[] | undefined;
}

export interface CohortEditResource {
    properties?: ModelPropertyBase[] | undefined;
}

export interface Cohort extends DataModel {
    name: string;
}

export interface IEPListDto extends SimpleDto {
    id: number;
    isIep: boolean;
}

export interface IEPListResource {
    properties?: ListPropertyBase[] | undefined;
}

export interface IEPViewResource {
    properties?: ModelPropertyBase[] | undefined;
}

export interface IEPEditResource {
    properties?: ModelPropertyBase[] | undefined;
}

export interface LEPListDto extends SimpleDto {
    id: number;
    isLep: boolean;
}

export interface LEPListResource {
    properties?: ListPropertyBase[] | undefined;
}

export interface LEPViewResource {
    properties?: ModelPropertyBase[] | undefined;
}

export interface LEPEditResource {
}

export interface PostHSPlanStatusListResource {
    properties?: ListPropertyBase[] | undefined;
}

export interface PostHSPlanStatusViewResource {
    properties?: ModelPropertyBase[] | undefined;
}

export interface PostHSPlanStatusEditResource {
    properties?: ModelPropertyBase[] | undefined;
}

export interface PostHighSchoolStatus extends DataModel {
    name: string;
}

export interface RegionListDto {
    id: number;
    name: string;
    districts?: string[] | undefined;
}

export interface RegionListResource {
    properties?: ListPropertyBase[] | undefined;
}

export interface RegionViewResource {
    properties?: ModelPropertyBase[] | undefined;
}

export interface RegionEditResource {
    districts?: District[] | undefined;
}

export interface ScholarshipPaymentMethodListDto {
    id: number;
    name?: string | undefined;
}

export interface ScholarshipPaymentMethodListResource {
    properties?: ListPropertyBase[] | undefined;
}

export interface ScholarshipPaymentMethodViewResource {
    properties?: ModelPropertyBase[] | undefined;
}

export interface ScholarshipPaymentMethodEditResource {
    properties?: ModelPropertyBase[] | undefined;
}

export interface ScholarshipPaymentMethod extends DataModel {
    name: string;
}

export interface IScholarshipStatusRepo {
}

export interface ScholarshipStatusListDto {
    id: number;
    name?: string | undefined;
}

export interface ScholarshipStatusListResource {
    properties?: ListPropertyBase[] | undefined;
}

export interface ScholarshipStatusViewResource {
    properties?: ModelPropertyBase[] | undefined;
}

export interface ScholarshipStatusEditResource {
    properties?: ModelPropertyBase[] | undefined;
}

export interface ScholarshipStatus extends DataModel {
    name: string;
}

export interface ScholarshipTypeListDto extends SimpleDto {
    id: number;
}

export interface ScholarshipTypeListResource {
    properties?: ListPropertyBase[] | undefined;
}

export interface ScholarshipTypeViewResource {
    properties?: ModelPropertyBase[] | undefined;
}

export interface ScholarshipTypeEditResource {
}

export interface ScholarshipType extends DataModel {
    name: string;
    tapr?: number | undefined;
}

export interface StaffPositionListDto {
    id: number;
    name?: string | undefined;
    displayOrder?: number | undefined;
}

export interface StaffPositionFilter extends ListFilterBase {
}

export interface StaffPositionListResource {
    properties?: ListPropertyBase[] | undefined;
}

export interface StaffPositionViewResource {
    properties?: ModelPropertyBase[] | undefined;
}

export interface CustomDataModelFieldListResource {
    customDataModelTypes?: LkCustomDataModelType[] | undefined;
}

export interface CustomDataModelFieldViewResource {
    properties?: ModelPropertyBase[] | undefined;
}

export interface CustomDataModelFieldSelectListItemListResource {
    properties?: ListPropertyBase[] | undefined;
    manualDisplayOrder: boolean;
}

export interface CustomDataModelFieldSelectListItemViewResource {
    properties?: ModelPropertyBase[] | undefined;
}

export interface StaffServiceListFilter extends ListFilterBase {
    staffFilter?: StaffFilter | undefined;
    serviceFilter?: StaffServiceFilter | undefined;
}

export interface StaffFilter {
    customFilters?: CustomFilter[] | undefined;
    schoolYears?: number[] | undefined;
    regionIds?: number[] | undefined;
    districtIds?: number[] | undefined;
    schoolIds?: number[] | undefined;
    disciplineIds?: number[] | undefined;
}

export interface StaffServiceFilter {
    customFilters?: CustomFilter[] | undefined;
    staffId?: number | undefined;
    staff?: Staff | undefined;
    dateFrom?: Date | undefined;
    dateTo?: Date | undefined;
    serviceTypeIds?: number[] | undefined;
}

export interface StaffServiceListDto {
    id: number;
    date?: Date | undefined;
    serviceName?: string | undefined;
    staffId?: number | undefined;
    staff?: string | undefined;
    serviceType?: string | undefined;
    durationInMinutes?: number | undefined;
    files: number;
}

export interface StaffServiceListResource {
    properties?: ListPropertyBase[] | undefined;
}

export interface StaffServiceFilterResource {
    properties?: ModelPropertyBase[] | undefined;
    customFilterProperties?: CustomReportProperty[] | undefined;
    serviceTypes?: StaffServiceType[] | undefined;
}

export interface CustomReportProperty {
    entityType: CustomFilterEntity;
    customProperties?: ReportPropertyBase[] | undefined;
}

export interface StaffService extends DataModel {
    generalValidationErrors?: string | undefined;
    date: Date;
    staffId: number;
    staff?: Staff | undefined;
    serviceTypeId: number;
    serviceType?: StaffServiceType | undefined;
    durationInMinutes?: number | undefined;
    name?: string | undefined;
    schoolId?: number | undefined;
    school?: School | undefined;
    note?: string | undefined;
    files?: StaffServiceFile[] | undefined;
}

export interface StaffServiceFile extends DataModel {
    staffServiceId: number;
    uploadFileId?: number | undefined;
    uploadFile: UploadFile;
}

export interface StaffServiceViewResource {
    properties?: ModelPropertyBase[] | undefined;
    serviceTypes?: StaffServiceType[] | undefined;
}

export interface StaffServiceEditResource {
    schools?: School[] | undefined;
}

export interface StaffServiceBulkUpdate {
    services?: StaffService[] | undefined;
    updateSchema?: StaffServiceBulkUpdateSchema | undefined;
}

export interface StaffServiceBulkUpdateSchema {
    updateDate: boolean;
    date?: Date | undefined;
    updateServiceTypeId: boolean;
    serviceTypeId?: number | undefined;
    updateName: boolean;
    name?: string | undefined;
    updateDurationInMinutes: boolean;
    durationInMinutes?: number | undefined;
    updateSchoolId: boolean;
    schoolId?: number | undefined;
    updateNote: boolean;
    note?: string | undefined;
    creatingFiles?: UploadFile[] | undefined;
}

export interface StaffServiceBulkUpdateResource {
    properties?: ModelPropertyBase[] | undefined;
    serviceTypes?: StaffServiceType[] | undefined;
    schools?: School[] | undefined;
}

export interface StudentServiceListFilter extends ListFilterBase {
    customFilters?: CustomFilter[] | undefined;
    studentFilter?: StudentFilter | undefined;
    serviceFilter?: StudentServiceFilter | undefined;
}

export interface StudentServiceFilter {
    customFilters?: CustomFilter[] | undefined;
    studentId?: number | undefined;
    student?: Student | undefined;
    dateFrom?: Date | undefined;
    dateTo?: Date | undefined;
    date?: Date | undefined;
    serviceTypeIds?: number[] | undefined;
    serviceSubTypeIds?: number[] | undefined;
    durationInMinutes?: number | undefined;
    serviceRecipientId?: number | undefined;
    providerId?: number | undefined;
    provider?: Provider | undefined;
    isLocked?: boolean | undefined;
    serviceName?: string | undefined;
    parentCount?: number | undefined;
    groupByDate?: boolean | undefined;
    flagForReview?: boolean | undefined;
    hasStudentSignatures?: boolean | undefined;
    hasStaffSignatures?: boolean | undefined;
    hasAttachments?: boolean | undefined;
}

export interface StudentServiceListDto {
    id: number;
    date?: Date | undefined;
    serviceName?: string | undefined;
    isForParent: boolean;
    parentCount?: number | undefined;
    files: number;
    customId1?: string | undefined;
    studentId?: number | undefined;
    student?: string | undefined;
    serviceType?: string | undefined;
    serviceSubType?: string | undefined;
    durationInMinutes?: number | undefined;
    school?: string | undefined;
    colleges?: string[] | undefined;
    isServiceLocationForCollege: boolean;
    isLocked: boolean;
    isFromQrCode: boolean;
    flagForReview: boolean;
}

export interface StudentServiceListResource {
    properties?: ListPropertyBase[] | undefined;
    displayFields?: LkStudentServiceDisplayField[] | undefined;
}

export interface LkStudentServiceDisplayField extends LookUp {
    required: boolean;
    displayName: string;
}

export interface StudentServiceFile extends DataModel {
    studentServiceId: number;
    note?: string | undefined;
    uploadFileId?: number | undefined;
    uploadFile: UploadFile;
    fileCategoryId?: number | undefined;
    fileCategory?: FileCategory | undefined;
}

export interface FileCategory extends DataModel {
    name: string;
}

export interface StudentServiceFilterResource {
    properties?: ModelPropertyBase[] | undefined;
    customFilterProperties?: CustomReportProperty[] | undefined;
    serviceTypes?: StudentServiceType[] | undefined;
    serviceSubTypes?: StudentServiceSubType[] | undefined;
    providers?: Provider[] | undefined;
    serviceRecipients?: LkStudentServiceRecipient[] | undefined;
    displayFields?: LkStudentServiceDisplayField[] | undefined;
}

export interface LkStudentServiceRecipient extends LookUp {
}

export interface StudentService extends DataModel {
    generalValidationErrors?: string | undefined;
    studentId: number;
    student?: Student | undefined;
    date: Date;
    serviceTypeId: number;
    serviceType?: StudentServiceType | undefined;
    serviceSubTypeId?: number | undefined;
    serviceSubType?: StudentServiceSubType | undefined;
    parentCount?: number | undefined;
    name?: string | undefined;
    durationInMinutes?: number | undefined;
    durationDecimal?: number | undefined;
    startTime?: string | undefined;
    endTime?: string | undefined;
    schoolId?: number | undefined;
    school?: School | undefined;
    providers?: Provider[] | undefined;
    colleges?: College[] | undefined;
    languageId?: number | undefined;
    language?: LkLanguage | undefined;
    modalityId?: number | undefined;
    modality?: LkModality | undefined;
    note?: string | undefined;
    isNoteRichText: boolean;
    followUp?: string | undefined;
    files?: StudentServiceFile[] | undefined;
    topics?: Topic[] | undefined;
    referralTopics?: Topic[] | undefined;
    isFromStudentPage: boolean;
    studentEnrollmentDate?: Date | undefined;
    studentSignatureUploadFileId?: number | undefined;
    studentSignatureUploadFile?: UploadFile | undefined;
    staffName?: string | undefined;
    staffSignatureUploadFileId?: number | undefined;
    staffSignatureUploadFile?: UploadFile | undefined;
    isService: boolean;
    referral: boolean;
    staffUserId?: number | undefined;
    staffUser?: User | undefined;
    room?: string | undefined;
    flagForReview: boolean;
}

export interface LkModality extends LookUp {
    isDefaultValue: boolean;
}

export interface StudentServiceViewResource {
    properties?: ModelPropertyBase[] | undefined;
    displayFields?: LkStudentServiceDisplayField[] | undefined;
    serviceTypes?: StudentServiceType[] | undefined;
    serviceSubTypes?: StudentServiceSubType[] | undefined;
}

export interface StudentServiceEditResource {
    colleges?: College[] | undefined;
    schools?: School[] | undefined;
    languages?: LkLanguage[] | undefined;
    modalities?: LkModality[] | undefined;
    providers?: Provider[] | undefined;
    topics?: Topic[] | undefined;
    staffUsers?: User[] | undefined;
    fileCategories?: FileCategory[] | undefined;
}

export interface StudentServiceCreateBulk {
    service?: StudentService | undefined;
    additionalEntries?: StudentServiceAdditionalEntry[] | undefined;
    additionalDates?: Date[] | undefined;
}

export interface StudentServiceAdditionalEntry {
    generalValidationErrors?: string | undefined;
    serviceTypeId: number;
    serviceSubTypeId?: number | undefined;
    parentCount?: number | undefined;
    durationInMinutes?: number | undefined;
    schoolId?: number | undefined;
    colleges?: College[] | undefined;
    referral: boolean;
    isService: boolean;
}

export interface StudentServiceBulkUpdate {
    services?: StudentService[] | undefined;
    updateSchema?: StudentServiceBulkUpdateSchema | undefined;
}

export interface StudentServiceBulkUpdateSchema {
    updateDate: boolean;
    date?: Date | undefined;
    updateServiceTypeId: boolean;
    serviceTypeId?: number | undefined;
    updateServiceSubTypeId: boolean;
    serviceSubTypeId?: number | undefined;
    updateName: boolean;
    name?: string | undefined;
    updateDurationInMinutes: boolean;
    durationInMinutes?: number | undefined;
    updateModalityId: boolean;
    modalityId?: number | undefined;
    updateLanguageId: boolean;
    languageId?: number | undefined;
    updateColleges: boolean;
    colleges?: College[] | undefined;
    updateSchoolId: boolean;
    schoolId?: number | undefined;
    updateProviders: boolean;
    providers?: Provider[] | undefined;
    updateTopics: boolean;
    topics?: Topic[] | undefined;
    updateNote: boolean;
    note?: string | undefined;
    updateFollowUp: boolean;
    followUp?: string | undefined;
    updateParentCount: boolean;
    parentCount?: number | undefined;
    updateIsLocked: boolean;
    isLocked?: boolean | undefined;
    updateStartTime: boolean;
    startTime?: string | undefined;
    updateEndTime: boolean;
    endTime?: string | undefined;
    updateStudentSignature: boolean;
    studentSignatureUploadFile?: UploadFile | undefined;
    updateStaffSignature: boolean;
    staffName?: string | undefined;
    staffSignatureUploadFile?: UploadFile | undefined;
    creatingFiles?: UploadFile[] | undefined;
}

export interface StudentServiceBulkUpdateResource {
    properties?: ModelPropertyBase[] | undefined;
    displayFields?: LkStudentServiceDisplayField[] | undefined;
    serviceTypes?: StudentServiceType[] | undefined;
    serviceSubTypes?: StudentServiceSubType[] | undefined;
    schools?: School[] | undefined;
    colleges?: College[] | undefined;
    providers?: Provider[] | undefined;
    topics?: Topic[] | undefined;
    languages?: LkLanguage[] | undefined;
    modalities?: LkModality[] | undefined;
}

export interface StaffListDto {
    id: number;
    identification?: string | undefined;
    fullName?: string | undefined;
    currentSchool?: string | undefined;
    currentSchoolDisplayOrder?: number | undefined;
    position?: string | undefined;
    positionDisplayOrder?: number | undefined;
    discipline?: string | undefined;
    disciplineDisplayOrder?: number | undefined;
}

export interface StaffListFilter extends ListFilterBase {
    staffFilter?: StaffFilter | undefined;
}

export interface StaffListResource {
    properties?: ListPropertyBase[] | undefined;
}

export interface StaffFilterResource {
    properties?: ModelPropertyBase[] | undefined;
    studentDisplayFilters?: LkStudentDisplayFilter[] | undefined;
    customFilterProperties?: CustomReportProperty[] | undefined;
    schoolYearsWithActive?: SimpleDto[] | undefined;
    regions?: Region[] | undefined;
    districts?: District[] | undefined;
    schools?: School[] | undefined;
    disciplines?: Discipline[] | undefined;
    canAccessRegionFilter: boolean;
    canAccessDistrictFilter: boolean;
    canAccessSchoolFilter: boolean;
}

export interface LkStudentDisplayFilter extends LookUp {
}

export interface StaffViewResource {
    properties?: ModelPropertyBase[] | undefined;
    activeSchoolYear?: number | undefined;
    currentSchool?: string | undefined;
    servicesTotal?: number | undefined;
    employmentsTotal?: number | undefined;
}

export interface StaffEditResource {
    positions?: StaffPosition[] | undefined;
    disciplines?: Discipline[] | undefined;
    employmentStatuses?: LkStaffEmploymentStatus[] | undefined;
}

export interface StaffBulkCreateServices {
    staffs?: Staff[] | undefined;
    service?: StaffService | undefined;
}

export interface StaffBulkCreateServicesResource {
    serviceProperties?: ModelPropertyBase[] | undefined;
    serviceTypes?: StaffServiceType[] | undefined;
    schools?: School[] | undefined;
}

export interface StudentReportEventTrackingRequest {
    customFilters?: CustomFilter[] | undefined;
    studentFilter?: StudentFilter | undefined;
    studentServiceFilter?: StudentServiceFilter | undefined;
    display?: StudentReportEventTrackingDisplay | undefined;
}

export interface StudentReportEventTrackingDisplay {
    eventDate?: Date | undefined;
    eventName?: string | undefined;
    providerName?: string | undefined;
    serviceTypeId?: number | undefined;
    serviceSubTypeId?: number | undefined;
    startTime?: string | undefined;
    endTime?: string | undefined;
}

export interface StudentReportEventTrackingResource {
    display?: StudentReportEventTrackingDisplayResource | undefined;
}

export interface StudentReportEventTrackingDisplayResource {
    properties?: ModelPropertyBase[] | undefined;
    serviceTypes?: StudentServiceType[] | undefined;
    serviceSubTypes?: StudentServiceSubType[] | undefined;
}

export interface StudentReportEventTrackingResponse {
    properties?: ReportPropertyOfStudentReportEventTrackingResponseRow[] | undefined;
    rows?: StudentReportEventTrackingResponseRow[] | undefined;
    filterDisplays?: FilterDisplay[] | undefined;
}

export interface ReportPropertyOfStudentReportEventTrackingResponseRow extends ReportPropertyBase {
}

export interface StudentReportEventTrackingResponseRow {
    id: number;
    attendance?: string | undefined;
    studentCustomId1?: string | undefined;
    studentCustomId2?: string | undefined;
    student?: string | undefined;
    dateOfBirth?: Date | undefined;
    gradeLevel?: string | undefined;
    gradeLevelDisplayOrder?: number | undefined;
    phone?: string | undefined;
    program?: string | undefined;
    cellPhone?: string | undefined;
    studentSignature?: string | undefined;
    parentSignature?: string | undefined;
    startTime?: string | undefined;
    endTime?: string | undefined;
}

export interface FilterDisplay {
    label: string;
    values: string[];
    operator?: string | undefined;
}

export interface StudentReportNscRequest {
    reportBy?: StudentReportNscReportBy | undefined;
    studentFilter?: StudentListFilter | undefined;
    controlGroupStudentFilter?: ControlGroupStudentFilter | undefined;
    display?: StudentReportNscDisplay | undefined;
}

export interface StudentReportNscReportBy {
    reportById: number;
}

export interface ControlGroupStudentFilter {
    schoolYears?: number[] | undefined;
    gradeLevelIds?: number[] | undefined;
    schoolIds?: number[] | undefined;
}

export interface StudentReportNscDisplay {
    searchBeginDate: Date;
}

export interface StudentReportNscResource {
    reportBy?: StudentReportNscReportByResource | undefined;
    nscAccount?: string | undefined;
    nscOrganization?: string | undefined;
}

export interface StudentReportNscReportByResource {
    properties?: ModelPropertyBase[] | undefined;
    reportByItems?: SimpleDto[] | undefined;
}

export interface ParticipantStatusReportResponse {
    rows?: ParticipantStatusRow[] | undefined;
    totalParticipants: number;
    activeSchoolYear: number;
}

export interface ParticipantStatusRow {
    participantStatusId: number;
    participantStatusName?: string | undefined;
    participantCount: number;
    percentage: number;
}

export interface ParticipantStatusReportRequest {
    schoolYear?: number | undefined;
    programId?: number | undefined;
}

export interface StudentReportServiceDetailRequest {
    customFilters?: CustomFilter[] | undefined;
    reportBy?: StudentReportServiceDetailReportBy | undefined;
    studentFilter?: StudentFilter | undefined;
    studentServiceFilter?: StudentServiceFilter | undefined;
}

export interface StudentReportServiceDetailReportBy {
    reportById: number;
}

export interface StudentReportServiceDetailResource {
    reportBy?: StudentReportServiceDetailReportByResource | undefined;
}

export interface StudentReportServiceDetailReportByResource {
    properties?: ModelPropertyBase[] | undefined;
    reportByItems?: SimpleDto[] | undefined;
}

export interface StudentReportServiceDetailResponse {
    rows?: any | undefined;
    filterDisplays?: FilterDisplay[] | undefined;
    properties?: ReportPropertyBase[] | undefined;
}

export interface StudentReportServiceSummaryRequest {
    customFilters?: CustomFilter[] | undefined;
    studentFilter?: StudentFilter | undefined;
    studentServiceFilter?: StudentServiceFilter | undefined;
    display?: StudentReportServiceSummaryDisplay | undefined;
}

export interface StudentReportServiceSummaryDisplay {
    groupByProperties?: string[] | undefined;
    aggregateProperties?: string[] | undefined;
}

export interface StudentReportServiceSummaryResource {
    display?: StudentReportServiceSummaryDisplayResource | undefined;
}

export interface StudentReportServiceSummaryDisplayResource {
    groupableProperties?: ReportPropertyBase[] | undefined;
    aggregatableProperties?: ReportPropertyBase[] | undefined;
}

export interface StudentReportServiceSummaryResponse {
    properties?: ReportPropertyBase[] | undefined;
    rows?: StudentReportServiceSummaryResponseRow[] | undefined;
    filterDisplays?: FilterDisplay[] | undefined;
}

export interface StudentReportServiceSummaryResponseRow {
    gender?: string | undefined;
    genderDisplayOrder?: number | undefined;
    race?: string | undefined;
    raceDisplayOrder?: number | undefined;
    ethnicity?: string | undefined;
    ethnicityDisplayOrder?: number | undefined;
    studentCurrentSchool?: string | undefined;
    studentCurrentSchoolDisplayOrder?: number | undefined;
    studentAdvisor?: string | undefined;
    serviceType?: string | undefined;
    serviceTypeDisplayOrder?: number | undefined;
    serviceSubType?: string | undefined;
    serviceSubTypeDisplayOrder?: number | undefined;
    date?: Date | undefined;
    serviceName?: string | undefined;
    program?: string | undefined;
    totalStudents: number;
    totalDurationInMinutes: number;
    avgDurationInMinutes: number;
}

export interface SurveyListResource {
    properties?: ListPropertyBase[] | undefined;
}

export interface SurveyReportListDto {
    id: number;
    createdDate?: Date | undefined;
    name: string;
    fileName: string;
}

export interface Survey extends DataModel {
    name: string;
    uploadFileId?: number | undefined;
    uploadFile: UploadFile;
}

export interface SurveyReportViewResource {
    canAccessRegionFilter: boolean;
    canAccessDistrictFilter: boolean;
    canAccessSchoolFilter: boolean;
    surveys?: Survey[] | undefined;
}

export interface SurveyReportResponse {
    questions?: SurveyReportQuestion[] | undefined;
    notes?: string[] | undefined;
    errors?: ErrorDto[] | undefined;
    selectLists?: SurveyReportSelectLists | undefined;
    totalParticipants: number;
    todayDate?: Date | undefined;
    reportTitle?: string | undefined;
}

export interface SurveyReportQuestion {
    label?: string | undefined;
    questionContent?: string | undefined;
    isMa: boolean;
    isDemographics: boolean;
    isSecondaryDemographics: boolean;
    isWriteIn: boolean;
    isQuestionOnly: boolean;
    percentBasedOnTotal: boolean;
    isSystemQuestion: boolean;
    answers?: SurveyReportAnswer[] | undefined;
    otherAnswers?: SurveyReportAnswer[] | undefined;
    totalResponse?: SurveyReportAnswer | undefined;
    totalNonResponse?: SurveyReportAnswer | undefined;
    total?: SurveyReportAnswer | undefined;
    maTotalUniqueRespondents: number;
    writeInCategories?: SurveyReportWriteInCategory[] | undefined;
}

export interface SurveyReportAnswer {
    answerCode?: number | undefined;
    answer?: string | undefined;
    count: number;
    percent?: number | undefined;
}

export interface SurveyReportWriteInCategory {
    categoryCode?: number | undefined;
    category?: string | undefined;
    total?: number | undefined;
    answers?: SurveyReportWriteInCategoryAnswer[] | undefined;
}

export interface SurveyReportWriteInCategoryAnswer {
    answer?: string | undefined;
    count: number;
}

export interface ErrorDto {
    message?: string | undefined;
    rowNumbers?: number[] | undefined;
}

export interface SurveyReportSelectLists {
    regionSelectList?: SimpleDto[] | undefined;
    districtSelectList?: SimpleDto[] | undefined;
    schoolSelectList?: SimpleDto[] | undefined;
    gradeLevelSelectList?: SimpleDto[] | undefined;
}

export interface SurveyReportRequest {
    surveyReportId: number;
    regionIds?: number[] | undefined;
    districtIds?: number[] | undefined;
    schoolIds?: number[] | undefined;
    gradeLevelIds?: number[] | undefined;
}

export interface StaffReportServiceDetailRequest {
    reportBy?: StaffReportServiceDetailReportBy | undefined;
    staffFilter?: StaffFilter | undefined;
    staffServiceFilter?: StaffServiceFilter | undefined;
}

export interface StaffReportServiceDetailReportBy {
    reportById: number;
}

export interface StaffReportServiceDetailResource {
    reportBy?: StaffReportServiceDetailReportByResource | undefined;
}

export interface StaffReportServiceDetailReportByResource {
    properties?: ModelPropertyBase[] | undefined;
    reportByItems?: SimpleDto[] | undefined;
}

export interface StaffReportServiceDetailResponse {
    rows?: any | undefined;
    filterDisplays?: FilterDisplay[] | undefined;
    properties?: ReportPropertyBase[] | undefined;
}

export interface StaffReportServiceSummaryRequest {
    staffFilter?: StaffFilter | undefined;
    staffServiceFilter?: StaffServiceFilter | undefined;
    display?: StaffReportServiceSummaryDisplay | undefined;
}

export interface StaffReportServiceSummaryDisplay {
    groupByProperties?: string[] | undefined;
    aggregateProperties?: string[] | undefined;
}

export interface StaffReportServiceSummaryResource {
    display?: StaffReportServiceSummaryDisplayResource | undefined;
}

export interface StaffReportServiceSummaryDisplayResource {
    groupableProperties?: ReportPropertyBase[] | undefined;
    aggregatableProperties?: ReportPropertyBase[] | undefined;
}

export interface StaffReportServiceSummaryResponse {
    properties?: ReportPropertyBase[] | undefined;
    rows?: StaffReportServiceSummaryResponseRow[] | undefined;
    filterDisplays?: FilterDisplay[] | undefined;
}

export interface StaffReportServiceSummaryResponseRow {
    serviceType?: string | undefined;
    serviceTypeDisplayOrder?: number | undefined;
    date?: Date | undefined;
    serviceName?: string | undefined;
    totalStaffs: number;
    totalDurationInMinutes: number;
    avgDurationInMinutes: number;
}

export interface ObjectiveReportsRequest {
    filter?: ObjectiveReportsFilter | undefined;
}

export interface ObjectiveReportsFilter {
    schoolYear: number;
    programId?: number | undefined;
    includeServices: boolean;
    serviceDateFrom?: Date | undefined;
    serviceDateTo?: Date | undefined;
    serviceReferral?: boolean | undefined;
}

export interface ObjectiveReportsResource {
    filterProperties?: ModelPropertyBase[] | undefined;
    studentDisplayFields?: LkStudentDisplayField[] | undefined;
    serviceDisplayFields?: LkStudentServiceDisplayField[] | undefined;
    schoolYears?: SimpleDto[] | undefined;
    programs?: Program[] | undefined;
}

export interface ObjectiveReportsResult {
    objectiveReports?: LkObjectiveReport[] | undefined;
    eligibilityCriteria?: ObjectiveReportsEligibilityCriteria | undefined;
    secondarySchoolPersistence?: ObjectiveReportsSecondarySchoolPersistence | undefined;
    secondarySchoolGraduation?: ObjectiveReportsSecondarySchoolGraduation | undefined;
    postsecondaryEducationEnrollment?: ObjectiveReportsPostsecondaryEducationEnrollment | undefined;
    postsecondaryAttainment?: ObjectiveReportsPostsecondaryAttainment | undefined;
    projectServices?: ObjectiveReportsProjectServices | undefined;
}

export interface LkObjectiveReport extends LookUp {
    displayName: string;
}

export interface ObjectiveReportsEligibilityCriteria {
    year: number;
    program?: string | undefined;
    participantsAdmitted: number;
    participantsServed: number;
    lowIncomeAndFirstGenerationCollegeStudentLabel?: string | undefined;
    lowIncomeAndFirstGenerationCollegeStudentProportion: number;
    data?: TupleOfStringAndInteger[] | undefined;
}

export interface TupleOfStringAndInteger {
    item1?: string | undefined;
    item2: number;
}

export interface ObjectiveReportsSecondarySchoolPersistence {
    participants: number;
    persistedForNextYearProportion: number;
    persistedForNextYearLabel?: string | undefined;
}

export interface ObjectiveReportsSecondarySchoolGraduation {
    participants: number;
    graduatesProportion: number;
    graduatesWithRigorousProgramProportion: number;
}

export interface ObjectiveReportsPostsecondaryEducationEnrollment {
    graduates: number;
    fallEnrollment: number;
    fallEnrollmentPercent: number;
    summerEnrollment: number;
    summerEnrollmentPercent: number;
    totalEnrollment: number;
    totalEnrollmentPercent: number;
}

export interface ObjectiveReportsPostsecondaryAttainment {
    yearDiff: number;
    schoolYear: number;
    participants: number;
    graduatedWithinXYears: number;
    attainmentPercent: number;
}

export interface ObjectiveReportsProjectServices {
    rows?: ObjectiveReportsProjectServicesTableRow[] | undefined;
}

export interface ObjectiveReportsProjectServicesTableRow {
    serviceTypeId: number;
    serviceType?: string | undefined;
    studentCount: number;
}

export interface Export {
    exportTypeId: number;
    exportSubTypeId?: number | undefined;
    timezone?: string | undefined;
    filterDisplayForExportTypeId: boolean;
    filterDisplayForExportSubTypeId: boolean;
    staffFilter?: StaffFilter | undefined;
    staffDisplayFields?: string[] | undefined;
    staffEmploymentFilter?: StaffEmploymentFilter | undefined;
    staffEmploymentDisplayFields?: string[] | undefined;
    staffServiceFilter?: StaffServiceFilter | undefined;
    staffServiceDisplayFields?: string[] | undefined;
    customFilters?: CustomFilter[] | undefined;
    studentFilter?: StudentListFilter | undefined;
    studentDisplayFields?: string[] | undefined;
    studentEnrollmentFilter?: StudentEnrollmentListFilter | undefined;
    studentEnrollmentDisplayFields?: string[] | undefined;
    studentServiceFilter?: StudentServiceFilter | undefined;
    studentServiceDisplayFields?: string[] | undefined;
    studentScholarshipFilter?: StudentScholarshipFilter | undefined;
    studentScholarshipDisplayFields?: string[] | undefined;
    studentParentDisplayFields?: string[] | undefined;
    studentAbsenceDisplayFields?: string[] | undefined;
    studentAbsenceFilter?: StudentAbsenceExportFilter | undefined;
    studentGpaDisplayFields?: string[] | undefined;
    studentGpaFilter?: StudentGpaExportFilter | undefined;
    studentGradesDisplayFields?: string[] | undefined;
    studentGradeFilter?: StudentGradeExportFilter | undefined;
    studentTestFilter?: StudentTestExportFilter | undefined;
    studentTestDisplayFields?: string[] | undefined;
    studentFafsaDisplayFields?: string[] | undefined;
    studentPostHSDisplayFields?: string[] | undefined;
    studentDiplomaDisplayFields?: string[] | undefined;
    studentFileDisplayFields?: string[] | undefined;
    nscCollegeFilter?: NscCollegeFilter | undefined;
    nscCollegeDisplayFields?: string[] | undefined;
    potentialStudentFilter?: PotentialStudentFilter | undefined;
    potentialStudentDisplayFields?: string[] | undefined;
    controlGroupStudentFilter?: ControlGroupStudentFilter | undefined;
    controlGroupStudentDisplayFields?: string[] | undefined;
    controlGroupStudentEnrollmentFilter?: ControlGroupStudentEnrollmentFilter | undefined;
    controlGroupStudentEnrollmentDisplayFields?: string[] | undefined;
    controlGroupStudentGradeFilter?: ControlGroupStudentGradeFilter | undefined;
    controlGroupStudentGradeDisplayFields?: string[] | undefined;
    controlGroupStudentAbsenceFilter?: ControlGroupStudentAbsenceFilter | undefined;
    controlGroupStudentAbsenceDisplayFields?: string[] | undefined;
    controlGroupStudentTestFilter?: ControlGroupStudentTestFilter | undefined;
    controlGroupStudentTestDisplayFields?: string[] | undefined;
    controlGroupStudentGpaFilter?: ControlGroupStudentGpaFilter | undefined;
    controlGroupStudentGpaDisplayFields?: string[] | undefined;
}

export interface StaffEmploymentFilter {
    staffId?: number | undefined;
}

export interface StudentEnrollmentListFilter extends ListFilterBase {
    customFilters?: CustomFilter[] | undefined;
    studentFilter?: StudentFilter | undefined;
    enrollmentFilter?: StudentEnrollmentFilter | undefined;
}

export interface StudentEnrollmentFilter {
    studentId?: number | undefined;
    student?: Student | undefined;
    schoolIds?: number[] | undefined;
    schoolYears?: number[] | undefined;
}

export interface StudentScholarshipFilter {
    studentId?: number | undefined;
    dateFrom?: Date | undefined;
    dateTo?: Date | undefined;
    date?: Date | undefined;
}

export interface StudentAbsenceExportFilter {
    schoolIds?: number[] | undefined;
    schoolYears?: number[] | undefined;
}

export interface StudentGpaExportFilter {
    schoolIds?: number[] | undefined;
    schoolYears?: number[] | undefined;
}

export interface StudentGradeExportFilter {
    schoolIds?: number[] | undefined;
    schoolYears?: number[] | undefined;
}

export interface StudentTestExportFilter {
    schoolIds?: number[] | undefined;
    schoolYears?: number[] | undefined;
}

export interface NscCollegeFilter extends ListFilterBase {
    identification?: string | undefined;
    schoolYears?: number[] | undefined;
    recordFound?: boolean | undefined;
}

export interface PotentialStudentFilter {
    schoolYears?: string[] | undefined;
    terms?: string[] | undefined;
}

export interface ControlGroupStudentEnrollmentFilter {
    customFilters?: CustomFilter[] | undefined;
    schoolIds?: number[] | undefined;
    schoolYears?: number[] | undefined;
}

export interface ControlGroupStudentGradeFilter {
    customFilters?: CustomFilter[] | undefined;
    schoolIds?: number[] | undefined;
    schoolYears?: number[] | undefined;
}

export interface ControlGroupStudentAbsenceFilter {
    customFilters?: CustomFilter[] | undefined;
    schoolIds?: number[] | undefined;
    schoolYears?: number[] | undefined;
}

export interface ControlGroupStudentTestFilter {
    customFilters?: CustomFilter[] | undefined;
    schoolIds?: number[] | undefined;
    schoolYears?: number[] | undefined;
}

export interface ControlGroupStudentGpaFilter {
    customFilters?: CustomFilter[] | undefined;
    schoolIds?: number[] | undefined;
    schoolYears?: number[] | undefined;
}

export interface ExportResource {
    exportTypes?: LkExportType[] | undefined;
    exportSubTypes?: LkExportSubType[] | undefined;
    displayFilterExportTypeIds?: number[] | undefined;
    displayFilterExportSubTypeIds?: number[] | undefined;
    potentialStudentTerms?: string[] | undefined;
    potentialStudentSchoolYears?: string[] | undefined;
    timezones?: TupleOfStringAndString[] | undefined;
}

export interface TupleOfStringAndString {
    item1?: string | undefined;
    item2?: string | undefined;
}

export interface ExportPreviewInfo {
    exportRowCount?: number | undefined;
    excelSheetCount?: number | undefined;
}

export interface ExportGridData {
    columns?: ReportPropertyBase[] | undefined;
    rows?: { [key: string]: any; }[] | undefined;
    filterDisplays?: FilterDisplay[] | undefined;
}

export interface DashboardReport {
    powerBis?: PowerBi[] | undefined;
}

export interface PowerBi extends DataModel {
    name: string;
    urlPostfix: string;
}

export interface ProviderEmploymentListDto {
    id: number;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    school?: string | undefined;
    schoolDisplayOrder?: number | undefined;
    endReason?: string | undefined;
}

export interface ProviderEmploymentListFilter extends ListFilterBase {
    employmentFilter?: ProviderEmploymentFilter | undefined;
}

export interface ProviderEmploymentFilter {
    providerId?: number | undefined;
}

export interface ProviderEmploymentListResource {
    properties?: ListPropertyBase[] | undefined;
}

export interface ProviderEmploymentViewResource {
    properties?: ModelPropertyBase[] | undefined;
    subPartners?: SubPartner[] | undefined;
}

export interface ProviderEmploymentEditResource {
    schools?: School[] | undefined;
}

export interface ProviderListDto {
    id: number;
    fullName?: string | undefined;
    enrollmentDate?: Date | undefined;
    position?: string | undefined;
    positionDisplayOrder?: number | undefined;
}

export interface ProviderListFilter extends ListFilterBase {
    providerFilter?: ProviderFilter | undefined;
}

export interface ProviderFilter {
    isActive?: boolean | undefined;
    regionIds?: number[] | undefined;
    districtIds?: number[] | undefined;
    schoolIds?: number[] | undefined;
}

export interface ProviderListResource {
    properties?: ListPropertyBase[] | undefined;
}

export interface ProviderFilterResource {
    properties?: ModelPropertyBase[] | undefined;
    regions?: Region[] | undefined;
    districts?: District[] | undefined;
    schools?: School[] | undefined;
    canAccessSchoolYearFilter: boolean;
    canAccessRegionFilter: boolean;
    canAccessDistrictFilter: boolean;
    canAccessSchoolFilter: boolean;
}

export interface ProviderViewResource {
    properties?: ModelPropertyBase[] | undefined;
}

export interface ProviderEditResource {
    positions?: ProviderPosition[] | undefined;
}

export interface ProviderPositionListDto {
    id: number;
    name?: string | undefined;
}

export interface ProviderPositionListFilter extends ListFilterBase {
}

export interface ProviderPositionListResource {
    properties?: ListPropertyBase[] | undefined;
}

export interface ProviderPositionViewResource {
    properties?: ModelPropertyBase[] | undefined;
}

export interface ProviderPositionEditResource {
    properties?: ModelPropertyBase[] | undefined;
}

export interface NscCollegeFilterResource {
    properties?: ModelPropertyBase[] | undefined;
    schoolYears?: SimpleDto[] | undefined;
}

export interface NscCollegeListDto {
    id: number;
    identification?: string | undefined;
    term?: string | undefined;
    termDisplayOrder?: number | undefined;
    startDateYear?: number | undefined;
    year?: number | undefined;
    collegeName?: string | undefined;
    enrollmentBegin?: Date | undefined;
    enrollmentEnd?: Date | undefined;
    graduationDate?: Date | undefined;
    degreeTitle?: string | undefined;
    recordFound: boolean;
}

export interface NscCollegeListFilter extends ListFilterBase {
    nscCollegeFilter?: NscCollegeFilter | undefined;
}

export interface NscCollegeListResource {
    properties?: ListPropertyBase[] | undefined;
}

export interface NscCollege extends DataModel {
    identification: string;
    firstName: string;
    middleInitial?: string | undefined;
    lastName: string;
    suffix?: string | undefined;
    requesterReturnField?: string | undefined;
    recordFound: boolean;
    searchDate: Date;
    collegeCode?: string | undefined;
    collegeName?: string | undefined;
    collegeState?: string | undefined;
    collegeTypeId?: number | undefined;
    collegeType?: LkNscCollegeType | undefined;
    publicOrPrivate?: string | undefined;
    enrollmentBegin?: Date | undefined;
    enrollmentEnd?: Date | undefined;
    enrollmentStatusId?: number | undefined;
    enrollmentStatus?: LkNscEnrollmentStatus | undefined;
    classLevelId?: number | undefined;
    classLevel?: LkNscClassLevel | undefined;
    enrollmentMajor1?: string | undefined;
    enrollmentMajor2?: string | undefined;
    enrollmentCip1?: number | undefined;
    enrollmentCip2?: number | undefined;
    graduated?: boolean | undefined;
    graduationDate?: Date | undefined;
    degreeTitle?: string | undefined;
    degreeMajor1?: string | undefined;
    degreeMajor2?: string | undefined;
    degreeMajor3?: string | undefined;
    degreeMajor4?: string | undefined;
    degreeCip1?: number | undefined;
    degreeCip2?: number | undefined;
    degreeCip3?: number | undefined;
    degreeCip4?: number | undefined;
    collegeSequence?: string | undefined;
    year?: number | undefined;
    termId?: number | undefined;
    term?: LkGradeLevelTerm | undefined;
    degreeLevelId?: number | undefined;
    degreeLevel?: DegreeLevel | undefined;
    sourceId?: number | undefined;
    source?: LkPSESource | undefined;
    collegeStatusId?: number | undefined;
    collegeStatus?: LkCollegeStatus | undefined;
    pseEnrollObjId?: number | undefined;
    pseEnrollObj?: LkPSEEnrollObjective | undefined;
    pseRemediationId?: number | undefined;
    pseRemediation?: LkPSERemediation | undefined;
    pseCompletionId?: number | undefined;
    pseCompletion?: LkPSECompletion | undefined;
    stemDegreeId?: number | undefined;
    stemDegree?: LkSTEMDegree | undefined;
}

export interface LkNscCollegeType extends LookUp {
}

export interface LkNscEnrollmentStatus extends LookUp {
}

export interface LkNscClassLevel extends LookUp {
}

export interface DegreeLevel extends DataModel {
    name: string;
}

export interface LkPSESource extends LookUp {
    tapr?: number | undefined;
}

export interface LkCollegeStatus extends LookUp {
    tapr?: number | undefined;
}

export interface LkPSEEnrollObjective extends LookUp {
    tapr?: number | undefined;
}

export interface LkPSERemediation extends LookUp {
    tapr?: number | undefined;
}

export interface LkPSECompletion extends LookUp {
    tapr?: number | undefined;
}

export interface LkSTEMDegree extends LookUp {
    tapr?: number | undefined;
}

export interface NscCollegeViewResource {
    properties?: ModelPropertyBase[] | undefined;
}

export interface NscCollegeEditResource {
    schoolYears?: SimpleDto[] | undefined;
    gradeLevelTerms?: LkGradeLevelTerm[] | undefined;
    sources?: LkPSESource[] | undefined;
    collegeStatuses?: LkCollegeStatus[] | undefined;
    degreeLevels?: DegreeLevel[] | undefined;
    remediations?: LkPSERemediation[] | undefined;
    stemDegrees?: LkSTEMDegree[] | undefined;
}

export interface StudentAbsenceListDto {
    id: number;
    schoolYear?: number | undefined;
    school?: string | undefined;
    schoolDisplayOrder?: number | undefined;
    termType?: string | undefined;
    termNumber?: number | undefined;
    excusedAbsences?: number | undefined;
    unexcusedAbsences?: number | undefined;
    daysAttended?: number | undefined;
    daysEnrolled?: number | undefined;
}

export interface StudentAbsenceListFilter extends ListFilterBase {
    absenceFilter?: StudentAbsenceFilter | undefined;
}

export interface StudentAbsenceFilter {
    schoolYear?: number | undefined;
    studentId?: number | undefined;
}

export interface StudentAbsenceFilterResource {
    properties?: ModelPropertyBase[] | undefined;
    schoolYears?: SimpleDto[] | undefined;
}

export interface StudentAbsence extends DataModel {
    generalValidationErrors?: string | undefined;
    studentId: number;
    year: number;
    schoolId?: number | undefined;
    school?: School | undefined;
    termTypeId: number;
    termType?: LkTermType | undefined;
    termNumber?: number | undefined;
    excusedAbsences?: number | undefined;
    unexcusedAbsences?: number | undefined;
    daysAttended?: number | undefined;
    daysEnrolled?: number | undefined;
}

export interface StudentAbsenceListResource {
    properties?: ListPropertyBase[] | undefined;
}

export interface StudentAbsenceViewResource {
    properties?: ModelPropertyBase[] | undefined;
    termTypes?: LkTermType[] | undefined;
}

export interface StudentAbsenceEditResource {
    schoolYears?: SimpleDto[] | undefined;
    schools?: School[] | undefined;
}

export interface StudentApplicationListDto {
    id: number;
    studentId?: number | undefined;
    applicationName?: string | undefined;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    schoolName?: string | undefined;
    schoolId?: number | undefined;
    applicationStatus?: LkApplicationStatus | undefined;
    applicationStatusId: number;
    submittedDate?: Date | undefined;
}

export interface StudentApplicationListFilter extends ListFilterBase {
    groupFilter?: StudentApplicationFilter | undefined;
}

export interface StudentApplicationFilter {
    applicationStatuses?: number[] | undefined;
    reviewers?: number[] | undefined;
}

export interface StudentApplicationListResource {
    properties?: ListPropertyBase[] | undefined;
    applicationStatuses?: LkApplicationStatus[] | undefined;
    reviewers?: User[] | undefined;
    tenantVariableProperties?: TenantVariableStudent | undefined;
    displayFields?: LkStudentDisplayField[] | undefined;
}

export interface TenantVariableStudent extends Entity {
    ninthGradeYear: boolean;
    permissionSlip: boolean;
    collegeBound: boolean;
    mentorProgram: boolean;
    migrant: boolean;
    sixYearsEsl: boolean;
    dualEnrollment: boolean;
    poverty: boolean;
    firstGeneration: boolean;
    trio: boolean;
    upwardBound: boolean;
    eops: boolean;
    referralType: boolean;
    primaryTransportation: boolean;
    reasonForEnrollment: boolean;
    graduationYear: boolean;
    graduationType: boolean;
    familyIncome: boolean;
    cohort: boolean;
    noCollegeReason: boolean;
    eligibility: boolean;
    academicNeed: boolean;
    isPartial: boolean;
}

export interface StudentApplicationFilterResource {
    properties?: ModelPropertyBase[] | undefined;
    applicationStatuses?: LkApplicationStatus[] | undefined;
    reviewers?: User[] | undefined;
    permissionToApprove: boolean;
}

export interface StudentApplicationEditResource {
    fileCategories: FileCategory[];
}

export interface StudentApplicationResponseDto {
    applicationResponse?: ApplicationResponse | undefined;
    createdDate?: Date | undefined;
    applicationName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    applicationId?: number | undefined;
    studentId?: number | undefined;
    schoolId?: number | undefined;
    schoolName?: string | undefined;
    school?: School | undefined;
    applicationStatusId: number;
    applicationStatus?: LkApplicationStatus | undefined;
    programStatusId?: number | undefined;
    programStatus?: LkProgramStatus | undefined;
    notes?: string | undefined;
    files?: ApplicationResponseFile[] | undefined;
    events?: Comment[] | undefined;
}

export interface ApplicationResponseFile extends DataModel {
    applicationResponseId: number;
    note?: string | undefined;
    fileCategoryId?: number | undefined;
    uploadFileId?: number | undefined;
    uploadFile: UploadFile;
}

export interface StudentDiplomaListDto {
    id: number;
    schoolYear?: number | undefined;
    date?: Date | undefined;
    diplomaType?: string | undefined;
    diplomaTypeDisplayOrder?: number | undefined;
}

export interface StudentDiplomaListFilter extends ListFilterBase {
    diplomaFilter?: StudentDiplomaFilter | undefined;
}

export interface StudentDiplomaFilter {
    studentId?: number | undefined;
}

export interface StudentDiploma extends DataModel {
    studentId: number;
    year: number;
    date?: Date | undefined;
    diplomaTypeId: number;
    diplomaType?: DiplomaType | undefined;
    degreeMajorId?: number | undefined;
    degreeMajor?: DegreeMajor | undefined;
}

export interface DegreeMajor extends DataModel {
    name: string;
    schoolId?: number | undefined;
    school?: School | undefined;
    diplomaFieldId?: number | undefined;
    diplomaField?: LkDiplomaField | undefined;
}

export interface StudentDiplomaViewResource {
    properties?: ModelPropertyBase[] | undefined;
    displayFields?: LkStudentDiplomaDisplayField[] | undefined;
}

export interface LkStudentDiplomaDisplayField extends LookUp {
    displayName?: string | undefined;
}

export interface StudentDiplomaEditResource {
    schoolYears?: SimpleDto[] | undefined;
    diplomaTypes?: DiplomaType[] | undefined;
    degreeMajors?: DegreeMajor[] | undefined;
}

export interface StudentEnrollmentListDto {
    id: number;
    studentId?: number | undefined;
    student?: string | undefined;
    customId1?: string | undefined;
    schoolYear?: number | undefined;
    school?: string | undefined;
    schoolDisplayOrder?: number | undefined;
    gradeLevel?: string | undefined;
    endGradeLevel?: string | undefined;
    gradeLevelDisplayOrder?: number | undefined;
    participantStatus?: string | undefined;
    participantLevel?: string | undefined;
    loanAmount?: number | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
}

export interface StudentEnrollmentFilterResource {
    properties?: ModelPropertyBase[] | undefined;
    customFilterProperties?: CustomReportProperty[] | undefined;
    schools?: School[] | undefined;
    schoolYears?: SimpleDto[] | undefined;
    studentTabs?: LkStudentTab[] | undefined;
}

export interface LkStudentTab extends LookUp {
}

export interface StudentEnrollmentListResource {
    properties?: ListPropertyBase[] | undefined;
    customIdTypes?: StudentCustomIdType[] | undefined;
    displayFields?: LkStudentEnrollmentDisplayField[] | undefined;
    variableFields?: TenantVariableStudentEnrollment | undefined;
}

export interface StudentCustomIdType extends DataModel {
    name: string;
    isRequired: boolean;
    isUnique: boolean;
    inactive: boolean;
    isSsn: boolean;
}

export interface LkStudentEnrollmentDisplayField extends LookUp {
    displayName?: string | undefined;
}

export interface TenantVariableStudentEnrollment extends Entity {
    magnet: boolean;
    heldBack: boolean;
    avid: boolean;
    mediaRelease: boolean;
    cacg: boolean;
    twentyFirstCentury: boolean;
    dropTransferForm: boolean;
    atRisk: boolean;
    atRiskReason: boolean;
    homeless: boolean;
    fosterCare: boolean;
    iep: boolean;
    lep: boolean;
    freeReducedLunch: boolean;
    ub: boolean;
    ubms: boolean;
    vub: boolean;
    ts: boolean;
    sss: boolean;
    gearUp: boolean;
    eoc: boolean;
    initialEnrollmentStatusId: boolean;
    finalEnrollmentStatusId: boolean;
    participantStatusId: boolean;
    militaryConnectionId: boolean;
    persistantStatusId: boolean;
}

export interface StudentEnrollmentViewResource {
    properties?: ModelPropertyBase[] | undefined;
    displayFields?: LkStudentEnrollmentDisplayField[] | undefined;
    customIdTypes?: StudentCustomIdType[] | undefined;
    variables?: TenantVariableStudentEnrollment | undefined;
    customDataModelFields?: CustomDataModelField[] | undefined;
    gradeLevels?: LkGradeLevel[] | undefined;
    endReasons?: EndReason[] | undefined;
}

export interface StudentEnrollmentEditResource {
    schoolYears?: SimpleDto[] | undefined;
    schools?: School[] | undefined;
    gradeLevels?: LkGradeLevel[] | undefined;
    gradeLevelTerms?: LkGradeLevelTerm[] | undefined;
    endReasons?: EndReason[] | undefined;
    ieps?: Iep[] | undefined;
    leps?: Lep[] | undefined;
    enrollmentStatuses?: LkEnrollmentStatus[] | undefined;
    participantStatuses?: LkParticipantStatus[] | undefined;
    militaryConnections?: LkMilitaryConnection[] | undefined;
    persistantStatuses?: LkPersistantStatus[] | undefined;
    participantLevels?: LkParticipantLevel[] | undefined;
    dualEnrollmentParticipations?: LkDualEnrollmentParticipation[] | undefined;
    dualEnrollmentCredentials?: LkDualEnrollmentCredentials[] | undefined;
    workStudyCulturalCommunity?: LkWorkStudyCulturalCommunity[] | undefined;
    employments?: LkEmploymentUB[] | undefined;
    advisors?: User[] | undefined;
    colleges?: College[] | undefined;
    dependentStatuses?: LkDependentStatus[] | undefined;
    academicStandings?: LkAcademicStanding[] | undefined;
    ccps?: LkCcp[] | undefined;
    rigorousCs?: LkRigorousC[] | undefined;
    diplomaTypes?: DiplomaType[] | undefined;
}

export interface StudentEnrollmentBulkUpdate {
    enrollments?: StudentEnrollment[] | undefined;
    updateSchema?: StudentEnrollmentBulkUpdateSchema | undefined;
}

export interface StudentEnrollmentBulkUpdateSchema {
    updateStartDate: boolean;
    startDate?: Date | undefined;
    updateEndDate: boolean;
    endDate?: Date | undefined;
    updateYear: boolean;
    year?: number | undefined;
    updateSchoolId: boolean;
    schoolId?: number | undefined;
    updateAdvisorId: boolean;
    advisorId?: number | undefined;
    updateGradeLevelId: boolean;
    gradeLevelId?: number | undefined;
    updateEndReasonId: boolean;
    endReasonId?: number | undefined;
    updateCohortId: boolean;
    cohortId?: number | undefined;
    updateIepId: boolean;
    iepId?: number | undefined;
    updateLepId: boolean;
    lepId?: number | undefined;
    updateLepInstructionId: boolean;
    lepInstructionId?: number | undefined;
    updateFreeReducedLunch: boolean;
    freeReducedLunch?: boolean | undefined;
    updateMagnet: boolean;
    magnet?: boolean | undefined;
    updateHeldBack: boolean;
    heldBack?: boolean | undefined;
    updateAvid: boolean;
    avid?: boolean | undefined;
    updateMediaRelease: boolean;
    mediaRelease?: boolean | undefined;
    updateCacg: boolean;
    cacg?: boolean | undefined;
    updateTwentyFirstCentury: boolean;
    twentyFirstCentury?: boolean | undefined;
    updateDropTransferForm: boolean;
    dropTransferForm?: boolean | undefined;
    updateAtRisk: boolean;
    atRisk?: boolean | undefined;
    updateHomeless: boolean;
    homeless?: boolean | undefined;
    updateFosterCare: boolean;
    fosterCare?: boolean | undefined;
    updateAtRiskReason: boolean;
    atRiskReason?: string | undefined;
    updateUb: boolean;
    ub?: boolean | undefined;
    updateUbms: boolean;
    ubms?: boolean | undefined;
    updateVub: boolean;
    vub?: boolean | undefined;
    updateTs: boolean;
    ts?: boolean | undefined;
    updateSss: boolean;
    sss?: boolean | undefined;
    updateGearUp: boolean;
    gearUp?: boolean | undefined;
    updateEoc: boolean;
    eoc?: boolean | undefined;
    updateInitialEnrollmentStatusId: boolean;
    initialEnrollmentStatusId?: number | undefined;
    updateFinalEnrollmentStatusId: boolean;
    finalEnrollmentStatusId?: number | undefined;
    updateParticipantStatusId: boolean;
    participantStatusId?: number | undefined;
    updateParticipantLevelId: boolean;
    participantLevelId?: number | undefined;
    updateDiplomaTypeId: boolean;
    diplomaTypeId?: number | undefined;
    updateMilitaryConnectionId: boolean;
    militaryConnectionId?: number | undefined;
    updatePersistantStatusId: boolean;
    persistantStatusId?: number | undefined;
    updateEnrollmentStatusId: boolean;
    enrollmentStatusId?: number | undefined;
    updateCredits: boolean;
    credits?: number | undefined;
    updateDependentStatusId: boolean;
    dependentStatusId?: number | undefined;
    updateNih: boolean;
    nih?: number | undefined;
    updateAgi: boolean;
    agi?: number | undefined;
    updateUnmetNeed: boolean;
    unmetNeed?: number | undefined;
    updateLoanAmount: boolean;
    loanAmount?: number | undefined;
    updatePellRecipient: boolean;
    pellRecipient?: boolean | undefined;
    updateAcademicStandingId: boolean;
    academicStandingId?: number | undefined;
    updateCcpId: boolean;
    ccpId?: number | undefined;
    updateRigorousCId: boolean;
    rigorousCId?: number | undefined;
    updateDualEnrollment: boolean;
    dualEnrollment?: boolean | undefined;
    updateDualEnrollmentParticipation: boolean;
    dualEnrollmentParticipationId?: number | undefined;
    updateDualEnrollmentCredentials: boolean;
    dualEnrollmentCredentialsId?: number | undefined;
    updateWorkStudy: boolean;
    workStudyId?: number | undefined;
    updateEmploymentUb: boolean;
    employmentUBId?: number | undefined;
    updateCultural: boolean;
    culturalId?: number | undefined;
    updateCommunityService: boolean;
    communityServiceId?: number | undefined;
}

export interface StudentEnrollmentBulkUpdateResource {
    properties?: ModelPropertyBase[] | undefined;
    variables?: TenantVariableStudentEnrollment | undefined;
    displayFields?: LkStudentEnrollmentDisplayField[] | undefined;
    schoolYears?: SimpleDto[] | undefined;
    schools?: School[] | undefined;
    gradeLevels?: LkGradeLevel[] | undefined;
    gradeLevelTerms?: LkGradeLevelTerm[] | undefined;
    endReasons?: EndReason[] | undefined;
    ieps?: Iep[] | undefined;
    leps?: Lep[] | undefined;
    enrollmentStatuses?: LkEnrollmentStatus[] | undefined;
    participantStatuses?: LkParticipantStatus[] | undefined;
    participantLevels?: LkParticipantLevel[] | undefined;
    diplomaTypes?: DiplomaType[] | undefined;
    militaryConnections?: LkMilitaryConnection[] | undefined;
    persistantStatuses?: LkPersistantStatus[] | undefined;
    advisors?: User[] | undefined;
    dependentStatuses?: LkDependentStatus[] | undefined;
    academicStandings?: LkAcademicStanding[] | undefined;
    ccps?: LkCcp[] | undefined;
    rigorousCs?: LkRigorousC[] | undefined;
    dualEnrollmentParticipations?: LkDualEnrollmentParticipation[] | undefined;
    dualEnrollmentCredentials?: LkDualEnrollmentCredentials[] | undefined;
    employmentUbs?: LkEmploymentUB[] | undefined;
    workStudyCulturalCommunities?: LkWorkStudyCulturalCommunity[] | undefined;
}

export interface EndReasonTypeStatsResponse {
    activeSchoolYear: number;
    data?: EndReasonTypeStatsDto[] | undefined;
    totalsByYear?: YearTotalDto[] | undefined;
    grandTotal?: GrandTotalDto | undefined;
}

export interface EndReasonTypeStatsDto {
    year: number;
    endReasonTypeName?: string | undefined;
    endReasonTypeId: number;
    studentCount: number;
    totalEnrolled: number;
    percentageSubmitted: number;
}

export interface YearTotalDto {
    year: number;
    totalStudents: number;
    totalEnrolled: number;
    totalPercentage: number;
}

export interface GrandTotalDto {
    totalStudents: number;
    totalEnrolled: number;
    totalPercentage: number;
}

export interface EndReasonTypeStatsFilter {
    schoolYears?: number[] | undefined;
    selectedEndReasonTypeIds?: number[] | undefined;
    programId?: number | undefined;
}

export interface StudentFafsaListDto {
    id: number;
    schoolYear?: number | undefined;
    date?: Date | undefined;
    submitted?: boolean | undefined;
    amount?: number | undefined;
    fafsaType?: string | undefined;
    fafsaTypeDisplayOrder?: number | undefined;
}

export interface StudentFafsaListFilter extends ListFilterBase {
    fafsaFilter?: StudentFafsaFilter | undefined;
}

export interface StudentFafsaFilter {
    studentId?: number | undefined;
}

export interface StudentFafsa extends DataModel {
    studentId: number;
    year: number;
    date?: Date | undefined;
    submitted?: boolean | undefined;
    verified?: boolean | undefined;
    completed?: boolean | undefined;
    notApplicable: boolean;
    amount?: number | undefined;
    studentName?: string | undefined;
}

export interface StudentFafsaViewResource {
    properties?: ModelPropertyBase[] | undefined;
    displayFields?: LkStudentFafsaDisplayField[] | undefined;
}

export interface LkStudentFafsaDisplayField extends LookUp {
    displayName?: string | undefined;
}

export interface StudentFafsaEditResource {
    schoolYears?: SimpleDto[] | undefined;
}

export interface StudentFileFilterResource {
    properties?: ModelPropertyBase[] | undefined;
    fileCategories?: FileCategory[] | undefined;
}

export interface StudentFileListDto {
    id: number;
    fileCategoryId?: number | undefined;
    fileName?: string | undefined;
    fileCategory?: string | undefined;
    note?: string | undefined;
    fileSize: number;
    createdDate?: Date | undefined;
    fileTypeCategory: FileTypeCategory;
    uploadFile?: UploadFile | undefined;
}

export enum FileTypeCategory {
    Application = 1,
    StudentFile = 2,
    StudentServiceFile = 3,
}

export interface StudentFileCategorizedListFilter extends ListFilterBase {
    fileFilter?: StudentFileCategorizedFilter | undefined;
}

export interface StudentFileCategorizedFilter {
    includeApplication: boolean;
    includeStudentFile: boolean;
    includeStudentServiceFile: boolean;
    fileCategoryIds?: number[] | undefined;
}

export interface StudentFile extends DataModel {
    studentId: number;
    note?: string | undefined;
    uploadFileId?: number | undefined;
    uploadFile: UploadFile;
    fileCategoryId?: number | undefined;
    fileCategory?: FileCategory | undefined;
}

export interface StudentFileListFilter extends ListFilterBase {
    fileFilter?: StudentFileFilter | undefined;
}

export interface StudentFileFilter {
    studentId?: number | undefined;
}

export interface StudentGpaListDto {
    id: number;
    schoolYear?: number | undefined;
    school?: string | undefined;
    schoolDisplayOrder?: number | undefined;
    termType?: string | undefined;
    termNumber?: number | undefined;
    gpa?: number | undefined;
    note?: string | undefined;
    noteDisplayOrder?: number | undefined;
}

export interface StudentGpaListFilter extends ListFilterBase {
    gpaFilter?: StudentGpaFilter | undefined;
}

export interface StudentGpaFilter {
    schoolYear?: number | undefined;
    studentId?: number | undefined;
}

export interface StudentGpaListResource {
    properties?: ListPropertyBase[] | undefined;
}

export interface StudentGpaFilterResource {
    properties?: ModelPropertyBase[] | undefined;
    schoolYears?: SimpleDto[] | undefined;
}

export interface StudentGpa extends DataModel {
    generalValidationErrors?: string | undefined;
    studentId: number;
    year: number;
    schoolId: number;
    school?: School | undefined;
    termTypeId?: number | undefined;
    termType?: LkTermType | undefined;
    termNumber?: number | undefined;
    gpa?: number | undefined;
    reasonMissingId?: number | undefined;
    reasonMissing?: LkReasonMissing | undefined;
    calculationId?: number | undefined;
    calculation?: LkGpaCalculation | undefined;
}

export interface LkReasonMissing extends LookUp {
}

export interface LkGpaCalculation extends LookUp {
}

export interface StudentGpaViewResource {
    properties?: ModelPropertyBase[] | undefined;
    termTypes?: LkTermType[] | undefined;
}

export interface StudentGpaEditResource {
    schoolYears?: SimpleDto[] | undefined;
    schools?: School[] | undefined;
    reasonMissings?: LkReasonMissing[] | undefined;
    calculations?: LkGpaCalculation[] | undefined;
}

export interface StudentGradeListDto {
    id: number;
    schoolYear?: number | undefined;
    school?: string | undefined;
    schoolDisplayOrder?: number | undefined;
    termType?: string | undefined;
    termNumber?: number | undefined;
    class?: string | undefined;
    grade?: string | undefined;
    gradeDisplayOrder?: number | undefined;
    note?: string | undefined;
    noteDisplayOrder?: number | undefined;
}

export interface StudentGradeListFilter extends ListFilterBase {
    gradeFilter?: StudentGradeFilter | undefined;
}

export interface StudentGradeFilter {
    schoolYear?: number | undefined;
    studentId?: number | undefined;
}

export interface StudentGradeListResource {
    properties?: ListPropertyBase[] | undefined;
}

export interface StudentGradeFilterResource {
    properties?: ModelPropertyBase[] | undefined;
    schoolYears?: SimpleDto[] | undefined;
}

export interface StudentGrade extends DataModel {
    generalValidationErrors?: string | undefined;
    studentId: number;
    year: number;
    termTypeId: number;
    termType?: LkTermType | undefined;
    termNumber?: number | undefined;
    classId?: number | undefined;
    class?: Class | undefined;
    gradeId?: number | undefined;
    grade?: Grade | undefined;
    reasonMissingId?: number | undefined;
    reasonMissing?: LkReasonMissing | undefined;
    schoolId?: number | undefined;
    dualEnrollment: boolean;
    dualEnrollmentClassId?: number | undefined;
    dualEnrollmentClass?: Class | undefined;
    finalGrade: boolean;
}

export interface Grade extends DataModel {
    isInUse: boolean;
    name: string;
    passing: boolean;
    atRisk: boolean;
}

export interface StudentGradeViewResource {
    properties?: ModelPropertyBase[] | undefined;
    termTypes?: LkTermType[] | undefined;
}

export interface StudentGradeEditResource {
    schoolYears?: SimpleDto[] | undefined;
    schools?: School[] | undefined;
    grades?: Grade[] | undefined;
    reasonMissings?: LkReasonMissing[] | undefined;
}

export interface StudentGradeBulkCreate {
    studentId?: number | undefined;
    schoolYear: number;
    schoolId: number;
    termTypeId: number;
    rows?: StudentGradeBulkCreateRow[] | undefined;
    badRequest: boolean;
}

export interface StudentGradeBulkCreateRow {
    classId?: number | undefined;
    class?: Class | undefined;
    grades?: StudentGradeBulkCreateGrade[] | undefined;
    summerGrade?: StudentGradeBulkCreateGrade | undefined;
}

export interface StudentGradeBulkCreateGrade {
    gradeId?: number | undefined;
    errors?: string[] | undefined;
}

export interface StudentGradeBulkCreateResource {
    properties?: ModelPropertyBase[] | undefined;
    rowProperties?: ModelPropertyBase[] | undefined;
    schoolYears?: SimpleDto[] | undefined;
    schools?: School[] | undefined;
    termTypes?: LkTermType[] | undefined;
    grades?: Grade[] | undefined;
}

export interface StudentGroupListDto {
    id: number;
    studentId?: number | undefined;
    name?: string | undefined;
    school?: string | undefined;
    schoolDisplayOrder?: number | undefined;
    inactive: boolean;
    assignedStudents: number;
}

export interface StudentGroupListFilter extends ListFilterBase {
    groupFilter?: StudentGroupFilter | undefined;
}

export interface StudentGroupFilter {
    schoolIds?: number[] | undefined;
    inactive?: boolean | undefined;
}

export interface StudentGroupListResource {
    properties?: ListPropertyBase[] | undefined;
}

export interface StudentGroupFilterResource {
    properties?: ModelPropertyBase[] | undefined;
    schools?: School[] | undefined;
}

export interface StudentGroupViewResource {
    properties?: ModelPropertyBase[] | undefined;
}

export interface StudentGroupEditResource {
    schools?: School[] | undefined;
}

export interface StudentGroupBulkUpdate {
    groups?: StudentGroup[] | undefined;
    updateSchema?: StudentGroupBulkUpdateSchema | undefined;
}

export interface StudentGroupBulkUpdateSchema {
    updateInactive: boolean;
    inactive?: boolean | undefined;
    updateSchoolId: boolean;
    schoolId?: number | undefined;
}

export interface StudentGroupBulkUpdateResource {
    properties?: ModelPropertyBase[] | undefined;
    schools?: School[] | undefined;
}

export interface StudentParentListDto {
    id: number;
    fullName?: string | undefined;
    relation?: string | undefined;
}

export interface StudentParentListFilter extends ListFilterBase {
    parentFilter?: StudentParentFilter | undefined;
}

export interface StudentParentFilter {
    studentId?: number | undefined;
}

export interface StudentParentViewResource {
    properties?: ModelPropertyBase[] | undefined;
    displayFields?: LkStudentParentDisplayField[] | undefined;
}

export interface LkStudentParentDisplayField extends LookUp {
}

export interface StudentParentEditResource {
    relations?: LkRelation[] | undefined;
    educationLevels?: LkEducationLevel[] | undefined;
    languages?: LkLanguage[] | undefined;
}

export interface ParentAssignDto {
    parent?: Parent | undefined;
    students?: ParentAssignDtoStudent[] | undefined;
}

export interface ParentAssignDtoStudent {
    id: number;
    customId1?: string | undefined;
    lastName?: string | undefined;
    firstName?: string | undefined;
}

export interface StudentPostHighSchoolListDto {
    id: number;
    college?: string | undefined;
    collegeDisplayOrder?: number | undefined;
    status?: string | undefined;
    statusDisplayOrder?: number | undefined;
    note?: string | undefined;
}

export interface StudentPostHighSchoolListFilter extends ListFilterBase {
    postHighSchoolFilter?: StudentPostHighSchoolFilter | undefined;
}

export interface StudentPostHighSchoolFilter {
    studentId?: number | undefined;
}

export interface StudentPostHighSchool extends DataModel {
    studentId: number;
    date?: Date | undefined;
    year?: number | undefined;
    collegeId: number;
    college?: College | undefined;
    statusId: number;
    status?: PostHighSchoolStatus | undefined;
    note?: string | undefined;
}

export interface StudentPostHighSchoolViewResource {
    properties?: ModelPropertyBase[] | undefined;
}

export interface StudentPostHighSchoolEditResource {
    schoolYears?: SimpleDto[] | undefined;
    colleges?: College[] | undefined;
    statuses?: PostHighSchoolStatus[] | undefined;
}

export interface StudentScholarshipListDto {
    id: number;
    date?: Date | undefined;
    scholarshipType?: string | undefined;
    amount?: number | undefined;
}

export interface StudentScholarshipListFilter extends ListFilterBase {
    scholarshipFilter?: StudentScholarshipFilter | undefined;
}

export interface StudentScholarship extends DataModel {
    studentId: number;
    date: Date;
    scholarshipTypeId: number;
    scholarshipType?: ScholarshipType | undefined;
    scholarshipName?: string | undefined;
    scholarshipPaymentMethodId?: number | undefined;
    scholarshipPaymentMethod?: ScholarshipPaymentMethod | undefined;
    statusId?: number | undefined;
    status?: ScholarshipStatus | undefined;
    sourceName?: string | undefined;
    website?: string | undefined;
    amount: number;
    note?: string | undefined;
    studentName?: string | undefined;
}

export interface StudentScholarshipViewResource {
    properties?: ModelPropertyBase[] | undefined;
}

export interface StudentScholarshipEditResource {
    scholarshipTypes?: ScholarshipType[] | undefined;
    paymentMethods?: ScholarshipPaymentMethod[] | undefined;
    statuses?: ScholarshipStatus[] | undefined;
}

export interface StudentListDto {
    id: number;
    customId1?: string | undefined;
    customId2?: string | undefined;
    customId3?: string | undefined;
    customId4?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    middleName?: string | undefined;
    nickName?: string | undefined;
    currentGradeLevel?: string | undefined;
    currentGradeLevelDisplayOrder?: number | undefined;
    currentSchool?: string | undefined;
    currentSchoolDisplayOrder?: number | undefined;
    questionnaireStatusId?: number | undefined;
    fileId?: number | undefined;
}

export interface StudentListResource {
    properties?: ListPropertyBase[] | undefined;
    customIdTypes?: StudentCustomIdType[] | undefined;
}

export interface StudentFilterResource {
    properties?: ModelPropertyBase[] | undefined;
    displayFilters?: LkStudentDisplayFilter[] | undefined;
    enrollmentDisplayFields?: LkStudentEnrollmentDisplayField[] | undefined;
    customIdTypes?: StudentCustomIdType[] | undefined;
    customFilterProperties?: CustomReportProperty[] | undefined;
    schoolYearsWithActive?: SimpleDto[] | undefined;
    regions?: Region[] | undefined;
    studentTabs?: LkStudentTab[] | undefined;
    districts?: District[] | undefined;
    schools?: School[] | undefined;
    gradeLevels?: LkGradeLevel[] | undefined;
    gradeLevelTerms?: LkGradeLevelTerm[] | undefined;
    studentGroups?: StudentGroup[] | undefined;
    duplicateByProperties?: ReportPropertyBase[] | undefined;
    programs?: Program[] | undefined;
    endReasonTypes?: LkEndReasonType[] | undefined;
    dataAssignedSchoolIds?: number[] | undefined;
    canAccessRegionFilter: boolean;
    canAccessDistrictFilter: boolean;
    canAccessSchoolFilter: boolean;
    canAccessAiFeature: boolean;
}

export interface StudentViewResource {
    properties?: ModelPropertyBase[] | undefined;
    activeSchoolYear?: number | undefined;
    currentSchool?: string | undefined;
    currentGradeLevel?: string | undefined;
    customIdTypes?: StudentCustomIdType[] | undefined;
    studentTabs?: LkStudentTab[] | undefined;
    displayFields?: LkStudentDisplayField[] | undefined;
    variables?: TenantVariableStudent | undefined;
    customDataModelFields?: CustomDataModelField[] | undefined;
    servicesTotal?: number | undefined;
    transcriptYearsTotal?: number | undefined;
    formsTotal?: number | undefined;
    applicationsTotal?: number | undefined;
    filesTotal?: number | undefined;
    nscCollegesTotal?: number | undefined;
    textingTotal?: number | undefined;
}

export interface StudentEditResource {
    canAutoAssignCustomId: boolean;
    genders?: LkGender[] | undefined;
    races?: LkRace[] | undefined;
    ethnicities?: LkEthnicity[] | undefined;
    optInMethods?: LkOptInMethod[] | undefined;
    feederSchools?: FeederSchool[] | undefined;
    familyIncomes?: LkFamilyIncome[] | undefined;
    cohorts?: LkCohort[] | undefined;
    noCollegeReasons?: NoCollegeReason[] | undefined;
    referralTypes?: LkReferralType[] | undefined;
    reasonsForEnrollment?: LkReasonForEnrollment[] | undefined;
    primaryTransportations?: LkPrimaryTransportation[] | undefined;
    eligibilities?: LkEligibility[] | undefined;
    academicNeeds?: LkAcademicNeed[] | undefined;
    users?: User[] | undefined;
    programs?: Program[] | undefined;
    atRiskLowGpas?: LkAtRiskLowGpa[] | undefined;
    atRiskStdTests?: LkAtRiskStdTest[] | undefined;
    atRiskAlgebras?: LkAtRiskAlgebra[] | undefined;
    otherNeeds?: LkOtherNeed[] | undefined;
    deceased?: LkDeceased[] | undefined;
    disabled?: LkDisabled[] | undefined;
    textingOptInMethods?: TextingOptIn[] | undefined;
}

export interface StudentTranscript {
    years?: StudentTranscriptYear[] | undefined;
}

export interface StudentTranscriptYear {
    year?: number | undefined;
    gradeTerms?: StudentTranscriptGradeTerm[] | undefined;
    gpas?: StudentGpa[] | undefined;
    tests?: StudentTest[] | undefined;
    absences?: StudentAbsence[] | undefined;
    noData: boolean;
}

export interface StudentTranscriptGradeTerm {
    termTypeId?: number | undefined;
    termType?: string | undefined;
    termTypeDisplayOrder?: number | undefined;
    termNumber?: number | undefined;
    schoolId?: number | undefined;
    school?: string | undefined;
    grades?: StudentGrade[] | undefined;
    gpa?: number | undefined;
}

export interface StudentTest extends DataModel {
    generalValidationErrors?: string | undefined;
    studentId: number;
    year: number;
    testTypeId: number;
    testType?: TestType | undefined;
    score: number;
    testDate?: Date | undefined;
    testLevelId?: number | undefined;
    testLevel?: TestLevel | undefined;
    benchmark?: string | undefined;
    languageId?: number | undefined;
    language?: LkLanguage | undefined;
}

export interface TestType extends DataModel {
    name?: string | undefined;
    code?: string | undefined;
    testTypeGroupId?: number | undefined;
    testTypeGroup?: LkTestTypeGroup | undefined;
    aprTestTypeId?: number | undefined;
    aprTestType?: LkAprTestType | undefined;
    isInUse: boolean;
    manualTestLevels?: TestLevel[] | undefined;
    manualTestLevelGeneralValidationErrors?: string | undefined;
}

export interface LkTestTypeGroup extends LookUp {
}

export interface LkAprTestType extends LookUp {
}

export interface TestLevel extends DataModel {
    name: string;
    testTypeId: number;
    proficiencyId?: number | undefined;
    proficiency?: LkProficiency | undefined;
}

export interface LkProficiency extends LookUp {
}

export interface AprUbResponseRow {
    awardNumber?: string | undefined;
    batchYear: number;
    studentType?: string | undefined;
    lepEntry?: string | undefined;
    caseNumber?: string | undefined;
    lastName?: string | undefined;
    firstName?: string | undefined;
    middleInitial?: string | undefined;
    dateOfBirth?: Date | undefined;
    genderCode: number;
    ethnicityCode: number;
    isRaceNative: number;
    isRaceAsian: number;
    isRaceAfrican: number;
    isRaceWhite: number;
    isRacePacific: number;
    eligibility: number;
    atRiskStdTest: number;
    atRiskLowGPA: number;
    atRiskAlgebra: number;
    disconnected: number;
    otherNeed: number;
    ncesSchool?: string | undefined;
    projectEntryDate?: string | undefined;
    collegeGradeLevel?: number | undefined;
    deceased?: number | undefined;
    participantStatus?: number | undefined;
    participantLevel?: number | undefined;
    federalServed?: number | undefined;
    startGradeLevel?: number | undefined;
    endGradeLevel?: number | undefined;
    highSchoolGPA?: string | undefined;
    highSchoolGPAUnweighted?: string | undefined;
    highSchoolGraduate?: number | undefined;
    highSchoolGraduateDate?: string | undefined;
    rigorousStudy?: number | undefined;
    schoolPersistNumber?: number | undefined;
    hsProficientRla?: number | undefined;
    hsProficientMath?: number | undefined;
    apCourse?: number | undefined;
    dualEnrollParticipation?: number | undefined;
    dualEnrollCredentials?: number | undefined;
    advancedMath?: number | undefined;
    fafsa?: number | undefined;
    lastServiceDate?: string | undefined;
    reason?: number | undefined;
    workStudy?: number | undefined;
    employment?: number | undefined;
    cultural?: number | undefined;
    communityService?: number | undefined;
    lepInstruction?: number | undefined;
    selfTranCD?: number | undefined;
    firstEnrollDate?: string | undefined;
    pseCohort?: string | undefined;
    pseCdfe?: string | undefined;
    pseGradeLv?: number | undefined;
    certificateCd?: number | undefined;
    certificateDt?: string | undefined;
    assocDegreeCd?: number | undefined;
    assocDegreeDt?: string | undefined;
    bachDegreeCd?: number | undefined;
    bachDegreeDt?: string | undefined;
    pseEnrollObjNum?: number | undefined;
    psRemediation?: number | undefined;
    psCompleteNum?: number | undefined;
    stemDegree?: number | undefined;
    fullNameChange?: string | undefined;
    customId1?: string | undefined;
    program?: string | undefined;
}

export interface StudentAprUbResource {
    properties?: ModelPropertyBase[] | undefined;
    studentDisplayFields?: LkStudentDisplayField[] | undefined;
    enrollmentDisplayFields?: LkStudentEnrollmentDisplayField[] | undefined;
}

export interface StudentBulkCreateServices {
    students?: Student[] | undefined;
    service?: StudentService | undefined;
    additionalEntries?: StudentServiceAdditionalEntry[] | undefined;
    additionalDates?: Date[] | undefined;
}

export interface StudentBulkCreateServicesResource {
    studentGroups?: StudentGroup[] | undefined;
    serviceProperties?: ModelPropertyBase[] | undefined;
    serviceDisplayFields?: LkStudentServiceDisplayField[] | undefined;
    serviceTypes?: StudentServiceType[] | undefined;
    serviceSubTypes?: StudentServiceSubType[] | undefined;
    colleges?: College[] | undefined;
    schools?: School[] | undefined;
    languages?: LkLanguage[] | undefined;
    modalities?: LkModality[] | undefined;
    providers?: Provider[] | undefined;
    topics?: Topic[] | undefined;
    staffUsers?: User[] | undefined;
}

export interface StudentBulkUpdate {
    students?: Student[] | undefined;
    updateSchema?: StudentBulkUpdateSchema | undefined;
}

export interface StudentBulkUpdateSchema {
    updateGenderId: boolean;
    genderId?: number | undefined;
    updateCohortId: boolean;
    cohortId?: number | undefined;
    updatePermissionSlip: boolean;
    permissionSlip?: boolean | undefined;
    updateCollegeBound: boolean;
    collegeBound?: boolean | undefined;
    updateMentorProgram: boolean;
    mentorProgram?: boolean | undefined;
    updateAssignedUserId: boolean;
    assignedUserId?: number | undefined;
    updateRaceId: boolean;
    raceId?: number | undefined;
    updateEthnicityId: boolean;
    ethnicityId?: number | undefined;
    updateUsCitizen: boolean;
    usCitizen?: boolean | undefined;
    updateEnrollmentDate: boolean;
    enrollmentDate?: Date | undefined;
    updateFeederSchoolId: boolean;
    feederSchoolId?: number | undefined;
    updateGraduationYear: boolean;
    graduationYear?: number | undefined;
    updateMigrant: boolean;
    migrant?: boolean | undefined;
    updateSixYearsEsl: boolean;
    sixYearsEsl?: boolean | undefined;
    updateDualEnrollment: boolean;
    dualEnrollment?: boolean | undefined;
    updatePoverty: boolean;
    poverty?: boolean | undefined;
    updateFirstGeneration: boolean;
    firstGeneration?: boolean | undefined;
    updateNinthGradeYear: boolean;
    ninthGradeYear?: number | undefined;
    updateReferralTypeId: boolean;
    referralTypeId?: number | undefined;
    updateNoCollegeReasonId: boolean;
    noCollegeReasonId?: number | undefined;
    updateReasonForEnrollmentId: boolean;
    reasonForEnrollmentId?: number | undefined;
    updatePrimaryTransportationId: boolean;
    primaryTransportationId?: number | undefined;
    updateEligibilityId: boolean;
    eligibilityId?: number | undefined;
    updateAcademicNeedId: boolean;
    academicNeedId?: number | undefined;
    updateFamilyIncomeId: boolean;
    familyIncomeId?: number | undefined;
    updateState: boolean;
    state?: string | undefined;
    updateCity: boolean;
    city?: string | undefined;
    updatePostal: boolean;
    postal?: string | undefined;
    updateAtRiskStdTestId: boolean;
    atRiskStdTestId?: number | undefined;
    updateAtRiskAlgebraId: boolean;
    atRiskAlgebraId?: number | undefined;
    updateAtRiskLowGpaId: boolean;
    atRiskLowGpaId?: number | undefined;
    updateOtherNeedId: boolean;
    otherNeedId?: number | undefined;
    updateOtherSecondaryNeedId: boolean;
    otherSecondaryNeedId?: number | undefined;
    updateDisconnected: boolean;
    disconnected?: boolean | undefined;
}

export interface StudentBulkUpdateResource {
    properties?: ModelPropertyBase[] | undefined;
    variables?: TenantVariableStudent | undefined;
    displayFields?: LkStudentDisplayField[] | undefined;
    genders?: LkGender[] | undefined;
    races?: LkRace[] | undefined;
    ethnicities?: LkEthnicity[] | undefined;
    optInMethods?: LkOptInMethod[] | undefined;
    feederSchools?: FeederSchool[] | undefined;
    familyIncomes?: LkFamilyIncome[] | undefined;
    cohorts?: LkCohort[] | undefined;
    noCollegeReasons?: NoCollegeReason[] | undefined;
    referralTypes?: LkReferralType[] | undefined;
    reasonsForEnrollment?: LkReasonForEnrollment[] | undefined;
    primaryTransportations?: LkPrimaryTransportation[] | undefined;
    eligibilities?: LkEligibility[] | undefined;
    academicNeeds?: LkAcademicNeed[] | undefined;
    users?: User[] | undefined;
    atRiskLowGpas?: LkAtRiskLowGpa[] | undefined;
    atRiskStdTests?: LkAtRiskStdTest[] | undefined;
    atRiskAlgebras?: LkAtRiskAlgebra[] | undefined;
    otherNeeds?: LkOtherNeed[] | undefined;
}

export interface StudentBulkAssignGroup {
    students?: Student[] | undefined;
    isCreateNewGroup: boolean;
    createStudentGroup?: StudentGroup | undefined;
    existingGroupId?: number | undefined;
}

export interface StudentBulkAssignGroupResource {
    properties?: ModelPropertyBase[] | undefined;
    studentGroups?: StudentGroup[] | undefined;
    schools?: School[] | undefined;
}

export interface StudentCustomIdsRequest {
    customIdTypeId?: number | undefined;
    customIds?: string[] | undefined;
}

export interface StudentBulkEmail {
    emailModel?: EmailModel | undefined;
}

export interface StudentBulkMerge {
    students?: StudentBulkMergeStudent[] | undefined;
    mergeToStudentId?: number | undefined;
}

export interface StudentBulkMergeStudent {
    number: number;
    id: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    customId1?: string | undefined;
    dateOfBirth?: Date | undefined;
    enrollmentsCount: number;
    servicesCount: number;
    parentsCount: number;
    gradesCount: number;
    absencesCount: number;
    testsCount: number;
    gpaCount: number;
    diplomasCount: number;
    postHighSchoolsCount: number;
    fafsasCount: number;
    scholarshipsCount: number;
    applicationsCount: number;
    filesCount: number;
}

export interface StudentBulkMergeResource {
    studentProperties?: ModelPropertyBase[] | undefined;
    customId1Name?: string | undefined;
}

export interface StudentServiceIndexListDto {
    id: number;
    name?: string | undefined;
    serviceType?: string | undefined;
    isForParent: boolean;
    serviceSubType?: string | undefined;
    activity?: string | undefined;
    provider?: string | undefined;
    note?: string | undefined;
    duration?: string | undefined;
    serviceLocation?: string | undefined;
    serviceDescription?: string | undefined;
}

export interface StudentServiceIndexListFilter extends ListFilterBase {
    studentServiceIndexFilter?: StudentServiceIndexFilter | undefined;
}

export interface StudentServiceIndexFilter {
    serviceTypeId?: number | undefined;
    serviceSubTypeId?: number | undefined;
    isForParent?: boolean | undefined;
}

export interface StudentServiceIndexListResource {
    properties?: ListPropertyBase[] | undefined;
}

export interface StudentServiceIndexFilterResource {
    properties?: ModelPropertyBase[] | undefined;
    customFilterProperties?: ReportPropertyBase[] | undefined;
    serviceTypes?: StudentServiceType[] | undefined;
    serviceSubTypes?: StudentServiceSubType[] | undefined;
    providers?: Provider[] | undefined;
    serviceRecipients?: LkStudentServiceRecipient[] | undefined;
}

export interface StudentServiceIndex extends DataModel {
    activity: string;
    serviceTypeId?: number | undefined;
    serviceType?: StudentServiceType | undefined;
    serviceSubTypeId?: number | undefined;
    serviceSubType?: StudentServiceSubType | undefined;
    name?: string | undefined;
    duration?: string | undefined;
    providerId?: number | undefined;
    provider?: Provider | undefined;
    modality?: string | undefined;
    serviceLocation?: string | undefined;
    serviceDescription?: string | undefined;
    note?: string | undefined;
}

export interface StudentServiceIndexViewResource {
    properties?: ModelPropertyBase[] | undefined;
    serviceTypes?: StudentServiceType[] | undefined;
    serviceSubTypes?: StudentServiceSubType[] | undefined;
}

export interface StudentServiceIndexEditResource {
    providers?: Provider[] | undefined;
}

export interface StudentServiceTemplateListDto {
    id: number;
    date?: Date | undefined;
    createdDate?: Date | undefined;
    serviceName?: string | undefined;
    isForParent: boolean;
    serviceType?: string | undefined;
    serviceSubType?: string | undefined;
    durationInMinutes?: number | undefined;
    school?: string | undefined;
    additionalServices?: string | undefined;
    colleges?: string[] | undefined;
    isServiceLocationForCollege: boolean;
    isLocked: boolean;
}

export interface StudentServiceTemplateListFilter extends ListFilterBase {
    groupFilter?: StudentServiceTemplateFilter | undefined;
}

export interface StudentServiceTemplateFilter {
    customFilters?: CustomFilter[] | undefined;
    serviceTypes?: number[] | undefined;
    serviceSubTypes?: number[] | undefined;
    serviceLocations?: number[] | undefined;
    isActive?: boolean | undefined;
}

export interface StudentServiceTemplateFilterResource {
    properties?: ModelPropertyBase[] | undefined;
    studentServiceTypes?: StudentServiceType[] | undefined;
    studentServiceSubTypes?: StudentServiceSubType[] | undefined;
    serviceLocations?: College[] | undefined;
    customFilterProperties?: CustomReportProperty[] | undefined;
}

export interface StudentServiceTemplateListResource {
    properties?: ListPropertyBase[] | undefined;
}

export interface StudentServiceTemplate extends DataModel {
    generalValidationErrors?: string | undefined;
    serviceTypeId: number;
    serviceType?: StudentServiceType | undefined;
    serviceSubTypeId?: number | undefined;
    serviceSubType?: StudentServiceSubType | undefined;
    additionalStudentServiceTypes?: string | undefined;
    name?: string | undefined;
    date?: Date | undefined;
    durationInMinutes?: number | undefined;
    schoolId?: number | undefined;
    school?: School | undefined;
    providers?: Provider[] | undefined;
    colleges?: College[] | undefined;
    modalityId?: number | undefined;
    modality?: LkModality | undefined;
    languageId?: number | undefined;
    language?: LkLanguage | undefined;
    parentCount?: number | undefined;
    note?: string | undefined;
    services?: StudentService[] | undefined;
    validationToken?: string | undefined;
    qrCodeUploadFileId?: number | undefined;
    qrCodeUploadFile?: UploadFile | undefined;
    newQrCodeUploadFileId?: number | undefined;
    newQrCodeUploadFile?: UploadFile | undefined;
    requireSignature: boolean;
    enableAdditionalServiceSelect: boolean;
    isActive: boolean;
    isService: boolean;
    referral: boolean;
    topics?: Topic[] | undefined;
    referralTopics?: Topic[] | undefined;
    createAdditionalEntries?: StudentServiceTemplateAdditionalEntry[] | undefined;
}

export interface StudentServiceTemplateAdditionalEntry {
    generalValidationErrors?: string | undefined;
    serviceTypeId: number;
    serviceSubTypeId?: number | undefined;
    parentCount?: number | undefined;
    durationInMinutes?: number | undefined;
    schoolId?: number | undefined;
    colleges?: College[] | undefined;
}

export interface StudentServicePartialStudent extends DataModel {
    studentServivceTemplateId: number;
    studentServiceTemplate?: StudentServiceTemplate | undefined;
    studentId?: number | undefined;
    student?: Student | undefined;
    studentName?: string | undefined;
    dateOfBirth: Date;
    endTime?: string | undefined;
    startTime: string;
    studentSignatureUploadFileId?: number | undefined;
    studentSignatureUploadFile?: UploadFile | undefined;
    additionalServices?: string | undefined;
}

export interface StudentServiceTemplateAttendee {
    label?: string | undefined;
    date: Date;
    studentServices?: StudentServiceAttendee[] | undefined;
}

export interface StudentServiceAttendee {
    date: Date;
    studentName?: string | undefined;
    partialStudentId?: number | undefined;
    customId?: string | undefined;
    startTime?: string | undefined;
    endTime?: string | undefined;
    servicesAttended?: string | undefined;
    durationInMinutes?: number | undefined;
    isPartial: boolean;
}

export interface StudentServiceTemplateViewResource {
    properties?: ModelPropertyBase[] | undefined;
    displayFields?: LkStudentServiceDisplayField[] | undefined;
    serviceTypes?: StudentServiceType[] | undefined;
    customIdTypes?: StudentCustomIdType[] | undefined;
    qrCodeUrl?: string | undefined;
    canAccessAiFeature: boolean;
}

export interface StudentServiceTemplateEditResource {
    colleges?: College[] | undefined;
    serviceSubTypes?: StudentServiceSubType[] | undefined;
    schools?: School[] | undefined;
    languages?: LkLanguage[] | undefined;
    modalities?: LkModality[] | undefined;
    providers?: Provider[] | undefined;
    topics?: Topic[] | undefined;
}

export interface StudentServiceAddAttendeeResponse {
    addedAttendees?: number[] | undefined;
    erroredAttendees?: { [key: string]: string; }[] | undefined;
}

export interface StudentServiceAddAttendeeRequest {
    attendees?: AiProcessedAttendee[] | undefined;
    serviceDate: Date;
    studentServiceTemplateId: number;
}

export interface StudentServiceTemplateLinkExisting {
    existingStudentId: number;
    studentServicePartialStudentId: number;
}

export interface StudentServiceTemplateSignUpRequest {
    tenantName?: string | undefined;
    studentServiceTemplateId: number;
    validationToken?: string | undefined;
    date?: Date | undefined;
    serviceName?: string | undefined;
    serviceType?: string | undefined;
    serviceSubType?: string | undefined;
    providers?: string[] | undefined;
    isSignedIn: boolean;
    isPartialStudent: boolean;
    requireSignature: boolean;
    isActive: boolean;
    signatureData?: string | undefined;
    additionalServices?: string[] | undefined;
    additionalServiceSpecificIndex?: number[] | undefined;
    isForParent: boolean;
    parentCount?: number | undefined;
    durationInMinutes?: number | undefined;
    studentId?: string | undefined;
    studentFirstName?: string | undefined;
    studentLastName?: string | undefined;
    studentDOB?: Date | undefined;
}

export interface StudentServiceTemplateSignUpResource {
    properties?: ModelPropertyBase[] | undefined;
    customIdTypes?: StudentCustomIdType[] | undefined;
}

export interface StudentServiceTemplateSignUpConfirmation {
    isSignedIn: boolean;
    student?: Student | undefined;
    additionalServiceSpecificIndex?: number[] | undefined;
}

export interface StudentTestListDto {
    id: number;
    schoolYear?: number | undefined;
    testDate?: Date | undefined;
    testType?: string | undefined;
    testTypeDisplayOrder?: number | undefined;
    score?: number | undefined;
    testLevel?: string | undefined;
    testLevelDisplayOrder?: number | undefined;
}

export interface StudentTestListFilter extends ListFilterBase {
    testFilter?: StudentTestFilter | undefined;
}

export interface StudentTestFilter {
    schoolYear?: number | undefined;
    studentId?: number | undefined;
}

export interface StudentTestListResource {
    properties?: ListPropertyBase[] | undefined;
}

export interface StudentTestViewResource {
    properties?: ModelPropertyBase[] | undefined;
    displayFields?: LkStudentTestDisplayField[] | undefined;
}

export interface LkStudentTestDisplayField extends LookUp {
    displayName?: string | undefined;
}

export interface StudentTestEditResource {
    schoolYears?: SimpleDto[] | undefined;
    testTypes?: TestType[] | undefined;
    testLevels?: TestLevel[] | undefined;
    languages?: LkLanguage[] | undefined;
}

export interface ContributorMatchServiceListDto {
    id: number;
    name?: string | undefined;
    displayOrder?: number | undefined;
}

export interface ContributorMatchServiceListResource {
    properties?: ListPropertyBase[] | undefined;
}

export interface ContributorMatchService extends DataModel {
    isInUse: boolean;
    name: string;
}

export interface ContributorMatchServiceViewResource {
    properties?: ModelPropertyBase[] | undefined;
}

export interface PartnerIndirectCostListDto {
    id: number;
    partner?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    mileage?: number | undefined;
    indirectPercent?: number | undefined;
}

export interface PartnerIndirectCostListFilter extends ListFilterBase {
    indirectCostFilter?: PartnerIndirectCostFilter | undefined;
}

export interface PartnerIndirectCostFilter {
    partnerId?: number | undefined;
}

export interface PartnerIndirectCostViewResource {
    properties?: ModelPropertyBase[] | undefined;
}

export interface PartnerIndirectCostListResource {
    properties?: ListPropertyBase[] | undefined;
}

export interface SubPartnerListDto {
    id: number;
    name?: string | undefined;
    contact?: string | undefined;
    phone?: string | undefined;
    fax?: string | undefined;
    address?: Address | undefined;
}

export interface SubPartnerListFilter extends ListFilterBase {
    subPartnerFilter?: SubPartnerFilter | undefined;
}

export interface SubPartnerFilter {
    partnerId?: number | undefined;
}

export interface SubPartnerViewResource {
    properties?: ModelPropertyBase[] | undefined;
}

export interface SubPartnerListResource {
    properties?: ListPropertyBase[] | undefined;
}

export interface SuppliesDetailListDto {
    id: number;
    name?: string | undefined;
    displayOrder?: number | undefined;
}

export interface SuppliesDetailListResource {
    properties?: ListPropertyBase[] | undefined;
}

export interface SuppliesDetail extends DataModel {
    isInUse: boolean;
    name: string;
}

export interface SuppliesDetailViewResource {
    properties?: ModelPropertyBase[] | undefined;
}

export interface CollegeListDto {
    id: number;
    name?: string | undefined;
    ipeds?: number | undefined;
}

export interface CollegeListResource {
    properties?: ListPropertyBase[] | undefined;
}

export interface CollegeViewResource {
    properties?: ModelPropertyBase[] | undefined;
}

export interface CollegeEditResource {
    ipeds?: LkIpeds[] | undefined;
}

export interface DisciplineListDto {
    id: number;
    name?: string | undefined;
}

export interface DisciplineListFilter extends ListFilterBase {
}

export interface DisciplineListResource {
    properties?: ListPropertyBase[] | undefined;
}

export interface DisciplineViewResource {
    properties?: ModelPropertyBase[] | undefined;
}

export interface DisciplineEditResource {
    properties?: ModelPropertyBase[] | undefined;
}

export interface DistrictListDto {
    id: number;
    name?: string | undefined;
    schools?: string[] | undefined;
}

export interface DistrictListResource {
    properties?: ListPropertyBase[] | undefined;
}

export interface DistrictViewResource {
    properties?: ModelPropertyBase[] | undefined;
}

export interface DistrictEditResource {
    schools?: School[] | undefined;
}

export interface EndReasonListDto {
    id: number;
    name?: string | undefined;
    endReasonType?: string | undefined;
    endReasonTypeDisplayOrder?: number | undefined;
    displayOrder?: number | undefined;
}

export interface EndReasonListResource {
    properties?: ListPropertyBase[] | undefined;
}

export interface EndReasonViewResource {
    properties?: ModelPropertyBase[] | undefined;
}

export interface EndReasonEditResource {
    endReasonTypes?: LkEndReasonType[] | undefined;
}

export interface FeederSchoolListDto {
    id: number;
    name?: string | undefined;
}

export interface FeederSchoolListResource {
    properties?: ListPropertyBase[] | undefined;
}

export interface FeederSchoolViewResource {
    properties?: ModelPropertyBase[] | undefined;
}

export interface FeederSchoolEditResource {
    properties?: ModelPropertyBase[] | undefined;
}

export interface FileCategoryListDto {
    id: number;
    name?: string | undefined;
}

export interface GradeListDto {
    id: number;
    name?: string | undefined;
    passing: boolean;
    atRisk: boolean;
    displayOrder?: number | undefined;
}

export interface GradeListResource {
    properties?: ListPropertyBase[] | undefined;
}

export interface GradeViewResource {
    properties?: ModelPropertyBase[] | undefined;
}

export interface SchoolListDto {
    id: number;
    name?: string | undefined;
    schoolType?: string | undefined;
    schoolTypeDisplayOrder?: number | undefined;
    nces?: string | undefined;
    schoolCode?: string | undefined;
    serviceLocationOnly: boolean;
    inactive: boolean;
}

export interface SchoolListFilter extends ListFilterBase {
    schoolFilter?: SchoolFilter | undefined;
}

export interface SchoolFilter {
    inactive?: boolean | undefined;
}

export interface SchoolListResource {
    properties?: ListPropertyBase[] | undefined;
}

export interface SchoolFilterResource {
    properties?: ModelPropertyBase[] | undefined;
}

export interface SchoolViewResource {
    properties?: ModelPropertyBase[] | undefined;
}

export interface SchoolEditResource {
    schoolTypes?: LkSchoolType[] | undefined;
    termTypes?: LkTermType[] | undefined;
    gradeLevels?: LkGradeLevel[] | undefined;
    contacts?: User[] | undefined;
}

export interface StaffServiceTypeListDto {
    id: number;
    name?: string | undefined;
    school?: string | undefined;
    schoolDisplayOrder?: number | undefined;
    inactive: boolean;
}

export interface StaffServiceTypeListFilter extends ListFilterBase {
    serviceTypeFilter?: StaffServiceTypeFilter | undefined;
}

export interface StaffServiceTypeFilter {
    schoolId?: number | undefined;
    inactive?: boolean | undefined;
}

export interface StaffServiceTypeListResource {
    properties?: ListPropertyBase[] | undefined;
}

export interface StaffServiceTypeFilterResource {
    properties?: ModelPropertyBase[] | undefined;
    schools?: School[] | undefined;
}

export interface StaffServiceTypeViewResource {
    properties?: ModelPropertyBase[] | undefined;
}

export interface StaffServiceTypeEditResource {
    schools?: School[] | undefined;
}

export interface StudentServiceSubTypeViewResource {
    properties?: ModelPropertyBase[] | undefined;
}

export interface StudentServiceSubTypeEditResource {
    ccrecServiceSubTypes?: LkCcrecStudentServiceSubType[] | undefined;
}

export interface StudentServiceTypeListDto {
    id: number;
    name?: string | undefined;
    aprStudentService?: string | undefined;
    aprStudentServiceDisplayOrder?: number | undefined;
    schools?: string[] | undefined;
    isForParent: boolean;
    subTypesCount: number;
    inactive: boolean;
}

export interface StudentServiceTypeListFilter extends ListFilterBase {
    serviceTypeFilter?: StudentServiceTypeFilter | undefined;
}

export interface StudentServiceTypeFilter {
    schoolId?: number | undefined;
    isForParent?: boolean | undefined;
    inactive?: boolean | undefined;
}

export interface StudentServiceTypeListResource {
    properties?: ListPropertyBase[] | undefined;
}

export interface StudentServiceTypeFilterResource {
    properties?: ModelPropertyBase[] | undefined;
    schools?: School[] | undefined;
}

export interface StudentServiceTypeViewResource {
    properties?: ModelPropertyBase[] | undefined;
}

export interface StudentServiceTypeEditResource {
    aprStudentServices?: LkAprStudentService[] | undefined;
    apr2StudentServices?: LkApr2StudentService[] | undefined;
    aprCategories?: LkAprCategory[] | undefined;
    ccrecServiceTypes?: LkCcrecStudentServiceType[] | undefined;
    schools?: School[] | undefined;
}

export interface TestLevelListDto {
    id: number;
    name?: string | undefined;
    testType?: string | undefined;
    proficiency?: string | undefined;
}

export interface TestLevelListFilter extends ListFilterBase {
    testLevelFilter?: TestLevelFilter | undefined;
}

export interface TestLevelFilter {
    id?: number | undefined;
    testLevelGroupId?: number | undefined;
}

export interface TestLevelListResource {
    properties?: ListPropertyBase[] | undefined;
}

export interface TestLevelFilterResource {
    properties?: ModelPropertyBase[] | undefined;
    testTypeGroups?: LkTestTypeGroup[] | undefined;
}

export interface TestLevelViewResource {
    properties?: ModelPropertyBase[] | undefined;
}

export interface TestLevelEditResource {
    testTypes?: TestType[] | undefined;
    proficiencies?: LkProficiency[] | undefined;
}

export interface TestTypeListDto {
    id: number;
    testType?: string | undefined;
    testTypeGroup?: string | undefined;
    aprCategory?: string | undefined;
}

export interface TestTypeListFilter extends ListFilterBase {
    testTypeFilter?: TestTypeFilter | undefined;
}

export interface TestTypeFilter {
    id?: number | undefined;
    testTypeGroupId?: number | undefined;
    testLevelGroupId?: number | undefined;
}

export interface TestTypeListResource {
    properties?: ListPropertyBase[] | undefined;
}

export interface TestTypeFilterResource {
    properties?: ModelPropertyBase[] | undefined;
    testTypeGroups?: LkTestTypeGroup[] | undefined;
}

export interface TestTypeViewResource {
    properties?: ModelPropertyBase[] | undefined;
}

export interface TestTypeEditResource {
    testTypeGroups?: LkTestTypeGroup[] | undefined;
    aprCategories?: LkAprCategory[] | undefined;
}

export interface ContributorListDto {
    id: number;
    employeeIdentification?: string | undefined;
    fullName?: string | undefined;
    currentTitle?: string | undefined;
    federal: boolean;
    currentPartner?: string | undefined;
    currentSubPartner?: string | undefined;
}

export interface ContributorListFilter extends ListFilterBase {
    contributorFilter?: ContributorFilter | undefined;
}

export interface ContributorFilter {
    customFilters?: CustomFilter[] | undefined;
    partnerId?: number | undefined;
    subPartnerId?: number | undefined;
    active?: boolean | undefined;
}

export interface ContributorListResource {
    properties?: ListPropertyBase[] | undefined;
}

export interface ContributorFilterResource {
    properties?: ModelPropertyBase[] | undefined;
    customFilterProperties?: CustomReportProperty[] | undefined;
    partners?: Partner[] | undefined;
    subPartners?: SubPartner[] | undefined;
}

export interface ContributorViewResource {
    properties?: ModelPropertyBase[] | undefined;
    currentTitle?: string | undefined;
    currentPartner?: string | undefined;
    currentSubPartner?: string | undefined;
    employmentsTotal?: number | undefined;
    matchesTotal?: number | undefined;
}

export interface ContributorEditResource {
    partners?: Partner[] | undefined;
    subPartners?: SubPartner[] | undefined;
    contributorEmployments?: ContributorEmployment[] | undefined;
    contributorMatchServices?: ContributorMatchService[] | undefined;
    matchStaticEndDate?: Date | undefined;
    matchReviews?: LkMatchReview[] | undefined;
    newContributorMatchPrototype?: ContributorMatch | undefined;
}

export interface LkMatchReview extends LookUp {
}

export interface ContributorMatch extends DataModel {
    generalValidationErrors?: string | undefined;
    contributorId: number;
    contributor?: Contributor | undefined;
    isCreatingBulk: boolean;
    date: Date;
    creatingBulkDates?: Date[] | undefined;
    serviceId: number;
    service?: ContributorMatchService | undefined;
    contributorEmploymentId?: number | undefined;
    contributorEmployment?: ContributorEmployment | undefined;
    durationInMinutes?: number | undefined;
    isMatch: boolean;
    note?: string | undefined;
    salary?: number | undefined;
    supplies?: number | undefined;
    miles?: number | undefined;
    suppliesDetailId?: number | undefined;
    suppliesDetail?: SuppliesDetail | undefined;
    consultant?: number | undefined;
    scholarship?: number | undefined;
    other?: number | undefined;
    otherDescription?: string | undefined;
    reviewId: number;
    review?: LkMatchReview | undefined;
    staffId?: number | undefined;
    staff?: User | undefined;
    files?: ContributorMatchFile[] | undefined;
    hourlySalary?: number | undefined;
    amount?: number | undefined;
    benefitAmount?: number | undefined;
    medicalBenefitAmount?: number | undefined;
    subTotalAmount?: number | undefined;
    totalAmount?: number | undefined;
    milesAmount?: number | undefined;
    indirectCostAmount?: number | undefined;
    indirectPercent?: number | undefined;
    correspondingPartnerId?: number | undefined;
    correspondingSubPartnerId?: number | undefined;
    isBeforeMatchStaticEndDate: boolean;
    oldHourlySalary?: number | undefined;
    oldAmount?: number | undefined;
    oldBenefitAmount?: number | undefined;
    oldTotalAmount?: number | undefined;
    oldIndirectCostAmount?: number | undefined;
    oldMilesAmount?: number | undefined;
    oldIndirectPercent?: number | undefined;
    isOldMatchData: boolean;
}

export interface ContributorMatchFile extends DataModel {
    contributorMatchId: number;
    uploadFileId?: number | undefined;
    uploadFile: UploadFile;
}

export interface ContributorBulkCreateMatches {
    contributors?: Contributor[] | undefined;
    match?: ContributorMatch | undefined;
}

export interface ContributorBulkMerge {
    contributors?: ContributorBulkMergeContributor[] | undefined;
    employments?: ContributorBulkMergeEmployment[] | undefined;
    mergeToContributorId?: number | undefined;
}

export interface ContributorBulkMergeContributor {
    number: number;
    id: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    employmentsCount: number;
    matchesCount: number;
    nonPersonnelsCount: number;
}

export interface ContributorBulkMergeEmployment {
    number: number;
    id: number;
    partner?: string | undefined;
    subPartner?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    hourlySalary?: number | undefined;
    usedByContributorMatches: number;
    keeping: boolean;
    assignMatchesToEmploymentId?: number | undefined;
}

export interface ContributorBulkMergeResource {
    contributorProperties?: ModelPropertyBase[] | undefined;
    employmentProperties?: ModelPropertyBase[] | undefined;
}

export interface ContributorMatchListDto {
    id: number;
    date?: Date | undefined;
    service?: string | undefined;
    serviceDisplayOrder?: number | undefined;
    contributor?: string | undefined;
    durationInMinutes?: number | undefined;
    amount?: number | undefined;
    benefitAmount?: number | undefined;
    medicalAmount?: number | undefined;
    files: number;
    isBeforeMatchStaticEndDate: boolean;
    isLocked: boolean;
}

export interface ContributorMatchListFilter extends ListFilterBase {
    matchFilter?: ContributorMatchFilter | undefined;
}

export interface ContributorMatchFilter {
    customFilters?: CustomFilter[] | undefined;
    contributorId?: number | undefined;
    contributor?: Contributor | undefined;
    dateFrom?: Date | undefined;
    dateTo?: Date | undefined;
    reviewId?: number | undefined;
    serviceId?: number | undefined;
    partnerIds?: number[] | undefined;
    subPartnerIds?: number[] | undefined;
    isMatch?: boolean | undefined;
    hasFile?: boolean | undefined;
}

export interface ContributorMatchListResource {
    properties?: ListPropertyBase[] | undefined;
}

export interface ContributorMatchFilterResource {
    properties?: ModelPropertyBase[] | undefined;
    customFilterProperties?: CustomReportProperty[] | undefined;
    reviews?: LkMatchReview[] | undefined;
    partners?: Partner[] | undefined;
    subPartners?: SubPartner[] | undefined;
    services?: ContributorMatchService[] | undefined;
}

export interface ContributorMatchViewResource {
    properties?: ModelPropertyBase[] | undefined;
}

export interface ContributorMatchEditResource {
    services?: ContributorMatchService[] | undefined;
    matchStaticEndDate?: Date | undefined;
    matchReviews?: LkMatchReview[] | undefined;
    staffs?: User[] | undefined;
    newContributorMatchPrototype?: ContributorMatch | undefined;
    canEditReview: boolean;
    canSendUnallowableEmail: boolean;
    createdByUserEmail: boolean;
}

export interface ContributorMatchBulkUpdate {
    matches?: ContributorMatch[] | undefined;
    updateSchema?: ContributorMatchBulkUpdateSchema | undefined;
}

export interface ContributorMatchBulkUpdateSchema {
    updateServiceId: boolean;
    serviceId?: number | undefined;
    updateDate: boolean;
    date?: Date | undefined;
    updateStartTime: boolean;
    startTime?: string | undefined;
    updateEndTime: boolean;
    endTime?: string | undefined;
    updateDurationInMinutes: boolean;
    durationInMinutes?: number | undefined;
    creatingFiles?: UploadFile[] | undefined;
}

export interface ContributorMatchBulkUpdateResource {
    properties?: ModelPropertyBase[] | undefined;
    services?: ContributorMatchService[] | undefined;
}

export interface NonPersonnelListDto {
    id: number;
    date?: Date | undefined;
    partner?: string | undefined;
    partnerDisplayOrder?: number | undefined;
    subPartner?: string | undefined;
    subPartnerDisplayOrder?: number | undefined;
    totalAmount?: number | undefined;
    files: number;
    isBeforeMatchStaticEndDate: boolean;
    isLocked: boolean;
}

export interface NonPersonnelListFilter extends ListFilterBase {
    nonPersonnelFilter?: NonPersonnelFilter | undefined;
}

export interface NonPersonnelFilter {
    customFilters?: CustomFilter[] | undefined;
    dateFrom?: Date | undefined;
    dateTo?: Date | undefined;
    partnerIds?: number[] | undefined;
    subPartnerIds?: number[] | undefined;
    partnerId?: number | undefined;
    subPartnerId?: number | undefined;
    contributorId?: number | undefined;
    reviewId?: number | undefined;
    isMatch?: boolean | undefined;
    hasFile?: boolean | undefined;
}

export interface NonPersonnelListResource {
    properties?: ListPropertyBase[] | undefined;
}

export interface NonPersonnelFilterResource {
    properties?: ModelPropertyBase[] | undefined;
    customFilterProperties?: CustomReportProperty[] | undefined;
    partners?: Partner[] | undefined;
    subPartners?: SubPartner[] | undefined;
    matchReviews?: LkMatchReview[] | undefined;
}

export interface NonPersonnel extends DataModel {
    date: Date;
    isMatch: boolean;
    partnerId: number;
    partner?: Partner | undefined;
    subPartnerId?: number | undefined;
    subPartner?: SubPartner | undefined;
    contributorId?: number | undefined;
    contributor?: Contributor | undefined;
    salary?: number | undefined;
    benefit?: number | undefined;
    travel?: number | undefined;
    equipment?: number | undefined;
    supplies?: number | undefined;
    consultant?: number | undefined;
    scholarship?: number | undefined;
    other?: number | undefined;
    annualSalary?: number | undefined;
    annualPercent?: number | undefined;
    isBeforeMatchStaticEndDate: boolean;
    indirectPercent?: number | undefined;
    indirectCostAmount?: number | undefined;
    totalAmount?: number | undefined;
    fileCount?: number | undefined;
    oldIndirectCostAmount?: number | undefined;
    oldIndirectPercent?: number | undefined;
    suppliesDetailId?: number | undefined;
    suppliesDetail?: SuppliesDetail | undefined;
    reviewId: number;
    review?: LkMatchReview | undefined;
    otherDescription?: string | undefined;
    staffId?: number | undefined;
    staff?: User | undefined;
    note?: string | undefined;
    files?: NonPersonnelFile[] | undefined;
}

export interface NonPersonnelFile extends DataModel {
    nonPersonnelId: number;
    uploadFileId?: number | undefined;
    uploadFile: UploadFile;
}

export interface NonPersonnelViewResource {
    properties?: ModelPropertyBase[] | undefined;
    subPartners?: SubPartner[] | undefined;
}

export interface NonPersonnelEditResource {
    partners?: Partner[] | undefined;
    matchReviews?: LkMatchReview[] | undefined;
    suppliesDetails?: SuppliesDetail[] | undefined;
    staffs?: User[] | undefined;
}

export interface MatchReportActualMatchResource {
    filterProperties?: ModelPropertyBase[] | undefined;
    aprSchoolYears?: MatchReportActualMatchFilterAprSchoolYear[] | undefined;
    matchReviews?: LkMatchReview[] | undefined;
}

export interface MatchReportActualMatchFilterAprSchoolYear {
    name?: string | undefined;
    dateFrom?: Date | undefined;
    dateTo?: Date | undefined;
}

export interface MatchReportActualMatch {
    tenantName?: string | undefined;
    dateFrom?: Date | undefined;
    dateTo?: Date | undefined;
    reviewName?: string | undefined;
    rows?: MatchReportActualMatchRow[] | undefined;
}

export interface MatchReportActualMatchRow {
    name?: string | undefined;
    amount: number;
    isBold: boolean;
}

export interface MatchReportActualMatchFilter {
    aprSchoolYear: MatchReportActualMatchFilterAprSchoolYear;
    dateFrom: Date;
    dateTo: Date;
    reviewId?: number | undefined;
    isMatch?: boolean | undefined;
}

export interface MatchReportActualYearlyResource {
    filterProperties?: ModelPropertyBase[] | undefined;
    matchReviews?: LkMatchReview[] | undefined;
    defaultDateFrom?: Date | undefined;
    defaultDateTo?: Date | undefined;
}

export interface MatchReportActualYearly {
    tenantName?: string | undefined;
    dateFrom?: Date | undefined;
    dateTo?: Date | undefined;
    reviewName?: string | undefined;
    reportProperties?: ReportPropertyBase[] | undefined;
    rows?: MatchReportActualYearlyRow[] | undefined;
    grandTotal: number;
}

export interface MatchReportActualYearlyRow {
    index?: string | undefined;
    dateFrom?: Date | undefined;
    dateTo?: Date | undefined;
    total: number;
}

export interface MatchReportActualYearlyFilter {
    dateFrom: Date;
    dateTo: Date;
    reviewId?: number | undefined;
    isMatch?: boolean | undefined;
}

export interface MatchReportAllPartnersResource {
    filterProperties?: ModelPropertyBase[] | undefined;
    matchReviews?: LkMatchReview[] | undefined;
}

export interface MatchReportAllPartners {
    reportProperties?: ReportPropertyBase[] | undefined;
    tenantName?: string | undefined;
    dateFrom?: Date | undefined;
    dateTo?: Date | undefined;
    reviewName?: string | undefined;
    grandTotal: number;
    reportResultRows?: MatchReportAllPartnersResultRow[] | undefined;
}

export interface MatchReportAllPartnersResultRow {
    partnerId: number;
    partnerName?: string | undefined;
    amountSum: number;
    benefitSum: number;
    travelSum: number;
    equipmentSum: number;
    suppliesSum: number;
    consultantSum: number;
    scholarshipSum: number;
    otherSum: number;
    totalDirectCost: number;
    totalIndirectCost: number;
    total: number;
}

export interface MatchReportAllPartnersFilter {
    dateFrom: Date;
    dateTo: Date;
    reviewId?: number | undefined;
    isMatch?: boolean | undefined;
    showPartnersWithoutData: boolean;
}

export interface MatchReportContributorResource {
    filterProperties?: ModelPropertyBase[] | undefined;
    partners?: Partner[] | undefined;
    subPartners?: SubPartner[] | undefined;
    matchReviews?: LkMatchReview[] | undefined;
}

export interface MatchReportContributor {
    tenantName?: string | undefined;
    dateFrom?: Date | undefined;
    dateTo?: Date | undefined;
    reviewName?: string | undefined;
    contributorRows?: MatchReportContributorRow[] | undefined;
}

export interface MatchReportContributorRow {
    contributor?: Contributor | undefined;
    partner?: Partner | undefined;
    subPartner?: SubPartner | undefined;
    milesAmountSum: number;
    benefitAmountSum: number;
    amountSum: number;
    totalDirectCost: number;
    totalIndirectCost: number;
    total: number;
}

export interface MatchReportContributorFilter {
    dateFrom: Date;
    dateTo: Date;
    contributorId?: number | undefined;
    contributor?: Contributor | undefined;
    partnerIds?: number[] | undefined;
    subPartnerIds?: number[] | undefined;
    reviewId?: number | undefined;
    isMatch?: boolean | undefined;
}

export interface MatchReportContributorDetailResource {
    filterProperties?: ModelPropertyBase[] | undefined;
    partners?: Partner[] | undefined;
    subPartners?: SubPartner[] | undefined;
    matchReviews?: LkMatchReview[] | undefined;
}

export interface MatchReportContributorDetail {
    reportProperties?: ReportPropertyBase[] | undefined;
    tenantName?: string | undefined;
    contributorDetailRows?: MatchReportContributorDetailRow[] | undefined;
    partners?: Partner[] | undefined;
    subPartners?: SubPartner[] | undefined;
    reviewName?: string | undefined;
    dateFrom?: Date | undefined;
    dateTo?: Date | undefined;
    grandTotal: number;
}

export interface MatchReportContributorDetailRow {
    id: number;
    fullName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    title?: string | undefined;
    partnerName?: string | undefined;
    employeeIdentification?: string | undefined;
    date?: Date | undefined;
    hourlySalary?: number | undefined;
    durationInMinutesSum: number;
    amountSum: number;
    milesAmountSum: number;
    benefitAmountSum: number;
    total: number;
    fileCountSum: number;
    contributorMatchAndNonPersonnelNotes?: string | undefined;
}

export interface MatchReportContributorDetailFilter {
    dateFrom: Date;
    dateTo: Date;
    contributorId?: number | undefined;
    contributor?: Contributor | undefined;
    partnerIds?: number[] | undefined;
    subPartnerIds?: number[] | undefined;
    reviewId?: number | undefined;
    isMatch?: boolean | undefined;
}

export interface MatchReportContributorSummaryResource {
    filterProperties?: ModelPropertyBase[] | undefined;
    partners?: Partner[] | undefined;
    subPartners?: SubPartner[] | undefined;
    matchReviews?: LkMatchReview[] | undefined;
}

export interface MatchReportContributorSummary {
    reportProperties?: ReportPropertyBase[] | undefined;
    tenantName?: string | undefined;
    contributorRows?: MatchReportContributorSummaryRow[] | undefined;
    partners?: Partner[] | undefined;
    subPartners?: SubPartner[] | undefined;
    reviewName?: string | undefined;
    dateFrom?: Date | undefined;
    dateTo?: Date | undefined;
    grandTotal: number;
}

export interface MatchReportContributorSummaryRow {
    id: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    title?: string | undefined;
    employeeIdentification?: string | undefined;
    dateFrom?: Date | undefined;
    dateTo?: Date | undefined;
    hourlySalary?: number | undefined;
    durationInMinutesSum: number;
    amountSum: number;
    milesAmountSum: number;
    benefitAmountSum: number;
    total: number;
}

export interface MatchReportContributorSummaryFilter {
    dateFrom: Date;
    dateTo: Date;
    contributorId?: number | undefined;
    contributor?: Contributor | undefined;
    partnerIds?: number[] | undefined;
    subPartnerIds?: number[] | undefined;
    reviewId?: number | undefined;
    isMatch?: boolean | undefined;
}

export interface MatchReportNonPersonnelDetailResource {
    filterProperties?: ModelPropertyBase[] | undefined;
    partners?: Partner[] | undefined;
    subPartners?: SubPartner[] | undefined;
    matchReviews?: LkMatchReview[] | undefined;
}

export interface MatchReportNonPersonnelDetail {
    reportProperties?: ReportPropertyBase[] | undefined;
    tenantName?: string | undefined;
    rows?: MatchReportNonPersonnelDetailRow[] | undefined;
    dateFrom?: Date | undefined;
    dateTo?: Date | undefined;
    reviewName?: string | undefined;
}

export interface MatchReportNonPersonnelDetailRow {
    partner?: string | undefined;
    subPartner?: string | undefined;
    salary?: number | undefined;
    benefit?: number | undefined;
    travel?: number | undefined;
    equipment?: number | undefined;
    supplies?: number | undefined;
    scholarship?: number | undefined;
    consultant?: number | undefined;
    other?: number | undefined;
    otherDescription?: string | undefined;
    date?: Date | undefined;
    note?: string | undefined;
}

export interface MatchReportNonPersonnelDetailFilter {
    dateFrom: Date;
    dateTo: Date;
    partnerIds?: number[] | undefined;
    subPartnerIds?: number[] | undefined;
    reviewId?: number | undefined;
    isMatch?: boolean | undefined;
}

export interface MatchReportPartnerResource {
    filterProperties?: ModelPropertyBase[] | undefined;
    partners?: Partner[] | undefined;
    subPartners?: SubPartner[] | undefined;
    matchReviews?: LkMatchReview[] | undefined;
}

export interface MatchReportPartner {
    tenantName?: string | undefined;
    partnerRows?: MatchReportPartnerRow[] | undefined;
    dateFrom?: Date | undefined;
    dateTo?: Date | undefined;
    reviewName?: string | undefined;
}

export interface MatchReportPartnerRow {
    partner?: Partner | undefined;
    subPartner?: SubPartner | undefined;
    amountSum: number;
    benefitSum: number;
    travelSum: number;
    equipmentSum: number;
    suppliesSum: number;
    consultantSum: number;
    scholarshipSum: number;
    otherSum: number;
    totalDirectCost: number;
    totalIndirectCost: number;
    total: number;
}

export interface MatchReportPartnerFilter {
    dateFrom: Date;
    dateTo: Date;
    contributorId?: number | undefined;
    contributor?: Contributor | undefined;
    partnerIds?: number[] | undefined;
    subPartnerIds?: number[] | undefined;
    reviewId?: number | undefined;
    isMatch?: boolean | undefined;
}

export interface MatchReportTimeCardResource {
    filterProperties?: ModelPropertyBase[] | undefined;
    partners?: Partner[] | undefined;
    subPartners?: SubPartner[] | undefined;
    matchReviews?: LkMatchReview[] | undefined;
}

export interface MatchReportTimeCard {
    tenantName?: string | undefined;
    dateFrom?: Date | undefined;
    dateTo?: Date | undefined;
    reviewName?: string | undefined;
    contributorRows?: MatchReportTimeCardContributorRow[] | undefined;
}

export interface MatchReportTimeCardContributorRow {
    contributor?: Contributor | undefined;
    partners?: Partner[] | undefined;
    subPartners?: SubPartner[] | undefined;
    calendarMonths?: MatchReportTimeCardCalendarMonth[] | undefined;
    durationInMinutesPerContributor?: number | undefined;
}

export interface MatchReportTimeCardCalendarMonth {
    monthName?: string | undefined;
    calendarDays?: MatchReportTimeCardCalendarDay[] | undefined;
    contributorMatchRows?: MatchReportTimeCardContributorMatchRow[] | undefined;
    durationInMinutesMonthly?: number | undefined;
}

export interface MatchReportTimeCardCalendarDay {
    date?: Date | undefined;
    durationInMinutes?: number | undefined;
}

export interface MatchReportTimeCardContributorMatchRow {
    date?: Date | undefined;
    contributorMatchService?: string | undefined;
    durationInMinutes?: number | undefined;
}

export interface MatchReportTimeCardFilter {
    dateFrom: Date;
    dateTo: Date;
    contributorId?: number | undefined;
    contributor?: Contributor | undefined;
    partnerIds?: number[] | undefined;
    subPartnerIds?: number[] | undefined;
    reviewId?: number | undefined;
    isMatch?: boolean | undefined;
}

export interface ContributorEmploymentListDto {
    id: number;
    partner?: string | undefined;
    subPartner?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    hourlySalary?: number | undefined;
    groupBenefit?: number | undefined;
    medicalBenefit?: number | undefined;
    isBeforeMatchStaticEndDate: boolean;
    isLocked: boolean;
}

export interface ContributorEmploymentListFilter extends ListFilterBase {
    employmentFilter?: ContributorEmploymentFilter | undefined;
}

export interface ContributorEmploymentFilter {
    contributorId?: number | undefined;
}

export interface ContributorEmploymentViewResource {
    properties?: ModelPropertyBase[] | undefined;
    subPartners?: SubPartner[] | undefined;
}

export interface ContributorEmploymentEditResource {
    partners?: Partner[] | undefined;
}

export interface ContributorEmploymentListResource {
    properties?: ListPropertyBase[] | undefined;
}

export interface StaffEmploymentListDto {
    id: number;
    schoolYear?: number | undefined;
    school?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    educator: boolean;
}

export interface StaffEmploymentListFilter extends ListFilterBase {
    employmentFilter?: StaffEmploymentFilter | undefined;
}

export interface StaffEmploymentViewResource {
    properties?: ModelPropertyBase[] | undefined;
}

export interface StaffEmploymentEditResource {
    schoolYears?: SimpleDto[] | undefined;
    schools?: School[] | undefined;
}

export interface StaffEmploymentListResource {
    properties?: ListPropertyBase[] | undefined;
}

export interface AprRequest {
    filter: AprRequestFilter;
    sectionItemIds: number[];
}

export interface AprRequestFilter {
    aprSchoolYearId: number;
    schoolYear?: number | undefined;
    programId?: number | undefined;
    serviceDateFrom?: Date | undefined;
    serviceDateTo?: Date | undefined;
}

export interface AprResource {
    properties?: ModelPropertyBase[] | undefined;
    aprSections?: AprSection[] | undefined;
    aprSchoolYears?: AprSchoolYear[] | undefined;
    schoolYears?: SimpleDto[] | undefined;
    programs?: Program[] | undefined;
    displayFields?: LkStudentDisplayField[] | undefined;
}

export interface AprSection {
    id: number;
    name: string;
    items?: AprSectionItem[] | undefined;
}

export interface AprSectionItem {
    id: number;
    name: string;
}

export interface AprSchoolYear {
    id: number;
    name: string;
    schoolYear: number;
    sections: number[];
}

export interface AprResponse {
    sectionIV?: AprResponseSectionIV | undefined;
    sectionV?: AprResponseSectionV | undefined;
    sectionVI?: AprResponseSectionVI | undefined;
    sectionVII?: AprResponseSectionVII | undefined;
    fprSectionIV?: AprResponseFprSectionIV | undefined;
    fprSectionV?: AprResponseFprSectionV | undefined;
    fprSectionVI?: AprResponseFprSectionVI | undefined;
}

export interface AprResponseSectionIV {
    studentParticipation?: AprResponseStudentParticipation | undefined;
    studentParticipationByEthnicBackground?: AprResponseStudentParticipationByEthnicBackground | undefined;
    studentParticipationByGender?: AprResponseStudentParticipationByGender | undefined;
    studentParticipationByIep?: number | undefined;
    studentParticipationByLep?: number | undefined;
    studentsByShelter?: AprResponseStudentsByShelter | undefined;
}

export interface AprResponseStudentParticipation {
    properties?: ReportPropertyBase[] | undefined;
    rows?: AprResponseStudentParticipationRow[] | undefined;
}

export interface AprResponseStudentParticipationRow {
    gradeLevel?: string | undefined;
    gradeLevelDisplayOrder?: number | undefined;
    continuingStudentCount: number;
    newStudentCount: number;
    withdrewStudentCount: number;
    droppedOutStudentCount: number;
    activeStudentsCount: number;
    totalStudentsCount: number;
}

export interface AprResponseStudentParticipationByEthnicBackground {
    properties?: ReportPropertyBase[] | undefined;
    rows?: AprResponseStudentParticipationByEthnicBackgroundRow[] | undefined;
}

export interface AprResponseStudentParticipationByEthnicBackgroundRow {
    ethnicBackground?: string | undefined;
    suffix?: string | undefined;
    studentCount: number;
}

export interface AprResponseStudentParticipationByGender {
    properties?: ReportPropertyBase[] | undefined;
    rows?: AprResponseStudentParticipationByGenderRow[] | undefined;
}

export interface AprResponseStudentParticipationByGenderRow {
    gender?: string | undefined;
    genderDisplayOrder?: number | undefined;
    studentCount: number;
}

export interface AprResponseStudentsByShelter {
    properties?: ReportPropertyBase[] | undefined;
    rows?: AprResponseStudentsByShelterRow[] | undefined;
}

export interface AprResponseStudentsByShelterRow {
    label?: string | undefined;
    studentCount: number;
}

export interface AprResponseSectionV {
    activitiesAndServices?: AprResponseActivitiesAndServices | undefined;
    studentsByAnotherFederallyFundedProgram?: AprResponseStudentsByAnotherFederallyFundedProgram | undefined;
    studentActivitiesAndServices?: AprResponseStudentActivitiesAndServices | undefined;
    coreActivitiesProvidedToFamilyMembers?: AprResponseCoreActivitiesProvidedToFamilyMembers | undefined;
    professionalDevelopmentActivities?: AprResponseProfessionalDevelopmentActivities | undefined;
}

export interface AprResponseActivitiesAndServices {
    studentCount: number;
    parentCount: number;
    staffCount: number;
}

export interface AprResponseStudentsByAnotherFederallyFundedProgram {
    properties?: ReportPropertyBase[] | undefined;
    rows?: AprResponseStudentsByAnotherFederallyFundedProgramRow[] | undefined;
}

export interface AprResponseStudentsByAnotherFederallyFundedProgramRow {
    label?: string | undefined;
    studentCount: number;
}

export interface AprResponseStudentActivitiesAndServices {
    properties?: ReportPropertyBase[] | undefined;
    rows?: AprResponseStudentActivitiesAndServicesRow[] | undefined;
}

export interface AprResponseStudentActivitiesAndServicesRow {
    aprStudentService?: string | undefined;
    aprStudentServiceDisplayOrder?: number | undefined;
    studentCount: number;
    totalDurationInMinutes: number;
}

export interface AprResponseCoreActivitiesProvidedToFamilyMembers {
    properties?: ReportPropertyBase[] | undefined;
    rows?: AprResponseCoreActivitiesProvidedToFamilyMembersRow[] | undefined;
}

export interface AprResponseCoreActivitiesProvidedToFamilyMembersRow {
    aprCategory?: string | undefined;
    aprCategoryDisplayOrder?: number | undefined;
    studentCount: number;
    totalDurationInMinutes: number;
}

export interface AprResponseProfessionalDevelopmentActivities {
    properties?: ReportPropertyBase[] | undefined;
    rows?: AprResponseProfessionalDevelopmentActivitiesRow[] | undefined;
}

export interface AprResponseProfessionalDevelopmentActivitiesRow {
    label?: string | undefined;
    staffCount: number;
}

export interface AprResponseSectionVI {
    algebraI?: AprResponseAlgebraI | undefined;
    academicEngagement?: AprResponseAcademicEngagement | undefined;
    fafsaCompletion?: AprResponseFafsaCompletion | undefined;
    highSchoolGraduation?: AprResponseHighSchoolGraduation | undefined;
}

export interface AprResponseAlgebraI {
    properties?: ReportPropertyBase[] | undefined;
    rows?: AprResponseAlgebraIRow[] | undefined;
}

export interface AprResponseAlgebraIRow {
    label?: string | undefined;
    studentCount: number;
}

export interface AprResponseAcademicEngagement {
    properties?: ReportPropertyBase[] | undefined;
    rows?: AprResponseAcademicEngagementRow[] | undefined;
}

export interface AprResponseAcademicEngagementRow {
    gradeLevel?: string | undefined;
    gradeLevelDisplayOrder?: number | undefined;
    aStudentCount: number;
    bStudentCount: number;
    cStudentCount: number;
    dStudentCount: number;
}

export interface AprResponseFafsaCompletion {
    properties?: ReportPropertyBase[] | undefined;
    rows?: AprResponseFafsaCompletionRow[] | undefined;
}

export interface AprResponseFafsaCompletionRow {
    label?: string | undefined;
    studentCount: number;
}

export interface AprResponseHighSchoolGraduation {
    properties?: ReportPropertyBase[] | undefined;
    rows?: AprResponseHighSchoolGraduationRow[] | undefined;
}

export interface AprResponseHighSchoolGraduationRow {
    label?: string | undefined;
    studentCount: number;
}

export interface AprResponseSectionVII {
    postsecondaryEnrollment?: AprResponsePostsecondaryEnrollment | undefined;
}

export interface AprResponsePostsecondaryEnrollment {
    properties?: ReportPropertyBase[] | undefined;
    rows?: AprResponsePostsecondaryEnrollmentRow[] | undefined;
}

export interface AprResponsePostsecondaryEnrollmentRow {
    label?: string | undefined;
    studentCount: number;
}

export interface AprResponseFprSectionIV {
    studentsServed?: AprResponseStudentServed | undefined;
    studentParticipationByEthnicBackground?: AprResponseStudentParticipationByEthnicBackground | undefined;
}

export interface AprResponseStudentServed {
    properties?: ReportPropertyBase[] | undefined;
    rows?: AprResponseStudentServedRow[] | undefined;
}

export interface AprResponseStudentServedRow {
    schoolYear?: string | undefined;
    studentCount: number;
}

export interface AprResponseFprSectionV {
    fafsaCompletion?: AprResponseFafsaCompletion | undefined;
    highSchoolGraduation?: AprResponseHighSchoolGraduation | undefined;
}

export interface AprResponseFprSectionVI {
    postsecondaryEnrollment?: AprResponsePostsecondaryEnrollment | undefined;
    postsecondarPersistence?: AprResponsePostsecondaryPersistence | undefined;
}

export interface AprResponsePostsecondaryPersistence {
    properties?: ReportPropertyBase[] | undefined;
    rows?: AprResponsePostsecondaryPersistenceRow[] | undefined;
}

export interface AprResponsePostsecondaryPersistenceRow {
    label?: string | undefined;
    studentCount: number;
}

export interface AprSssResponse {
    projectIdentifiers?: AprSssResponseProjectIdentifiers | undefined;
}

export interface AprSssResponseProjectIdentifiers {
    properties?: ReportPropertyBase[] | undefined;
    rows?: AprSssResponseRow[] | undefined;
}

export interface AprSssResponseRow {
    awardNumber?: string | undefined;
    batchYear: number;
    caseNumber?: string | undefined;
    lastName?: string | undefined;
    firstName?: string | undefined;
    middleInitial?: string | undefined;
    dateOfBirth?: Date | undefined;
    genderCode: number;
    ethnicityCode: number;
    isRaceNative: number;
    isRaceAsian: number;
    isRaceAfrican: number;
    isRaceWhite: number;
    isRacePacific: number;
    eligibility: number;
    disability: number;
    academicNeed?: number | undefined;
    firstEnrollmentDate?: Date | undefined;
    firstServiceDate?: string | undefined;
    collegeGradeLevel?: number | undefined;
    enrollmentStatus?: number | undefined;
    cohortYear?: number | undefined;
    participantStatus?: number | undefined;
    endEnrollmentStatus?: number | undefined;
    academicStanding?: number | undefined;
    cumulativeGPA?: string | undefined;
    begCurrentGradeLevel?: number | undefined;
    currentEndGradeLevel?: number | undefined;
    lastServiceDate?: string | undefined;
    reasonForWithdrawal?: number | undefined;
    transfers?: number | undefined;
    undergraduateDegree?: number | undefined;
    degreeDate?: string | undefined;
    fieldOfStudy?: number | undefined;
    persistenceStatus?: number | undefined;
    financialAidReceived?: number | undefined;
    grantAidAwarded?: number | undefined;
    partNameChange?: number | undefined;
    customId?: string | undefined;
}

export interface AprUBResponse {
    projectIdentifiers?: AprUbResponseProjectIdentifiers | undefined;
}

export interface AprUbResponseProjectIdentifiers {
    properties?: ReportPropertyBase[] | undefined;
    rows?: AprUbResponseRow[] | undefined;
}

export interface AprEtsResponse {
    properties?: ModelPropertyBase[] | undefined;
    tabA?: AprEtsTabA | undefined;
    tabB?: AprEtsTabB | undefined;
    tabC?: AprEtsTabC | undefined;
    tabD?: AprEtsTabD | undefined;
    tabE?: AprEtsTabE | undefined;
    tabH?: AprEtsTabH | undefined;
    tabI?: AprEtsTabI | undefined;
    tabJ?: AprEtsTabJ | undefined;
    tabK?: AprEtsTabK | undefined;
    tabL?: AprEtsTabL | undefined;
    tabM?: AprEtsTabM | undefined;
    tab3A?: AprEtsTabIIIA | undefined;
    tab4A?: AprEtsTabIVA | undefined;
    tab4B?: AprEtsTabIVB | undefined;
    tab4C?: AprEtsTabIVC | undefined;
    tab4D?: AprEtsTabIVD | undefined;
    tab4E?: AprEtsTabIVE | undefined;
    tab4E2?: AprEtsTabIVE2 | undefined;
}

export interface AprEtsTabA {
    totalParticipants: number;
    newParticipants?: number | undefined;
    continuingParticipants?: number | undefined;
    priorYearEnrolled?: number | undefined;
    priorYearNoLongerEnrolled?: number | undefined;
    newSummerParticipantEarnedCredits?: number | undefined;
    newSummerParticipantNoCredits?: number | undefined;
    unknownParticipants?: number | undefined;
    chartValues?: AprEtsChartValue[] | undefined;
}

export interface AprEtsChartValue {
    label?: string | undefined;
    value: number;
}

export interface AprEtsTabB {
    lowIncomeFirstGenCollege: number;
    lowIncome: number;
    firstGenCollege: number;
    other: number;
    totalParticipants: number;
    chartValues?: AprEtsChartValue[] | undefined;
}

export interface AprEtsTabC {
    hispanicLatino: number;
    americanIndian: number;
    asian: number;
    africanAmerican: number;
    white: number;
    pacificIslander: number;
    twoRaces: number;
    unknown: number;
    totalParticipants: number;
    chartValues?: AprEtsChartValue[] | undefined;
}

export interface AprEtsTabD {
    male: number;
    female: number;
    unknownGender: number;
    nonBinary: number;
    totalParticipants: number;
    chartValues?: AprEtsChartValue[] | undefined;
}

export interface AprEtsTabE {
    tenThirteen: number;
    fourteenEighteen: number;
    nineteenTwentySeven: number;
    twentyEightAbove: number;
    unknownAge: number;
    totalParticipants: number;
    chartValues?: AprEtsChartValue[] | undefined;
}

export interface AprEtsTabH {
    yesTargetSchool: number;
    yesNonTargetSchool: number;
    noTargetSchool: number;
    noNonTargetSchool: number;
    unknownTargetSchool: number;
    unknownNonTargetSchool: number;
    targetSchoolTotalParticipants: number;
    nonTargetSchoolTotalParticipants: number;
    chartValues?: AprEtsChartValue[] | undefined;
}

export interface AprEtsTabI {
    paidWithGrantFunds: number;
    attendSchoolsDistrictNoCost: number;
    targetSchoolsPartnerNoCost: number;
    thirdPartyTuitionWaivers: number;
    other: number;
    totalParticipants: number;
    chartValues?: AprEtsChartValue[] | undefined;
}

export interface AprEtsTabJ {
    upwardBound: number;
    upwardBoundMathScience: number;
    veteranUpwardBound: number;
    gearUp: number;
    other: number;
    servedByMoreThanOne: number;
    totalParticipants: number;
    chartValues?: AprEtsChartValue[] | undefined;
}

export interface AprEtsTabK {
    seniorFafsaNoPostSecondary: number;
    seniorFafsaWithPostSecondary: number;
    seniorNoFafsa: number;
    totalParticipants: number;
}

export interface AprEtsTabL {
    tutoringOnly: number;
    mentoringOnly: number;
    tutoringMentoring: number;
    neither: number;
    totalParticipants: number;
    chartValues?: AprEtsChartValue[] | undefined;
}

export interface AprEtsTabM {
    nonTargetSchoolTotal: number;
    schoolRows?: AprEtsTabMItem[] | undefined;
    chartValues?: AprEtsChartValue[] | undefined;
}

export interface AprEtsTabMItem {
    ncesId?: string | undefined;
    targetSchoolName?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zipCode?: string | undefined;
    numberServed: number;
    dualEnrolled: number;
}

export interface AprEtsTabIIIA {
    totalParticipants: number;
    middleSchoolers?: number | undefined;
    freshmen?: number | undefined;
    sophomores?: number | undefined;
    juniors?: number | undefined;
    seniors?: number | undefined;
    alternativeStudents?: number | undefined;
    fourthYearStudents?: number | undefined;
    fifthYearStudents?: number | undefined;
    secondary3A?: number | undefined;
    other3A?: number | undefined;
    unknown3A?: number | undefined;
}

export interface AprEtsTabIVA {
    totalParticipants: number;
    movedUpGradeLevel?: number | undefined;
    repeatedGradeLevel?: number | undefined;
    dropOuts?: number | undefined;
    deceased?: number | undefined;
    other4A?: number | undefined;
    unknown4A?: number | undefined;
}

export interface AprEtsTabIVB {
    totalParticipants: number;
    graduatedNonRigorous?: number | undefined;
    graduatedRigorous?: number | undefined;
    graduatedLate?: number | undefined;
    alternativeCredential?: number | undefined;
    dropOuts4B?: number | undefined;
    deceased4B?: number | undefined;
    other4B?: number | undefined;
    unknown4B?: number | undefined;
    secondaryDropouts?: number | undefined;
}

export interface AprEtsTabIVC {
    totalParticipantsNsc: number;
    totalParticipantsNoNsc: number;
    nscCode1?: number | undefined;
    nscCode2?: number | undefined;
    nscCode3?: number | undefined;
    nscCode4?: number | undefined;
    nscCode5?: number | undefined;
    nscCode1And2?: number | undefined;
    nscCode3And4And5?: number | undefined;
    noNscCode1?: number | undefined;
    noNscCode2?: number | undefined;
    noNscCode3?: number | undefined;
    noNscCode4?: number | undefined;
    noNscCode5?: number | undefined;
    noNscCode1And2?: number | undefined;
    noNscCode3And4And5?: number | undefined;
}

export interface AprEtsTabIVD {
    totalParticipantsNsc: number;
    public2YearCode1?: number | undefined;
    public2YearCode2?: number | undefined;
    public2YearCode3?: number | undefined;
    public2YearCode4?: number | undefined;
    public2YearCode5?: number | undefined;
    private2YearCode1?: number | undefined;
    private2YearCode2?: number | undefined;
    private2YearCode3?: number | undefined;
    private2YearCode4?: number | undefined;
    private2YearCode5?: number | undefined;
    public4YearCode1?: number | undefined;
    public4YearCode2?: number | undefined;
    public4YearCode3?: number | undefined;
    public4YearCode4?: number | undefined;
    public4YearCode5?: number | undefined;
    private4YearCode1?: number | undefined;
    private4YearCode2?: number | undefined;
    private4YearCode3?: number | undefined;
    private4YearCode4?: number | undefined;
    private4YearCode5?: number | undefined;
    vocationalCode1?: number | undefined;
    vocationalCode2?: number | undefined;
    vocationalCode3?: number | undefined;
    vocationalCode4?: number | undefined;
    vocationalCode5?: number | undefined;
}

export interface AprEtsTabIVE {
    graduates: number;
    totalEnrollment?: number | undefined;
    totalEnrollmentPercent?: number | undefined;
    projectIdentifiers?: AprEtsTabIVEProjectIdentifiers | undefined;
}

export interface AprEtsTabIVEProjectIdentifiers {
    properties?: ReportPropertyBase[] | undefined;
    rows?: AprEtsTabIVERow[] | undefined;
}

export interface AprEtsTabIVERow {
    prNumber?: string | undefined;
    batchYear?: string | undefined;
    lastName?: string | undefined;
    firstName?: string | undefined;
    middleInitial?: string | undefined;
    studentId?: string | undefined;
    sample?: string | undefined;
}

export interface AprEtsTabIVE2 {
    certificatesOnly: number;
    associatesOnly?: number | undefined;
    bachelorsOnly?: number | undefined;
    bachelorAndAssociate?: number | undefined;
    moreThanOneCredential?: number | undefined;
    totalCredential?: number | undefined;
    noPostSecondaryCredential?: number | undefined;
    deceased4E2?: number | undefined;
    totalParticipants4E2?: number | undefined;
}

export interface AprEocResponse {
    properties?: ModelPropertyBase[] | undefined;
    tabA?: AprEocTabA | undefined;
    tabB?: AprEocTabB | undefined;
    tabC?: AprEocTabC | undefined;
    tabD?: AprEocTabD | undefined;
    tabE?: AprEocTabE | undefined;
    tabF?: AprEocTabF | undefined;
    tabG?: AprEocTabG | undefined;
    tabH?: AprEocTabH | undefined;
    tabCpp?: AprEocTabCpp | undefined;
    tab3A?: AprEocTabIIIA | undefined;
    tab3B?: AprEocTabIIIB | undefined;
    tab4A?: AprEocTabIVA | undefined;
    tab4B?: AprEocTabIVB | undefined;
    tab4C?: AprEocTabIVC | undefined;
    tab4D?: AprEocTabIVD | undefined;
    tab4E?: AprEocTabIVE | undefined;
    tab4E2?: AprEocTabIVE2 | undefined;
}

export interface AprEocTabA {
    totalParticipants: number;
    newParticipants?: number | undefined;
    continuingParticipants?: number | undefined;
    priorYearEnrolled?: number | undefined;
    priorYearNoLongerEnrolled?: number | undefined;
    newSummerParticipantEarnedCredits?: number | undefined;
    newSummerParticipantNoCredits?: number | undefined;
    unknownParticipants?: number | undefined;
    chartValues?: AprEocChartValue[] | undefined;
}

export interface AprEocChartValue {
    label?: string | undefined;
    value: number;
}

export interface AprEocTabB {
    lowIncomeFirstGenCollege: number;
    lowIncome: number;
    firstGenCollege: number;
    other: number;
    totalParticipants: number;
    chartValues?: AprEocChartValue[] | undefined;
}

export interface AprEocTabC {
    hispanicLatino: number;
    americanIndian: number;
    asian: number;
    africanAmerican: number;
    white: number;
    pacificIslander: number;
    twoRaces: number;
    unknown: number;
    totalParticipants: number;
    chartValues?: AprEocChartValue[] | undefined;
}

export interface AprEocTabD {
    male: number;
    female: number;
    unknownGender: number;
    nonBinary: number;
    totalParticipants: number;
    chartValues?: AprEocChartValue[] | undefined;
}

export interface AprEocTabE {
    tenThirteen: number;
    fourteenEighteen: number;
    nineteenTwentySeven: number;
    twentyEightAbove: number;
    unknownAge: number;
    totalParticipants: number;
    chartValues?: AprEocChartValue[] | undefined;
}

export interface AprEocTabF {
    lepStudents: number;
}

export interface AprEocTabG {
    upwardBound: number;
    upwardBoundMathScience: number;
    veteranUpwardBound: number;
    talentSearch: number;
    gearUp: number;
    studentSupportiveServices: number;
    other: number;
    servedByMoreThanOne: number;
    totalParticipants: number;
    chartValues?: AprEocChartValue[] | undefined;
}

export interface AprEocTabH {
    schoolRows?: AprEocTabHItem[] | undefined;
    chartValues?: AprEocChartValue[] | undefined;
}

export interface AprEocTabHItem {
    ncesId?: string | undefined;
    targetSchoolName?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zipCode?: string | undefined;
    numberServed: number;
    dualEnrolled: number;
}

export interface AprEocTabCpp {
    veterans: number;
    activeDuty: number;
    spouseActiveDuty: number;
    childActiveDuty: number;
}

export interface AprEocTabIIIA {
    a1: number;
    a2?: number | undefined;
    a3?: number | undefined;
    a4?: number | undefined;
    a5?: number | undefined;
    a6?: number | undefined;
    a7?: number | undefined;
    a8?: number | undefined;
    unknownA9?: number | undefined;
    totalParticipants: number;
}

export interface AprEocTabIIIB {
    highSchoolNonSenior: number;
    highSchoolSenior?: number | undefined;
    secondarySchoolDropout?: number | undefined;
    otherParticipantUnder?: number | undefined;
    totalParticipants: number;
}

export interface AprEocTabIVA {
    a1EndReason: number;
    a2EndReason?: number | undefined;
    a3EndReason?: number | undefined;
    a4EndReason?: number | undefined;
    a5EndReason?: number | undefined;
    a6EndReason?: number | undefined;
    totalParticipants: number;
}

export interface AprEocTabIVB {
    totalParticipants: number;
    completeFafsa?: number | undefined;
    incompleteFafsa?: number | undefined;
    unknown4B?: number | undefined;
}

export interface AprEocTabIVC {
    totalParticipantsC4: number;
    submittedApplication?: number | undefined;
    otherApplicationStatus?: number | undefined;
    unknownApplicationStatus?: number | undefined;
}

export interface AprEocTabIVD {
    totalParticipantsD6: number;
    d1?: number | undefined;
    d2?: number | undefined;
    d3?: number | undefined;
    d4?: number | undefined;
    d5?: number | undefined;
}

export interface AprEocTabIVE {
    e1: number;
    e2: number;
    e3: number;
    e4: number;
    e5: number;
    e6: number;
    e7: number;
    e8: number;
}

export interface AprEocTabIVE2 {
    certificatesOnly: number;
    associatesOnly?: number | undefined;
    bachelorsOnly?: number | undefined;
    bachelorAndAssociate?: number | undefined;
    moreThanOneCredential?: number | undefined;
    totalCredential?: number | undefined;
    noPostSecondaryCredential?: number | undefined;
    deceased4E2?: number | undefined;
    totalParticipants4E2?: number | undefined;
}

export interface EligibilityDashboardResponse {
    activeSchoolYear: number;
    year: number;
    program?: string | undefined;
    participantsAdmitted: number;
    lowIncomeAndFirstGenerationCollegeStudentLabel?: string | undefined;
    lowIncomeAndFirstGenerationCollegeStudentProportion: number;
    data: EligibilityDistributionDto[];
}

export interface EligibilityDistributionDto {
    eligibilityName?: string | undefined;
    studentCount: number;
    percentage: number;
}

export interface EligibilityDashboardFilter {
    schoolYear?: number | undefined;
    programId?: number | undefined;
}

export interface EthnicityDashboardResponse {
    activeSchoolYear: number;
    data: EthnicityDistributionDto[];
    totalsByYear: EthnicityYearTotalDto[];
    grandTotal: EthnicityGrandTotalDto;
}

export interface EthnicityDistributionDto {
    year: number;
    ethnicityId: number;
    ethnicityName: string;
    ethnicityDisplayOrder: number;
    studentCount: number;
    percentage: number;
}

export interface EthnicityYearTotalDto {
    year: number;
    totalStudents: number;
}

export interface EthnicityGrandTotalDto {
    totalStudents: number;
}

export interface EthnicityDashboardFilter {
    schoolYears: number[];
}

export interface FafsaDashboardFilter {
    schoolYears?: number[] | undefined;
    groupBySchool: boolean;
}

export interface GenderDashboardResponse {
    activeSchoolYear: number;
    data: GenderDistributionDto[];
    totalsByYear: GenderYearTotalDto[];
    grandTotal: GenderGrandTotalDto;
}

export interface GenderDistributionDto {
    year: number;
    genderId: number;
    genderName: string;
    genderDisplayOrder: number;
    studentCount: number;
    percentage: number;
}

export interface GenderYearTotalDto {
    year: number;
    totalStudents: number;
}

export interface GenderGrandTotalDto {
    totalStudents: number;
}

export interface GenderDashboardFilter {
    schoolYears: number[];
}

export interface IEPDashboardResponse {
    activeSchoolYear: number;
    data: IEPDistributionDto[];
    totalsByYear: IEPYearTotalDto[];
    grandTotal: IEPGrandTotalDto;
}

export interface IEPDistributionDto {
    year: number;
    iepId: number;
    iepName: string;
    iepDisplayOrder: number;
    studentCount: number;
    percentage: number;
}

export interface IEPYearTotalDto {
    year: number;
    totalStudents: number;
}

export interface IEPGrandTotalDto {
    totalStudents: number;
}

export interface IEPDashboardFilter {
    schoolYears: number[];
}

export interface LEPDashboardResponse {
    activeSchoolYear: number;
    data: LEPDistributionDto[];
    totalsByYear: LEPYearTotalDto[];
    grandTotal: LEPGrandTotalDto;
}

export interface LEPDistributionDto {
    year: number;
    lepId: number;
    lepName: string;
    lepDisplayOrder: number;
    studentCount: number;
    percentage: number;
}

export interface LEPYearTotalDto {
    year: number;
    totalStudents: number;
}

export interface LEPGrandTotalDto {
    totalStudents: number;
}

export interface LEPDashboardFilter {
    schoolYears: number[];
}

export interface RaceDashboardResponse {
    activeSchoolYear: number;
    data: RaceDistributionDto[];
    totalsByYear: RaceYearTotalDto[];
    grandTotal: RaceGrandTotalDto;
}

export interface RaceDistributionDto {
    year: number;
    raceId: number;
    raceName: string;
    raceDisplayOrder: number;
    studentCount: number;
    percentage: number;
}

export interface RaceYearTotalDto {
    year: number;
    totalStudents: number;
}

export interface RaceGrandTotalDto {
    totalStudents: number;
}

export interface RaceDashboardFilter {
    schoolYears: number[];
}

export interface ControlGroupStudentFilterResource {
    properties?: ModelPropertyBase[] | undefined;
    schoolYearsWithActive?: SimpleDto[] | undefined;
    gradeLevels?: LkGradeLevel[] | undefined;
    schools?: School[] | undefined;
    customFilterProperties?: CustomReportProperty[] | undefined;
}

export interface ControlGroupStudentEnrollmentListFilter extends ListFilterBase {
    studentFilter?: StudentFilter | undefined;
    enrollmentFilter?: StudentEnrollmentFilter | undefined;
    controlGroupStudentEnrollmentFilter?: ControlGroupStudentEnrollmentFilter | undefined;
}

export interface ControlGroupStudentEnrollmentFilterResource {
    properties?: ModelPropertyBase[] | undefined;
    customFilterProperties?: ReportPropertyBase[] | undefined;
    schools?: School[] | undefined;
    schoolYears?: SimpleDto[] | undefined;
}

export interface ControlGroupStudentEnrollmentListResource {
    properties?: ListPropertyBase[] | undefined;
    customIdTypes?: StudentCustomIdType[] | undefined;
    displayFields?: LkStudentEnrollmentDisplayField[] | undefined;
    variableFields?: TenantVariableStudentEnrollment | undefined;
}

export interface ControlGroupStudentEnrollment extends DataModel {
    controlGroupStudentId: number;
    year: number;
    schoolId: number;
    school?: School | undefined;
    gradeLevelId: number;
    gradeLevel?: LkGradeLevel | undefined;
    gradeLevelTermId?: number | undefined;
    gradeLevelTerm?: LkGradeLevelTerm | undefined;
    startDate: Date;
    endDate?: Date | undefined;
    endReasonId?: number | undefined;
    endReason?: EndReason | undefined;
    iepId?: number | undefined;
    iep?: Iep | undefined;
    lepId?: number | undefined;
    lep?: Lep | undefined;
    freeReducedLunch?: boolean | undefined;
    elYears?: string | undefined;
    reclassificationDate?: Date | undefined;
    cohortId?: number | undefined;
    cohort?: LkCohort | undefined;
}

export interface ControlGroupStudentEnrollmentViewResource {
    properties?: ModelPropertyBase[] | undefined;
    displayFields?: LkStudentEnrollmentDisplayField[] | undefined;
    customIdTypes?: StudentCustomIdType[] | undefined;
    variables?: TenantVariableStudentEnrollment | undefined;
    customDataModelFields?: CustomDataModelField[] | undefined;
    gradeLevels?: LkGradeLevel[] | undefined;
    endReasons?: EndReason[] | undefined;
}

export interface ControlGroupStudentEnrollmentEditResource {
    schoolYears?: SimpleDto[] | undefined;
    schools?: School[] | undefined;
    gradeLevels?: LkGradeLevel[] | undefined;
    gradeLevelTerms?: LkGradeLevelTerm[] | undefined;
    endReasons?: EndReason[] | undefined;
    ieps?: Iep[] | undefined;
    leps?: Lep[] | undefined;
    enrollmentStatuses?: LkEnrollmentStatus[] | undefined;
    participantStatuses?: LkParticipantStatus[] | undefined;
    militaryConnections?: LkMilitaryConnection[] | undefined;
    persistantStatuses?: LkPersistantStatus[] | undefined;
    participantLevels?: LkParticipantLevel[] | undefined;
    dualEnrollmentParticipations?: LkDualEnrollmentParticipation[] | undefined;
    dualEnrollmentCredentials?: LkDualEnrollmentCredentials[] | undefined;
    workStudyCulturalCommunity?: LkWorkStudyCulturalCommunity[] | undefined;
    employments?: LkEmploymentUB[] | undefined;
    advisors?: User[] | undefined;
    colleges?: College[] | undefined;
    dependentStatuses?: LkDependentStatus[] | undefined;
    academicStandings?: LkAcademicStanding[] | undefined;
    ccps?: LkCcp[] | undefined;
    rigorousCs?: LkRigorousC[] | undefined;
    diplomaTypes?: DiplomaType[] | undefined;
}

export interface ControlGroupStudentEnrollmentBulkUpdate {
    controlGroupStudentEnrollments?: ControlGroupStudentEnrollment[] | undefined;
    updateSchema?: ControlGroupStudentEnrollmentBulkUpdateSchema | undefined;
}

export interface ControlGroupStudentEnrollmentBulkUpdateSchema {
    updateStartDate: boolean;
    startDate?: Date | undefined;
    updateEndDate: boolean;
    endDate?: Date | undefined;
    updateYear: boolean;
    year?: number | undefined;
    updateSchoolId: boolean;
    schoolId?: number | undefined;
    updateAdvisorId: boolean;
    advisorId?: number | undefined;
    updateGradeLevelId: boolean;
    gradeLevelId?: number | undefined;
    updateEndReasonId: boolean;
    endReasonId?: number | undefined;
    updateCohortId: boolean;
    cohortId?: number | undefined;
    updateIepId: boolean;
    iepId?: number | undefined;
    updateLepId: boolean;
    lepId?: number | undefined;
    updateLepInstructionId: boolean;
    lepInstructionId?: number | undefined;
    updateFreeReducedLunch: boolean;
    freeReducedLunch?: boolean | undefined;
    updateMagnet: boolean;
    magnet?: boolean | undefined;
    updateHeldBack: boolean;
    heldBack?: boolean | undefined;
    updateAvid: boolean;
    avid?: boolean | undefined;
    updateMediaRelease: boolean;
    mediaRelease?: boolean | undefined;
    updateCacg: boolean;
    cacg?: boolean | undefined;
    updateTwentyFirstCentury: boolean;
    twentyFirstCentury?: boolean | undefined;
    updateDropTransferForm: boolean;
    dropTransferForm?: boolean | undefined;
    updateAtRisk: boolean;
    atRisk?: boolean | undefined;
    updateHomeless: boolean;
    homeless?: boolean | undefined;
    updateFosterCare: boolean;
    fosterCare?: boolean | undefined;
    updateAtRiskReason: boolean;
    atRiskReason?: string | undefined;
    updateUb: boolean;
    ub?: boolean | undefined;
    updateUbms: boolean;
    ubms?: boolean | undefined;
    updateVub: boolean;
    vub?: boolean | undefined;
    updateTs: boolean;
    ts?: boolean | undefined;
    updateSss: boolean;
    sss?: boolean | undefined;
    updateGearUp: boolean;
    gearUp?: boolean | undefined;
    updateEoc: boolean;
    eoc?: boolean | undefined;
    updateInitialEnrollmentStatusId: boolean;
    initialEnrollmentStatusId?: number | undefined;
    updateFinalEnrollmentStatusId: boolean;
    finalEnrollmentStatusId?: number | undefined;
    updateParticipantStatusId: boolean;
    participantStatusId?: number | undefined;
    updateParticipantLevelId: boolean;
    participantLevelId?: number | undefined;
    updateDiplomaTypeId: boolean;
    diplomaTypeId?: number | undefined;
    updateMilitaryConnectionId: boolean;
    militaryConnectionId?: number | undefined;
    updatePersistantStatusId: boolean;
    persistantStatusId?: number | undefined;
    updateEnrollmentStatusId: boolean;
    enrollmentStatusId?: number | undefined;
    updateCredits: boolean;
    credits?: number | undefined;
    updateDependentStatusId: boolean;
    dependentStatusId?: number | undefined;
    updateNih: boolean;
    nih?: number | undefined;
    updateAgi: boolean;
    agi?: number | undefined;
    updateUnmetNeed: boolean;
    unmetNeed?: number | undefined;
    updateLoanAmount: boolean;
    loanAmount?: number | undefined;
    updatePellRecipient: boolean;
    pellRecipient?: boolean | undefined;
    updateAcademicStandingId: boolean;
    academicStandingId?: number | undefined;
    updateCcpId: boolean;
    ccpId?: number | undefined;
    updateRigorousCId: boolean;
    rigorousCId?: number | undefined;
    updateDualEnrollment: boolean;
    dualEnrollment?: boolean | undefined;
    updateDualEnrollmentParticipation: boolean;
    dualEnrollmentParticipationId?: number | undefined;
    updateDualEnrollmentCredentials: boolean;
    dualEnrollmentCredentialsId?: number | undefined;
    updateWorkStudy: boolean;
    workStudyId?: number | undefined;
    updateEmploymentUb: boolean;
    employmentUBId?: number | undefined;
    updateCultural: boolean;
    culturalId?: number | undefined;
    updateCommunityService: boolean;
    communityServiceId?: number | undefined;
}

export interface ControlGroupStudentEnrollmentBulkUpdateResource {
    properties?: ModelPropertyBase[] | undefined;
    variables?: TenantVariableStudentEnrollment | undefined;
    displayFields?: LkStudentEnrollmentDisplayField[] | undefined;
    schoolYears?: SimpleDto[] | undefined;
    schools?: School[] | undefined;
    gradeLevels?: LkGradeLevel[] | undefined;
    gradeLevelTerms?: LkGradeLevelTerm[] | undefined;
    endReasons?: EndReason[] | undefined;
    ieps?: Iep[] | undefined;
    leps?: Lep[] | undefined;
    enrollmentStatuses?: LkEnrollmentStatus[] | undefined;
    participantStatuses?: LkParticipantStatus[] | undefined;
    participantLevels?: LkParticipantLevel[] | undefined;
    diplomaTypes?: DiplomaType[] | undefined;
    militaryConnections?: LkMilitaryConnection[] | undefined;
    persistantStatuses?: LkPersistantStatus[] | undefined;
    advisors?: User[] | undefined;
    dependentStatuses?: LkDependentStatus[] | undefined;
    academicStandings?: LkAcademicStanding[] | undefined;
    ccps?: LkCcp[] | undefined;
    rigorousCs?: LkRigorousC[] | undefined;
    dualEnrollmentParticipations?: LkDualEnrollmentParticipation[] | undefined;
    dualEnrollmentCredentials?: LkDualEnrollmentCredentials[] | undefined;
    employmentUbs?: LkEmploymentUB[] | undefined;
    workStudyCulturalCommunities?: LkWorkStudyCulturalCommunity[] | undefined;
}

export interface ApplicationListDto {
    id: number;
    name: string;
}

export interface ApplicationListResource {
    properties?: ListPropertyBase[] | undefined;
}

export interface ApplicationViewResource {
    properties?: ModelPropertyBase[] | undefined;
    publicUrl: string;
    publicTenant: string;
    applicationQuestionCount: number;
    applicationSectionCount: number;
    formQuestionTypes: LkFormQuestionType[];
    formQuestionWriteInTypes: LkFormQuestionWriteInType[];
    applicationPropertyTypes: LkApplicationProperty[];
    questionSizes: string[];
    existingApplications: Application[];
    schools?: School[] | undefined;
    educationLevels?: LkEducationLevel[] | undefined;
    customStudentFields?: CustomDataModelField[] | undefined;
    relations?: LkRelation[] | undefined;
    gradeLevels?: LkGradeLevel[] | undefined;
    ethnicities?: LkEthnicity[] | undefined;
    races?: LkRace[] | undefined;
    genders?: LkGender[] | undefined;
    leps?: Lep[] | undefined;
}

export interface ApplicationEditResource {
    languages: LkLanguage[];
    parentApplications: Application[];
}

export interface DeveloperListDto {
    id: number;
    name?: string | undefined;
    developerType?: string | undefined;
    gender?: string | undefined;
    genderDisplayOrder?: number | undefined;
    createdDate?: Date | undefined;
    carCount?: number | undefined;
    hourlySalary?: number | undefined;
    dateOfBirth?: Date | undefined;
    isMarried: boolean;
    hasChildren?: boolean | undefined;
    workDurationInMinutes?: number | undefined;
    progressPercent?: number | undefined;
}

export interface DeveloperListFilter extends ListFilterBase {
    developerFilter?: DeveloperFilter | undefined;
}

export interface DeveloperFilter {
    developerTypeId?: number | undefined;
    genderId?: number | undefined;
}

export interface DeveloperListResource {
    properties?: ListPropertyBase[] | undefined;
}

export interface DeveloperFilterResource {
    properties?: ModelPropertyBase[] | undefined;
    developerTypes?: DeveloperType[] | undefined;
    genders?: LkGender[] | undefined;
    colleges?: College[] | undefined;
}

export interface DeveloperViewResource {
    properties?: ModelPropertyBase[] | undefined;
}

export interface DeveloperEditResource {
    developerTypes?: DeveloperType[] | undefined;
    genders?: LkGender[] | undefined;
    colleges?: College[] | undefined;
}

export interface DeveloperBulkUpdate {
    developers?: Developer[] | undefined;
    updateSchema?: DeveloperBulkUpdateSchema | undefined;
}

export interface DeveloperBulkUpdateSchema {
    updateGenderId: boolean;
    genderId?: number | undefined;
    updateTypeId: boolean;
    typeId?: number | undefined;
}

export interface DeveloperBulkUpdateResource {
    properties?: ModelPropertyBase[] | undefined;
    developerTypes?: DeveloperType[] | undefined;
    genders?: LkGender[] | undefined;
}

export interface SurveyExportResource {
    surveys: Form[];
    exportTypes: SimpleDto[];
}

export interface SurveyExportRequest {
    formId: number;
    formExportTypeId: number;
}

export interface SurveyResponseListDto {
    id: number;
    surveyResponseIdentifier: string;
    surveyIdentifier: string;
    sentDate: Date;
    completedDate?: Date | undefined;
    surveyName: string;
    recipientName?: string | undefined;
    recipientStudentId?: number | undefined;
    recipientEmailAddress?: string | undefined;
    sentAsType: string;
}

export interface SurveyResponseListFilter extends ListFilterBase {
    surveyResponseFilter?: SurveyResponseFilter | undefined;
}

export interface SurveyResponseFilter {
    surveyIds?: number[] | undefined;
    surveyTypeIds?: number[] | undefined;
    isComplete?: boolean | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
}

export interface SurveyResponseDto {
    formResponse?: FormResponse | undefined;
    tenantName?: string | undefined;
}

export interface SurveyResponseUpdateDto {
    id: number;
    studentId?: string | undefined;
}

export interface SurveyResponseListResource {
    properties?: ListPropertyBase[] | undefined;
    tenantName: string;
}

export interface SurveyResponseFilterResource {
    properties?: ModelPropertyBase[] | undefined;
    surveys: Form[];
    surveyTypes: LkFormType[];
}

export interface SurveyListDto {
    id: number;
    name: string;
    inActive: boolean;
    questionCount?: number | undefined;
}

export interface SurveyListFilter extends ListFilterBase {
    surveyFilter?: SurveyFilter | undefined;
}

export interface SurveyFilter {
    formTypeId?: number | undefined;
    formModeId?: number | undefined;
}

export interface SurveyFilterResource {
    properties?: ModelPropertyBase[] | undefined;
    formTypes?: LkFormType[] | undefined;
    formModes?: LkFormMode[] | undefined;
}

export interface SurveyViewResource {
    formProperties: ModelPropertyBase[];
    formQuestionProperties: ModelPropertyBase[];
    formQuestionTypes: LkFormQuestionType[];
    formQuestionWriteInTypes: LkFormQuestionWriteInType[];
    applicationProperties: LkApplicationProperty[];
    existingSurveys: Form[];
    publicUrl: string;
    publicTenant: string;
    formQuestionCount: number;
    formSectionCount: number;
}

export interface SurveyEditResource {
    formTypes: LkFormType[];
    languages: LkLanguage[];
    formModes: LkFormMode[];
}

export interface DataCenterFileListDto {
    id: number;
    client?: string | undefined;
    fileName?: string | undefined;
    fileThumbnail?: string | undefined;
    date?: Date | undefined;
    uploadedById?: number | undefined;
    uploadedBy?: string | undefined;
    statusUpdated?: Date | undefined;
    hasImportantComments: boolean;
    hasPublicComments: boolean;
    tasks?: DataCenterFileListTaskDto[] | undefined;
    status?: LkDataCenterFileTaskStatus | undefined;
}

export interface DataCenterFileListTaskDto {
    id: number;
    name?: string | undefined;
    assignedName?: string | undefined;
    isUrgent: boolean;
    status?: LkDataCenterFileTaskStatus | undefined;
}

export interface LookUp2 extends Entity {
    name: string;
    code?: string | undefined;
}

export interface LkDataCenterFileTaskStatus extends LookUp2 {
    reactColor?: string | undefined;
    color?: string | undefined;
}

export interface DataCenterFileListFilter extends ListFilterBase {
    dataCenterFileFilter?: DataCenterFileFilter | undefined;
}

export interface DataCenterFileFilter {
    tenantIds?: number[] | undefined;
    contentIds?: number[] | undefined;
    dataTypeIds?: number[] | undefined;
    schoolYears?: number[] | undefined;
    statusIds?: number[] | undefined;
    dateFrom?: Date | undefined;
    dateTo?: Date | undefined;
    assignedUserIds?: number[] | undefined;
    createdByClientUserId?: number | undefined;
    noTasks?: boolean | undefined;
    lastStatusUpdateStartDate?: Date | undefined;
    lastStatusUpdateEndDate?: Date | undefined;
    openTasks?: boolean | undefined;
    assignedToMe: boolean;
}

export interface DataCenterFileListResource {
    properties?: ListPropertyBase[] | undefined;
}

export interface DataCenterFileFilterResource {
    properties?: ModelPropertyBase[] | undefined;
    dataTypes?: LkDataCenterFileTaskDataType[] | undefined;
    contents?: LkDataCenterFileTaskContent[] | undefined;
    statuses?: LkDataCenterFileTaskStatus[] | undefined;
    users?: User[] | undefined;
    schoolYears?: SimpleDto[] | undefined;
}

export interface LkDataCenterFileTaskDataType extends LookUp2 {
}

export interface LkDataCenterFileTaskContent extends LookUp2 {
}

export interface DataCenterFile extends DataModel2 {
    tenantId?: number | undefined;
    tenant?: Tenant | undefined;
    uploadFileId: number;
    uploadFile: UploadFile2;
    note?: string | undefined;
    infoTaskId?: number | undefined;
    creatingInfoTask?: DataCenterFileTask | undefined;
    createdByClientUserId?: number | undefined;
    createdByClientUser?: string | undefined;
    createdByClientUserEmail?: string | undefined;
    lastStatusUpdateDate?: Date | undefined;
}

export interface Tenant extends DataModel2 {
    name: string;
    deactivated: boolean;
    infobipSourceNumber?: string | undefined;
}

export interface UploadFile2 extends DataModel2 {
    fileName: string;
    fileRef?: string | undefined;
    fileSize: number;
    uploadingData?: string | undefined;
    imagePreviewData?: string | undefined;
}

export interface DataCenterFileTask extends DataModel2 {
    dataCenterFileId?: number | undefined;
    name: string;
    statusId: number;
    status?: LkDataCenterFileTaskStatus | undefined;
    priorityId: number;
    priority?: LkDataCenterFileTaskPriority | undefined;
    assignedUserId?: number | undefined;
    assignedUser?: User2 | undefined;
    isInfoTask: boolean;
    dataTypes: LkDataCenterFileTaskDataType[];
    contents: LkDataCenterFileTaskContent[];
    contentUpdates?: LkDataCenterFileTaskContentUpdate[] | undefined;
    schoolYears: DataCenterFileTaskSchoolYear[];
    comments?: Comment2[] | undefined;
    publicCommentCount?: number | undefined;
}

export interface LkDataCenterFileTaskPriority extends LookUp2 {
}

export interface User2 extends DataModel2 {
    username?: string | undefined;
    lastName: string;
    firstName: string;
    email?: string | undefined;
    membershipId: number;
    settingId: number;
}

export interface LkDataCenterFileTaskContentUpdate extends LookUp2 {
}

export interface DataCenterFileTaskSchoolYear extends DataModel2 {
    dataCenterFileTaskId: number;
    schoolYear: number;
}

export interface Comment2 extends DataModel2 {
    message: string;
    isPublic: boolean;
    isImportant: boolean;
    isActivity: boolean;
    createdByName?: string | undefined;
}

export interface DataCenterFileViewResource {
    canDelete: boolean;
}

export interface DataCenterFileEditResource {
    statuses?: LkDataCenterFileTaskStatus[] | undefined;
    users?: User[] | undefined;
    priorities?: LkDataCenterFileTaskPriority[] | undefined;
    dataTypes?: LkDataCenterFileTaskDataType[] | undefined;
    contents?: LkDataCenterFileTaskContent[] | undefined;
    contentUpdates?: LkDataCenterFileTaskContentUpdate[] | undefined;
    schoolYears?: SimpleDto[] | undefined;
}

export interface DataCenterFileTaskListFilter extends ListFilterBase {
    taskFilter?: DataCenterFileTaskFilter | undefined;
}

export interface DataCenterFileTaskFilter {
    dataCenterFileId?: number | undefined;
    includeInfoTasks: boolean;
}

export interface PartnerListDto {
    id: number;
    name?: string | undefined;
    currentIndirectPercent?: number | undefined;
    currentMileage?: number | undefined;
}

export interface PartnerListResource {
    properties?: ListPropertyBase[] | undefined;
}

export interface PartnerViewResource {
    properties?: ModelPropertyBase[] | undefined;
    indirectCostsTotal?: number | undefined;
    subPartnersTotal?: number | undefined;
}

export interface ClassEditResource {
    classLevels?: LkClassLevel[] | undefined;
    classTypes?: LkClassType[] | undefined;
    classModes?: LkClassMode[] | undefined;
    schools?: School[] | undefined;
}

export interface ClassViewResource {
    properties?: ModelPropertyBase[] | undefined;
}

export interface ClassListDto {
    id: number;
    name?: string | undefined;
    identification?: string | undefined;
    school?: string | undefined;
    schoolDisplayOrder?: number | undefined;
    classType?: string | undefined;
    classLevel?: string | undefined;
    usedBy: number;
    isLocked: boolean;
}

export interface ClassListFilter extends ListFilterBase {
    classFilter?: ClassFilter | undefined;
}

export interface ClassFilter extends ListFilterBase {
    schoolId?: number | undefined;
    locked?: boolean | undefined;
}

export interface ClassFilterResource {
    properties?: ModelPropertyBase[] | undefined;
    schools?: School[] | undefined;
}

export interface ClassListResource {
    properties?: ListPropertyBase[] | undefined;
}

export interface ClassBulkUpdateDto {
    ids?: number[] | undefined;
    classTypeId?: number | undefined;
    classLevelId?: number | undefined;
    isLocked?: boolean | undefined;
}

export interface ClassBulkEditResource {
    selectedClasses?: ClassBulkEditItemDto[] | undefined;
    classTypes?: LkClassType[] | undefined;
    classLevels?: LkClassLevel[] | undefined;
}

export interface ClassBulkEditItemDto {
    id: number;
    name?: string | undefined;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}